/**
 * Auto-generated divisions dataset — DO NOT EDIT MANUALLY.
 * Generated: 2026-07-14T15:38:23.349Z
 */

import type { IDivision } from '../types';

export const DIVISIONS: IDivision[] = [
  {
    "name": "Badakhshan",
    "iso2": "BDS",
    "timezone": "Asia/Kabul",
    "countryCode": "AF"
  },
  {
    "name": "Badghis",
    "iso2": "BDG",
    "timezone": "Asia/Kabul",
    "countryCode": "AF"
  },
  {
    "name": "Baghlan",
    "iso2": "BGL",
    "timezone": "Asia/Kabul",
    "countryCode": "AF"
  },
  {
    "name": "Balkh",
    "iso2": "BAL",
    "timezone": "Asia/Kabul",
    "countryCode": "AF"
  },
  {
    "name": "Bamyan",
    "iso2": "BAM",
    "timezone": "Asia/Kabul",
    "countryCode": "AF"
  },
  {
    "name": "Daykundi",
    "iso2": "DAY",
    "timezone": "Asia/Kabul",
    "countryCode": "AF"
  },
  {
    "name": "Farah",
    "iso2": "FRA",
    "timezone": "Asia/Kabul",
    "countryCode": "AF"
  },
  {
    "name": "Faryab",
    "iso2": "FYB",
    "timezone": "Asia/Kabul",
    "countryCode": "AF"
  },
  {
    "name": "Ghazni",
    "iso2": "GHA",
    "timezone": "Asia/Kabul",
    "countryCode": "AF"
  },
  {
    "name": "Ghōr",
    "iso2": "GHO",
    "timezone": "Asia/Kabul",
    "countryCode": "AF"
  },
  {
    "name": "Helmand",
    "iso2": "HEL",
    "timezone": "Asia/Kabul",
    "countryCode": "AF"
  },
  {
    "name": "Herat",
    "iso2": "HER",
    "timezone": "Asia/Kabul",
    "countryCode": "AF"
  },
  {
    "name": "Jowzjan",
    "iso2": "JOW",
    "timezone": "Asia/Kabul",
    "countryCode": "AF"
  },
  {
    "name": "Kabul",
    "iso2": "KAB",
    "timezone": "Asia/Kabul",
    "countryCode": "AF"
  },
  {
    "name": "Kandahar",
    "iso2": "KAN",
    "timezone": "Asia/Kabul",
    "countryCode": "AF"
  },
  {
    "name": "Kapisa",
    "iso2": "KAP",
    "timezone": "Asia/Kabul",
    "countryCode": "AF"
  },
  {
    "name": "Khost",
    "iso2": "KHO",
    "timezone": "Asia/Kabul",
    "countryCode": "AF"
  },
  {
    "name": "Kunar",
    "iso2": "KNR",
    "timezone": "Asia/Kabul",
    "countryCode": "AF"
  },
  {
    "name": "Kunduz Province",
    "iso2": "KDZ",
    "timezone": "Asia/Kabul",
    "countryCode": "AF"
  },
  {
    "name": "Laghman",
    "iso2": "LAG",
    "timezone": "Asia/Kabul",
    "countryCode": "AF"
  },
  {
    "name": "Logar",
    "iso2": "LOG",
    "timezone": "Asia/Kabul",
    "countryCode": "AF"
  },
  {
    "name": "Nangarhar",
    "iso2": "NAN",
    "timezone": "Asia/Kabul",
    "countryCode": "AF"
  },
  {
    "name": "Nimruz",
    "iso2": "NIM",
    "timezone": "Asia/Kabul",
    "countryCode": "AF"
  },
  {
    "name": "Nuristan",
    "iso2": "NUR",
    "timezone": "Asia/Kabul",
    "countryCode": "AF"
  },
  {
    "name": "Paktia",
    "iso2": "PIA",
    "timezone": "Asia/Kabul",
    "countryCode": "AF"
  },
  {
    "name": "Paktika",
    "iso2": "PKA",
    "timezone": "Asia/Kabul",
    "countryCode": "AF"
  },
  {
    "name": "Panjshir",
    "iso2": "PAN",
    "timezone": "Asia/Kabul",
    "countryCode": "AF"
  },
  {
    "name": "Parwan",
    "iso2": "PAR",
    "timezone": "Asia/Kabul",
    "countryCode": "AF"
  },
  {
    "name": "Samangan",
    "iso2": "SAM",
    "timezone": "Asia/Kabul",
    "countryCode": "AF"
  },
  {
    "name": "Sar-e Pol",
    "iso2": "SAR",
    "timezone": "Asia/Kabul",
    "countryCode": "AF"
  },
  {
    "name": "Takhar",
    "iso2": "TAK",
    "timezone": "Asia/Kabul",
    "countryCode": "AF"
  },
  {
    "name": "Urozgan",
    "iso2": "URU",
    "timezone": "Asia/Kabul",
    "countryCode": "AF"
  },
  {
    "name": "Wardak",
    "iso2": "WAR",
    "timezone": "Asia/Kabul",
    "countryCode": "AF"
  },
  {
    "name": "Zabul",
    "iso2": "ZAB",
    "timezone": "Asia/Kabul",
    "countryCode": "AF"
  },
  {
    "name": "Brändö",
    "iso2": "12",
    "timezone": "Europe/Mariehamn",
    "countryCode": "AX"
  },
  {
    "name": "Eckerö",
    "iso2": "08",
    "timezone": "Europe/Mariehamn",
    "countryCode": "AX"
  },
  {
    "name": "Finström",
    "iso2": "03",
    "timezone": "Europe/Mariehamn",
    "countryCode": "AX"
  },
  {
    "name": "Föglö",
    "iso2": "09",
    "timezone": "Europe/Mariehamn",
    "countryCode": "AX"
  },
  {
    "name": "Geta",
    "iso2": "10",
    "timezone": "Europe/Mariehamn",
    "countryCode": "AX"
  },
  {
    "name": "Hammarland",
    "iso2": "06",
    "timezone": "Europe/Mariehamn",
    "countryCode": "AX"
  },
  {
    "name": "Jomala",
    "iso2": "02",
    "timezone": "Europe/Mariehamn",
    "countryCode": "AX"
  },
  {
    "name": "Kökar",
    "iso2": "15",
    "timezone": "Europe/Mariehamn",
    "countryCode": "AX"
  },
  {
    "name": "Kumlinge",
    "iso2": "14",
    "timezone": "Europe/Mariehamn",
    "countryCode": "AX"
  },
  {
    "name": "Lemland",
    "iso2": "04",
    "timezone": "Europe/Mariehamn",
    "countryCode": "AX"
  },
  {
    "name": "Lumparland",
    "iso2": "13",
    "timezone": "Europe/Mariehamn",
    "countryCode": "AX"
  },
  {
    "name": "Mariehamn",
    "iso2": "01",
    "timezone": "Europe/Mariehamn",
    "countryCode": "AX"
  },
  {
    "name": "Saltvik",
    "iso2": "05",
    "timezone": "Europe/Mariehamn",
    "countryCode": "AX"
  },
  {
    "name": "Sottunga",
    "iso2": "16",
    "timezone": "Europe/Mariehamn",
    "countryCode": "AX"
  },
  {
    "name": "Sund",
    "iso2": "07",
    "timezone": "Europe/Mariehamn",
    "countryCode": "AX"
  },
  {
    "name": "Vårdö",
    "iso2": "11",
    "timezone": "Europe/Mariehamn",
    "countryCode": "AX"
  },
  {
    "name": "Berat",
    "iso2": "01",
    "timezone": "Europe/Tirane",
    "countryCode": "AL"
  },
  {
    "name": "Dibër",
    "iso2": "09",
    "timezone": "Europe/Tirane",
    "countryCode": "AL"
  },
  {
    "name": "Durrës",
    "iso2": "02",
    "timezone": "Europe/Tirane",
    "countryCode": "AL"
  },
  {
    "name": "Elbasan",
    "iso2": "03",
    "timezone": "Europe/Tirane",
    "countryCode": "AL"
  },
  {
    "name": "Fier",
    "iso2": "04",
    "timezone": "Europe/Tirane",
    "countryCode": "AL"
  },
  {
    "name": "Gjirokastër",
    "iso2": "05",
    "timezone": "Europe/Tirane",
    "countryCode": "AL"
  },
  {
    "name": "Korçë",
    "iso2": "06",
    "timezone": "Europe/Tirane",
    "countryCode": "AL"
  },
  {
    "name": "Kukës",
    "iso2": "07",
    "timezone": "Europe/Tirane",
    "countryCode": "AL"
  },
  {
    "name": "Lezhë",
    "iso2": "08",
    "timezone": "Europe/Tirane",
    "countryCode": "AL"
  },
  {
    "name": "Shkodër",
    "iso2": "10",
    "timezone": "Europe/Tirane",
    "countryCode": "AL"
  },
  {
    "name": "Tirana",
    "iso2": "11",
    "timezone": "Europe/Tirane",
    "countryCode": "AL"
  },
  {
    "name": "Vlorë",
    "iso2": "12",
    "timezone": "Europe/Tirane",
    "countryCode": "AL"
  },
  {
    "name": "Adrar",
    "iso2": "01",
    "timezone": "Africa/Algiers",
    "countryCode": "DZ"
  },
  {
    "name": "Aïn Defla",
    "iso2": "44",
    "timezone": "Africa/Algiers",
    "countryCode": "DZ"
  },
  {
    "name": "Aïn Témouchent",
    "iso2": "46",
    "timezone": "Africa/Algiers",
    "countryCode": "DZ"
  },
  {
    "name": "Algiers",
    "iso2": "16",
    "timezone": "Africa/Algiers",
    "countryCode": "DZ"
  },
  {
    "name": "Annaba",
    "iso2": "23",
    "timezone": "Africa/Algiers",
    "countryCode": "DZ"
  },
  {
    "name": "Batna",
    "iso2": "05",
    "timezone": "Africa/Algiers",
    "countryCode": "DZ"
  },
  {
    "name": "Béchar",
    "iso2": "08",
    "timezone": "Africa/Algiers",
    "countryCode": "DZ"
  },
  {
    "name": "Béjaïa",
    "iso2": "06",
    "timezone": "Africa/Algiers",
    "countryCode": "DZ"
  },
  {
    "name": "Béni Abbès",
    "iso2": "53",
    "timezone": "Africa/Algiers",
    "countryCode": "DZ"
  },
  {
    "name": "Biskra",
    "iso2": "07",
    "timezone": "Africa/Algiers",
    "countryCode": "DZ"
  },
  {
    "name": "Blida",
    "iso2": "09",
    "timezone": "Africa/Algiers",
    "countryCode": "DZ"
  },
  {
    "name": "Bordj Baji Mokhtar",
    "iso2": "52",
    "timezone": "Africa/Algiers",
    "countryCode": "DZ"
  },
  {
    "name": "Bordj Bou Arréridj",
    "iso2": "34",
    "timezone": "Africa/Algiers",
    "countryCode": "DZ"
  },
  {
    "name": "Bouïra",
    "iso2": "10",
    "timezone": "Africa/Algiers",
    "countryCode": "DZ"
  },
  {
    "name": "Boumerdès",
    "iso2": "35",
    "timezone": "Africa/Algiers",
    "countryCode": "DZ"
  },
  {
    "name": "Chlef",
    "iso2": "02",
    "timezone": "Africa/Algiers",
    "countryCode": "DZ"
  },
  {
    "name": "Constantine",
    "iso2": "25",
    "timezone": "Africa/Algiers",
    "countryCode": "DZ"
  },
  {
    "name": "Djanet",
    "iso2": "56",
    "timezone": "Africa/Algiers",
    "countryCode": "DZ"
  },
  {
    "name": "Djelfa",
    "iso2": "17",
    "timezone": "Africa/Algiers",
    "countryCode": "DZ"
  },
  {
    "name": "El Bayadh",
    "iso2": "32",
    "timezone": "Africa/Algiers",
    "countryCode": "DZ"
  },
  {
    "name": "El M'ghair",
    "iso2": "49",
    "timezone": "Africa/Algiers",
    "countryCode": "DZ"
  },
  {
    "name": "El Menia",
    "iso2": "50",
    "timezone": "Africa/Algiers",
    "countryCode": "DZ"
  },
  {
    "name": "El Oued",
    "iso2": "39",
    "timezone": "Africa/Algiers",
    "countryCode": "DZ"
  },
  {
    "name": "El Tarf",
    "iso2": "36",
    "timezone": "Africa/Algiers",
    "countryCode": "DZ"
  },
  {
    "name": "Ghardaïa",
    "iso2": "47",
    "timezone": "Africa/Algiers",
    "countryCode": "DZ"
  },
  {
    "name": "Guelma",
    "iso2": "24",
    "timezone": "Africa/Algiers",
    "countryCode": "DZ"
  },
  {
    "name": "Illizi",
    "iso2": "33",
    "timezone": "Africa/Algiers",
    "countryCode": "DZ"
  },
  {
    "name": "In Guezzam",
    "iso2": "58",
    "timezone": "Africa/Algiers",
    "countryCode": "DZ"
  },
  {
    "name": "In Salah",
    "iso2": "57",
    "timezone": "Africa/Algiers",
    "countryCode": "DZ"
  },
  {
    "name": "Jijel",
    "iso2": "18",
    "timezone": "Africa/Algiers",
    "countryCode": "DZ"
  },
  {
    "name": "Khenchela",
    "iso2": "40",
    "timezone": "Africa/Algiers",
    "countryCode": "DZ"
  },
  {
    "name": "Laghouat",
    "iso2": "03",
    "timezone": "Africa/Algiers",
    "countryCode": "DZ"
  },
  {
    "name": "M'Sila",
    "iso2": "28",
    "timezone": "Africa/Algiers",
    "countryCode": "DZ"
  },
  {
    "name": "Mascara",
    "iso2": "29",
    "timezone": "Africa/Algiers",
    "countryCode": "DZ"
  },
  {
    "name": "Médéa",
    "iso2": "26",
    "timezone": "Africa/Algiers",
    "countryCode": "DZ"
  },
  {
    "name": "Mila",
    "iso2": "43",
    "timezone": "Africa/Algiers",
    "countryCode": "DZ"
  },
  {
    "name": "Mostaganem",
    "iso2": "27",
    "timezone": "Africa/Algiers",
    "countryCode": "DZ"
  },
  {
    "name": "Naama",
    "iso2": "45",
    "timezone": "Africa/Algiers",
    "countryCode": "DZ"
  },
  {
    "name": "Oran",
    "iso2": "31",
    "timezone": "Africa/Algiers",
    "countryCode": "DZ"
  },
  {
    "name": "Ouargla",
    "iso2": "30",
    "timezone": "Africa/Algiers",
    "countryCode": "DZ"
  },
  {
    "name": "Ouled Djellal",
    "iso2": "51",
    "timezone": "Africa/Algiers",
    "countryCode": "DZ"
  },
  {
    "name": "Oum El Bouaghi",
    "iso2": "04",
    "timezone": "Africa/Algiers",
    "countryCode": "DZ"
  },
  {
    "name": "Relizane",
    "iso2": "48",
    "timezone": "Africa/Algiers",
    "countryCode": "DZ"
  },
  {
    "name": "Saïda",
    "iso2": "20",
    "timezone": "Africa/Algiers",
    "countryCode": "DZ"
  },
  {
    "name": "Sétif",
    "iso2": "19",
    "timezone": "Africa/Algiers",
    "countryCode": "DZ"
  },
  {
    "name": "Sidi Bel Abbès",
    "iso2": "22",
    "timezone": "Africa/Algiers",
    "countryCode": "DZ"
  },
  {
    "name": "Skikda",
    "iso2": "21",
    "timezone": "Africa/Algiers",
    "countryCode": "DZ"
  },
  {
    "name": "Souk Ahras",
    "iso2": "41",
    "timezone": "Africa/Algiers",
    "countryCode": "DZ"
  },
  {
    "name": "Tamanghasset",
    "iso2": "11",
    "timezone": "Africa/Algiers",
    "countryCode": "DZ"
  },
  {
    "name": "Tébessa",
    "iso2": "12",
    "timezone": "Africa/Algiers",
    "countryCode": "DZ"
  },
  {
    "name": "Tiaret",
    "iso2": "14",
    "timezone": "Africa/Algiers",
    "countryCode": "DZ"
  },
  {
    "name": "Timimoun",
    "iso2": "54",
    "timezone": "Africa/Algiers",
    "countryCode": "DZ"
  },
  {
    "name": "Tindouf",
    "iso2": "37",
    "timezone": "Africa/Algiers",
    "countryCode": "DZ"
  },
  {
    "name": "Tipasa",
    "iso2": "42",
    "timezone": "Africa/Algiers",
    "countryCode": "DZ"
  },
  {
    "name": "Tissemsilt",
    "iso2": "38",
    "timezone": "Africa/Algiers",
    "countryCode": "DZ"
  },
  {
    "name": "Tizi Ouzou",
    "iso2": "15",
    "timezone": "Africa/Algiers",
    "countryCode": "DZ"
  },
  {
    "name": "Tlemcen",
    "iso2": "13",
    "timezone": "Africa/Algiers",
    "countryCode": "DZ"
  },
  {
    "name": "Touggourt",
    "iso2": "55",
    "timezone": "Africa/Algiers",
    "countryCode": "DZ"
  },
  {
    "name": "Eastern",
    "iso2": "02",
    "timezone": "Pacific/Pago_Pago",
    "countryCode": "AS"
  },
  {
    "name": "Manuʻa",
    "iso2": "03",
    "timezone": "Pacific/Pago_Pago",
    "countryCode": "AS"
  },
  {
    "name": "Rose",
    "iso2": "05",
    "timezone": "Pacific/Pago_Pago",
    "countryCode": "AS"
  },
  {
    "name": "Swains",
    "iso2": "04",
    "timezone": "Pacific/Pago_Pago",
    "countryCode": "AS"
  },
  {
    "name": "Western",
    "iso2": "01",
    "timezone": "Pacific/Pago_Pago",
    "countryCode": "AS"
  },
  {
    "name": "Andorra la Vella",
    "iso2": "07",
    "timezone": "Europe/Andorra",
    "countryCode": "AD"
  },
  {
    "name": "Canillo",
    "iso2": "02",
    "timezone": "Europe/Andorra",
    "countryCode": "AD"
  },
  {
    "name": "Encamp",
    "iso2": "03",
    "timezone": "Europe/Andorra",
    "countryCode": "AD"
  },
  {
    "name": "Escaldes-Engordany",
    "iso2": "08",
    "timezone": "Europe/Andorra",
    "countryCode": "AD"
  },
  {
    "name": "La Massana",
    "iso2": "04",
    "timezone": "Europe/Andorra",
    "countryCode": "AD"
  },
  {
    "name": "Ordino",
    "iso2": "05",
    "timezone": "Europe/Andorra",
    "countryCode": "AD"
  },
  {
    "name": "Sant Julià de Lòria",
    "iso2": "06",
    "timezone": "Europe/Andorra",
    "countryCode": "AD"
  },
  {
    "name": "Bengo",
    "iso2": "BGO",
    "timezone": "Africa/Luanda",
    "countryCode": "AO"
  },
  {
    "name": "Benguela",
    "iso2": "BGU",
    "timezone": "Africa/Luanda",
    "countryCode": "AO"
  },
  {
    "name": "Bié",
    "iso2": "BIE",
    "timezone": "Africa/Luanda",
    "countryCode": "AO"
  },
  {
    "name": "Cabinda",
    "iso2": "CAB",
    "timezone": "Africa/Luanda",
    "countryCode": "AO"
  },
  {
    "name": "Cuando Cubango",
    "iso2": "CCU",
    "timezone": "Africa/Luanda",
    "countryCode": "AO"
  },
  {
    "name": "Cuanza",
    "iso2": "CUS",
    "timezone": "Africa/Luanda",
    "countryCode": "AO"
  },
  {
    "name": "Cuanza Norte",
    "iso2": "CNO",
    "timezone": "Africa/Luanda",
    "countryCode": "AO"
  },
  {
    "name": "Cunene",
    "iso2": "CNN",
    "timezone": "Africa/Luanda",
    "countryCode": "AO"
  },
  {
    "name": "Huambo",
    "iso2": "HUA",
    "timezone": "Africa/Luanda",
    "countryCode": "AO"
  },
  {
    "name": "Huíla",
    "iso2": "HUI",
    "timezone": "Africa/Luanda",
    "countryCode": "AO"
  },
  {
    "name": "Luanda",
    "iso2": "LUA",
    "timezone": "Africa/Luanda",
    "countryCode": "AO"
  },
  {
    "name": "Lunda Norte",
    "iso2": "LNO",
    "timezone": "Africa/Luanda",
    "countryCode": "AO"
  },
  {
    "name": "Lunda Sul",
    "iso2": "LSU",
    "timezone": "Africa/Luanda",
    "countryCode": "AO"
  },
  {
    "name": "Malanje",
    "iso2": "MAL",
    "timezone": "Africa/Luanda",
    "countryCode": "AO"
  },
  {
    "name": "Moxico",
    "iso2": "MOX",
    "timezone": "Africa/Luanda",
    "countryCode": "AO"
  },
  {
    "name": "Namibe",
    "iso2": "NAM",
    "timezone": "Africa/Luanda",
    "countryCode": "AO"
  },
  {
    "name": "Uíge",
    "iso2": "UIG",
    "timezone": "Africa/Luanda",
    "countryCode": "AO"
  },
  {
    "name": "Zaire",
    "iso2": "ZAI",
    "timezone": "Africa/Luanda",
    "countryCode": "AO"
  },
  {
    "name": "Blowing Point",
    "iso2": "01",
    "timezone": "America/Anguilla",
    "countryCode": "AI"
  },
  {
    "name": "East End",
    "iso2": "02",
    "timezone": "America/Anguilla",
    "countryCode": "AI"
  },
  {
    "name": "George Hill",
    "iso2": "03",
    "timezone": "America/Anguilla",
    "countryCode": "AI"
  },
  {
    "name": "Island Harbour",
    "iso2": "04",
    "timezone": "America/Anguilla",
    "countryCode": "AI"
  },
  {
    "name": "North Hill",
    "iso2": "05",
    "timezone": "America/Anguilla",
    "countryCode": "AI"
  },
  {
    "name": "North Side",
    "iso2": "06",
    "timezone": "America/Anguilla",
    "countryCode": "AI"
  },
  {
    "name": "Sandy Ground",
    "iso2": "07",
    "timezone": "America/Anguilla",
    "countryCode": "AI"
  },
  {
    "name": "Sandy Hill",
    "iso2": "08",
    "timezone": "America/Anguilla",
    "countryCode": "AI"
  },
  {
    "name": "South Hill",
    "iso2": "09",
    "timezone": "America/Anguilla",
    "countryCode": "AI"
  },
  {
    "name": "Stoney Ground",
    "iso2": "10",
    "timezone": "America/Anguilla",
    "countryCode": "AI"
  },
  {
    "name": "The Farrington",
    "iso2": "11",
    "timezone": "America/Anguilla",
    "countryCode": "AI"
  },
  {
    "name": "The Quarter",
    "iso2": "12",
    "timezone": "America/Anguilla",
    "countryCode": "AI"
  },
  {
    "name": "The Valley",
    "iso2": "13",
    "timezone": "America/Anguilla",
    "countryCode": "AI"
  },
  {
    "name": "West End",
    "iso2": "14",
    "timezone": "America/Anguilla",
    "countryCode": "AI"
  },
  {
    "name": "Barbuda",
    "iso2": "10",
    "timezone": "America/Antigua",
    "countryCode": "AG"
  },
  {
    "name": "Redonda",
    "iso2": "11",
    "timezone": "America/Antigua",
    "countryCode": "AG"
  },
  {
    "name": "Saint George",
    "iso2": "03",
    "timezone": "America/Antigua",
    "countryCode": "AG"
  },
  {
    "name": "Saint John",
    "iso2": "04",
    "timezone": "America/Antigua",
    "countryCode": "AG"
  },
  {
    "name": "Saint Mary",
    "iso2": "05",
    "timezone": "America/Antigua",
    "countryCode": "AG"
  },
  {
    "name": "Saint Paul",
    "iso2": "06",
    "timezone": "America/Antigua",
    "countryCode": "AG"
  },
  {
    "name": "Saint Peter",
    "iso2": "07",
    "timezone": "America/Antigua",
    "countryCode": "AG"
  },
  {
    "name": "Saint Philip",
    "iso2": "08",
    "timezone": "America/Antigua",
    "countryCode": "AG"
  },
  {
    "name": "Autonomous City of Buenos Aires",
    "iso2": "C",
    "timezone": "America/Argentina/Buenos_Aires",
    "countryCode": "AR"
  },
  {
    "name": "Buenos Aires",
    "iso2": "B",
    "timezone": "America/Argentina/Buenos_Aires",
    "countryCode": "AR"
  },
  {
    "name": "Catamarca",
    "iso2": "K",
    "timezone": "America/Argentina/Catamarca",
    "countryCode": "AR"
  },
  {
    "name": "Chaco",
    "iso2": "H",
    "timezone": "America/Argentina/Cordoba",
    "countryCode": "AR"
  },
  {
    "name": "Chubut",
    "iso2": "U",
    "timezone": "America/Argentina/Catamarca",
    "countryCode": "AR"
  },
  {
    "name": "Córdoba",
    "iso2": "X",
    "timezone": "America/Argentina/Cordoba",
    "countryCode": "AR"
  },
  {
    "name": "Corrientes",
    "iso2": "W",
    "timezone": "America/Argentina/Cordoba",
    "countryCode": "AR"
  },
  {
    "name": "Entre Ríos",
    "iso2": "E",
    "timezone": "America/Argentina/Cordoba",
    "countryCode": "AR"
  },
  {
    "name": "Formosa",
    "iso2": "P",
    "timezone": "America/Argentina/Cordoba",
    "countryCode": "AR"
  },
  {
    "name": "Jujuy",
    "iso2": "Y",
    "timezone": "America/Argentina/Jujuy",
    "countryCode": "AR"
  },
  {
    "name": "La Pampa",
    "iso2": "L",
    "timezone": "America/Argentina/Buenos_Aires",
    "countryCode": "AR"
  },
  {
    "name": "La Rioja",
    "iso2": "F",
    "timezone": "America/Argentina/La_Rioja",
    "countryCode": "AR"
  },
  {
    "name": "Mendoza",
    "iso2": "M",
    "timezone": "America/Argentina/Mendoza",
    "countryCode": "AR"
  },
  {
    "name": "Misiones",
    "iso2": "N",
    "timezone": "America/Argentina/Cordoba",
    "countryCode": "AR"
  },
  {
    "name": "Neuquén",
    "iso2": "Q",
    "timezone": "America/Argentina/Salta",
    "countryCode": "AR"
  },
  {
    "name": "Río Negro",
    "iso2": "R",
    "timezone": "America/Argentina/Salta",
    "countryCode": "AR"
  },
  {
    "name": "Salta",
    "iso2": "A",
    "timezone": "America/Argentina/Salta",
    "countryCode": "AR"
  },
  {
    "name": "San Juan",
    "iso2": "J",
    "timezone": "America/Argentina/San_Juan",
    "countryCode": "AR"
  },
  {
    "name": "San Luis",
    "iso2": "D",
    "timezone": "America/Argentina/San_Luis",
    "countryCode": "AR"
  },
  {
    "name": "Santa Cruz",
    "iso2": "Z",
    "timezone": "America/Argentina/Rio_Gallegos",
    "countryCode": "AR"
  },
  {
    "name": "Santa Fe",
    "iso2": "S",
    "timezone": "America/Argentina/Cordoba",
    "countryCode": "AR"
  },
  {
    "name": "Santiago del Estero",
    "iso2": "G",
    "timezone": "America/Argentina/Cordoba",
    "countryCode": "AR"
  },
  {
    "name": "Tierra del Fuego",
    "iso2": "V",
    "timezone": "America/Argentina/Ushuaia",
    "countryCode": "AR"
  },
  {
    "name": "Tucumán",
    "iso2": "T",
    "timezone": "America/Argentina/Tucuman",
    "countryCode": "AR"
  },
  {
    "name": "Aragatsotn",
    "iso2": "AG",
    "timezone": "Asia/Yerevan",
    "countryCode": "AM"
  },
  {
    "name": "Ararat",
    "iso2": "AR",
    "timezone": "Asia/Yerevan",
    "countryCode": "AM"
  },
  {
    "name": "Armavir",
    "iso2": "AV",
    "timezone": "Asia/Yerevan",
    "countryCode": "AM"
  },
  {
    "name": "Gegharkunik",
    "iso2": "GR",
    "timezone": "Asia/Yerevan",
    "countryCode": "AM"
  },
  {
    "name": "Kotayk",
    "iso2": "KT",
    "timezone": "Asia/Yerevan",
    "countryCode": "AM"
  },
  {
    "name": "Lori",
    "iso2": "LO",
    "timezone": "Asia/Yerevan",
    "countryCode": "AM"
  },
  {
    "name": "Shirak",
    "iso2": "SH",
    "timezone": "Asia/Yerevan",
    "countryCode": "AM"
  },
  {
    "name": "Syunik",
    "iso2": "SU",
    "timezone": "Asia/Yerevan",
    "countryCode": "AM"
  },
  {
    "name": "Tavush",
    "iso2": "TV",
    "timezone": "Asia/Yerevan",
    "countryCode": "AM"
  },
  {
    "name": "Vayots Dzor",
    "iso2": "VD",
    "timezone": "Asia/Yerevan",
    "countryCode": "AM"
  },
  {
    "name": "Yerevan",
    "iso2": "ER",
    "timezone": "Asia/Yerevan",
    "countryCode": "AM"
  },
  {
    "name": "Noord",
    "iso2": "01",
    "timezone": "America/Aruba",
    "countryCode": "AW"
  },
  {
    "name": "Oranjestad",
    "iso2": "09",
    "timezone": "America/Aruba",
    "countryCode": "AW"
  },
  {
    "name": "Oranjestad East",
    "iso2": "03",
    "timezone": "America/Aruba",
    "countryCode": "AW"
  },
  {
    "name": "Oranjestad West",
    "iso2": "02",
    "timezone": "America/Aruba",
    "countryCode": "AW"
  },
  {
    "name": "Paradera",
    "iso2": "04",
    "timezone": "America/Aruba",
    "countryCode": "AW"
  },
  {
    "name": "San Nicolaas Noord",
    "iso2": "05",
    "timezone": "America/Aruba",
    "countryCode": "AW"
  },
  {
    "name": "San Nicolaas Zuid",
    "iso2": "06",
    "timezone": "America/Aruba",
    "countryCode": "AW"
  },
  {
    "name": "Santa Cruz",
    "iso2": "07",
    "timezone": "America/Aruba",
    "countryCode": "AW"
  },
  {
    "name": "Savaneta",
    "iso2": "08",
    "timezone": "America/Aruba",
    "countryCode": "AW"
  },
  {
    "name": "Australian Capital Territory",
    "iso2": "ACT",
    "timezone": "Australia/Sydney",
    "countryCode": "AU"
  },
  {
    "name": "New South Wales",
    "iso2": "NSW",
    "timezone": "Australia/Sydney",
    "countryCode": "AU"
  },
  {
    "name": "Northern Territory",
    "iso2": "NT",
    "timezone": "Australia/Darwin",
    "countryCode": "AU"
  },
  {
    "name": "Queensland",
    "iso2": "QLD",
    "timezone": "Australia/Brisbane",
    "countryCode": "AU"
  },
  {
    "name": "South Australia",
    "iso2": "SA",
    "timezone": "Australia/Adelaide",
    "countryCode": "AU"
  },
  {
    "name": "Tasmania",
    "iso2": "TAS",
    "timezone": "Australia/Hobart",
    "countryCode": "AU"
  },
  {
    "name": "Victoria",
    "iso2": "VIC",
    "timezone": "Australia/Melbourne",
    "countryCode": "AU"
  },
  {
    "name": "Western Australia",
    "iso2": "WA",
    "timezone": "Australia/Perth",
    "countryCode": "AU"
  },
  {
    "name": "Burgenland",
    "iso2": "1",
    "timezone": "Europe/Vienna",
    "countryCode": "AT"
  },
  {
    "name": "Carinthia",
    "iso2": "2",
    "timezone": "Europe/Vienna",
    "countryCode": "AT"
  },
  {
    "name": "Lower Austria",
    "iso2": "3",
    "timezone": "Europe/Vienna",
    "countryCode": "AT"
  },
  {
    "name": "Salzburg",
    "iso2": "5",
    "timezone": "Europe/Vienna",
    "countryCode": "AT"
  },
  {
    "name": "Styria",
    "iso2": "6",
    "timezone": "Europe/Vienna",
    "countryCode": "AT"
  },
  {
    "name": "Tyrol",
    "iso2": "7",
    "timezone": "Europe/Vienna",
    "countryCode": "AT"
  },
  {
    "name": "Upper Austria",
    "iso2": "4",
    "timezone": "Europe/Vienna",
    "countryCode": "AT"
  },
  {
    "name": "Vienna",
    "iso2": "9",
    "timezone": "Europe/Vienna",
    "countryCode": "AT"
  },
  {
    "name": "Vorarlberg",
    "iso2": "8",
    "timezone": "Europe/Vienna",
    "countryCode": "AT"
  },
  {
    "name": "Absheron",
    "iso2": "ABS",
    "timezone": "Asia/Baku",
    "countryCode": "AZ"
  },
  {
    "name": "Agdam",
    "iso2": "AGM",
    "timezone": "Asia/Baku",
    "countryCode": "AZ"
  },
  {
    "name": "Agdash",
    "iso2": "AGS",
    "timezone": "Asia/Baku",
    "countryCode": "AZ"
  },
  {
    "name": "Aghjabadi",
    "iso2": "AGC",
    "timezone": "Asia/Baku",
    "countryCode": "AZ"
  },
  {
    "name": "Agstafa",
    "iso2": "AGA",
    "timezone": "Asia/Baku",
    "countryCode": "AZ"
  },
  {
    "name": "Agsu",
    "iso2": "AGU",
    "timezone": "Asia/Baku",
    "countryCode": "AZ"
  },
  {
    "name": "Astara",
    "iso2": "AST",
    "timezone": "Asia/Baku",
    "countryCode": "AZ"
  },
  {
    "name": "Babek",
    "iso2": "BAB",
    "timezone": "Asia/Baku",
    "countryCode": "AZ"
  },
  {
    "name": "Baku",
    "iso2": "BA",
    "timezone": "Asia/Baku",
    "countryCode": "AZ"
  },
  {
    "name": "Balakan",
    "iso2": "BAL",
    "timezone": "Asia/Baku",
    "countryCode": "AZ"
  },
  {
    "name": "Barda",
    "iso2": "BAR",
    "timezone": "Asia/Baku",
    "countryCode": "AZ"
  },
  {
    "name": "Beylagan",
    "iso2": "BEY",
    "timezone": "Asia/Baku",
    "countryCode": "AZ"
  },
  {
    "name": "Bilasuvar",
    "iso2": "BIL",
    "timezone": "Asia/Baku",
    "countryCode": "AZ"
  },
  {
    "name": "Dashkasan",
    "iso2": "DAS",
    "timezone": "Asia/Baku",
    "countryCode": "AZ"
  },
  {
    "name": "Fizuli",
    "iso2": "FUZ",
    "timezone": "Asia/Baku",
    "countryCode": "AZ"
  },
  {
    "name": "Ganja",
    "iso2": "GA",
    "timezone": "Asia/Baku",
    "countryCode": "AZ"
  },
  {
    "name": "Gədəbəy",
    "iso2": "GAD",
    "timezone": "Asia/Baku",
    "countryCode": "AZ"
  },
  {
    "name": "Gobustan",
    "iso2": "QOB",
    "timezone": "Asia/Baku",
    "countryCode": "AZ"
  },
  {
    "name": "Goranboy",
    "iso2": "GOR",
    "timezone": "Asia/Baku",
    "countryCode": "AZ"
  },
  {
    "name": "Goychay",
    "iso2": "GOY",
    "timezone": "Asia/Baku",
    "countryCode": "AZ"
  },
  {
    "name": "Goygol",
    "iso2": "GYG",
    "timezone": "Asia/Baku",
    "countryCode": "AZ"
  },
  {
    "name": "Hajigabul",
    "iso2": "HAC",
    "timezone": "Asia/Baku",
    "countryCode": "AZ"
  },
  {
    "name": "Imishli",
    "iso2": "IMI",
    "timezone": "Asia/Baku",
    "countryCode": "AZ"
  },
  {
    "name": "Ismailli",
    "iso2": "ISM",
    "timezone": "Asia/Baku",
    "countryCode": "AZ"
  },
  {
    "name": "Jabrayil",
    "iso2": "CAB",
    "timezone": "Asia/Baku",
    "countryCode": "AZ"
  },
  {
    "name": "Jalilabad",
    "iso2": "CAL",
    "timezone": "Asia/Baku",
    "countryCode": "AZ"
  },
  {
    "name": "Julfa",
    "iso2": "CUL",
    "timezone": "Asia/Baku",
    "countryCode": "AZ"
  },
  {
    "name": "Kalbajar",
    "iso2": "KAL",
    "timezone": "Asia/Baku",
    "countryCode": "AZ"
  },
  {
    "name": "Kangarli",
    "iso2": "KAN",
    "timezone": "Asia/Baku",
    "countryCode": "AZ"
  },
  {
    "name": "Khachmaz",
    "iso2": "XAC",
    "timezone": "Asia/Baku",
    "countryCode": "AZ"
  },
  {
    "name": "Khankendi",
    "iso2": "XA",
    "timezone": "Asia/Baku",
    "countryCode": "AZ"
  },
  {
    "name": "Khizi",
    "iso2": "XIZ",
    "timezone": "Asia/Baku",
    "countryCode": "AZ"
  },
  {
    "name": "Khojali",
    "iso2": "XCI",
    "timezone": "Asia/Baku",
    "countryCode": "AZ"
  },
  {
    "name": "Kurdamir",
    "iso2": "KUR",
    "timezone": "Asia/Baku",
    "countryCode": "AZ"
  },
  {
    "name": "Lachin",
    "iso2": "LAC",
    "timezone": "Asia/Baku",
    "countryCode": "AZ"
  },
  {
    "name": "Lankaran",
    "iso2": "LAN",
    "timezone": "Asia/Baku",
    "countryCode": "AZ"
  },
  {
    "name": "Lankaran",
    "iso2": "LA",
    "timezone": "Asia/Baku",
    "countryCode": "AZ"
  },
  {
    "name": "Lerik",
    "iso2": "LER",
    "timezone": "Asia/Baku",
    "countryCode": "AZ"
  },
  {
    "name": "Martuni",
    "iso2": "XVD",
    "timezone": "Asia/Baku",
    "countryCode": "AZ"
  },
  {
    "name": "Masally",
    "iso2": "MAS",
    "timezone": "Asia/Baku",
    "countryCode": "AZ"
  },
  {
    "name": "Mingachevir",
    "iso2": "MI",
    "timezone": "Asia/Baku",
    "countryCode": "AZ"
  },
  {
    "name": "Naftalan",
    "iso2": "NA",
    "timezone": "Asia/Baku",
    "countryCode": "AZ"
  },
  {
    "name": "Nakhchivan",
    "iso2": "NV",
    "timezone": "Asia/Baku",
    "countryCode": "AZ"
  },
  {
    "name": "Nakhchivan",
    "iso2": "NX",
    "timezone": "Asia/Baku",
    "countryCode": "AZ"
  },
  {
    "name": "Neftchala",
    "iso2": "NEF",
    "timezone": "Asia/Baku",
    "countryCode": "AZ"
  },
  {
    "name": "Oghuz",
    "iso2": "OGU",
    "timezone": "Asia/Baku",
    "countryCode": "AZ"
  },
  {
    "name": "Ordubad",
    "iso2": "ORD",
    "timezone": "Asia/Baku",
    "countryCode": "AZ"
  },
  {
    "name": "Qabala",
    "iso2": "QAB",
    "timezone": "Asia/Baku",
    "countryCode": "AZ"
  },
  {
    "name": "Qakh",
    "iso2": "QAX",
    "timezone": "Asia/Baku",
    "countryCode": "AZ"
  },
  {
    "name": "Qazakh",
    "iso2": "QAZ",
    "timezone": "Asia/Baku",
    "countryCode": "AZ"
  },
  {
    "name": "Quba",
    "iso2": "QBA",
    "timezone": "Asia/Baku",
    "countryCode": "AZ"
  },
  {
    "name": "Qubadli",
    "iso2": "QBI",
    "timezone": "Asia/Baku",
    "countryCode": "AZ"
  },
  {
    "name": "Qusar",
    "iso2": "QUS",
    "timezone": "Asia/Baku",
    "countryCode": "AZ"
  },
  {
    "name": "Saatly",
    "iso2": "SAT",
    "timezone": "Asia/Baku",
    "countryCode": "AZ"
  },
  {
    "name": "Sabirabad",
    "iso2": "SAB",
    "timezone": "Asia/Baku",
    "countryCode": "AZ"
  },
  {
    "name": "Sadarak",
    "iso2": "SAD",
    "timezone": "Asia/Baku",
    "countryCode": "AZ"
  },
  {
    "name": "Salyan",
    "iso2": "SAL",
    "timezone": "Asia/Baku",
    "countryCode": "AZ"
  },
  {
    "name": "Samukh",
    "iso2": "SMX",
    "timezone": "Asia/Baku",
    "countryCode": "AZ"
  },
  {
    "name": "Shabran",
    "iso2": "SBN",
    "timezone": "Asia/Baku",
    "countryCode": "AZ"
  },
  {
    "name": "Shahbuz",
    "iso2": "SAH",
    "timezone": "Asia/Baku",
    "countryCode": "AZ"
  },
  {
    "name": "Shaki",
    "iso2": "SA",
    "timezone": "Asia/Baku",
    "countryCode": "AZ"
  },
  {
    "name": "Shaki",
    "iso2": "SAK",
    "timezone": "Asia/Baku",
    "countryCode": "AZ"
  },
  {
    "name": "Shamakhi",
    "iso2": "SMI",
    "timezone": "Asia/Baku",
    "countryCode": "AZ"
  },
  {
    "name": "Shamkir",
    "iso2": "SKR",
    "timezone": "Asia/Baku",
    "countryCode": "AZ"
  },
  {
    "name": "Sharur",
    "iso2": "SAR",
    "timezone": "Asia/Baku",
    "countryCode": "AZ"
  },
  {
    "name": "Shirvan",
    "iso2": "SR",
    "timezone": "Asia/Baku",
    "countryCode": "AZ"
  },
  {
    "name": "Shusha",
    "iso2": "SUS",
    "timezone": "Asia/Baku",
    "countryCode": "AZ"
  },
  {
    "name": "Siazan",
    "iso2": "SIY",
    "timezone": "Asia/Baku",
    "countryCode": "AZ"
  },
  {
    "name": "Sumqayit",
    "iso2": "SM",
    "timezone": "Asia/Baku",
    "countryCode": "AZ"
  },
  {
    "name": "Tartar",
    "iso2": "TAR",
    "timezone": "Asia/Baku",
    "countryCode": "AZ"
  },
  {
    "name": "Tovuz",
    "iso2": "TOV",
    "timezone": "Asia/Baku",
    "countryCode": "AZ"
  },
  {
    "name": "Ujar",
    "iso2": "UCA",
    "timezone": "Asia/Baku",
    "countryCode": "AZ"
  },
  {
    "name": "Yardymli",
    "iso2": "YAR",
    "timezone": "Asia/Baku",
    "countryCode": "AZ"
  },
  {
    "name": "Yevlakh",
    "iso2": "YEV",
    "timezone": "Asia/Baku",
    "countryCode": "AZ"
  },
  {
    "name": "Yevlakh",
    "iso2": "YE",
    "timezone": "Asia/Baku",
    "countryCode": "AZ"
  },
  {
    "name": "Zangilan",
    "iso2": "ZAN",
    "timezone": "Asia/Baku",
    "countryCode": "AZ"
  },
  {
    "name": "Zaqatala",
    "iso2": "ZAQ",
    "timezone": "Asia/Baku",
    "countryCode": "AZ"
  },
  {
    "name": "Zardab",
    "iso2": "ZAR",
    "timezone": "Asia/Baku",
    "countryCode": "AZ"
  },
  {
    "name": "Capital",
    "iso2": "13",
    "timezone": "Asia/Bahrain",
    "countryCode": "BH"
  },
  {
    "name": "Muharraq",
    "iso2": "15",
    "timezone": "Asia/Bahrain",
    "countryCode": "BH"
  },
  {
    "name": "Northern",
    "iso2": "17",
    "timezone": "Asia/Bahrain",
    "countryCode": "BH"
  },
  {
    "name": "Southern",
    "iso2": "14",
    "timezone": "Asia/Bahrain",
    "countryCode": "BH"
  },
  {
    "name": "Bagerhat",
    "iso2": "05",
    "timezone": "Asia/Dhaka",
    "countryCode": "BD"
  },
  {
    "name": "Bandarban",
    "iso2": "01",
    "timezone": "Asia/Dhaka",
    "countryCode": "BD"
  },
  {
    "name": "Barguna",
    "iso2": "02",
    "timezone": "Asia/Dhaka",
    "countryCode": "BD"
  },
  {
    "name": "Barisal ",
    "iso2": "A",
    "timezone": "Asia/Dhaka",
    "countryCode": "BD"
  },
  {
    "name": "Barishal",
    "iso2": "06",
    "timezone": "Asia/Dhaka",
    "countryCode": "BD"
  },
  {
    "name": "Bhola",
    "iso2": "07",
    "timezone": "Asia/Dhaka",
    "countryCode": "BD"
  },
  {
    "name": "Bogura",
    "iso2": "03",
    "timezone": "Asia/Dhaka",
    "countryCode": "BD"
  },
  {
    "name": "Brahmanbaria",
    "iso2": "04",
    "timezone": "Asia/Dhaka",
    "countryCode": "BD"
  },
  {
    "name": "Chandpur",
    "iso2": "09",
    "timezone": "Asia/Dhaka",
    "countryCode": "BD"
  },
  {
    "name": "Chapai Nawabganj",
    "iso2": "45",
    "timezone": "Asia/Dhaka",
    "countryCode": "BD"
  },
  {
    "name": "Chattogram",
    "iso2": "10",
    "timezone": "Asia/Dhaka",
    "countryCode": "BD"
  },
  {
    "name": "Chittagong ",
    "iso2": "B",
    "timezone": "Asia/Dhaka",
    "countryCode": "BD"
  },
  {
    "name": "Chuadanga",
    "iso2": "12",
    "timezone": "Asia/Dhaka",
    "countryCode": "BD"
  },
  {
    "name": "Cox's Bazar",
    "iso2": "11",
    "timezone": "Asia/Dhaka",
    "countryCode": "BD"
  },
  {
    "name": "Cumilla",
    "iso2": "08",
    "timezone": "Asia/Dhaka",
    "countryCode": "BD"
  },
  {
    "name": "Dhaka",
    "iso2": "13",
    "timezone": "Asia/Dhaka",
    "countryCode": "BD"
  },
  {
    "name": "Dhaka ",
    "iso2": "C",
    "timezone": "Asia/Dhaka",
    "countryCode": "BD"
  },
  {
    "name": "Dinajpur",
    "iso2": "14",
    "timezone": "Asia/Dhaka",
    "countryCode": "BD"
  },
  {
    "name": "Faridpur",
    "iso2": "15",
    "timezone": "Asia/Dhaka",
    "countryCode": "BD"
  },
  {
    "name": "Feni",
    "iso2": "16",
    "timezone": "Asia/Dhaka",
    "countryCode": "BD"
  },
  {
    "name": "Gaibandha",
    "iso2": "19",
    "timezone": "Asia/Dhaka",
    "countryCode": "BD"
  },
  {
    "name": "Gazipur",
    "iso2": "18",
    "timezone": "Asia/Dhaka",
    "countryCode": "BD"
  },
  {
    "name": "Gopalganj",
    "iso2": "17",
    "timezone": "Asia/Dhaka",
    "countryCode": "BD"
  },
  {
    "name": "Habiganj",
    "iso2": "20",
    "timezone": "Asia/Dhaka",
    "countryCode": "BD"
  },
  {
    "name": "Jamalpur",
    "iso2": "21",
    "timezone": "Asia/Dhaka",
    "countryCode": "BD"
  },
  {
    "name": "Jashore",
    "iso2": "22",
    "timezone": "Asia/Dhaka",
    "countryCode": "BD"
  },
  {
    "name": "Jhalakathi",
    "iso2": "25",
    "timezone": "Asia/Dhaka",
    "countryCode": "BD"
  },
  {
    "name": "Jhenaidah",
    "iso2": "23",
    "timezone": "Asia/Dhaka",
    "countryCode": "BD"
  },
  {
    "name": "Joypurhat",
    "iso2": "24",
    "timezone": "Asia/Dhaka",
    "countryCode": "BD"
  },
  {
    "name": "Khagrachhari",
    "iso2": "29",
    "timezone": "Asia/Dhaka",
    "countryCode": "BD"
  },
  {
    "name": "Khulna",
    "iso2": "27",
    "timezone": "Asia/Dhaka",
    "countryCode": "BD"
  },
  {
    "name": "Khulna ",
    "iso2": "D",
    "timezone": "Asia/Dhaka",
    "countryCode": "BD"
  },
  {
    "name": "Kishoreganj",
    "iso2": "26",
    "timezone": "Asia/Dhaka",
    "countryCode": "BD"
  },
  {
    "name": "Kurigram",
    "iso2": "28",
    "timezone": "Asia/Dhaka",
    "countryCode": "BD"
  },
  {
    "name": "Kushtia",
    "iso2": "30",
    "timezone": "Asia/Dhaka",
    "countryCode": "BD"
  },
  {
    "name": "Lakshmipur",
    "iso2": "31",
    "timezone": "Asia/Dhaka",
    "countryCode": "BD"
  },
  {
    "name": "Lalmonirhat",
    "iso2": "32",
    "timezone": "Asia/Dhaka",
    "countryCode": "BD"
  },
  {
    "name": "Madaripur",
    "iso2": "36",
    "timezone": "Asia/Dhaka",
    "countryCode": "BD"
  },
  {
    "name": "Magura",
    "iso2": "37",
    "timezone": "Asia/Dhaka",
    "countryCode": "BD"
  },
  {
    "name": "Manikganj",
    "iso2": "33",
    "timezone": "Asia/Dhaka",
    "countryCode": "BD"
  },
  {
    "name": "Meherpur",
    "iso2": "39",
    "timezone": "Asia/Dhaka",
    "countryCode": "BD"
  },
  {
    "name": "Moulvibazar",
    "iso2": "38",
    "timezone": "Asia/Dhaka",
    "countryCode": "BD"
  },
  {
    "name": "Munshiganj",
    "iso2": "35",
    "timezone": "Asia/Dhaka",
    "countryCode": "BD"
  },
  {
    "name": "Mymensingh",
    "iso2": "34",
    "timezone": "Asia/Dhaka",
    "countryCode": "BD"
  },
  {
    "name": "Mymensingh ",
    "iso2": "H",
    "timezone": "Asia/Dhaka",
    "countryCode": "BD"
  },
  {
    "name": "Naogaon",
    "iso2": "48",
    "timezone": "Asia/Dhaka",
    "countryCode": "BD"
  },
  {
    "name": "Narail",
    "iso2": "43",
    "timezone": "Asia/Dhaka",
    "countryCode": "BD"
  },
  {
    "name": "Narayanganj",
    "iso2": "40",
    "timezone": "Asia/Dhaka",
    "countryCode": "BD"
  },
  {
    "name": "Narsingdi",
    "iso2": "42",
    "timezone": "Asia/Dhaka",
    "countryCode": "BD"
  },
  {
    "name": "Natore",
    "iso2": "44",
    "timezone": "Asia/Dhaka",
    "countryCode": "BD"
  },
  {
    "name": "Netrakona",
    "iso2": "41",
    "timezone": "Asia/Dhaka",
    "countryCode": "BD"
  },
  {
    "name": "Nilphamari",
    "iso2": "46",
    "timezone": "Asia/Dhaka",
    "countryCode": "BD"
  },
  {
    "name": "Noakhali",
    "iso2": "47",
    "timezone": "Asia/Dhaka",
    "countryCode": "BD"
  },
  {
    "name": "Pabna",
    "iso2": "49",
    "timezone": "Asia/Dhaka",
    "countryCode": "BD"
  },
  {
    "name": "Panchagarh",
    "iso2": "52",
    "timezone": "Asia/Dhaka",
    "countryCode": "BD"
  },
  {
    "name": "Patuakhali",
    "iso2": "51",
    "timezone": "Asia/Dhaka",
    "countryCode": "BD"
  },
  {
    "name": "Pirojpur",
    "iso2": "50",
    "timezone": "Asia/Dhaka",
    "countryCode": "BD"
  },
  {
    "name": "Rajbari",
    "iso2": "53",
    "timezone": "Asia/Dhaka",
    "countryCode": "BD"
  },
  {
    "name": "Rajshahi",
    "iso2": "54",
    "timezone": "Asia/Dhaka",
    "countryCode": "BD"
  },
  {
    "name": "Rajshahi ",
    "iso2": "E",
    "timezone": "Asia/Dhaka",
    "countryCode": "BD"
  },
  {
    "name": "Rangamati",
    "iso2": "56",
    "timezone": "Asia/Dhaka",
    "countryCode": "BD"
  },
  {
    "name": "Rangpur ",
    "iso2": "F",
    "timezone": "Asia/Dhaka",
    "countryCode": "BD"
  },
  {
    "name": "Rangpur",
    "iso2": "55",
    "timezone": "Asia/Dhaka",
    "countryCode": "BD"
  },
  {
    "name": "Satkhira",
    "iso2": "58",
    "timezone": "Asia/Dhaka",
    "countryCode": "BD"
  },
  {
    "name": "Shariatpur",
    "iso2": "62",
    "timezone": "Asia/Dhaka",
    "countryCode": "BD"
  },
  {
    "name": "Sherpur",
    "iso2": "57",
    "timezone": "Asia/Dhaka",
    "countryCode": "BD"
  },
  {
    "name": "Sirajganj",
    "iso2": "59",
    "timezone": "Asia/Dhaka",
    "countryCode": "BD"
  },
  {
    "name": "Sunamganj",
    "iso2": "61",
    "timezone": "Asia/Dhaka",
    "countryCode": "BD"
  },
  {
    "name": "Sylhet ",
    "iso2": "G",
    "timezone": "Asia/Dhaka",
    "countryCode": "BD"
  },
  {
    "name": "Sylhet",
    "iso2": "60",
    "timezone": "Asia/Dhaka",
    "countryCode": "BD"
  },
  {
    "name": "Tangail",
    "iso2": "63",
    "timezone": "Asia/Dhaka",
    "countryCode": "BD"
  },
  {
    "name": "Thakurgaon",
    "iso2": "64",
    "timezone": "Asia/Dhaka",
    "countryCode": "BD"
  },
  {
    "name": "Christ Church",
    "iso2": "01",
    "timezone": "America/Barbados",
    "countryCode": "BB"
  },
  {
    "name": "Saint Andrew",
    "iso2": "02",
    "timezone": "America/Barbados",
    "countryCode": "BB"
  },
  {
    "name": "Saint George",
    "iso2": "03",
    "timezone": "America/Barbados",
    "countryCode": "BB"
  },
  {
    "name": "Saint James",
    "iso2": "04",
    "timezone": "America/Barbados",
    "countryCode": "BB"
  },
  {
    "name": "Saint John",
    "iso2": "05",
    "timezone": "America/Barbados",
    "countryCode": "BB"
  },
  {
    "name": "Saint Joseph",
    "iso2": "06",
    "timezone": "America/Barbados",
    "countryCode": "BB"
  },
  {
    "name": "Saint Lucy",
    "iso2": "07",
    "timezone": "America/Barbados",
    "countryCode": "BB"
  },
  {
    "name": "Saint Michael",
    "iso2": "08",
    "timezone": "America/Barbados",
    "countryCode": "BB"
  },
  {
    "name": "Saint Peter",
    "iso2": "09",
    "timezone": "America/Barbados",
    "countryCode": "BB"
  },
  {
    "name": "Saint Philip",
    "iso2": "10",
    "timezone": "America/Barbados",
    "countryCode": "BB"
  },
  {
    "name": "Saint Thomas",
    "iso2": "11",
    "timezone": "America/Barbados",
    "countryCode": "BB"
  },
  {
    "name": "Brest",
    "iso2": "BR",
    "timezone": "Europe/Minsk",
    "countryCode": "BY"
  },
  {
    "name": "Gomel",
    "iso2": "HO",
    "timezone": "Europe/Minsk",
    "countryCode": "BY"
  },
  {
    "name": "Grodno",
    "iso2": "HR",
    "timezone": "Europe/Minsk",
    "countryCode": "BY"
  },
  {
    "name": "Minsk",
    "iso2": "MI",
    "timezone": "Europe/Minsk",
    "countryCode": "BY"
  },
  {
    "name": "Minsk",
    "iso2": "HM",
    "timezone": "Europe/Minsk",
    "countryCode": "BY"
  },
  {
    "name": "Mogilev",
    "iso2": "MA",
    "timezone": "Europe/Minsk",
    "countryCode": "BY"
  },
  {
    "name": "Vitebsk",
    "iso2": "VI",
    "timezone": "Europe/Minsk",
    "countryCode": "BY"
  },
  {
    "name": "Antwerp",
    "iso2": "VAN",
    "timezone": "Europe/Brussels",
    "countryCode": "BE"
  },
  {
    "name": "Brussels-Capital ",
    "iso2": "BRU",
    "timezone": "Europe/Brussels",
    "countryCode": "BE"
  },
  {
    "name": "East Flanders",
    "iso2": "VOV",
    "timezone": "Europe/Brussels",
    "countryCode": "BE"
  },
  {
    "name": "Flanders",
    "iso2": "VLG",
    "timezone": "Europe/Brussels",
    "countryCode": "BE"
  },
  {
    "name": "Flemish Brabant",
    "iso2": "VBR",
    "timezone": "Europe/Brussels",
    "countryCode": "BE"
  },
  {
    "name": "Hainaut",
    "iso2": "WHT",
    "timezone": "Europe/Brussels",
    "countryCode": "BE"
  },
  {
    "name": "Liège",
    "iso2": "WLG",
    "timezone": "Europe/Brussels",
    "countryCode": "BE"
  },
  {
    "name": "Limburg",
    "iso2": "VLI",
    "timezone": "Europe/Brussels",
    "countryCode": "BE"
  },
  {
    "name": "Luxembourg",
    "iso2": "WLX",
    "timezone": "Europe/Brussels",
    "countryCode": "BE"
  },
  {
    "name": "Namur",
    "iso2": "WNA",
    "timezone": "Europe/Brussels",
    "countryCode": "BE"
  },
  {
    "name": "Wallonia",
    "iso2": "WAL",
    "timezone": "Europe/Brussels",
    "countryCode": "BE"
  },
  {
    "name": "Walloon Brabant",
    "iso2": "WBR",
    "timezone": "Europe/Brussels",
    "countryCode": "BE"
  },
  {
    "name": "West Flanders",
    "iso2": "VWV",
    "timezone": "Europe/Brussels",
    "countryCode": "BE"
  },
  {
    "name": "Belize",
    "iso2": "BZ",
    "timezone": "America/Belize",
    "countryCode": "BZ"
  },
  {
    "name": "Cayo",
    "iso2": "CY",
    "timezone": "America/Belize",
    "countryCode": "BZ"
  },
  {
    "name": "Corozal",
    "iso2": "CZL",
    "timezone": "America/Belize",
    "countryCode": "BZ"
  },
  {
    "name": "Orange Walk",
    "iso2": "OW",
    "timezone": "America/Belize",
    "countryCode": "BZ"
  },
  {
    "name": "Stann Creek",
    "iso2": "SC",
    "timezone": "America/Belize",
    "countryCode": "BZ"
  },
  {
    "name": "Toledo",
    "iso2": "TOL",
    "timezone": "America/Belize",
    "countryCode": "BZ"
  },
  {
    "name": "Alibori",
    "iso2": "AL",
    "timezone": "Africa/Porto-Novo",
    "countryCode": "BJ"
  },
  {
    "name": "Atakora",
    "iso2": "AK",
    "timezone": "Africa/Porto-Novo",
    "countryCode": "BJ"
  },
  {
    "name": "Atlantique",
    "iso2": "AQ",
    "timezone": "Africa/Porto-Novo",
    "countryCode": "BJ"
  },
  {
    "name": "Borgou",
    "iso2": "BO",
    "timezone": "Africa/Porto-Novo",
    "countryCode": "BJ"
  },
  {
    "name": "Collines",
    "iso2": "CO",
    "timezone": "Africa/Porto-Novo",
    "countryCode": "BJ"
  },
  {
    "name": "Donga",
    "iso2": "DO",
    "timezone": "Africa/Porto-Novo",
    "countryCode": "BJ"
  },
  {
    "name": "Kouffo",
    "iso2": "KO",
    "timezone": "Africa/Porto-Novo",
    "countryCode": "BJ"
  },
  {
    "name": "Littoral",
    "iso2": "LI",
    "timezone": "Africa/Porto-Novo",
    "countryCode": "BJ"
  },
  {
    "name": "Mono",
    "iso2": "MO",
    "timezone": "Africa/Porto-Novo",
    "countryCode": "BJ"
  },
  {
    "name": "Ouémé",
    "iso2": "OU",
    "timezone": "Africa/Porto-Novo",
    "countryCode": "BJ"
  },
  {
    "name": "Plateau",
    "iso2": "PL",
    "timezone": "Africa/Porto-Novo",
    "countryCode": "BJ"
  },
  {
    "name": "Zou",
    "iso2": "ZO",
    "timezone": "Africa/Porto-Novo",
    "countryCode": "BJ"
  },
  {
    "name": "Devonshire",
    "iso2": "DEV",
    "timezone": "Atlantic/Bermuda",
    "countryCode": "BM"
  },
  {
    "name": "Hamilton",
    "iso2": "HA",
    "timezone": "Atlantic/Bermuda",
    "countryCode": "BM"
  },
  {
    "name": "Paget",
    "iso2": "PAG",
    "timezone": "Atlantic/Bermuda",
    "countryCode": "BM"
  },
  {
    "name": "Pembroke",
    "iso2": "PEM",
    "timezone": "Atlantic/Bermuda",
    "countryCode": "BM"
  },
  {
    "name": "Saint George's",
    "iso2": "SGE",
    "timezone": "Atlantic/Bermuda",
    "countryCode": "BM"
  },
  {
    "name": "Sandys",
    "iso2": "SAN",
    "timezone": "Atlantic/Bermuda",
    "countryCode": "BM"
  },
  {
    "name": "Smith's",
    "iso2": "SMI",
    "timezone": "Atlantic/Bermuda",
    "countryCode": "BM"
  },
  {
    "name": "Southampton",
    "iso2": "SOU",
    "timezone": "Atlantic/Bermuda",
    "countryCode": "BM"
  },
  {
    "name": "Warwick",
    "iso2": "WAR",
    "timezone": "Atlantic/Bermuda",
    "countryCode": "BM"
  },
  {
    "name": "Bumthang ",
    "iso2": "33",
    "timezone": "Asia/Thimphu",
    "countryCode": "BT"
  },
  {
    "name": "Chukha ",
    "iso2": "12",
    "timezone": "Asia/Thimphu",
    "countryCode": "BT"
  },
  {
    "name": "Dagana ",
    "iso2": "22",
    "timezone": "Asia/Thimphu",
    "countryCode": "BT"
  },
  {
    "name": "Gasa ",
    "iso2": "GA",
    "timezone": "Asia/Thimphu",
    "countryCode": "BT"
  },
  {
    "name": "Haa ",
    "iso2": "13",
    "timezone": "Asia/Thimphu",
    "countryCode": "BT"
  },
  {
    "name": "Lhuntse ",
    "iso2": "44",
    "timezone": "Asia/Thimphu",
    "countryCode": "BT"
  },
  {
    "name": "Mongar ",
    "iso2": "42",
    "timezone": "Asia/Thimphu",
    "countryCode": "BT"
  },
  {
    "name": "Paro ",
    "iso2": "11",
    "timezone": "Asia/Thimphu",
    "countryCode": "BT"
  },
  {
    "name": "Pemagatshel ",
    "iso2": "43",
    "timezone": "Asia/Thimphu",
    "countryCode": "BT"
  },
  {
    "name": "Punakha ",
    "iso2": "23",
    "timezone": "Asia/Thimphu",
    "countryCode": "BT"
  },
  {
    "name": "Samdrup Jongkhar ",
    "iso2": "45",
    "timezone": "Asia/Thimphu",
    "countryCode": "BT"
  },
  {
    "name": "Samtse ",
    "iso2": "14",
    "timezone": "Asia/Thimphu",
    "countryCode": "BT"
  },
  {
    "name": "Sarpang ",
    "iso2": "31",
    "timezone": "Asia/Thimphu",
    "countryCode": "BT"
  },
  {
    "name": "Thimphu ",
    "iso2": "15",
    "timezone": "Asia/Thimphu",
    "countryCode": "BT"
  },
  {
    "name": "Trashi Yangtse\t",
    "iso2": "TY",
    "timezone": "Asia/Thimphu",
    "countryCode": "BT"
  },
  {
    "name": "Trashigang ",
    "iso2": "41",
    "timezone": "Asia/Thimphu",
    "countryCode": "BT"
  },
  {
    "name": "Trongsa ",
    "iso2": "32",
    "timezone": "Asia/Thimphu",
    "countryCode": "BT"
  },
  {
    "name": "Tsirang ",
    "iso2": "21",
    "timezone": "Asia/Thimphu",
    "countryCode": "BT"
  },
  {
    "name": "Wangdue Phodrang ",
    "iso2": "24",
    "timezone": "Asia/Thimphu",
    "countryCode": "BT"
  },
  {
    "name": "Zhemgang ",
    "iso2": "34",
    "timezone": "Asia/Thimphu",
    "countryCode": "BT"
  },
  {
    "name": "Beni",
    "iso2": "B",
    "timezone": "America/La_Paz",
    "countryCode": "BO"
  },
  {
    "name": "Chuquisaca",
    "iso2": "H",
    "timezone": "America/La_Paz",
    "countryCode": "BO"
  },
  {
    "name": "Cochabamba",
    "iso2": "C",
    "timezone": "America/La_Paz",
    "countryCode": "BO"
  },
  {
    "name": "La Paz",
    "iso2": "L",
    "timezone": "America/La_Paz",
    "countryCode": "BO"
  },
  {
    "name": "Oruro",
    "iso2": "O",
    "timezone": "America/La_Paz",
    "countryCode": "BO"
  },
  {
    "name": "Pando",
    "iso2": "N",
    "timezone": "America/La_Paz",
    "countryCode": "BO"
  },
  {
    "name": "Potosí",
    "iso2": "P",
    "timezone": "America/La_Paz",
    "countryCode": "BO"
  },
  {
    "name": "Santa Cruz",
    "iso2": "S",
    "timezone": "America/La_Paz",
    "countryCode": "BO"
  },
  {
    "name": "Tarija",
    "iso2": "T",
    "timezone": "America/La_Paz",
    "countryCode": "BO"
  },
  {
    "name": "Bonaire",
    "iso2": "BQ1",
    "timezone": "America/Curacao",
    "countryCode": "BQ"
  },
  {
    "name": "Saba",
    "iso2": "BQ2",
    "timezone": "America/Curacao",
    "countryCode": "BQ"
  },
  {
    "name": "Sint Eustatius",
    "iso2": "BQ3",
    "timezone": "America/Curacao",
    "countryCode": "BQ"
  },
  {
    "name": "Brčko",
    "iso2": "BRC",
    "timezone": "Europe/Sarajevo",
    "countryCode": "BA"
  },
  {
    "name": "Federation of Bosnia and Herzegovina",
    "iso2": "BIH",
    "timezone": "Europe/Sarajevo",
    "countryCode": "BA"
  },
  {
    "name": "Republika Srpska",
    "iso2": "SRP",
    "timezone": "Europe/Sarajevo",
    "countryCode": "BA"
  },
  {
    "name": "Central",
    "iso2": "CE",
    "timezone": "Africa/Gaborone",
    "countryCode": "BW"
  },
  {
    "name": "Chobe",
    "iso2": "CH",
    "timezone": "Africa/Gaborone",
    "countryCode": "BW"
  },
  {
    "name": "Francistown",
    "iso2": "FR",
    "timezone": "Africa/Gaborone",
    "countryCode": "BW"
  },
  {
    "name": "Gaborone",
    "iso2": "GA",
    "timezone": "Africa/Gaborone",
    "countryCode": "BW"
  },
  {
    "name": "Ghanzi",
    "iso2": "GH",
    "timezone": "Africa/Gaborone",
    "countryCode": "BW"
  },
  {
    "name": "Jwaneng",
    "iso2": "JW",
    "timezone": "Africa/Gaborone",
    "countryCode": "BW"
  },
  {
    "name": "Kgalagadi",
    "iso2": "KG",
    "timezone": "Africa/Gaborone",
    "countryCode": "BW"
  },
  {
    "name": "Kgatleng",
    "iso2": "KL",
    "timezone": "Africa/Gaborone",
    "countryCode": "BW"
  },
  {
    "name": "Kweneng",
    "iso2": "KW",
    "timezone": "Africa/Gaborone",
    "countryCode": "BW"
  },
  {
    "name": "Lobatse",
    "iso2": "LO",
    "timezone": "Africa/Gaborone",
    "countryCode": "BW"
  },
  {
    "name": "North-East",
    "iso2": "NE",
    "timezone": "Africa/Gaborone",
    "countryCode": "BW"
  },
  {
    "name": "North-West",
    "iso2": "NW",
    "timezone": "Africa/Gaborone",
    "countryCode": "BW"
  },
  {
    "name": "Selibe Phikwe",
    "iso2": "SP",
    "timezone": "Africa/Gaborone",
    "countryCode": "BW"
  },
  {
    "name": "South-East",
    "iso2": "SE",
    "timezone": "Africa/Gaborone",
    "countryCode": "BW"
  },
  {
    "name": "Southern",
    "iso2": "SO",
    "timezone": "Africa/Gaborone",
    "countryCode": "BW"
  },
  {
    "name": "Sowa Town",
    "iso2": "ST",
    "timezone": "Africa/Gaborone",
    "countryCode": "BW"
  },
  {
    "name": "Acre",
    "iso2": "AC",
    "timezone": "America/Rio_Branco",
    "countryCode": "BR"
  },
  {
    "name": "Alagoas",
    "iso2": "AL",
    "timezone": "America/Maceio",
    "countryCode": "BR"
  },
  {
    "name": "Amapá",
    "iso2": "AP",
    "timezone": "America/Belem",
    "countryCode": "BR"
  },
  {
    "name": "Amazonas",
    "iso2": "AM",
    "timezone": "America/Manaus",
    "countryCode": "BR"
  },
  {
    "name": "Bahia",
    "iso2": "BA",
    "timezone": "America/Bahia",
    "countryCode": "BR"
  },
  {
    "name": "Ceará",
    "iso2": "CE",
    "timezone": "America/Fortaleza",
    "countryCode": "BR"
  },
  {
    "name": "Distrito Federal",
    "iso2": "DF",
    "timezone": "America/Sao_Paulo",
    "countryCode": "BR"
  },
  {
    "name": "Espírito Santo",
    "iso2": "ES",
    "timezone": "America/Sao_Paulo",
    "countryCode": "BR"
  },
  {
    "name": "Goiás",
    "iso2": "GO",
    "timezone": "America/Sao_Paulo",
    "countryCode": "BR"
  },
  {
    "name": "Maranhão",
    "iso2": "MA",
    "timezone": "America/Fortaleza",
    "countryCode": "BR"
  },
  {
    "name": "Mato Grosso",
    "iso2": "MT",
    "timezone": "America/Cuiaba",
    "countryCode": "BR"
  },
  {
    "name": "Mato Grosso do Sul",
    "iso2": "MS",
    "timezone": "America/Campo_Grande",
    "countryCode": "BR"
  },
  {
    "name": "Minas Gerais",
    "iso2": "MG",
    "timezone": "America/Sao_Paulo",
    "countryCode": "BR"
  },
  {
    "name": "Pará",
    "iso2": "PA",
    "timezone": "America/Belem",
    "countryCode": "BR"
  },
  {
    "name": "Paraíba",
    "iso2": "PB",
    "timezone": "America/Fortaleza",
    "countryCode": "BR"
  },
  {
    "name": "Paraná",
    "iso2": "PR",
    "timezone": "America/Sao_Paulo",
    "countryCode": "BR"
  },
  {
    "name": "Pernambuco",
    "iso2": "PE",
    "timezone": "America/Recife",
    "countryCode": "BR"
  },
  {
    "name": "Piauí",
    "iso2": "PI",
    "timezone": "America/Fortaleza",
    "countryCode": "BR"
  },
  {
    "name": "Rio de Janeiro",
    "iso2": "RJ",
    "timezone": "America/Sao_Paulo",
    "countryCode": "BR"
  },
  {
    "name": "Rio Grande do Norte",
    "iso2": "RN",
    "timezone": "America/Fortaleza",
    "countryCode": "BR"
  },
  {
    "name": "Rio Grande do Sul",
    "iso2": "RS",
    "timezone": "America/Sao_Paulo",
    "countryCode": "BR"
  },
  {
    "name": "Rondônia",
    "iso2": "RO",
    "timezone": "America/Porto_Velho",
    "countryCode": "BR"
  },
  {
    "name": "Roraima",
    "iso2": "RR",
    "timezone": "America/Boa_Vista",
    "countryCode": "BR"
  },
  {
    "name": "Santa Catarina",
    "iso2": "SC",
    "timezone": "America/Sao_Paulo",
    "countryCode": "BR"
  },
  {
    "name": "São Paulo",
    "iso2": "SP",
    "timezone": "America/Sao_Paulo",
    "countryCode": "BR"
  },
  {
    "name": "Sergipe",
    "iso2": "SE",
    "timezone": "America/Maceio",
    "countryCode": "BR"
  },
  {
    "name": "Tocantins",
    "iso2": "TO",
    "timezone": "America/Araguaina",
    "countryCode": "BR"
  },
  {
    "name": "Belait",
    "iso2": "BE",
    "timezone": "Asia/Brunei",
    "countryCode": "BN"
  },
  {
    "name": "Brunei-Muara",
    "iso2": "BM",
    "timezone": "Asia/Brunei",
    "countryCode": "BN"
  },
  {
    "name": "Temburong",
    "iso2": "TE",
    "timezone": "Asia/Brunei",
    "countryCode": "BN"
  },
  {
    "name": "Tutong",
    "iso2": "TU",
    "timezone": "Asia/Brunei",
    "countryCode": "BN"
  },
  {
    "name": "Blagoevgrad",
    "iso2": "01",
    "timezone": "Europe/Sofia",
    "countryCode": "BG"
  },
  {
    "name": "Burgas",
    "iso2": "02",
    "timezone": "Europe/Sofia",
    "countryCode": "BG"
  },
  {
    "name": "Dobrich",
    "iso2": "08",
    "timezone": "Europe/Sofia",
    "countryCode": "BG"
  },
  {
    "name": "Gabrovo",
    "iso2": "07",
    "timezone": "Europe/Sofia",
    "countryCode": "BG"
  },
  {
    "name": "Haskovo",
    "iso2": "26",
    "timezone": "Europe/Sofia",
    "countryCode": "BG"
  },
  {
    "name": "Kardzhali",
    "iso2": "09",
    "timezone": "Europe/Sofia",
    "countryCode": "BG"
  },
  {
    "name": "Kyustendil",
    "iso2": "10",
    "timezone": "Europe/Sofia",
    "countryCode": "BG"
  },
  {
    "name": "Lovech",
    "iso2": "11",
    "timezone": "Europe/Sofia",
    "countryCode": "BG"
  },
  {
    "name": "Montana",
    "iso2": "12",
    "timezone": "Europe/Sofia",
    "countryCode": "BG"
  },
  {
    "name": "Pazardzhik",
    "iso2": "13",
    "timezone": "Europe/Sofia",
    "countryCode": "BG"
  },
  {
    "name": "Pernik",
    "iso2": "14",
    "timezone": "Europe/Sofia",
    "countryCode": "BG"
  },
  {
    "name": "Pleven",
    "iso2": "15",
    "timezone": "Europe/Sofia",
    "countryCode": "BG"
  },
  {
    "name": "Plovdiv",
    "iso2": "16",
    "timezone": "Europe/Sofia",
    "countryCode": "BG"
  },
  {
    "name": "Razgrad",
    "iso2": "17",
    "timezone": "Europe/Sofia",
    "countryCode": "BG"
  },
  {
    "name": "Ruse",
    "iso2": "18",
    "timezone": "Europe/Sofia",
    "countryCode": "BG"
  },
  {
    "name": "Shumen",
    "iso2": "27",
    "timezone": "Europe/Sofia",
    "countryCode": "BG"
  },
  {
    "name": "Silistra",
    "iso2": "19",
    "timezone": "Europe/Sofia",
    "countryCode": "BG"
  },
  {
    "name": "Sliven",
    "iso2": "20",
    "timezone": "Europe/Sofia",
    "countryCode": "BG"
  },
  {
    "name": "Smolyan",
    "iso2": "21",
    "timezone": "Europe/Sofia",
    "countryCode": "BG"
  },
  {
    "name": "Sofia",
    "iso2": "23",
    "timezone": "Europe/Sofia",
    "countryCode": "BG"
  },
  {
    "name": "Sofia City",
    "iso2": "22",
    "timezone": "Europe/Sofia",
    "countryCode": "BG"
  },
  {
    "name": "Stara Zagora",
    "iso2": "24",
    "timezone": "Europe/Sofia",
    "countryCode": "BG"
  },
  {
    "name": "Targovishte",
    "iso2": "25",
    "timezone": "Europe/Sofia",
    "countryCode": "BG"
  },
  {
    "name": "Varna",
    "iso2": "03",
    "timezone": "Europe/Sofia",
    "countryCode": "BG"
  },
  {
    "name": "Veliko Tarnovo",
    "iso2": "04",
    "timezone": "Europe/Sofia",
    "countryCode": "BG"
  },
  {
    "name": "Vidin",
    "iso2": "05",
    "timezone": "Europe/Sofia",
    "countryCode": "BG"
  },
  {
    "name": "Vratsa",
    "iso2": "06",
    "timezone": "Europe/Sofia",
    "countryCode": "BG"
  },
  {
    "name": "Yambol",
    "iso2": "28",
    "timezone": "Europe/Sofia",
    "countryCode": "BG"
  },
  {
    "name": "Balé",
    "iso2": "BAL",
    "timezone": "Africa/Ouagadougou",
    "countryCode": "BF"
  },
  {
    "name": "Bam",
    "iso2": "BAM",
    "timezone": "Africa/Ouagadougou",
    "countryCode": "BF"
  },
  {
    "name": "Banwa",
    "iso2": "BAN",
    "timezone": "Africa/Ouagadougou",
    "countryCode": "BF"
  },
  {
    "name": "Bazèga",
    "iso2": "BAZ",
    "timezone": "Africa/Ouagadougou",
    "countryCode": "BF"
  },
  {
    "name": "Boucle du Mouhoun",
    "iso2": "01",
    "timezone": "Africa/Ouagadougou",
    "countryCode": "BF"
  },
  {
    "name": "Bougouriba",
    "iso2": "BGR",
    "timezone": "Africa/Ouagadougou",
    "countryCode": "BF"
  },
  {
    "name": "Boulgou",
    "iso2": "BLG",
    "timezone": "Africa/Ouagadougou",
    "countryCode": "BF"
  },
  {
    "name": "Boulkiemde",
    "iso2": "BLK",
    "timezone": "Africa/Ouagadougou",
    "countryCode": "BF"
  },
  {
    "name": "Cascades",
    "iso2": "02",
    "timezone": "Africa/Ouagadougou",
    "countryCode": "BF"
  },
  {
    "name": "Centre",
    "iso2": "03",
    "timezone": "Africa/Ouagadougou",
    "countryCode": "BF"
  },
  {
    "name": "Centre-Est",
    "iso2": "04",
    "timezone": "Africa/Ouagadougou",
    "countryCode": "BF"
  },
  {
    "name": "Centre-Nord",
    "iso2": "05",
    "timezone": "Africa/Ouagadougou",
    "countryCode": "BF"
  },
  {
    "name": "Centre-Ouest",
    "iso2": "06",
    "timezone": "Africa/Ouagadougou",
    "countryCode": "BF"
  },
  {
    "name": "Centre-Sud",
    "iso2": "07",
    "timezone": "Africa/Ouagadougou",
    "countryCode": "BF"
  },
  {
    "name": "Comoé",
    "iso2": "COM",
    "timezone": "Africa/Ouagadougou",
    "countryCode": "BF"
  },
  {
    "name": "Est",
    "iso2": "08",
    "timezone": "Africa/Ouagadougou",
    "countryCode": "BF"
  },
  {
    "name": "Ganzourgou",
    "iso2": "GAN",
    "timezone": "Africa/Ouagadougou",
    "countryCode": "BF"
  },
  {
    "name": "Gnagna",
    "iso2": "GNA",
    "timezone": "Africa/Ouagadougou",
    "countryCode": "BF"
  },
  {
    "name": "Gourma",
    "iso2": "GOU",
    "timezone": "Africa/Ouagadougou",
    "countryCode": "BF"
  },
  {
    "name": "Hauts-Bassins",
    "iso2": "09",
    "timezone": "Africa/Ouagadougou",
    "countryCode": "BF"
  },
  {
    "name": "Houet",
    "iso2": "HOU",
    "timezone": "Africa/Ouagadougou",
    "countryCode": "BF"
  },
  {
    "name": "Ioba",
    "iso2": "IOB",
    "timezone": "Africa/Ouagadougou",
    "countryCode": "BF"
  },
  {
    "name": "Kadiogo",
    "iso2": "KAD",
    "timezone": "Africa/Ouagadougou",
    "countryCode": "BF"
  },
  {
    "name": "Kénédougou",
    "iso2": "KEN",
    "timezone": "Africa/Ouagadougou",
    "countryCode": "BF"
  },
  {
    "name": "Komondjari",
    "iso2": "KMD",
    "timezone": "Africa/Ouagadougou",
    "countryCode": "BF"
  },
  {
    "name": "Kompienga",
    "iso2": "KMP",
    "timezone": "Africa/Ouagadougou",
    "countryCode": "BF"
  },
  {
    "name": "Kossi",
    "iso2": "KOS",
    "timezone": "Africa/Ouagadougou",
    "countryCode": "BF"
  },
  {
    "name": "Koulpélogo",
    "iso2": "KOP",
    "timezone": "Africa/Ouagadougou",
    "countryCode": "BF"
  },
  {
    "name": "Kouritenga",
    "iso2": "KOT",
    "timezone": "Africa/Ouagadougou",
    "countryCode": "BF"
  },
  {
    "name": "Kourwéogo",
    "iso2": "KOW",
    "timezone": "Africa/Ouagadougou",
    "countryCode": "BF"
  },
  {
    "name": "Léraba",
    "iso2": "LER",
    "timezone": "Africa/Ouagadougou",
    "countryCode": "BF"
  },
  {
    "name": "Loroum",
    "iso2": "LOR",
    "timezone": "Africa/Ouagadougou",
    "countryCode": "BF"
  },
  {
    "name": "Mouhoun",
    "iso2": "MOU",
    "timezone": "Africa/Ouagadougou",
    "countryCode": "BF"
  },
  {
    "name": "Nahouri",
    "iso2": "NAO",
    "timezone": "Africa/Ouagadougou",
    "countryCode": "BF"
  },
  {
    "name": "Namentenga",
    "iso2": "NAM",
    "timezone": "Africa/Ouagadougou",
    "countryCode": "BF"
  },
  {
    "name": "Nayala",
    "iso2": "NAY",
    "timezone": "Africa/Ouagadougou",
    "countryCode": "BF"
  },
  {
    "name": "Nord",
    "iso2": "10",
    "timezone": "Africa/Ouagadougou",
    "countryCode": "BF"
  },
  {
    "name": "Noumbiel",
    "iso2": "NOU",
    "timezone": "Africa/Ouagadougou",
    "countryCode": "BF"
  },
  {
    "name": "Oubritenga",
    "iso2": "OUB",
    "timezone": "Africa/Ouagadougou",
    "countryCode": "BF"
  },
  {
    "name": "Oudalan",
    "iso2": "OUD",
    "timezone": "Africa/Ouagadougou",
    "countryCode": "BF"
  },
  {
    "name": "Passoré",
    "iso2": "PAS",
    "timezone": "Africa/Ouagadougou",
    "countryCode": "BF"
  },
  {
    "name": "Plateau-Central",
    "iso2": "11",
    "timezone": "Africa/Ouagadougou",
    "countryCode": "BF"
  },
  {
    "name": "Poni",
    "iso2": "PON",
    "timezone": "Africa/Ouagadougou",
    "countryCode": "BF"
  },
  {
    "name": "Sahel",
    "iso2": "12",
    "timezone": "Africa/Ouagadougou",
    "countryCode": "BF"
  },
  {
    "name": "Sanguié",
    "iso2": "SNG",
    "timezone": "Africa/Ouagadougou",
    "countryCode": "BF"
  },
  {
    "name": "Sanmatenga",
    "iso2": "SMT",
    "timezone": "Africa/Ouagadougou",
    "countryCode": "BF"
  },
  {
    "name": "Séno",
    "iso2": "SEN",
    "timezone": "Africa/Ouagadougou",
    "countryCode": "BF"
  },
  {
    "name": "Sissili",
    "iso2": "SIS",
    "timezone": "Africa/Ouagadougou",
    "countryCode": "BF"
  },
  {
    "name": "Soum",
    "iso2": "SOM",
    "timezone": "Africa/Ouagadougou",
    "countryCode": "BF"
  },
  {
    "name": "Sourou",
    "iso2": "SOR",
    "timezone": "Africa/Ouagadougou",
    "countryCode": "BF"
  },
  {
    "name": "Sud-Ouest",
    "iso2": "13",
    "timezone": "Africa/Ouagadougou",
    "countryCode": "BF"
  },
  {
    "name": "Tapoa",
    "iso2": "TAP",
    "timezone": "Africa/Ouagadougou",
    "countryCode": "BF"
  },
  {
    "name": "Tuy",
    "iso2": "TUI",
    "timezone": "Africa/Ouagadougou",
    "countryCode": "BF"
  },
  {
    "name": "Yagha",
    "iso2": "YAG",
    "timezone": "Africa/Ouagadougou",
    "countryCode": "BF"
  },
  {
    "name": "Yatenga",
    "iso2": "YAT",
    "timezone": "Africa/Ouagadougou",
    "countryCode": "BF"
  },
  {
    "name": "Ziro",
    "iso2": "ZIR",
    "timezone": "Africa/Ouagadougou",
    "countryCode": "BF"
  },
  {
    "name": "Zondoma",
    "iso2": "ZON",
    "timezone": "Africa/Ouagadougou",
    "countryCode": "BF"
  },
  {
    "name": "Zoundwéogo",
    "iso2": "ZOU",
    "timezone": "Africa/Ouagadougou",
    "countryCode": "BF"
  },
  {
    "name": "Bubanza",
    "iso2": "BB",
    "timezone": "Africa/Bujumbura",
    "countryCode": "BI"
  },
  {
    "name": "Bujumbura Mairie",
    "iso2": "BM",
    "timezone": "Africa/Bujumbura",
    "countryCode": "BI"
  },
  {
    "name": "Bujumbura Rural",
    "iso2": "BL",
    "timezone": "Africa/Bujumbura",
    "countryCode": "BI"
  },
  {
    "name": "Bururi",
    "iso2": "BR",
    "timezone": "Africa/Bujumbura",
    "countryCode": "BI"
  },
  {
    "name": "Cankuzo",
    "iso2": "CA",
    "timezone": "Africa/Bujumbura",
    "countryCode": "BI"
  },
  {
    "name": "Cibitoke",
    "iso2": "CI",
    "timezone": "Africa/Bujumbura",
    "countryCode": "BI"
  },
  {
    "name": "Gitega",
    "iso2": "GI",
    "timezone": "Africa/Bujumbura",
    "countryCode": "BI"
  },
  {
    "name": "Karuzi",
    "iso2": "KR",
    "timezone": "Africa/Bujumbura",
    "countryCode": "BI"
  },
  {
    "name": "Kayanza",
    "iso2": "KY",
    "timezone": "Africa/Bujumbura",
    "countryCode": "BI"
  },
  {
    "name": "Kirundo",
    "iso2": "KI",
    "timezone": "Africa/Bujumbura",
    "countryCode": "BI"
  },
  {
    "name": "Makamba",
    "iso2": "MA",
    "timezone": "Africa/Bujumbura",
    "countryCode": "BI"
  },
  {
    "name": "Muramvya",
    "iso2": "MU",
    "timezone": "Africa/Bujumbura",
    "countryCode": "BI"
  },
  {
    "name": "Muyinga",
    "iso2": "MY",
    "timezone": "Africa/Bujumbura",
    "countryCode": "BI"
  },
  {
    "name": "Mwaro",
    "iso2": "MW",
    "timezone": "Africa/Bujumbura",
    "countryCode": "BI"
  },
  {
    "name": "Ngozi",
    "iso2": "NG",
    "timezone": "Africa/Bujumbura",
    "countryCode": "BI"
  },
  {
    "name": "Rumonge",
    "iso2": "RM",
    "timezone": "Africa/Bujumbura",
    "countryCode": "BI"
  },
  {
    "name": "Rutana",
    "iso2": "RT",
    "timezone": "Africa/Bujumbura",
    "countryCode": "BI"
  },
  {
    "name": "Ruyigi",
    "iso2": "RY",
    "timezone": "Africa/Bujumbura",
    "countryCode": "BI"
  },
  {
    "name": "Banteay Meanchey",
    "iso2": "1",
    "timezone": "Asia/Phnom_Penh",
    "countryCode": "KH"
  },
  {
    "name": "Battambang",
    "iso2": "2",
    "timezone": "Asia/Phnom_Penh",
    "countryCode": "KH"
  },
  {
    "name": "Kampong Cham",
    "iso2": "3",
    "timezone": "Asia/Phnom_Penh",
    "countryCode": "KH"
  },
  {
    "name": "Kampong Chhnang",
    "iso2": "4",
    "timezone": "Asia/Phnom_Penh",
    "countryCode": "KH"
  },
  {
    "name": "Kampong Speu",
    "iso2": "5",
    "timezone": "Asia/Phnom_Penh",
    "countryCode": "KH"
  },
  {
    "name": "Kampong Thom",
    "iso2": "6",
    "timezone": "Asia/Phnom_Penh",
    "countryCode": "KH"
  },
  {
    "name": "Kampot",
    "iso2": "7",
    "timezone": "Asia/Phnom_Penh",
    "countryCode": "KH"
  },
  {
    "name": "Kandal",
    "iso2": "8",
    "timezone": "Asia/Phnom_Penh",
    "countryCode": "KH"
  },
  {
    "name": "Kep",
    "iso2": "23",
    "timezone": "Asia/Phnom_Penh",
    "countryCode": "KH"
  },
  {
    "name": "Koh Kong",
    "iso2": "9",
    "timezone": "Asia/Phnom_Penh",
    "countryCode": "KH"
  },
  {
    "name": "Kratie",
    "iso2": "10",
    "timezone": "Asia/Phnom_Penh",
    "countryCode": "KH"
  },
  {
    "name": "Mondulkiri",
    "iso2": "11",
    "timezone": "Asia/Phnom_Penh",
    "countryCode": "KH"
  },
  {
    "name": "Oddar Meanchey",
    "iso2": "22",
    "timezone": "Asia/Phnom_Penh",
    "countryCode": "KH"
  },
  {
    "name": "Pailin",
    "iso2": "24",
    "timezone": "Asia/Phnom_Penh",
    "countryCode": "KH"
  },
  {
    "name": "Phnom Penh",
    "iso2": "12",
    "timezone": "Asia/Phnom_Penh",
    "countryCode": "KH"
  },
  {
    "name": "Preah Vihear",
    "iso2": "13",
    "timezone": "Asia/Phnom_Penh",
    "countryCode": "KH"
  },
  {
    "name": "Prey Veng",
    "iso2": "14",
    "timezone": "Asia/Phnom_Penh",
    "countryCode": "KH"
  },
  {
    "name": "Pursat",
    "iso2": "15",
    "timezone": "Asia/Phnom_Penh",
    "countryCode": "KH"
  },
  {
    "name": "Ratanakiri",
    "iso2": "16",
    "timezone": "Asia/Phnom_Penh",
    "countryCode": "KH"
  },
  {
    "name": "Siem Reap",
    "iso2": "17",
    "timezone": "Asia/Phnom_Penh",
    "countryCode": "KH"
  },
  {
    "name": "Sihanoukville",
    "iso2": "18",
    "timezone": "Asia/Phnom_Penh",
    "countryCode": "KH"
  },
  {
    "name": "Stung Treng",
    "iso2": "19",
    "timezone": "Asia/Phnom_Penh",
    "countryCode": "KH"
  },
  {
    "name": "Svay Rieng",
    "iso2": "20",
    "timezone": "Asia/Phnom_Penh",
    "countryCode": "KH"
  },
  {
    "name": "Takeo",
    "iso2": "21",
    "timezone": "Asia/Phnom_Penh",
    "countryCode": "KH"
  },
  {
    "name": "Tboung Khmum",
    "iso2": "25",
    "timezone": "Asia/Phnom_Penh",
    "countryCode": "KH"
  },
  {
    "name": "Adamawa",
    "iso2": "AD",
    "timezone": "Africa/Douala",
    "countryCode": "CM"
  },
  {
    "name": "Centre",
    "iso2": "CE",
    "timezone": "Africa/Douala",
    "countryCode": "CM"
  },
  {
    "name": "East",
    "iso2": "ES",
    "timezone": "Africa/Douala",
    "countryCode": "CM"
  },
  {
    "name": "Far North",
    "iso2": "EN",
    "timezone": "Africa/Douala",
    "countryCode": "CM"
  },
  {
    "name": "Littoral",
    "iso2": "LT",
    "timezone": "Africa/Douala",
    "countryCode": "CM"
  },
  {
    "name": "North",
    "iso2": "NO",
    "timezone": "Africa/Douala",
    "countryCode": "CM"
  },
  {
    "name": "Northwest",
    "iso2": "NW",
    "timezone": "Africa/Douala",
    "countryCode": "CM"
  },
  {
    "name": "South",
    "iso2": "SU",
    "timezone": "Africa/Douala",
    "countryCode": "CM"
  },
  {
    "name": "Southwest",
    "iso2": "SW",
    "timezone": "Africa/Douala",
    "countryCode": "CM"
  },
  {
    "name": "West",
    "iso2": "OU",
    "timezone": "Africa/Douala",
    "countryCode": "CM"
  },
  {
    "name": "Alberta",
    "iso2": "AB",
    "timezone": "America/Edmonton",
    "countryCode": "CA"
  },
  {
    "name": "British Columbia",
    "iso2": "BC",
    "timezone": "America/Vancouver",
    "countryCode": "CA"
  },
  {
    "name": "Manitoba",
    "iso2": "MB",
    "timezone": "America/Winnipeg",
    "countryCode": "CA"
  },
  {
    "name": "New Brunswick",
    "iso2": "NB",
    "timezone": "America/Moncton",
    "countryCode": "CA"
  },
  {
    "name": "Newfoundland and Labrador",
    "iso2": "NL",
    "timezone": "America/St_Johns",
    "countryCode": "CA"
  },
  {
    "name": "Northwest Territories",
    "iso2": "NT",
    "timezone": "America/Yellowknife",
    "countryCode": "CA"
  },
  {
    "name": "Nova Scotia",
    "iso2": "NS",
    "timezone": "America/Halifax",
    "countryCode": "CA"
  },
  {
    "name": "Nunavut",
    "iso2": "NU",
    "timezone": "America/Iqaluit",
    "countryCode": "CA"
  },
  {
    "name": "Ontario",
    "iso2": "ON",
    "timezone": "America/Toronto",
    "countryCode": "CA"
  },
  {
    "name": "Prince Edward Island",
    "iso2": "PE",
    "timezone": "America/Halifax",
    "countryCode": "CA"
  },
  {
    "name": "Quebec",
    "iso2": "QC",
    "timezone": "America/Toronto",
    "countryCode": "CA"
  },
  {
    "name": "Saskatchewan",
    "iso2": "SK",
    "timezone": "America/Regina",
    "countryCode": "CA"
  },
  {
    "name": "Yukon",
    "iso2": "YT",
    "timezone": "America/Whitehorse",
    "countryCode": "CA"
  },
  {
    "name": "Barlavento Islands",
    "iso2": "B",
    "timezone": "Atlantic/Cape_Verde",
    "countryCode": "CV"
  },
  {
    "name": "Boa Vista",
    "iso2": "BV",
    "timezone": "Atlantic/Cape_Verde",
    "countryCode": "CV"
  },
  {
    "name": "Brava",
    "iso2": "BR",
    "timezone": "Atlantic/Cape_Verde",
    "countryCode": "CV"
  },
  {
    "name": "Maio",
    "iso2": "MA",
    "timezone": "Atlantic/Cape_Verde",
    "countryCode": "CV"
  },
  {
    "name": "Mosteiros",
    "iso2": "MO",
    "timezone": "Atlantic/Cape_Verde",
    "countryCode": "CV"
  },
  {
    "name": "Paul",
    "iso2": "PA",
    "timezone": "Atlantic/Cape_Verde",
    "countryCode": "CV"
  },
  {
    "name": "Porto Novo",
    "iso2": "PN",
    "timezone": "Atlantic/Cape_Verde",
    "countryCode": "CV"
  },
  {
    "name": "Praia",
    "iso2": "PR",
    "timezone": "Atlantic/Cape_Verde",
    "countryCode": "CV"
  },
  {
    "name": "Ribeira Brava",
    "iso2": "RB",
    "timezone": "Atlantic/Cape_Verde",
    "countryCode": "CV"
  },
  {
    "name": "Ribeira Grande",
    "iso2": "RG",
    "timezone": "Atlantic/Cape_Verde",
    "countryCode": "CV"
  },
  {
    "name": "Ribeira Grande de Santiago",
    "iso2": "RS",
    "timezone": "Atlantic/Cape_Verde",
    "countryCode": "CV"
  },
  {
    "name": "Sal",
    "iso2": "SL",
    "timezone": "Atlantic/Cape_Verde",
    "countryCode": "CV"
  },
  {
    "name": "Santa Catarina",
    "iso2": "CA",
    "timezone": "Atlantic/Cape_Verde",
    "countryCode": "CV"
  },
  {
    "name": "Santa Catarina do Fogo",
    "iso2": "CF",
    "timezone": "Atlantic/Cape_Verde",
    "countryCode": "CV"
  },
  {
    "name": "Santa Cruz",
    "iso2": "CR",
    "timezone": "Atlantic/Cape_Verde",
    "countryCode": "CV"
  },
  {
    "name": "São Domingos",
    "iso2": "SD",
    "timezone": "Atlantic/Cape_Verde",
    "countryCode": "CV"
  },
  {
    "name": "São Filipe",
    "iso2": "SF",
    "timezone": "Atlantic/Cape_Verde",
    "countryCode": "CV"
  },
  {
    "name": "São Lourenço dos Órgãos",
    "iso2": "SO",
    "timezone": "Atlantic/Cape_Verde",
    "countryCode": "CV"
  },
  {
    "name": "São Miguel",
    "iso2": "SM",
    "timezone": "Atlantic/Cape_Verde",
    "countryCode": "CV"
  },
  {
    "name": "São Salvador do Mundo",
    "iso2": "SS",
    "timezone": "Atlantic/Cape_Verde",
    "countryCode": "CV"
  },
  {
    "name": "São Vicente",
    "iso2": "SV",
    "timezone": "Atlantic/Cape_Verde",
    "countryCode": "CV"
  },
  {
    "name": "Sotavento Islands",
    "iso2": "S",
    "timezone": "Atlantic/Cape_Verde",
    "countryCode": "CV"
  },
  {
    "name": "Tarrafal",
    "iso2": "TA",
    "timezone": "Atlantic/Cape_Verde",
    "countryCode": "CV"
  },
  {
    "name": "Tarrafal de São Nicolau",
    "iso2": "TS",
    "timezone": "Atlantic/Cape_Verde",
    "countryCode": "CV"
  },
  {
    "name": "Cayman Brac",
    "iso2": "02",
    "timezone": "America/Cayman",
    "countryCode": "KY"
  },
  {
    "name": "Grand Cayman",
    "iso2": "01",
    "timezone": "America/Cayman",
    "countryCode": "KY"
  },
  {
    "name": "Little Cayman",
    "iso2": "03",
    "timezone": "America/Cayman",
    "countryCode": "KY"
  },
  {
    "name": "Bamingui-Bangoran",
    "iso2": "BB",
    "timezone": "Africa/Bangui",
    "countryCode": "CF"
  },
  {
    "name": "Bangui",
    "iso2": "BGF",
    "timezone": "Africa/Bangui",
    "countryCode": "CF"
  },
  {
    "name": "Basse-Kotto",
    "iso2": "BK",
    "timezone": "Africa/Bangui",
    "countryCode": "CF"
  },
  {
    "name": "Haut-Mbomou",
    "iso2": "HM",
    "timezone": "Africa/Bangui",
    "countryCode": "CF"
  },
  {
    "name": "Haute-Kotto",
    "iso2": "HK",
    "timezone": "Africa/Bangui",
    "countryCode": "CF"
  },
  {
    "name": "Kémo",
    "iso2": "KG",
    "timezone": "Africa/Bangui",
    "countryCode": "CF"
  },
  {
    "name": "Lobaye",
    "iso2": "LB",
    "timezone": "Africa/Bangui",
    "countryCode": "CF"
  },
  {
    "name": "Mambéré-Kadéï",
    "iso2": "HS",
    "timezone": "Africa/Bangui",
    "countryCode": "CF"
  },
  {
    "name": "Mbomou",
    "iso2": "MB",
    "timezone": "Africa/Bangui",
    "countryCode": "CF"
  },
  {
    "name": "Nana-Grébizi",
    "iso2": "KB",
    "timezone": "Africa/Bangui",
    "countryCode": "CF"
  },
  {
    "name": "Nana-Mambéré",
    "iso2": "NM",
    "timezone": "Africa/Bangui",
    "countryCode": "CF"
  },
  {
    "name": "Ombella-M'Poko",
    "iso2": "MP",
    "timezone": "Africa/Bangui",
    "countryCode": "CF"
  },
  {
    "name": "Ouaka",
    "iso2": "UK",
    "timezone": "Africa/Bangui",
    "countryCode": "CF"
  },
  {
    "name": "Ouham",
    "iso2": "AC",
    "timezone": "Africa/Bangui",
    "countryCode": "CF"
  },
  {
    "name": "Ouham-Pendé",
    "iso2": "OP",
    "timezone": "Africa/Bangui",
    "countryCode": "CF"
  },
  {
    "name": "Sangha-Mbaéré",
    "iso2": "SE",
    "timezone": "Africa/Bangui",
    "countryCode": "CF"
  },
  {
    "name": "Vakaga",
    "iso2": "VK",
    "timezone": "Africa/Bangui",
    "countryCode": "CF"
  },
  {
    "name": "Bahr el Gazel",
    "iso2": "BG",
    "timezone": "Africa/Ndjamena",
    "countryCode": "TD"
  },
  {
    "name": "Batha",
    "iso2": "BA",
    "timezone": "Africa/Ndjamena",
    "countryCode": "TD"
  },
  {
    "name": "Borkou",
    "iso2": "BO",
    "timezone": "Africa/Ndjamena",
    "countryCode": "TD"
  },
  {
    "name": "Chari-Baguirmi",
    "iso2": "CB",
    "timezone": "Africa/Ndjamena",
    "countryCode": "TD"
  },
  {
    "name": "Ennedi-Est",
    "iso2": "EE",
    "timezone": "Africa/Ndjamena",
    "countryCode": "TD"
  },
  {
    "name": "Ennedi-Ouest",
    "iso2": "EO",
    "timezone": "Africa/Ndjamena",
    "countryCode": "TD"
  },
  {
    "name": "Guéra",
    "iso2": "GR",
    "timezone": "Africa/Ndjamena",
    "countryCode": "TD"
  },
  {
    "name": "Hadjer-Lamis",
    "iso2": "HL",
    "timezone": "Africa/Ndjamena",
    "countryCode": "TD"
  },
  {
    "name": "Kanem",
    "iso2": "KA",
    "timezone": "Africa/Ndjamena",
    "countryCode": "TD"
  },
  {
    "name": "Lac",
    "iso2": "LC",
    "timezone": "Africa/Ndjamena",
    "countryCode": "TD"
  },
  {
    "name": "Logone Occidental",
    "iso2": "LO",
    "timezone": "Africa/Ndjamena",
    "countryCode": "TD"
  },
  {
    "name": "Logone Oriental",
    "iso2": "LR",
    "timezone": "Africa/Ndjamena",
    "countryCode": "TD"
  },
  {
    "name": "Mandoul",
    "iso2": "MA",
    "timezone": "Africa/Ndjamena",
    "countryCode": "TD"
  },
  {
    "name": "Mayo-Kebbi Est",
    "iso2": "ME",
    "timezone": "Africa/Ndjamena",
    "countryCode": "TD"
  },
  {
    "name": "Mayo-Kebbi Ouest",
    "iso2": "MO",
    "timezone": "Africa/Ndjamena",
    "countryCode": "TD"
  },
  {
    "name": "Moyen-Chari",
    "iso2": "MC",
    "timezone": "Africa/Ndjamena",
    "countryCode": "TD"
  },
  {
    "name": "N'Djamena",
    "iso2": "ND",
    "timezone": "Africa/Ndjamena",
    "countryCode": "TD"
  },
  {
    "name": "Ouaddaï",
    "iso2": "OD",
    "timezone": "Africa/Ndjamena",
    "countryCode": "TD"
  },
  {
    "name": "Salamat",
    "iso2": "SA",
    "timezone": "Africa/Ndjamena",
    "countryCode": "TD"
  },
  {
    "name": "Sila",
    "iso2": "SI",
    "timezone": "Africa/Ndjamena",
    "countryCode": "TD"
  },
  {
    "name": "Tandjilé",
    "iso2": "TA",
    "timezone": "Africa/Ndjamena",
    "countryCode": "TD"
  },
  {
    "name": "Tibesti",
    "iso2": "TI",
    "timezone": "Africa/Ndjamena",
    "countryCode": "TD"
  },
  {
    "name": "Wadi Fira",
    "iso2": "WF",
    "timezone": "Africa/Ndjamena",
    "countryCode": "TD"
  },
  {
    "name": "Aisén del General Carlos Ibañez del Campo",
    "iso2": "AI",
    "timezone": "America/Punta_Arenas",
    "countryCode": "CL"
  },
  {
    "name": "Antofagasta",
    "iso2": "AN",
    "timezone": "America/Santiago",
    "countryCode": "CL"
  },
  {
    "name": "Arica y Parinacota",
    "iso2": "AP",
    "timezone": "America/Santiago",
    "countryCode": "CL"
  },
  {
    "name": "Atacama",
    "iso2": "AT",
    "timezone": "America/Santiago",
    "countryCode": "CL"
  },
  {
    "name": "Biobío",
    "iso2": "BI",
    "timezone": "America/Santiago",
    "countryCode": "CL"
  },
  {
    "name": "Coquimbo",
    "iso2": "CO",
    "timezone": "America/Santiago",
    "countryCode": "CL"
  },
  {
    "name": "La Araucanía",
    "iso2": "AR",
    "timezone": "America/Santiago",
    "countryCode": "CL"
  },
  {
    "name": "Libertador General Bernardo O'Higgins",
    "iso2": "LI",
    "timezone": "America/Santiago",
    "countryCode": "CL"
  },
  {
    "name": "Los Lagos",
    "iso2": "LL",
    "timezone": "America/Santiago",
    "countryCode": "CL"
  },
  {
    "name": "Los Ríos",
    "iso2": "LR",
    "timezone": "America/Santiago",
    "countryCode": "CL"
  },
  {
    "name": "Magallanes y de la Antártica Chilena",
    "iso2": "MA",
    "timezone": "America/Punta_Arenas",
    "countryCode": "CL"
  },
  {
    "name": "Maule",
    "iso2": "ML",
    "timezone": "America/Santiago",
    "countryCode": "CL"
  },
  {
    "name": "Ñuble",
    "iso2": "NB",
    "timezone": "America/Santiago",
    "countryCode": "CL"
  },
  {
    "name": "Región Metropolitana de Santiago",
    "iso2": "RM",
    "timezone": "America/Santiago",
    "countryCode": "CL"
  },
  {
    "name": "Tarapacá",
    "iso2": "TA",
    "timezone": "America/Santiago",
    "countryCode": "CL"
  },
  {
    "name": "Valparaíso",
    "iso2": "VS",
    "timezone": "America/Santiago",
    "countryCode": "CL"
  },
  {
    "name": "Anhui",
    "iso2": "AH",
    "timezone": "Asia/Shanghai",
    "countryCode": "CN"
  },
  {
    "name": "Beijing",
    "iso2": "BJ",
    "timezone": "Asia/Shanghai",
    "countryCode": "CN"
  },
  {
    "name": "Chongqing",
    "iso2": "CQ",
    "timezone": "Asia/Shanghai",
    "countryCode": "CN"
  },
  {
    "name": "Fujian",
    "iso2": "FJ",
    "timezone": "Asia/Shanghai",
    "countryCode": "CN"
  },
  {
    "name": "Gansu",
    "iso2": "GS",
    "timezone": "Asia/Shanghai",
    "countryCode": "CN"
  },
  {
    "name": "Guangdong",
    "iso2": "GD",
    "timezone": "Asia/Shanghai",
    "countryCode": "CN"
  },
  {
    "name": "Guangxi",
    "iso2": "GX",
    "timezone": "Asia/Shanghai",
    "countryCode": "CN"
  },
  {
    "name": "Guizhou",
    "iso2": "GZ",
    "timezone": "Asia/Shanghai",
    "countryCode": "CN"
  },
  {
    "name": "Hainan",
    "iso2": "HI",
    "timezone": "Asia/Shanghai",
    "countryCode": "CN"
  },
  {
    "name": "Hebei",
    "iso2": "HE",
    "timezone": "Asia/Shanghai",
    "countryCode": "CN"
  },
  {
    "name": "Heilongjiang",
    "iso2": "HL",
    "timezone": "Asia/Shanghai",
    "countryCode": "CN"
  },
  {
    "name": "Henan",
    "iso2": "HA",
    "timezone": "Asia/Shanghai",
    "countryCode": "CN"
  },
  {
    "name": "Hong Kong SAR",
    "iso2": "HK",
    "timezone": "Asia/Shanghai",
    "countryCode": "CN"
  },
  {
    "name": "Hubei",
    "iso2": "HB",
    "timezone": "Asia/Shanghai",
    "countryCode": "CN"
  },
  {
    "name": "Hunan",
    "iso2": "HN",
    "timezone": "Asia/Shanghai",
    "countryCode": "CN"
  },
  {
    "name": "Inner Mongolia",
    "iso2": "NM",
    "timezone": "Asia/Shanghai",
    "countryCode": "CN"
  },
  {
    "name": "Jiangsu",
    "iso2": "JS",
    "timezone": "Asia/Shanghai",
    "countryCode": "CN"
  },
  {
    "name": "Jiangxi",
    "iso2": "JX",
    "timezone": "Asia/Shanghai",
    "countryCode": "CN"
  },
  {
    "name": "Jilin",
    "iso2": "JL",
    "timezone": "Asia/Shanghai",
    "countryCode": "CN"
  },
  {
    "name": "Liaoning",
    "iso2": "LN",
    "timezone": "Asia/Shanghai",
    "countryCode": "CN"
  },
  {
    "name": "Macau SAR",
    "iso2": "MO",
    "timezone": "Asia/Shanghai",
    "countryCode": "CN"
  },
  {
    "name": "Ningxia",
    "iso2": "NX",
    "timezone": "Asia/Shanghai",
    "countryCode": "CN"
  },
  {
    "name": "Qinghai",
    "iso2": "QH",
    "timezone": "Asia/Shanghai",
    "countryCode": "CN"
  },
  {
    "name": "Shaanxi",
    "iso2": "SN",
    "timezone": "Asia/Shanghai",
    "countryCode": "CN"
  },
  {
    "name": "Shandong",
    "iso2": "SD",
    "timezone": "Asia/Shanghai",
    "countryCode": "CN"
  },
  {
    "name": "Shanghai",
    "iso2": "SH",
    "timezone": "Asia/Shanghai",
    "countryCode": "CN"
  },
  {
    "name": "Shanxi",
    "iso2": "SX",
    "timezone": "Asia/Shanghai",
    "countryCode": "CN"
  },
  {
    "name": "Sichuan",
    "iso2": "SC",
    "timezone": "Asia/Shanghai",
    "countryCode": "CN"
  },
  {
    "name": "Taiwan",
    "iso2": "TW",
    "timezone": "Asia/Shanghai",
    "countryCode": "CN"
  },
  {
    "name": "Tianjin",
    "iso2": "TJ",
    "timezone": "Asia/Shanghai",
    "countryCode": "CN"
  },
  {
    "name": "Tibet",
    "iso2": "XZ",
    "timezone": "Asia/Shanghai",
    "countryCode": "CN"
  },
  {
    "name": "Xinjiang",
    "iso2": "XJ",
    "timezone": "Asia/Urumqi",
    "countryCode": "CN"
  },
  {
    "name": "Yunnan",
    "iso2": "YN",
    "timezone": "Asia/Shanghai",
    "countryCode": "CN"
  },
  {
    "name": "Zhejiang",
    "iso2": "ZJ",
    "timezone": "Asia/Shanghai",
    "countryCode": "CN"
  },
  {
    "name": "Amazonas",
    "iso2": "AMA",
    "timezone": "America/Bogota",
    "countryCode": "CO"
  },
  {
    "name": "Antioquia",
    "iso2": "ANT",
    "timezone": "America/Bogota",
    "countryCode": "CO"
  },
  {
    "name": "Arauca",
    "iso2": "ARA",
    "timezone": "America/Bogota",
    "countryCode": "CO"
  },
  {
    "name": "Atlántico",
    "iso2": "ATL",
    "timezone": "America/Bogota",
    "countryCode": "CO"
  },
  {
    "name": "Bogotá D.C.",
    "iso2": "DC",
    "timezone": "America/Bogota",
    "countryCode": "CO"
  },
  {
    "name": "Bolívar",
    "iso2": "BOL",
    "timezone": "America/Bogota",
    "countryCode": "CO"
  },
  {
    "name": "Boyacá",
    "iso2": "BOY",
    "timezone": "America/Bogota",
    "countryCode": "CO"
  },
  {
    "name": "Caldas",
    "iso2": "CAL",
    "timezone": "America/Bogota",
    "countryCode": "CO"
  },
  {
    "name": "Caquetá",
    "iso2": "CAQ",
    "timezone": "America/Bogota",
    "countryCode": "CO"
  },
  {
    "name": "Casanare",
    "iso2": "CAS",
    "timezone": "America/Bogota",
    "countryCode": "CO"
  },
  {
    "name": "Cauca",
    "iso2": "CAU",
    "timezone": "America/Bogota",
    "countryCode": "CO"
  },
  {
    "name": "Cesar",
    "iso2": "CES",
    "timezone": "America/Bogota",
    "countryCode": "CO"
  },
  {
    "name": "Chocó",
    "iso2": "CHO",
    "timezone": "America/Bogota",
    "countryCode": "CO"
  },
  {
    "name": "Córdoba",
    "iso2": "COR",
    "timezone": "America/Bogota",
    "countryCode": "CO"
  },
  {
    "name": "Cundinamarca",
    "iso2": "CUN",
    "timezone": "America/Bogota",
    "countryCode": "CO"
  },
  {
    "name": "Guainía",
    "iso2": "GUA",
    "timezone": "America/Bogota",
    "countryCode": "CO"
  },
  {
    "name": "Guaviare",
    "iso2": "GUV",
    "timezone": "America/Bogota",
    "countryCode": "CO"
  },
  {
    "name": "Huila",
    "iso2": "HUI",
    "timezone": "America/Bogota",
    "countryCode": "CO"
  },
  {
    "name": "La Guajira",
    "iso2": "LAG",
    "timezone": "America/Bogota",
    "countryCode": "CO"
  },
  {
    "name": "Magdalena",
    "iso2": "MAG",
    "timezone": "America/Bogota",
    "countryCode": "CO"
  },
  {
    "name": "Meta",
    "iso2": "MET",
    "timezone": "America/Bogota",
    "countryCode": "CO"
  },
  {
    "name": "Nariño",
    "iso2": "NAR",
    "timezone": "America/Bogota",
    "countryCode": "CO"
  },
  {
    "name": "Norte de Santander",
    "iso2": "NSA",
    "timezone": "America/Bogota",
    "countryCode": "CO"
  },
  {
    "name": "Putumayo",
    "iso2": "PUT",
    "timezone": "America/Bogota",
    "countryCode": "CO"
  },
  {
    "name": "Quindío",
    "iso2": "QUI",
    "timezone": "America/Bogota",
    "countryCode": "CO"
  },
  {
    "name": "Risaralda",
    "iso2": "RIS",
    "timezone": "America/Bogota",
    "countryCode": "CO"
  },
  {
    "name": "San Andrés, Providencia y Santa Catalina",
    "iso2": "SAP",
    "timezone": "America/Bogota",
    "countryCode": "CO"
  },
  {
    "name": "Santander",
    "iso2": "SAN",
    "timezone": "America/Bogota",
    "countryCode": "CO"
  },
  {
    "name": "Sucre",
    "iso2": "SUC",
    "timezone": "America/Bogota",
    "countryCode": "CO"
  },
  {
    "name": "Tolima",
    "iso2": "TOL",
    "timezone": "America/Bogota",
    "countryCode": "CO"
  },
  {
    "name": "Valle del Cauca",
    "iso2": "VAC",
    "timezone": "America/Bogota",
    "countryCode": "CO"
  },
  {
    "name": "Vaupés",
    "iso2": "VAU",
    "timezone": "America/Bogota",
    "countryCode": "CO"
  },
  {
    "name": "Vichada",
    "iso2": "VID",
    "timezone": "America/Bogota",
    "countryCode": "CO"
  },
  {
    "name": "Anjouan",
    "iso2": "A",
    "timezone": "Indian/Comoro",
    "countryCode": "KM"
  },
  {
    "name": "Grande Comore",
    "iso2": "G",
    "timezone": "Indian/Comoro",
    "countryCode": "KM"
  },
  {
    "name": "Mohéli",
    "iso2": "M",
    "timezone": "Indian/Comoro",
    "countryCode": "KM"
  },
  {
    "name": "Bouenza",
    "iso2": "11",
    "timezone": "Africa/Brazzaville",
    "countryCode": "CG"
  },
  {
    "name": "Brazzaville",
    "iso2": "BZV",
    "timezone": "Africa/Brazzaville",
    "countryCode": "CG"
  },
  {
    "name": "Cuvette",
    "iso2": "8",
    "timezone": "Africa/Brazzaville",
    "countryCode": "CG"
  },
  {
    "name": "Cuvette-Ouest",
    "iso2": "15",
    "timezone": "Africa/Brazzaville",
    "countryCode": "CG"
  },
  {
    "name": "Kouilou",
    "iso2": "5",
    "timezone": "Africa/Brazzaville",
    "countryCode": "CG"
  },
  {
    "name": "Lékoumou",
    "iso2": "2",
    "timezone": "Africa/Brazzaville",
    "countryCode": "CG"
  },
  {
    "name": "Likouala",
    "iso2": "7",
    "timezone": "Africa/Brazzaville",
    "countryCode": "CG"
  },
  {
    "name": "Niari",
    "iso2": "9",
    "timezone": "Africa/Brazzaville",
    "countryCode": "CG"
  },
  {
    "name": "Plateaux",
    "iso2": "14",
    "timezone": "Africa/Brazzaville",
    "countryCode": "CG"
  },
  {
    "name": "Pointe-Noire",
    "iso2": "16",
    "timezone": "Africa/Brazzaville",
    "countryCode": "CG"
  },
  {
    "name": "Pool",
    "iso2": "12",
    "timezone": "Africa/Brazzaville",
    "countryCode": "CG"
  },
  {
    "name": "Sangha",
    "iso2": "13",
    "timezone": "Africa/Brazzaville",
    "countryCode": "CG"
  },
  {
    "name": "Alajuela",
    "iso2": "A",
    "timezone": "America/Costa_Rica",
    "countryCode": "CR"
  },
  {
    "name": "Cartago",
    "iso2": "C",
    "timezone": "America/Costa_Rica",
    "countryCode": "CR"
  },
  {
    "name": "Guanacaste",
    "iso2": "G",
    "timezone": "America/Costa_Rica",
    "countryCode": "CR"
  },
  {
    "name": "Heredia",
    "iso2": "H",
    "timezone": "America/Costa_Rica",
    "countryCode": "CR"
  },
  {
    "name": "Limón",
    "iso2": "L",
    "timezone": "America/Costa_Rica",
    "countryCode": "CR"
  },
  {
    "name": "Puntarenas",
    "iso2": "P",
    "timezone": "America/Costa_Rica",
    "countryCode": "CR"
  },
  {
    "name": "San José",
    "iso2": "SJ",
    "timezone": "America/Costa_Rica",
    "countryCode": "CR"
  },
  {
    "name": "Bjelovar-Bilogora",
    "iso2": "07",
    "timezone": "Europe/Zagreb",
    "countryCode": "HR"
  },
  {
    "name": "Brod-Posavina",
    "iso2": "12",
    "timezone": "Europe/Zagreb",
    "countryCode": "HR"
  },
  {
    "name": "Dubrovnik-Neretva",
    "iso2": "19",
    "timezone": "Europe/Zagreb",
    "countryCode": "HR"
  },
  {
    "name": "Istria",
    "iso2": "18",
    "timezone": "Europe/Zagreb",
    "countryCode": "HR"
  },
  {
    "name": "Karlovac",
    "iso2": "04",
    "timezone": "Europe/Zagreb",
    "countryCode": "HR"
  },
  {
    "name": "Koprivnica-Križevci",
    "iso2": "06",
    "timezone": "Europe/Zagreb",
    "countryCode": "HR"
  },
  {
    "name": "Krapina-Zagorje",
    "iso2": "02",
    "timezone": "Europe/Zagreb",
    "countryCode": "HR"
  },
  {
    "name": "Lika-Senj",
    "iso2": "09",
    "timezone": "Europe/Zagreb",
    "countryCode": "HR"
  },
  {
    "name": "Međimurje",
    "iso2": "20",
    "timezone": "Europe/Zagreb",
    "countryCode": "HR"
  },
  {
    "name": "Osijek-Baranja",
    "iso2": "14",
    "timezone": "Europe/Zagreb",
    "countryCode": "HR"
  },
  {
    "name": "Požega-Slavonia",
    "iso2": "11",
    "timezone": "Europe/Zagreb",
    "countryCode": "HR"
  },
  {
    "name": "Primorje-Gorski Kotar",
    "iso2": "08",
    "timezone": "Europe/Zagreb",
    "countryCode": "HR"
  },
  {
    "name": "Šibenik-Knin",
    "iso2": "15",
    "timezone": "Europe/Zagreb",
    "countryCode": "HR"
  },
  {
    "name": "Sisak-Moslavina",
    "iso2": "03",
    "timezone": "Europe/Zagreb",
    "countryCode": "HR"
  },
  {
    "name": "Split-Dalmatia",
    "iso2": "17",
    "timezone": "Europe/Zagreb",
    "countryCode": "HR"
  },
  {
    "name": "Varaždin",
    "iso2": "05",
    "timezone": "Europe/Zagreb",
    "countryCode": "HR"
  },
  {
    "name": "Virovitica-Podravina",
    "iso2": "10",
    "timezone": "Europe/Zagreb",
    "countryCode": "HR"
  },
  {
    "name": "Vukovar-Syrmia",
    "iso2": "16",
    "timezone": "Europe/Zagreb",
    "countryCode": "HR"
  },
  {
    "name": "Zadar",
    "iso2": "13",
    "timezone": "Europe/Zagreb",
    "countryCode": "HR"
  },
  {
    "name": "Zagreb",
    "iso2": "01",
    "timezone": "Europe/Zagreb",
    "countryCode": "HR"
  },
  {
    "name": "Artemisa",
    "iso2": "15",
    "timezone": "America/Havana",
    "countryCode": "CU"
  },
  {
    "name": "Camagüey",
    "iso2": "09",
    "timezone": "America/Havana",
    "countryCode": "CU"
  },
  {
    "name": "Ciego de Ávila",
    "iso2": "08",
    "timezone": "America/Havana",
    "countryCode": "CU"
  },
  {
    "name": "Cienfuegos",
    "iso2": "06",
    "timezone": "America/Havana",
    "countryCode": "CU"
  },
  {
    "name": "Granma",
    "iso2": "12",
    "timezone": "America/Havana",
    "countryCode": "CU"
  },
  {
    "name": "Guantánamo",
    "iso2": "14",
    "timezone": "America/Havana",
    "countryCode": "CU"
  },
  {
    "name": "Havana",
    "iso2": "03",
    "timezone": "America/Havana",
    "countryCode": "CU"
  },
  {
    "name": "Holguín",
    "iso2": "11",
    "timezone": "America/Havana",
    "countryCode": "CU"
  },
  {
    "name": "Isla de la Juventud",
    "iso2": "99",
    "timezone": "America/Havana",
    "countryCode": "CU"
  },
  {
    "name": "Las Tunas",
    "iso2": "10",
    "timezone": "America/Havana",
    "countryCode": "CU"
  },
  {
    "name": "Matanzas",
    "iso2": "04",
    "timezone": "America/Havana",
    "countryCode": "CU"
  },
  {
    "name": "Mayabeque",
    "iso2": "16",
    "timezone": "America/Havana",
    "countryCode": "CU"
  },
  {
    "name": "Pinar del Río",
    "iso2": "01",
    "timezone": "America/Havana",
    "countryCode": "CU"
  },
  {
    "name": "Sancti Spíritus",
    "iso2": "07",
    "timezone": "America/Havana",
    "countryCode": "CU"
  },
  {
    "name": "Santiago de Cuba",
    "iso2": "13",
    "timezone": "America/Havana",
    "countryCode": "CU"
  },
  {
    "name": "Villa Clara",
    "iso2": "05",
    "timezone": "America/Havana",
    "countryCode": "CU"
  },
  {
    "name": "Famagusta (Mağusa)",
    "iso2": "04",
    "timezone": "Asia/Famagusta",
    "countryCode": "CY"
  },
  {
    "name": "Kyrenia (Keryneia)",
    "iso2": "06",
    "timezone": "Asia/Famagusta",
    "countryCode": "CY"
  },
  {
    "name": "Larnaca (Larnaka)",
    "iso2": "03",
    "timezone": "Asia/Famagusta",
    "countryCode": "CY"
  },
  {
    "name": "Limassol (Leymasun)",
    "iso2": "02",
    "timezone": "Asia/Famagusta",
    "countryCode": "CY"
  },
  {
    "name": "Nicosia (Lefkoşa)",
    "iso2": "01",
    "timezone": "Asia/Famagusta",
    "countryCode": "CY"
  },
  {
    "name": "Paphos (Pafos)",
    "iso2": "05",
    "timezone": "Asia/Famagusta",
    "countryCode": "CY"
  },
  {
    "name": "Benešov",
    "iso2": "201",
    "timezone": "Europe/Prague",
    "countryCode": "CZ"
  },
  {
    "name": "Beroun",
    "iso2": "202",
    "timezone": "Europe/Prague",
    "countryCode": "CZ"
  },
  {
    "name": "Blansko",
    "iso2": "641",
    "timezone": "Europe/Prague",
    "countryCode": "CZ"
  },
  {
    "name": "Břeclav",
    "iso2": "644",
    "timezone": "Europe/Prague",
    "countryCode": "CZ"
  },
  {
    "name": "Brno-město",
    "iso2": "642",
    "timezone": "Europe/Prague",
    "countryCode": "CZ"
  },
  {
    "name": "Brno-venkov",
    "iso2": "643",
    "timezone": "Europe/Prague",
    "countryCode": "CZ"
  },
  {
    "name": "Bruntál",
    "iso2": "801",
    "timezone": "Europe/Prague",
    "countryCode": "CZ"
  },
  {
    "name": "Česká Lípa",
    "iso2": "511",
    "timezone": "Europe/Prague",
    "countryCode": "CZ"
  },
  {
    "name": "České Budějovice",
    "iso2": "311",
    "timezone": "Europe/Prague",
    "countryCode": "CZ"
  },
  {
    "name": "Český Krumlov",
    "iso2": "312",
    "timezone": "Europe/Prague",
    "countryCode": "CZ"
  },
  {
    "name": "Cheb",
    "iso2": "411",
    "timezone": "Europe/Prague",
    "countryCode": "CZ"
  },
  {
    "name": "Chomutov",
    "iso2": "422",
    "timezone": "Europe/Prague",
    "countryCode": "CZ"
  },
  {
    "name": "Chrudim",
    "iso2": "531",
    "timezone": "Europe/Prague",
    "countryCode": "CZ"
  },
  {
    "name": "Děčín",
    "iso2": "421",
    "timezone": "Europe/Prague",
    "countryCode": "CZ"
  },
  {
    "name": "Domažlice",
    "iso2": "321",
    "timezone": "Europe/Prague",
    "countryCode": "CZ"
  },
  {
    "name": "Frýdek-Místek",
    "iso2": "802",
    "timezone": "Europe/Prague",
    "countryCode": "CZ"
  },
  {
    "name": "Havlíčkův Brod",
    "iso2": "631",
    "timezone": "Europe/Prague",
    "countryCode": "CZ"
  },
  {
    "name": "Hodonín",
    "iso2": "645",
    "timezone": "Europe/Prague",
    "countryCode": "CZ"
  },
  {
    "name": "Hradec Králové",
    "iso2": "521",
    "timezone": "Europe/Prague",
    "countryCode": "CZ"
  },
  {
    "name": "Jablonec nad Nisou",
    "iso2": "512",
    "timezone": "Europe/Prague",
    "countryCode": "CZ"
  },
  {
    "name": "Jeseník",
    "iso2": "711",
    "timezone": "Europe/Prague",
    "countryCode": "CZ"
  },
  {
    "name": "Jičín",
    "iso2": "522",
    "timezone": "Europe/Prague",
    "countryCode": "CZ"
  },
  {
    "name": "Jihlava",
    "iso2": "632",
    "timezone": "Europe/Prague",
    "countryCode": "CZ"
  },
  {
    "name": "Jihočeský kraj",
    "iso2": "31",
    "timezone": "Europe/Prague",
    "countryCode": "CZ"
  },
  {
    "name": "Jihomoravský kraj",
    "iso2": "64",
    "timezone": "Europe/Prague",
    "countryCode": "CZ"
  },
  {
    "name": "Jindřichův Hradec",
    "iso2": "313",
    "timezone": "Europe/Prague",
    "countryCode": "CZ"
  },
  {
    "name": "Karlovarský kraj",
    "iso2": "41",
    "timezone": "Europe/Prague",
    "countryCode": "CZ"
  },
  {
    "name": "Karlovy Vary",
    "iso2": "412",
    "timezone": "Europe/Prague",
    "countryCode": "CZ"
  },
  {
    "name": "Karviná",
    "iso2": "803",
    "timezone": "Europe/Prague",
    "countryCode": "CZ"
  },
  {
    "name": "Kladno",
    "iso2": "203",
    "timezone": "Europe/Prague",
    "countryCode": "CZ"
  },
  {
    "name": "Klatovy",
    "iso2": "322",
    "timezone": "Europe/Prague",
    "countryCode": "CZ"
  },
  {
    "name": "Kolín",
    "iso2": "204",
    "timezone": "Europe/Prague",
    "countryCode": "CZ"
  },
  {
    "name": "Kraj Vysočina",
    "iso2": "63",
    "timezone": "Europe/Prague",
    "countryCode": "CZ"
  },
  {
    "name": "Královéhradecký kraj",
    "iso2": "52",
    "timezone": "Europe/Prague",
    "countryCode": "CZ"
  },
  {
    "name": "Kroměříž",
    "iso2": "721",
    "timezone": "Europe/Prague",
    "countryCode": "CZ"
  },
  {
    "name": "Kutná Hora",
    "iso2": "205",
    "timezone": "Europe/Prague",
    "countryCode": "CZ"
  },
  {
    "name": "Liberec",
    "iso2": "513",
    "timezone": "Europe/Prague",
    "countryCode": "CZ"
  },
  {
    "name": "Liberecký kraj",
    "iso2": "51",
    "timezone": "Europe/Prague",
    "countryCode": "CZ"
  },
  {
    "name": "Litoměřice",
    "iso2": "423",
    "timezone": "Europe/Prague",
    "countryCode": "CZ"
  },
  {
    "name": "Louny",
    "iso2": "424",
    "timezone": "Europe/Prague",
    "countryCode": "CZ"
  },
  {
    "name": "Mělník",
    "iso2": "206",
    "timezone": "Europe/Prague",
    "countryCode": "CZ"
  },
  {
    "name": "Mladá Boleslav",
    "iso2": "207",
    "timezone": "Europe/Prague",
    "countryCode": "CZ"
  },
  {
    "name": "Moravskoslezský kraj",
    "iso2": "80",
    "timezone": "Europe/Prague",
    "countryCode": "CZ"
  },
  {
    "name": "Most",
    "iso2": "425",
    "timezone": "Europe/Prague",
    "countryCode": "CZ"
  },
  {
    "name": "Náchod",
    "iso2": "523",
    "timezone": "Europe/Prague",
    "countryCode": "CZ"
  },
  {
    "name": "Nový Jičín",
    "iso2": "804",
    "timezone": "Europe/Prague",
    "countryCode": "CZ"
  },
  {
    "name": "Nymburk",
    "iso2": "208",
    "timezone": "Europe/Prague",
    "countryCode": "CZ"
  },
  {
    "name": "Olomouc",
    "iso2": "712",
    "timezone": "Europe/Prague",
    "countryCode": "CZ"
  },
  {
    "name": "Olomoucký kraj",
    "iso2": "71",
    "timezone": "Europe/Prague",
    "countryCode": "CZ"
  },
  {
    "name": "Opava",
    "iso2": "805",
    "timezone": "Europe/Prague",
    "countryCode": "CZ"
  },
  {
    "name": "Ostrava-město",
    "iso2": "806",
    "timezone": "Europe/Prague",
    "countryCode": "CZ"
  },
  {
    "name": "Pardubice",
    "iso2": "532",
    "timezone": "Europe/Prague",
    "countryCode": "CZ"
  },
  {
    "name": "Pardubický kraj",
    "iso2": "53",
    "timezone": "Europe/Prague",
    "countryCode": "CZ"
  },
  {
    "name": "Pelhřimov",
    "iso2": "633",
    "timezone": "Europe/Prague",
    "countryCode": "CZ"
  },
  {
    "name": "Písek",
    "iso2": "314",
    "timezone": "Europe/Prague",
    "countryCode": "CZ"
  },
  {
    "name": "Plzeň-jih",
    "iso2": "324",
    "timezone": "Europe/Prague",
    "countryCode": "CZ"
  },
  {
    "name": "Plzeň-město",
    "iso2": "323",
    "timezone": "Europe/Prague",
    "countryCode": "CZ"
  },
  {
    "name": "Plzeň-sever",
    "iso2": "325",
    "timezone": "Europe/Prague",
    "countryCode": "CZ"
  },
  {
    "name": "Plzeňský kraj",
    "iso2": "32",
    "timezone": "Europe/Prague",
    "countryCode": "CZ"
  },
  {
    "name": "Prachatice",
    "iso2": "315",
    "timezone": "Europe/Prague",
    "countryCode": "CZ"
  },
  {
    "name": "Praha-východ",
    "iso2": "209",
    "timezone": "Europe/Prague",
    "countryCode": "CZ"
  },
  {
    "name": "Praha-západ",
    "iso2": "20A",
    "timezone": "Europe/Prague",
    "countryCode": "CZ"
  },
  {
    "name": "Praha, Hlavní město",
    "iso2": "10",
    "timezone": "Europe/Prague",
    "countryCode": "CZ"
  },
  {
    "name": "Přerov",
    "iso2": "714",
    "timezone": "Europe/Prague",
    "countryCode": "CZ"
  },
  {
    "name": "Příbram",
    "iso2": "20B",
    "timezone": "Europe/Prague",
    "countryCode": "CZ"
  },
  {
    "name": "Prostějov",
    "iso2": "713",
    "timezone": "Europe/Prague",
    "countryCode": "CZ"
  },
  {
    "name": "Rakovník",
    "iso2": "20C",
    "timezone": "Europe/Prague",
    "countryCode": "CZ"
  },
  {
    "name": "Rokycany",
    "iso2": "326",
    "timezone": "Europe/Prague",
    "countryCode": "CZ"
  },
  {
    "name": "Rychnov nad Kněžnou",
    "iso2": "524",
    "timezone": "Europe/Prague",
    "countryCode": "CZ"
  },
  {
    "name": "Semily",
    "iso2": "514",
    "timezone": "Europe/Prague",
    "countryCode": "CZ"
  },
  {
    "name": "Sokolov",
    "iso2": "413",
    "timezone": "Europe/Prague",
    "countryCode": "CZ"
  },
  {
    "name": "Strakonice",
    "iso2": "316",
    "timezone": "Europe/Prague",
    "countryCode": "CZ"
  },
  {
    "name": "Středočeský kraj",
    "iso2": "20",
    "timezone": "Europe/Prague",
    "countryCode": "CZ"
  },
  {
    "name": "Šumperk",
    "iso2": "715",
    "timezone": "Europe/Prague",
    "countryCode": "CZ"
  },
  {
    "name": "Svitavy",
    "iso2": "533",
    "timezone": "Europe/Prague",
    "countryCode": "CZ"
  },
  {
    "name": "Tábor",
    "iso2": "317",
    "timezone": "Europe/Prague",
    "countryCode": "CZ"
  },
  {
    "name": "Tachov",
    "iso2": "327",
    "timezone": "Europe/Prague",
    "countryCode": "CZ"
  },
  {
    "name": "Teplice",
    "iso2": "426",
    "timezone": "Europe/Prague",
    "countryCode": "CZ"
  },
  {
    "name": "Třebíč",
    "iso2": "634",
    "timezone": "Europe/Prague",
    "countryCode": "CZ"
  },
  {
    "name": "Trutnov",
    "iso2": "525",
    "timezone": "Europe/Prague",
    "countryCode": "CZ"
  },
  {
    "name": "Uherské Hradiště",
    "iso2": "722",
    "timezone": "Europe/Prague",
    "countryCode": "CZ"
  },
  {
    "name": "Ústecký kraj",
    "iso2": "42",
    "timezone": "Europe/Prague",
    "countryCode": "CZ"
  },
  {
    "name": "Ústí nad Labem",
    "iso2": "427",
    "timezone": "Europe/Prague",
    "countryCode": "CZ"
  },
  {
    "name": "Ústí nad Orlicí",
    "iso2": "534",
    "timezone": "Europe/Prague",
    "countryCode": "CZ"
  },
  {
    "name": "Vsetín",
    "iso2": "723",
    "timezone": "Europe/Prague",
    "countryCode": "CZ"
  },
  {
    "name": "Vyškov",
    "iso2": "646",
    "timezone": "Europe/Prague",
    "countryCode": "CZ"
  },
  {
    "name": "Žďár nad Sázavou",
    "iso2": "635",
    "timezone": "Europe/Prague",
    "countryCode": "CZ"
  },
  {
    "name": "Zlín",
    "iso2": "724",
    "timezone": "Europe/Prague",
    "countryCode": "CZ"
  },
  {
    "name": "Zlínský kraj",
    "iso2": "72",
    "timezone": "Europe/Prague",
    "countryCode": "CZ"
  },
  {
    "name": "Znojmo",
    "iso2": "647",
    "timezone": "Europe/Prague",
    "countryCode": "CZ"
  },
  {
    "name": "Bas-Uélé",
    "iso2": "BU",
    "timezone": "Africa/Kinshasa",
    "countryCode": "CD"
  },
  {
    "name": "Équateur",
    "iso2": "EQ",
    "timezone": "Africa/Kinshasa",
    "countryCode": "CD"
  },
  {
    "name": "Haut-Katanga",
    "iso2": "HK",
    "timezone": "Africa/Kinshasa",
    "countryCode": "CD"
  },
  {
    "name": "Haut-Lomami",
    "iso2": "HL",
    "timezone": "Africa/Kinshasa",
    "countryCode": "CD"
  },
  {
    "name": "Haut-Uélé",
    "iso2": "HU",
    "timezone": "Africa/Kinshasa",
    "countryCode": "CD"
  },
  {
    "name": "Ituri",
    "iso2": "IT",
    "timezone": "Africa/Kinshasa",
    "countryCode": "CD"
  },
  {
    "name": "Kasaï",
    "iso2": "KS",
    "timezone": "Africa/Kinshasa",
    "countryCode": "CD"
  },
  {
    "name": "Kasaï Central",
    "iso2": "KC",
    "timezone": "Africa/Kinshasa",
    "countryCode": "CD"
  },
  {
    "name": "Kasaï Oriental",
    "iso2": "KE",
    "timezone": "Africa/Kinshasa",
    "countryCode": "CD"
  },
  {
    "name": "Kinshasa",
    "iso2": "KN",
    "timezone": "Africa/Kinshasa",
    "countryCode": "CD"
  },
  {
    "name": "Kongo Central",
    "iso2": "BC",
    "timezone": "Africa/Kinshasa",
    "countryCode": "CD"
  },
  {
    "name": "Kwango",
    "iso2": "KG",
    "timezone": "Africa/Kinshasa",
    "countryCode": "CD"
  },
  {
    "name": "Kwilu",
    "iso2": "KL",
    "timezone": "Africa/Kinshasa",
    "countryCode": "CD"
  },
  {
    "name": "Lomami",
    "iso2": "LO",
    "timezone": "Africa/Kinshasa",
    "countryCode": "CD"
  },
  {
    "name": "Lualaba",
    "iso2": "LU",
    "timezone": "Africa/Kinshasa",
    "countryCode": "CD"
  },
  {
    "name": "Mai-Ndombe",
    "iso2": "MN",
    "timezone": "Africa/Kinshasa",
    "countryCode": "CD"
  },
  {
    "name": "Maniema",
    "iso2": "MA",
    "timezone": "Africa/Kinshasa",
    "countryCode": "CD"
  },
  {
    "name": "Mongala",
    "iso2": "MO",
    "timezone": "Africa/Kinshasa",
    "countryCode": "CD"
  },
  {
    "name": "Nord-Kivu",
    "iso2": "NK",
    "timezone": "Africa/Kinshasa",
    "countryCode": "CD"
  },
  {
    "name": "Nord-Ubangi",
    "iso2": "NU",
    "timezone": "Africa/Kinshasa",
    "countryCode": "CD"
  },
  {
    "name": "Sankuru",
    "iso2": "SA",
    "timezone": "Africa/Kinshasa",
    "countryCode": "CD"
  },
  {
    "name": "Sud-Kivu",
    "iso2": "SK",
    "timezone": "Africa/Kinshasa",
    "countryCode": "CD"
  },
  {
    "name": "Sud-Ubangi",
    "iso2": "SU",
    "timezone": "Africa/Kinshasa",
    "countryCode": "CD"
  },
  {
    "name": "Tanganyika",
    "iso2": "TA",
    "timezone": "Africa/Kinshasa",
    "countryCode": "CD"
  },
  {
    "name": "Tshopo",
    "iso2": "TO",
    "timezone": "Africa/Kinshasa",
    "countryCode": "CD"
  },
  {
    "name": "Tshuapa",
    "iso2": "TU",
    "timezone": "Africa/Kinshasa",
    "countryCode": "CD"
  },
  {
    "name": "Central Denmark",
    "iso2": "82",
    "timezone": "Europe/Copenhagen",
    "countryCode": "DK"
  },
  {
    "name": "Denmark",
    "iso2": "84",
    "timezone": "Europe/Copenhagen",
    "countryCode": "DK"
  },
  {
    "name": "North Denmark",
    "iso2": "81",
    "timezone": "Europe/Copenhagen",
    "countryCode": "DK"
  },
  {
    "name": "Southern Denmark",
    "iso2": "83",
    "timezone": "Europe/Copenhagen",
    "countryCode": "DK"
  },
  {
    "name": "Zealand",
    "iso2": "85",
    "timezone": "Europe/Copenhagen",
    "countryCode": "DK"
  },
  {
    "name": "Ali Sabieh",
    "iso2": "AS",
    "timezone": "Africa/Djibouti",
    "countryCode": "DJ"
  },
  {
    "name": "Arta",
    "iso2": "AR",
    "timezone": "Africa/Djibouti",
    "countryCode": "DJ"
  },
  {
    "name": "Dikhil",
    "iso2": "DI",
    "timezone": "Africa/Djibouti",
    "countryCode": "DJ"
  },
  {
    "name": "Djibouti",
    "iso2": "DJ",
    "timezone": "Africa/Djibouti",
    "countryCode": "DJ"
  },
  {
    "name": "Obock",
    "iso2": "OB",
    "timezone": "Africa/Djibouti",
    "countryCode": "DJ"
  },
  {
    "name": "Tadjourah",
    "iso2": "TA",
    "timezone": "Africa/Djibouti",
    "countryCode": "DJ"
  },
  {
    "name": "Saint Andrew",
    "iso2": "02",
    "timezone": "America/Dominica",
    "countryCode": "DM"
  },
  {
    "name": "Saint David",
    "iso2": "03",
    "timezone": "America/Dominica",
    "countryCode": "DM"
  },
  {
    "name": "Saint George",
    "iso2": "04",
    "timezone": "America/Dominica",
    "countryCode": "DM"
  },
  {
    "name": "Saint John",
    "iso2": "05",
    "timezone": "America/Dominica",
    "countryCode": "DM"
  },
  {
    "name": "Saint Joseph",
    "iso2": "06",
    "timezone": "America/Dominica",
    "countryCode": "DM"
  },
  {
    "name": "Saint Luke",
    "iso2": "07",
    "timezone": "America/Dominica",
    "countryCode": "DM"
  },
  {
    "name": "Saint Mark",
    "iso2": "08",
    "timezone": "America/Dominica",
    "countryCode": "DM"
  },
  {
    "name": "Saint Patrick",
    "iso2": "09",
    "timezone": "America/Dominica",
    "countryCode": "DM"
  },
  {
    "name": "Saint Paul",
    "iso2": "10",
    "timezone": "America/Dominica",
    "countryCode": "DM"
  },
  {
    "name": "Saint Peter",
    "iso2": "11",
    "timezone": "America/Dominica",
    "countryCode": "DM"
  },
  {
    "name": "Azua",
    "iso2": "02",
    "timezone": "America/Santo_Domingo",
    "countryCode": "DO"
  },
  {
    "name": "Baoruco",
    "iso2": "03",
    "timezone": "America/Santo_Domingo",
    "countryCode": "DO"
  },
  {
    "name": "Barahona",
    "iso2": "04",
    "timezone": "America/Santo_Domingo",
    "countryCode": "DO"
  },
  {
    "name": "Cibao Nordeste",
    "iso2": "33",
    "timezone": "America/Santo_Domingo",
    "countryCode": "DO"
  },
  {
    "name": "Cibao Noroeste",
    "iso2": "34",
    "timezone": "America/Santo_Domingo",
    "countryCode": "DO"
  },
  {
    "name": "Cibao Norte",
    "iso2": "35",
    "timezone": "America/Santo_Domingo",
    "countryCode": "DO"
  },
  {
    "name": "Cibao Sur",
    "iso2": "36",
    "timezone": "America/Santo_Domingo",
    "countryCode": "DO"
  },
  {
    "name": "Dajabón",
    "iso2": "05",
    "timezone": "America/Santo_Domingo",
    "countryCode": "DO"
  },
  {
    "name": "Distrito Nacional",
    "iso2": "01",
    "timezone": "America/Santo_Domingo",
    "countryCode": "DO"
  },
  {
    "name": "Duarte",
    "iso2": "06",
    "timezone": "America/Santo_Domingo",
    "countryCode": "DO"
  },
  {
    "name": "El Seibo",
    "iso2": "08",
    "timezone": "America/Santo_Domingo",
    "countryCode": "DO"
  },
  {
    "name": "El Valle",
    "iso2": "37",
    "timezone": "America/Santo_Domingo",
    "countryCode": "DO"
  },
  {
    "name": "Elías Piña",
    "iso2": "07",
    "timezone": "America/Santo_Domingo",
    "countryCode": "DO"
  },
  {
    "name": "Enriquillo",
    "iso2": "38",
    "timezone": "America/Santo_Domingo",
    "countryCode": "DO"
  },
  {
    "name": "Espaillat",
    "iso2": "09",
    "timezone": "America/Santo_Domingo",
    "countryCode": "DO"
  },
  {
    "name": "Hato Mayor",
    "iso2": "30",
    "timezone": "America/Santo_Domingo",
    "countryCode": "DO"
  },
  {
    "name": "Hermanas Mirabal",
    "iso2": "19",
    "timezone": "America/Santo_Domingo",
    "countryCode": "DO"
  },
  {
    "name": "Higuamo",
    "iso2": "39",
    "timezone": "America/Santo_Domingo",
    "countryCode": "DO"
  },
  {
    "name": "Independencia",
    "iso2": "10",
    "timezone": "America/Santo_Domingo",
    "countryCode": "DO"
  },
  {
    "name": "La Altagracia",
    "iso2": "11",
    "timezone": "America/Santo_Domingo",
    "countryCode": "DO"
  },
  {
    "name": "La Romana",
    "iso2": "12",
    "timezone": "America/Santo_Domingo",
    "countryCode": "DO"
  },
  {
    "name": "La Vega",
    "iso2": "13",
    "timezone": "America/Santo_Domingo",
    "countryCode": "DO"
  },
  {
    "name": "María Trinidad Sánchez",
    "iso2": "14",
    "timezone": "America/Santo_Domingo",
    "countryCode": "DO"
  },
  {
    "name": "Monseñor Nouel",
    "iso2": "28",
    "timezone": "America/Santo_Domingo",
    "countryCode": "DO"
  },
  {
    "name": "Monte Cristi",
    "iso2": "15",
    "timezone": "America/Santo_Domingo",
    "countryCode": "DO"
  },
  {
    "name": "Monte Plata",
    "iso2": "29",
    "timezone": "America/Santo_Domingo",
    "countryCode": "DO"
  },
  {
    "name": "Ozama",
    "iso2": "40",
    "timezone": "America/Santo_Domingo",
    "countryCode": "DO"
  },
  {
    "name": "Pedernales",
    "iso2": "16",
    "timezone": "America/Santo_Domingo",
    "countryCode": "DO"
  },
  {
    "name": "Peravia",
    "iso2": "17",
    "timezone": "America/Santo_Domingo",
    "countryCode": "DO"
  },
  {
    "name": "Puerto Plata",
    "iso2": "18",
    "timezone": "America/Santo_Domingo",
    "countryCode": "DO"
  },
  {
    "name": "Samaná",
    "iso2": "20",
    "timezone": "America/Santo_Domingo",
    "countryCode": "DO"
  },
  {
    "name": "San Cristóbal",
    "iso2": "21",
    "timezone": "America/Santo_Domingo",
    "countryCode": "DO"
  },
  {
    "name": "San José de Ocoa",
    "iso2": "31",
    "timezone": "America/Santo_Domingo",
    "countryCode": "DO"
  },
  {
    "name": "San Juan",
    "iso2": "22",
    "timezone": "America/Santo_Domingo",
    "countryCode": "DO"
  },
  {
    "name": "San Pedro de Macorís",
    "iso2": "23",
    "timezone": "America/Santo_Domingo",
    "countryCode": "DO"
  },
  {
    "name": "Sánchez Ramírez",
    "iso2": "24",
    "timezone": "America/Santo_Domingo",
    "countryCode": "DO"
  },
  {
    "name": "Santiago",
    "iso2": "25",
    "timezone": "America/Santo_Domingo",
    "countryCode": "DO"
  },
  {
    "name": "Santiago Rodríguez",
    "iso2": "26",
    "timezone": "America/Santo_Domingo",
    "countryCode": "DO"
  },
  {
    "name": "Santo Domingo",
    "iso2": "32",
    "timezone": "America/Santo_Domingo",
    "countryCode": "DO"
  },
  {
    "name": "Valdesia",
    "iso2": "41",
    "timezone": "America/Santo_Domingo",
    "countryCode": "DO"
  },
  {
    "name": "Valverde",
    "iso2": "27",
    "timezone": "America/Santo_Domingo",
    "countryCode": "DO"
  },
  {
    "name": "Yuma",
    "iso2": "42",
    "timezone": "America/Santo_Domingo",
    "countryCode": "DO"
  },
  {
    "name": "Azuay",
    "iso2": "A",
    "timezone": "America/Guayaquil",
    "countryCode": "EC"
  },
  {
    "name": "Bolívar",
    "iso2": "B",
    "timezone": "America/Guayaquil",
    "countryCode": "EC"
  },
  {
    "name": "Cañar",
    "iso2": "F",
    "timezone": "America/Guayaquil",
    "countryCode": "EC"
  },
  {
    "name": "Carchi",
    "iso2": "C",
    "timezone": "America/Guayaquil",
    "countryCode": "EC"
  },
  {
    "name": "Chimborazo",
    "iso2": "H",
    "timezone": "America/Guayaquil",
    "countryCode": "EC"
  },
  {
    "name": "Cotopaxi",
    "iso2": "X",
    "timezone": "America/Guayaquil",
    "countryCode": "EC"
  },
  {
    "name": "El Oro",
    "iso2": "O",
    "timezone": "America/Guayaquil",
    "countryCode": "EC"
  },
  {
    "name": "Esmeraldas",
    "iso2": "E",
    "timezone": "America/Guayaquil",
    "countryCode": "EC"
  },
  {
    "name": "Galápagos",
    "iso2": "W",
    "timezone": "America/Guayaquil",
    "countryCode": "EC"
  },
  {
    "name": "Guayas",
    "iso2": "G",
    "timezone": "America/Guayaquil",
    "countryCode": "EC"
  },
  {
    "name": "Imbabura",
    "iso2": "I",
    "timezone": "America/Guayaquil",
    "countryCode": "EC"
  },
  {
    "name": "Loja",
    "iso2": "L",
    "timezone": "America/Guayaquil",
    "countryCode": "EC"
  },
  {
    "name": "Los Ríos",
    "iso2": "R",
    "timezone": "America/Guayaquil",
    "countryCode": "EC"
  },
  {
    "name": "Manabí",
    "iso2": "M",
    "timezone": "America/Guayaquil",
    "countryCode": "EC"
  },
  {
    "name": "Morona-Santiago",
    "iso2": "S",
    "timezone": "America/Guayaquil",
    "countryCode": "EC"
  },
  {
    "name": "Napo",
    "iso2": "N",
    "timezone": "America/Guayaquil",
    "countryCode": "EC"
  },
  {
    "name": "Orellana",
    "iso2": "D",
    "timezone": "America/Guayaquil",
    "countryCode": "EC"
  },
  {
    "name": "Pastaza",
    "iso2": "Y",
    "timezone": "America/Guayaquil",
    "countryCode": "EC"
  },
  {
    "name": "Pichincha",
    "iso2": "P",
    "timezone": "America/Guayaquil",
    "countryCode": "EC"
  },
  {
    "name": "Santa Elena",
    "iso2": "SE",
    "timezone": "America/Guayaquil",
    "countryCode": "EC"
  },
  {
    "name": "Santo Domingo de los Tsáchilas",
    "iso2": "SD",
    "timezone": "America/Guayaquil",
    "countryCode": "EC"
  },
  {
    "name": "Sucumbíos",
    "iso2": "U",
    "timezone": "America/Guayaquil",
    "countryCode": "EC"
  },
  {
    "name": "Tungurahua",
    "iso2": "T",
    "timezone": "America/Guayaquil",
    "countryCode": "EC"
  },
  {
    "name": "Zamora Chinchipe",
    "iso2": "Z",
    "timezone": "America/Guayaquil",
    "countryCode": "EC"
  },
  {
    "name": "Alexandria",
    "iso2": "ALX",
    "timezone": "Africa/Cairo",
    "countryCode": "EG"
  },
  {
    "name": "Aswan",
    "iso2": "ASN",
    "timezone": "Africa/Cairo",
    "countryCode": "EG"
  },
  {
    "name": "Asyut",
    "iso2": "AST",
    "timezone": "Africa/Cairo",
    "countryCode": "EG"
  },
  {
    "name": "Beheira",
    "iso2": "BH",
    "timezone": "Africa/Cairo",
    "countryCode": "EG"
  },
  {
    "name": "Beni Suef",
    "iso2": "BNS",
    "timezone": "Africa/Cairo",
    "countryCode": "EG"
  },
  {
    "name": "Cairo",
    "iso2": "C",
    "timezone": "Africa/Cairo",
    "countryCode": "EG"
  },
  {
    "name": "Dakahlia",
    "iso2": "DK",
    "timezone": "Africa/Cairo",
    "countryCode": "EG"
  },
  {
    "name": "Damietta",
    "iso2": "DT",
    "timezone": "Africa/Cairo",
    "countryCode": "EG"
  },
  {
    "name": "Faiyum",
    "iso2": "FYM",
    "timezone": "Africa/Cairo",
    "countryCode": "EG"
  },
  {
    "name": "Gharbia",
    "iso2": "GH",
    "timezone": "Africa/Cairo",
    "countryCode": "EG"
  },
  {
    "name": "Giza",
    "iso2": "GZ",
    "timezone": "Africa/Cairo",
    "countryCode": "EG"
  },
  {
    "name": "Ismailia",
    "iso2": "IS",
    "timezone": "Africa/Cairo",
    "countryCode": "EG"
  },
  {
    "name": "Kafr El-Sheikh",
    "iso2": "KFS",
    "timezone": "Africa/Cairo",
    "countryCode": "EG"
  },
  {
    "name": "Luxor",
    "iso2": "LX",
    "timezone": "Africa/Cairo",
    "countryCode": "EG"
  },
  {
    "name": "Matrouh",
    "iso2": "MT",
    "timezone": "Africa/Cairo",
    "countryCode": "EG"
  },
  {
    "name": "Minya",
    "iso2": "MN",
    "timezone": "Africa/Cairo",
    "countryCode": "EG"
  },
  {
    "name": "Monufia",
    "iso2": "MNF",
    "timezone": "Africa/Cairo",
    "countryCode": "EG"
  },
  {
    "name": "New Valley",
    "iso2": "WAD",
    "timezone": "Africa/Cairo",
    "countryCode": "EG"
  },
  {
    "name": "North Sinai",
    "iso2": "SIN",
    "timezone": "Africa/Cairo",
    "countryCode": "EG"
  },
  {
    "name": "Port Said",
    "iso2": "PTS",
    "timezone": "Africa/Cairo",
    "countryCode": "EG"
  },
  {
    "name": "Qalyubia",
    "iso2": "KB",
    "timezone": "Africa/Cairo",
    "countryCode": "EG"
  },
  {
    "name": "Qena",
    "iso2": "KN",
    "timezone": "Africa/Cairo",
    "countryCode": "EG"
  },
  {
    "name": "Red Sea",
    "iso2": "BA",
    "timezone": "Africa/Cairo",
    "countryCode": "EG"
  },
  {
    "name": "Sharqia",
    "iso2": "SHR",
    "timezone": "Africa/Cairo",
    "countryCode": "EG"
  },
  {
    "name": "Sohag",
    "iso2": "SHG",
    "timezone": "Africa/Cairo",
    "countryCode": "EG"
  },
  {
    "name": "South Sinai",
    "iso2": "JS",
    "timezone": "Africa/Cairo",
    "countryCode": "EG"
  },
  {
    "name": "Suez",
    "iso2": "SUZ",
    "timezone": "Africa/Cairo",
    "countryCode": "EG"
  },
  {
    "name": "Ahuachapán",
    "iso2": "AH",
    "timezone": "America/El_Salvador",
    "countryCode": "SV"
  },
  {
    "name": "Cabañas",
    "iso2": "CA",
    "timezone": "America/El_Salvador",
    "countryCode": "SV"
  },
  {
    "name": "Chalatenango",
    "iso2": "CH",
    "timezone": "America/El_Salvador",
    "countryCode": "SV"
  },
  {
    "name": "Cuscatlán",
    "iso2": "CU",
    "timezone": "America/El_Salvador",
    "countryCode": "SV"
  },
  {
    "name": "La Libertad",
    "iso2": "LI",
    "timezone": "America/El_Salvador",
    "countryCode": "SV"
  },
  {
    "name": "La Paz",
    "iso2": "PA",
    "timezone": "America/El_Salvador",
    "countryCode": "SV"
  },
  {
    "name": "La Unión ",
    "iso2": "UN",
    "timezone": "America/El_Salvador",
    "countryCode": "SV"
  },
  {
    "name": "Morazán",
    "iso2": "MO",
    "timezone": "America/El_Salvador",
    "countryCode": "SV"
  },
  {
    "name": "San Miguel",
    "iso2": "SM",
    "timezone": "America/El_Salvador",
    "countryCode": "SV"
  },
  {
    "name": "San Salvador",
    "iso2": "SS",
    "timezone": "America/El_Salvador",
    "countryCode": "SV"
  },
  {
    "name": "San Vicente",
    "iso2": "SV",
    "timezone": "America/El_Salvador",
    "countryCode": "SV"
  },
  {
    "name": "Santa Ana",
    "iso2": "SA",
    "timezone": "America/El_Salvador",
    "countryCode": "SV"
  },
  {
    "name": "Sonsonate",
    "iso2": "SO",
    "timezone": "America/El_Salvador",
    "countryCode": "SV"
  },
  {
    "name": "Usulután",
    "iso2": "US",
    "timezone": "America/El_Salvador",
    "countryCode": "SV"
  },
  {
    "name": "Annobón",
    "iso2": "AN",
    "timezone": "Africa/Malabo",
    "countryCode": "GQ"
  },
  {
    "name": "Bioko Norte",
    "iso2": "BN",
    "timezone": "Africa/Malabo",
    "countryCode": "GQ"
  },
  {
    "name": "Bioko Sur",
    "iso2": "BS",
    "timezone": "Africa/Malabo",
    "countryCode": "GQ"
  },
  {
    "name": "Centro Sur",
    "iso2": "CS",
    "timezone": "Africa/Malabo",
    "countryCode": "GQ"
  },
  {
    "name": "Djibloho",
    "iso2": "DJ",
    "timezone": "Africa/Malabo",
    "countryCode": "GQ"
  },
  {
    "name": "Insular",
    "iso2": "I",
    "timezone": "Africa/Malabo",
    "countryCode": "GQ"
  },
  {
    "name": "Kié-Ntem",
    "iso2": "KN",
    "timezone": "Africa/Malabo",
    "countryCode": "GQ"
  },
  {
    "name": "Litoral",
    "iso2": "LI",
    "timezone": "Africa/Malabo",
    "countryCode": "GQ"
  },
  {
    "name": "Río Muni",
    "iso2": "C",
    "timezone": "Africa/Malabo",
    "countryCode": "GQ"
  },
  {
    "name": "Wele-Nzas",
    "iso2": "WN",
    "timezone": "Africa/Malabo",
    "countryCode": "GQ"
  },
  {
    "name": "Anseba",
    "iso2": "AN",
    "timezone": "Africa/Asmara",
    "countryCode": "ER"
  },
  {
    "name": "Debub",
    "iso2": "DU",
    "timezone": "Africa/Asmara",
    "countryCode": "ER"
  },
  {
    "name": "Gash-Barka",
    "iso2": "GB",
    "timezone": "Africa/Asmara",
    "countryCode": "ER"
  },
  {
    "name": "Maekel",
    "iso2": "MA",
    "timezone": "Africa/Asmara",
    "countryCode": "ER"
  },
  {
    "name": "Northern Red Sea",
    "iso2": "SK",
    "timezone": "Africa/Asmara",
    "countryCode": "ER"
  },
  {
    "name": "Southern Red Sea",
    "iso2": "DK",
    "timezone": "Africa/Asmara",
    "countryCode": "ER"
  },
  {
    "name": "Alutaguse",
    "iso2": "130",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Anija",
    "iso2": "141",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Antsla",
    "iso2": "142",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Elva",
    "iso2": "171",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Häädemeeste",
    "iso2": "214",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Haapsalu",
    "iso2": "184",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Haljala",
    "iso2": "191",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Harju",
    "iso2": "37",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Harku",
    "iso2": "198",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Hiiu",
    "iso2": "39",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Hiiumaa",
    "iso2": "205",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Ida-Viru",
    "iso2": "45",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Järva",
    "iso2": "52",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Järva",
    "iso2": "255",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Joelähtme",
    "iso2": "245",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Jõgeva",
    "iso2": "50",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Jõgeva",
    "iso2": "247",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Jõhvi",
    "iso2": "251",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Kadrina",
    "iso2": "272",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Kambja",
    "iso2": "283",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Kanepi",
    "iso2": "284",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Kastre",
    "iso2": "291",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Kehtna",
    "iso2": "293",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Keila",
    "iso2": "296",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Kihnu",
    "iso2": "303",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Kiili",
    "iso2": "305",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Kohila",
    "iso2": "317",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Kohtla-Järve",
    "iso2": "321",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Kose",
    "iso2": "338",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Kuusalu",
    "iso2": "353",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Lääne",
    "iso2": "56",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Lääne-Harju",
    "iso2": "430",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Lääne-Nigula",
    "iso2": "441",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Lääne-Viru",
    "iso2": "60",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Lääneranna",
    "iso2": "431",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Loksa",
    "iso2": "424",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Lüganuse",
    "iso2": "442",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Luunja",
    "iso2": "432",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Maardu",
    "iso2": "446",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Märjamaa",
    "iso2": "503",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Muhu",
    "iso2": "478",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Mulgi",
    "iso2": "480",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Mustvee",
    "iso2": "486",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Narva",
    "iso2": "511",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Narva-Jõesuu",
    "iso2": "514",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Noo",
    "iso2": "528",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Otepää",
    "iso2": "557",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Paide",
    "iso2": "567",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Pärnu",
    "iso2": "68",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Pärnu",
    "iso2": "624",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Peipsiääre",
    "iso2": "586",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Põhja-Pärnu",
    "iso2": "638",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Põhja-Sakala",
    "iso2": "615",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Poltsamaa",
    "iso2": "618",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Põlva",
    "iso2": "622",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Põlva",
    "iso2": "64",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Raasiku",
    "iso2": "651",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Rae",
    "iso2": "653",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Rakvere",
    "iso2": "663",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Rakvere",
    "iso2": "661",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Räpina",
    "iso2": "708",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Rapla",
    "iso2": "668",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Rapla",
    "iso2": "71",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Rõuge",
    "iso2": "698",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Ruhnu",
    "iso2": "689",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Saarde",
    "iso2": "712",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Saare",
    "iso2": "74",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Saaremaa",
    "iso2": "714",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Saku",
    "iso2": "719",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Saue",
    "iso2": "726",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Setomaa",
    "iso2": "732",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Sillamäe",
    "iso2": "735",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Tallinn",
    "iso2": "784",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Tapa",
    "iso2": "792",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Tartu",
    "iso2": "793",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Tartu",
    "iso2": "79",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Tartu",
    "iso2": "796",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Toila",
    "iso2": "803",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Tori",
    "iso2": "809",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Tõrva",
    "iso2": "824",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Türi",
    "iso2": "834",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Väike-Maarja",
    "iso2": "928",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Valga",
    "iso2": "855",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Valga",
    "iso2": "81",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Viimsi",
    "iso2": "890",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Viljandi",
    "iso2": "897",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Viljandi",
    "iso2": "84",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Viljandi",
    "iso2": "899",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Vinni",
    "iso2": "901",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Viru-Nigula",
    "iso2": "903",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Vormsi",
    "iso2": "907",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Võru",
    "iso2": "917",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Võru",
    "iso2": "87",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Võru",
    "iso2": "919",
    "timezone": "Europe/Tallinn",
    "countryCode": "EE"
  },
  {
    "name": "Hhohho",
    "iso2": "HH",
    "timezone": "Africa/Mbabane",
    "countryCode": "SZ"
  },
  {
    "name": "Lubombo",
    "iso2": "LU",
    "timezone": "Africa/Mbabane",
    "countryCode": "SZ"
  },
  {
    "name": "Manzini",
    "iso2": "MA",
    "timezone": "Africa/Mbabane",
    "countryCode": "SZ"
  },
  {
    "name": "Shiselweni",
    "iso2": "SH",
    "timezone": "Africa/Mbabane",
    "countryCode": "SZ"
  },
  {
    "name": "Addis Ababa",
    "iso2": "AA",
    "timezone": "Africa/Addis_Ababa",
    "countryCode": "ET"
  },
  {
    "name": "Afar",
    "iso2": "AF",
    "timezone": "Africa/Addis_Ababa",
    "countryCode": "ET"
  },
  {
    "name": "Amhara",
    "iso2": "AM",
    "timezone": "Africa/Addis_Ababa",
    "countryCode": "ET"
  },
  {
    "name": "Benishangul-Gumuz",
    "iso2": "BE",
    "timezone": "Africa/Addis_Ababa",
    "countryCode": "ET"
  },
  {
    "name": "Dire Dawa",
    "iso2": "DD",
    "timezone": "Africa/Addis_Ababa",
    "countryCode": "ET"
  },
  {
    "name": "Gambela",
    "iso2": "GA",
    "timezone": "Africa/Addis_Ababa",
    "countryCode": "ET"
  },
  {
    "name": "Harari",
    "iso2": "HA",
    "timezone": "Africa/Addis_Ababa",
    "countryCode": "ET"
  },
  {
    "name": "Oromia",
    "iso2": "OR",
    "timezone": "Africa/Addis_Ababa",
    "countryCode": "ET"
  },
  {
    "name": "Sidama",
    "iso2": "SI",
    "timezone": "Africa/Addis_Ababa",
    "countryCode": "ET"
  },
  {
    "name": "Somali",
    "iso2": "SO",
    "timezone": "Africa/Addis_Ababa",
    "countryCode": "ET"
  },
  {
    "name": "Southern Nations, Nationalities, and Peoples",
    "iso2": "SN",
    "timezone": "Africa/Addis_Ababa",
    "countryCode": "ET"
  },
  {
    "name": "Southwest Ethiopia Peoples",
    "iso2": "SW",
    "timezone": "Africa/Addis_Ababa",
    "countryCode": "ET"
  },
  {
    "name": "Tigray",
    "iso2": "TI",
    "timezone": "Africa/Addis_Ababa",
    "countryCode": "ET"
  },
  {
    "name": "Eysturoy",
    "iso2": "EY",
    "timezone": "Atlantic/Faroe",
    "countryCode": "FO"
  },
  {
    "name": "Northern Isles",
    "iso2": "NO",
    "timezone": "Atlantic/Faroe",
    "countryCode": "FO"
  },
  {
    "name": "Sandoy",
    "iso2": "SA",
    "timezone": "Atlantic/Faroe",
    "countryCode": "FO"
  },
  {
    "name": "Streymoy",
    "iso2": "ST",
    "timezone": "Atlantic/Faroe",
    "countryCode": "FO"
  },
  {
    "name": "Suðuroy",
    "iso2": "SU",
    "timezone": "Atlantic/Faroe",
    "countryCode": "FO"
  },
  {
    "name": "Vágar",
    "iso2": "VA",
    "timezone": "Atlantic/Faroe",
    "countryCode": "FO"
  },
  {
    "name": "Ba",
    "iso2": "01",
    "timezone": "Pacific/Fiji",
    "countryCode": "FJ"
  },
  {
    "name": "Bua",
    "iso2": "02",
    "timezone": "Pacific/Fiji",
    "countryCode": "FJ"
  },
  {
    "name": "Cakaudrove",
    "iso2": "03",
    "timezone": "Pacific/Fiji",
    "countryCode": "FJ"
  },
  {
    "name": "Central",
    "iso2": "C",
    "timezone": "Pacific/Fiji",
    "countryCode": "FJ"
  },
  {
    "name": "Eastern",
    "iso2": "E",
    "timezone": "Pacific/Fiji",
    "countryCode": "FJ"
  },
  {
    "name": "Kadavu",
    "iso2": "04",
    "timezone": "Pacific/Fiji",
    "countryCode": "FJ"
  },
  {
    "name": "Lau",
    "iso2": "05",
    "timezone": "Pacific/Fiji",
    "countryCode": "FJ"
  },
  {
    "name": "Lomaiviti",
    "iso2": "06",
    "timezone": "Pacific/Fiji",
    "countryCode": "FJ"
  },
  {
    "name": "Macuata",
    "iso2": "07",
    "timezone": "Pacific/Fiji",
    "countryCode": "FJ"
  },
  {
    "name": "Nadroga-Navosa",
    "iso2": "08",
    "timezone": "Pacific/Fiji",
    "countryCode": "FJ"
  },
  {
    "name": "Naitasiri",
    "iso2": "09",
    "timezone": "Pacific/Fiji",
    "countryCode": "FJ"
  },
  {
    "name": "Namosi",
    "iso2": "10",
    "timezone": "Pacific/Fiji",
    "countryCode": "FJ"
  },
  {
    "name": "Northern",
    "iso2": "N",
    "timezone": "Pacific/Fiji",
    "countryCode": "FJ"
  },
  {
    "name": "Ra",
    "iso2": "11",
    "timezone": "Pacific/Fiji",
    "countryCode": "FJ"
  },
  {
    "name": "Rewa",
    "iso2": "12",
    "timezone": "Pacific/Fiji",
    "countryCode": "FJ"
  },
  {
    "name": "Rotuma",
    "iso2": "R",
    "timezone": "Pacific/Fiji",
    "countryCode": "FJ"
  },
  {
    "name": "Serua",
    "iso2": "13",
    "timezone": "Pacific/Fiji",
    "countryCode": "FJ"
  },
  {
    "name": "Tailevu",
    "iso2": "14",
    "timezone": "Pacific/Fiji",
    "countryCode": "FJ"
  },
  {
    "name": "Western",
    "iso2": "W",
    "timezone": "Pacific/Fiji",
    "countryCode": "FJ"
  },
  {
    "name": "Central Finland",
    "iso2": "08",
    "timezone": "Europe/Helsinki",
    "countryCode": "FI"
  },
  {
    "name": "Central Ostrobothnia",
    "iso2": "07",
    "timezone": "Europe/Helsinki",
    "countryCode": "FI"
  },
  {
    "name": "Finland Proper",
    "iso2": "19",
    "timezone": "Europe/Helsinki",
    "countryCode": "FI"
  },
  {
    "name": "Kainuu",
    "iso2": "05",
    "timezone": "Europe/Helsinki",
    "countryCode": "FI"
  },
  {
    "name": "Kymenlaakso",
    "iso2": "09",
    "timezone": "Europe/Helsinki",
    "countryCode": "FI"
  },
  {
    "name": "Lapland",
    "iso2": "10",
    "timezone": "Europe/Helsinki",
    "countryCode": "FI"
  },
  {
    "name": "North Karelia",
    "iso2": "13",
    "timezone": "Europe/Helsinki",
    "countryCode": "FI"
  },
  {
    "name": "Northern Ostrobothnia",
    "iso2": "14",
    "timezone": "Europe/Helsinki",
    "countryCode": "FI"
  },
  {
    "name": "Northern Savonia",
    "iso2": "15",
    "timezone": "Europe/Helsinki",
    "countryCode": "FI"
  },
  {
    "name": "Ostrobothnia",
    "iso2": "12",
    "timezone": "Europe/Helsinki",
    "countryCode": "FI"
  },
  {
    "name": "Päijänne Tavastia",
    "iso2": "16",
    "timezone": "Europe/Helsinki",
    "countryCode": "FI"
  },
  {
    "name": "Pirkanmaa",
    "iso2": "11",
    "timezone": "Europe/Helsinki",
    "countryCode": "FI"
  },
  {
    "name": "Satakunta",
    "iso2": "17",
    "timezone": "Europe/Helsinki",
    "countryCode": "FI"
  },
  {
    "name": "South Karelia",
    "iso2": "02",
    "timezone": "Europe/Helsinki",
    "countryCode": "FI"
  },
  {
    "name": "Southern Ostrobothnia",
    "iso2": "03",
    "timezone": "Europe/Helsinki",
    "countryCode": "FI"
  },
  {
    "name": "Southern Savonia",
    "iso2": "04",
    "timezone": "Europe/Helsinki",
    "countryCode": "FI"
  },
  {
    "name": "Tavastia Proper",
    "iso2": "06",
    "timezone": "Europe/Helsinki",
    "countryCode": "FI"
  },
  {
    "name": "Uusimaa",
    "iso2": "18",
    "timezone": "Europe/Helsinki",
    "countryCode": "FI"
  },
  {
    "name": "Ain",
    "iso2": "01",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Aisne",
    "iso2": "02",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Allier",
    "iso2": "03",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Alpes-de-Haute-Provence",
    "iso2": "04",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Alpes-Maritimes",
    "iso2": "06",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Alsace",
    "iso2": "6AE",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Ardèche",
    "iso2": "07",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Ardennes",
    "iso2": "08",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Ariège",
    "iso2": "09",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Aube",
    "iso2": "10",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Aude",
    "iso2": "11",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Auvergne-Rhône-Alpes",
    "iso2": "ARA",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Aveyron",
    "iso2": "12",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Bas-Rhin",
    "iso2": "67",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Bouches-du-Rhône",
    "iso2": "13",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Bourgogne-Franche-Comté",
    "iso2": "BFC",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Bretagne",
    "iso2": "BRE",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Calvados",
    "iso2": "14",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Cantal",
    "iso2": "15",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Centre-Val de Loire",
    "iso2": "CVL",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Charente",
    "iso2": "16",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Charente-Maritime",
    "iso2": "17",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Cher",
    "iso2": "18",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Clipperton",
    "iso2": "CP",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Corrèze",
    "iso2": "19",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Corse",
    "iso2": "20R",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Corse-du-Sud",
    "iso2": "2A",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Côte-d'Or",
    "iso2": "21",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Côtes-d'Armor",
    "iso2": "22",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Creuse",
    "iso2": "23",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Deux-Sèvres",
    "iso2": "79",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Dordogne",
    "iso2": "24",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Doubs",
    "iso2": "25",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Drôme",
    "iso2": "26",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Essonne",
    "iso2": "91",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Eure",
    "iso2": "27",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Eure-et-Loir",
    "iso2": "28",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Finistère",
    "iso2": "29",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "French Guiana",
    "iso2": "973",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "French Polynesia",
    "iso2": "PF",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "French Southern and Antarctic Lands",
    "iso2": "TF",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Gard",
    "iso2": "30",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Gers",
    "iso2": "32",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Gironde",
    "iso2": "33",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Grand-Est",
    "iso2": "GES",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Guadeloupe",
    "iso2": "971",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Haut-Rhin",
    "iso2": "68",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Haute-Corse",
    "iso2": "2B",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Haute-Garonne",
    "iso2": "31",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Haute-Loire",
    "iso2": "43",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Haute-Marne",
    "iso2": "52",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Haute-Saône",
    "iso2": "70",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Haute-Savoie",
    "iso2": "74",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Haute-Vienne",
    "iso2": "87",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Hautes-Alpes",
    "iso2": "05",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Hautes-Pyrénées",
    "iso2": "65",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Hauts-de-France",
    "iso2": "HDF",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Hauts-de-Seine",
    "iso2": "92",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Hérault",
    "iso2": "34",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Île-de-France",
    "iso2": "IDF",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Ille-et-Vilaine",
    "iso2": "35",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Indre",
    "iso2": "36",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Indre-et-Loire",
    "iso2": "37",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Isère",
    "iso2": "38",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Jura",
    "iso2": "39",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "La Réunion",
    "iso2": "974",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Landes",
    "iso2": "40",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Loir-et-Cher",
    "iso2": "41",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Loire",
    "iso2": "42",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Loire-Atlantique",
    "iso2": "44",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Loiret",
    "iso2": "45",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Lot",
    "iso2": "46",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Lot-et-Garonne",
    "iso2": "47",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Lozère",
    "iso2": "48",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Maine-et-Loire",
    "iso2": "49",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Manche",
    "iso2": "50",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Marne",
    "iso2": "51",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Martinique",
    "iso2": "972",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Mayenne",
    "iso2": "53",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Mayotte",
    "iso2": "976",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Métropole de Lyon",
    "iso2": "69M",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Meurthe-et-Moselle",
    "iso2": "54",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Meuse",
    "iso2": "55",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Morbihan",
    "iso2": "56",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Moselle",
    "iso2": "57",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Nièvre",
    "iso2": "58",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Nord",
    "iso2": "59",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Normandie",
    "iso2": "NOR",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Nouvelle-Aquitaine",
    "iso2": "NAQ",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Nouvelle-Calédonie",
    "iso2": "NC",
    "timezone": "Pacific/Noumea",
    "countryCode": "FR"
  },
  {
    "name": "Occitanie",
    "iso2": "OCC",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Oise",
    "iso2": "60",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Orne",
    "iso2": "61",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Paris",
    "iso2": "75C",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Pas-de-Calais",
    "iso2": "62",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Pays-de-la-Loire",
    "iso2": "PDL",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Provence-Alpes-Côte-d’Azur",
    "iso2": "PAC",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Puy-de-Dôme",
    "iso2": "63",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Pyrénées-Atlantiques",
    "iso2": "64",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Pyrénées-Orientales",
    "iso2": "66",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Rhône",
    "iso2": "69",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Saint Pierre and Miquelon",
    "iso2": "PM",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Saint-Barthélemy",
    "iso2": "BL",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Saint-Martin",
    "iso2": "MF",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Saône-et-Loire",
    "iso2": "71",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Sarthe",
    "iso2": "72",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Savoie",
    "iso2": "73",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Seine-et-Marne",
    "iso2": "77",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Seine-Maritime",
    "iso2": "76",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Seine-Saint-Denis",
    "iso2": "93",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Somme",
    "iso2": "80",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Tarn",
    "iso2": "81",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Tarn-et-Garonne",
    "iso2": "82",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Territoire de Belfort",
    "iso2": "90",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Val-d'Oise",
    "iso2": "95",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Val-de-Marne",
    "iso2": "94",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Var",
    "iso2": "83",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Vaucluse",
    "iso2": "84",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Vendée",
    "iso2": "85",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Vienne",
    "iso2": "86",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Vosges",
    "iso2": "88",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Wallis and Futuna",
    "iso2": "WF",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Yonne",
    "iso2": "89",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Yvelines",
    "iso2": "78",
    "timezone": "Europe/Paris",
    "countryCode": "FR"
  },
  {
    "name": "Guyane",
    "iso2": "01",
    "timezone": "America/Cayenne",
    "countryCode": "GF"
  },
  {
    "name": "Austral Islands",
    "iso2": "01",
    "timezone": "Pacific/Gambier",
    "countryCode": "PF"
  },
  {
    "name": "Leeward Islands",
    "iso2": "02",
    "timezone": "Pacific/Gambier",
    "countryCode": "PF"
  },
  {
    "name": "Marquesas Islands",
    "iso2": "03",
    "timezone": "Pacific/Marquesas",
    "countryCode": "PF"
  },
  {
    "name": "Tuamotu-Gambier",
    "iso2": "04",
    "timezone": "Pacific/Gambier",
    "countryCode": "PF"
  },
  {
    "name": "Windward Islands",
    "iso2": "05",
    "timezone": "Pacific/Gambier",
    "countryCode": "PF"
  },
  {
    "name": "Adélie Land",
    "iso2": "01",
    "timezone": "Antarctica/DumontDUrville",
    "countryCode": "TF"
  },
  {
    "name": "Crozet Islands",
    "iso2": "02",
    "timezone": "Indian/Kerguelen",
    "countryCode": "TF"
  },
  {
    "name": "Kerguelen Islands",
    "iso2": "03",
    "timezone": "Indian/Kerguelen",
    "countryCode": "TF"
  },
  {
    "name": "Saint-Paul and Amsterdam Islands",
    "iso2": "04",
    "timezone": "Indian/Kerguelen",
    "countryCode": "TF"
  },
  {
    "name": "Scattered Islands",
    "iso2": "05",
    "timezone": "Indian/Reunion",
    "countryCode": "TF"
  },
  {
    "name": "Estuaire",
    "iso2": "1",
    "timezone": "Africa/Libreville",
    "countryCode": "GA"
  },
  {
    "name": "Haut-Ogooué",
    "iso2": "2",
    "timezone": "Africa/Libreville",
    "countryCode": "GA"
  },
  {
    "name": "Moyen-Ogooué",
    "iso2": "3",
    "timezone": "Africa/Libreville",
    "countryCode": "GA"
  },
  {
    "name": "Ngounié",
    "iso2": "4",
    "timezone": "Africa/Libreville",
    "countryCode": "GA"
  },
  {
    "name": "Nyanga",
    "iso2": "5",
    "timezone": "Africa/Libreville",
    "countryCode": "GA"
  },
  {
    "name": "Ogooué-Ivindo",
    "iso2": "6",
    "timezone": "Africa/Libreville",
    "countryCode": "GA"
  },
  {
    "name": "Ogooué-Lolo",
    "iso2": "7",
    "timezone": "Africa/Libreville",
    "countryCode": "GA"
  },
  {
    "name": "Ogooué-Maritime",
    "iso2": "8",
    "timezone": "Africa/Libreville",
    "countryCode": "GA"
  },
  {
    "name": "Woleu-Ntem",
    "iso2": "9",
    "timezone": "Africa/Libreville",
    "countryCode": "GA"
  },
  {
    "name": "Abkhazia",
    "iso2": "AB",
    "timezone": "Asia/Tbilisi",
    "countryCode": "GE"
  },
  {
    "name": "Adjara",
    "iso2": "AJ",
    "timezone": "Asia/Tbilisi",
    "countryCode": "GE"
  },
  {
    "name": "Guria",
    "iso2": "GU",
    "timezone": "Asia/Tbilisi",
    "countryCode": "GE"
  },
  {
    "name": "Imereti",
    "iso2": "IM",
    "timezone": "Asia/Tbilisi",
    "countryCode": "GE"
  },
  {
    "name": "Kakheti",
    "iso2": "KA",
    "timezone": "Asia/Tbilisi",
    "countryCode": "GE"
  },
  {
    "name": "Kvemo Kartli",
    "iso2": "KK",
    "timezone": "Asia/Tbilisi",
    "countryCode": "GE"
  },
  {
    "name": "Mtskheta-Mtianeti",
    "iso2": "MM",
    "timezone": "Asia/Tbilisi",
    "countryCode": "GE"
  },
  {
    "name": "Racha-Lechkhumi and Kvemo Svaneti",
    "iso2": "RL",
    "timezone": "Asia/Tbilisi",
    "countryCode": "GE"
  },
  {
    "name": "Samegrelo-Zemo Svaneti",
    "iso2": "SZ",
    "timezone": "Asia/Tbilisi",
    "countryCode": "GE"
  },
  {
    "name": "Samtskhe-Javakheti",
    "iso2": "SJ",
    "timezone": "Asia/Tbilisi",
    "countryCode": "GE"
  },
  {
    "name": "Shida Kartli",
    "iso2": "SK",
    "timezone": "Asia/Tbilisi",
    "countryCode": "GE"
  },
  {
    "name": "Tbilisi",
    "iso2": "TB",
    "timezone": "Asia/Tbilisi",
    "countryCode": "GE"
  },
  {
    "name": "Baden-Württemberg",
    "iso2": "BW",
    "timezone": "Europe/Berlin",
    "countryCode": "DE"
  },
  {
    "name": "Bavaria",
    "iso2": "BY",
    "timezone": "Europe/Berlin",
    "countryCode": "DE"
  },
  {
    "name": "Berlin",
    "iso2": "BE",
    "timezone": "Europe/Berlin",
    "countryCode": "DE"
  },
  {
    "name": "Brandenburg",
    "iso2": "BB",
    "timezone": "Europe/Berlin",
    "countryCode": "DE"
  },
  {
    "name": "Bremen",
    "iso2": "HB",
    "timezone": "Europe/Berlin",
    "countryCode": "DE"
  },
  {
    "name": "Hamburg",
    "iso2": "HH",
    "timezone": "Europe/Berlin",
    "countryCode": "DE"
  },
  {
    "name": "Hessen",
    "iso2": "HE",
    "timezone": "Europe/Berlin",
    "countryCode": "DE"
  },
  {
    "name": "Lower Saxony",
    "iso2": "NI",
    "timezone": "Europe/Berlin",
    "countryCode": "DE"
  },
  {
    "name": "Mecklenburg-Vorpommern",
    "iso2": "MV",
    "timezone": "Europe/Berlin",
    "countryCode": "DE"
  },
  {
    "name": "North Rhine-Westphalia",
    "iso2": "NW",
    "timezone": "Europe/Berlin",
    "countryCode": "DE"
  },
  {
    "name": "Rhineland-Palatinate",
    "iso2": "RP",
    "timezone": "Europe/Berlin",
    "countryCode": "DE"
  },
  {
    "name": "Saarland",
    "iso2": "SL",
    "timezone": "Europe/Berlin",
    "countryCode": "DE"
  },
  {
    "name": "Saxony",
    "iso2": "SN",
    "timezone": "Europe/Berlin",
    "countryCode": "DE"
  },
  {
    "name": "Saxony-Anhalt",
    "iso2": "ST",
    "timezone": "Europe/Berlin",
    "countryCode": "DE"
  },
  {
    "name": "Schleswig-Holstein",
    "iso2": "SH",
    "timezone": "Europe/Berlin",
    "countryCode": "DE"
  },
  {
    "name": "Thuringia",
    "iso2": "TH",
    "timezone": "Europe/Berlin",
    "countryCode": "DE"
  },
  {
    "name": "Ahafo",
    "iso2": "AF",
    "timezone": "Africa/Accra",
    "countryCode": "GH"
  },
  {
    "name": "Ashanti",
    "iso2": "AH",
    "timezone": "Africa/Accra",
    "countryCode": "GH"
  },
  {
    "name": "Bono",
    "iso2": "BO",
    "timezone": "Africa/Accra",
    "countryCode": "GH"
  },
  {
    "name": "Bono East",
    "iso2": "BE",
    "timezone": "Africa/Accra",
    "countryCode": "GH"
  },
  {
    "name": "Central",
    "iso2": "CP",
    "timezone": "Africa/Accra",
    "countryCode": "GH"
  },
  {
    "name": "Eastern",
    "iso2": "EP",
    "timezone": "Africa/Accra",
    "countryCode": "GH"
  },
  {
    "name": "Greater Accra",
    "iso2": "AA",
    "timezone": "Africa/Accra",
    "countryCode": "GH"
  },
  {
    "name": "North East",
    "iso2": "NE",
    "timezone": "Africa/Accra",
    "countryCode": "GH"
  },
  {
    "name": "Northern",
    "iso2": "NP",
    "timezone": "Africa/Accra",
    "countryCode": "GH"
  },
  {
    "name": "Oti",
    "iso2": "OT",
    "timezone": "Africa/Accra",
    "countryCode": "GH"
  },
  {
    "name": "Savannah",
    "iso2": "SV",
    "timezone": "Africa/Accra",
    "countryCode": "GH"
  },
  {
    "name": "Upper East",
    "iso2": "UE",
    "timezone": "Africa/Accra",
    "countryCode": "GH"
  },
  {
    "name": "Upper West",
    "iso2": "UW",
    "timezone": "Africa/Accra",
    "countryCode": "GH"
  },
  {
    "name": "Volta",
    "iso2": "TV",
    "timezone": "Africa/Accra",
    "countryCode": "GH"
  },
  {
    "name": "Western",
    "iso2": "WP",
    "timezone": "Africa/Accra",
    "countryCode": "GH"
  },
  {
    "name": "Western North",
    "iso2": "WN",
    "timezone": "Africa/Accra",
    "countryCode": "GH"
  },
  {
    "name": "Achaea",
    "iso2": "13",
    "timezone": "Europe/Athens",
    "countryCode": "GR"
  },
  {
    "name": "Attica",
    "iso2": "I",
    "timezone": "Europe/Athens",
    "countryCode": "GR"
  },
  {
    "name": "Central Greece",
    "iso2": "H",
    "timezone": "Europe/Athens",
    "countryCode": "GR"
  },
  {
    "name": "Central Macedonia",
    "iso2": "B",
    "timezone": "Europe/Athens",
    "countryCode": "GR"
  },
  {
    "name": "Crete",
    "iso2": "M",
    "timezone": "Europe/Athens",
    "countryCode": "GR"
  },
  {
    "name": "East Attica",
    "iso2": "A2",
    "timezone": "Europe/Athens",
    "countryCode": "GR"
  },
  {
    "name": "East Macedonia and Thrace",
    "iso2": "A",
    "timezone": "Europe/Athens",
    "countryCode": "GR"
  },
  {
    "name": "Epirus",
    "iso2": "D",
    "timezone": "Europe/Athens",
    "countryCode": "GR"
  },
  {
    "name": "Ionian Islands",
    "iso2": "F",
    "timezone": "Europe/Athens",
    "countryCode": "GR"
  },
  {
    "name": "North Aegean",
    "iso2": "K",
    "timezone": "Europe/Athens",
    "countryCode": "GR"
  },
  {
    "name": "Peloponnese",
    "iso2": "J",
    "timezone": "Europe/Athens",
    "countryCode": "GR"
  },
  {
    "name": "South Aegean",
    "iso2": "L",
    "timezone": "Europe/Athens",
    "countryCode": "GR"
  },
  {
    "name": "Thessaly",
    "iso2": "E",
    "timezone": "Europe/Athens",
    "countryCode": "GR"
  },
  {
    "name": "West Greece",
    "iso2": "G",
    "timezone": "Europe/Athens",
    "countryCode": "GR"
  },
  {
    "name": "West Macedonia",
    "iso2": "C",
    "timezone": "Europe/Athens",
    "countryCode": "GR"
  },
  {
    "name": "Avannaata",
    "iso2": "AV",
    "timezone": "America/Nuuk",
    "countryCode": "GL"
  },
  {
    "name": "Kujalleq",
    "iso2": "KU",
    "timezone": "America/Nuuk",
    "countryCode": "GL"
  },
  {
    "name": "Qeqertalik",
    "iso2": "QT",
    "timezone": "America/Danmarkshavn",
    "countryCode": "GL"
  },
  {
    "name": "Qeqqata",
    "iso2": "QE",
    "timezone": "America/Nuuk",
    "countryCode": "GL"
  },
  {
    "name": "Sermersooq",
    "iso2": "SM",
    "timezone": "America/Nuuk",
    "countryCode": "GL"
  },
  {
    "name": "Carriacou",
    "iso2": "10",
    "timezone": "America/Grenada",
    "countryCode": "GD"
  },
  {
    "name": "Saint Andrew",
    "iso2": "01",
    "timezone": "America/Grenada",
    "countryCode": "GD"
  },
  {
    "name": "Saint David",
    "iso2": "02",
    "timezone": "America/Grenada",
    "countryCode": "GD"
  },
  {
    "name": "Saint George",
    "iso2": "03",
    "timezone": "America/Grenada",
    "countryCode": "GD"
  },
  {
    "name": "Saint John",
    "iso2": "04",
    "timezone": "America/Grenada",
    "countryCode": "GD"
  },
  {
    "name": "Saint Mark",
    "iso2": "05",
    "timezone": "America/Grenada",
    "countryCode": "GD"
  },
  {
    "name": "Saint Patrick",
    "iso2": "06",
    "timezone": "America/Grenada",
    "countryCode": "GD"
  },
  {
    "name": "Basse-Terre",
    "iso2": "01",
    "timezone": "America/Guadeloupe",
    "countryCode": "GP"
  },
  {
    "name": "Pointe-à-Pitre",
    "iso2": "02",
    "timezone": "America/Guadeloupe",
    "countryCode": "GP"
  },
  {
    "name": "Agana Heights",
    "iso2": "01",
    "timezone": "Pacific/Guam",
    "countryCode": "GU"
  },
  {
    "name": "Asan-Maina",
    "iso2": "02",
    "timezone": "Pacific/Guam",
    "countryCode": "GU"
  },
  {
    "name": "Barrigada",
    "iso2": "03",
    "timezone": "Pacific/Guam",
    "countryCode": "GU"
  },
  {
    "name": "Chalan Pago-Ordot",
    "iso2": "04",
    "timezone": "Pacific/Guam",
    "countryCode": "GU"
  },
  {
    "name": "Dededo",
    "iso2": "05",
    "timezone": "Pacific/Guam",
    "countryCode": "GU"
  },
  {
    "name": "Hågat",
    "iso2": "06",
    "timezone": "Pacific/Guam",
    "countryCode": "GU"
  },
  {
    "name": "Hagåtña",
    "iso2": "12",
    "timezone": "Pacific/Guam",
    "countryCode": "GU"
  },
  {
    "name": "Inarajan (Inalåhan)",
    "iso2": "08",
    "timezone": "Pacific/Guam",
    "countryCode": "GU"
  },
  {
    "name": "Mangilao",
    "iso2": "10",
    "timezone": "Pacific/Guam",
    "countryCode": "GU"
  },
  {
    "name": "Merizo (Malesso)",
    "iso2": "09",
    "timezone": "Pacific/Guam",
    "countryCode": "GU"
  },
  {
    "name": "Mongmong-Toto-Maite",
    "iso2": "11",
    "timezone": "Pacific/Guam",
    "countryCode": "GU"
  },
  {
    "name": "Piti",
    "iso2": "13",
    "timezone": "Pacific/Guam",
    "countryCode": "GU"
  },
  {
    "name": "Santa Rita (Sånta Rita-Sumai)",
    "iso2": "14",
    "timezone": "Pacific/Guam",
    "countryCode": "GU"
  },
  {
    "name": "Sinajana",
    "iso2": "15",
    "timezone": "Pacific/Guam",
    "countryCode": "GU"
  },
  {
    "name": "Talofofo (Talo'fo'fo)",
    "iso2": "16",
    "timezone": "Pacific/Guam",
    "countryCode": "GU"
  },
  {
    "name": "Tamuning",
    "iso2": "17",
    "timezone": "Pacific/Guam",
    "countryCode": "GU"
  },
  {
    "name": "Umatac (Humåtak)",
    "iso2": "07",
    "timezone": "Pacific/Guam",
    "countryCode": "GU"
  },
  {
    "name": "Yigo",
    "iso2": "18",
    "timezone": "Pacific/Guam",
    "countryCode": "GU"
  },
  {
    "name": "Yona",
    "iso2": "19",
    "timezone": "Pacific/Guam",
    "countryCode": "GU"
  },
  {
    "name": "Alta Verapaz ",
    "iso2": "16",
    "timezone": "America/Guatemala",
    "countryCode": "GT"
  },
  {
    "name": "Baja Verapaz ",
    "iso2": "15",
    "timezone": "America/Guatemala",
    "countryCode": "GT"
  },
  {
    "name": "Chimaltenango ",
    "iso2": "04",
    "timezone": "America/Guatemala",
    "countryCode": "GT"
  },
  {
    "name": "Chiquimula ",
    "iso2": "20",
    "timezone": "America/Guatemala",
    "countryCode": "GT"
  },
  {
    "name": "El Progreso ",
    "iso2": "02",
    "timezone": "America/Guatemala",
    "countryCode": "GT"
  },
  {
    "name": "Escuintla ",
    "iso2": "05",
    "timezone": "America/Guatemala",
    "countryCode": "GT"
  },
  {
    "name": "Guatemala ",
    "iso2": "01",
    "timezone": "America/Guatemala",
    "countryCode": "GT"
  },
  {
    "name": "Huehuetenango ",
    "iso2": "13",
    "timezone": "America/Guatemala",
    "countryCode": "GT"
  },
  {
    "name": "Izabal ",
    "iso2": "18",
    "timezone": "America/Guatemala",
    "countryCode": "GT"
  },
  {
    "name": "Jalapa ",
    "iso2": "21",
    "timezone": "America/Guatemala",
    "countryCode": "GT"
  },
  {
    "name": "Jutiapa ",
    "iso2": "22",
    "timezone": "America/Guatemala",
    "countryCode": "GT"
  },
  {
    "name": "Petén ",
    "iso2": "17",
    "timezone": "America/Guatemala",
    "countryCode": "GT"
  },
  {
    "name": "Quetzaltenango ",
    "iso2": "09",
    "timezone": "America/Guatemala",
    "countryCode": "GT"
  },
  {
    "name": "Quiché ",
    "iso2": "14",
    "timezone": "America/Guatemala",
    "countryCode": "GT"
  },
  {
    "name": "Retalhuleu ",
    "iso2": "11",
    "timezone": "America/Guatemala",
    "countryCode": "GT"
  },
  {
    "name": "Sacatepéquez ",
    "iso2": "03",
    "timezone": "America/Guatemala",
    "countryCode": "GT"
  },
  {
    "name": "San Marcos ",
    "iso2": "12",
    "timezone": "America/Guatemala",
    "countryCode": "GT"
  },
  {
    "name": "Santa Rosa ",
    "iso2": "06",
    "timezone": "America/Guatemala",
    "countryCode": "GT"
  },
  {
    "name": "Sololá ",
    "iso2": "07",
    "timezone": "America/Guatemala",
    "countryCode": "GT"
  },
  {
    "name": "Suchitepéquez ",
    "iso2": "10",
    "timezone": "America/Guatemala",
    "countryCode": "GT"
  },
  {
    "name": "Totonicapán ",
    "iso2": "08",
    "timezone": "America/Guatemala",
    "countryCode": "GT"
  },
  {
    "name": "Zacapa",
    "iso2": "19",
    "timezone": "America/Guatemala",
    "countryCode": "GT"
  },
  {
    "name": "Alderney",
    "iso2": "04",
    "timezone": "Europe/Guernsey",
    "countryCode": "GG"
  },
  {
    "name": "Castel",
    "iso2": "01",
    "timezone": "Europe/Guernsey",
    "countryCode": "GG"
  },
  {
    "name": "Forest",
    "iso2": "02",
    "timezone": "Europe/Guernsey",
    "countryCode": "GG"
  },
  {
    "name": "Sark",
    "iso2": "07",
    "timezone": "Europe/Guernsey",
    "countryCode": "GG"
  },
  {
    "name": "St Andrew",
    "iso2": "03",
    "timezone": "Europe/Guernsey",
    "countryCode": "GG"
  },
  {
    "name": "St Martin",
    "iso2": "05",
    "timezone": "Europe/Guernsey",
    "countryCode": "GG"
  },
  {
    "name": "St Peter Port",
    "iso2": "06",
    "timezone": "Europe/Guernsey",
    "countryCode": "GG"
  },
  {
    "name": "St Pierre du Bois",
    "iso2": "08",
    "timezone": "Europe/Guernsey",
    "countryCode": "GG"
  },
  {
    "name": "St Sampson",
    "iso2": "09",
    "timezone": "Europe/Guernsey",
    "countryCode": "GG"
  },
  {
    "name": "St Saviour",
    "iso2": "10",
    "timezone": "Europe/Guernsey",
    "countryCode": "GG"
  },
  {
    "name": "Torteval",
    "iso2": "11",
    "timezone": "Europe/Guernsey",
    "countryCode": "GG"
  },
  {
    "name": "Vale",
    "iso2": "12",
    "timezone": "Europe/Guernsey",
    "countryCode": "GG"
  },
  {
    "name": "Beyla",
    "iso2": "BE",
    "timezone": "Africa/Conakry",
    "countryCode": "GN"
  },
  {
    "name": "Boffa",
    "iso2": "BF",
    "timezone": "Africa/Conakry",
    "countryCode": "GN"
  },
  {
    "name": "Boké",
    "iso2": "B",
    "timezone": "Africa/Conakry",
    "countryCode": "GN"
  },
  {
    "name": "Boké",
    "iso2": "BK",
    "timezone": "Africa/Conakry",
    "countryCode": "GN"
  },
  {
    "name": "Conakry",
    "iso2": "C",
    "timezone": "Africa/Conakry",
    "countryCode": "GN"
  },
  {
    "name": "Coyah",
    "iso2": "CO",
    "timezone": "Africa/Conakry",
    "countryCode": "GN"
  },
  {
    "name": "Dabola",
    "iso2": "DB",
    "timezone": "Africa/Conakry",
    "countryCode": "GN"
  },
  {
    "name": "Dalaba",
    "iso2": "DL",
    "timezone": "Africa/Conakry",
    "countryCode": "GN"
  },
  {
    "name": "Dinguiraye",
    "iso2": "DI",
    "timezone": "Africa/Conakry",
    "countryCode": "GN"
  },
  {
    "name": "Dubréka",
    "iso2": "DU",
    "timezone": "Africa/Conakry",
    "countryCode": "GN"
  },
  {
    "name": "Faranah",
    "iso2": "F",
    "timezone": "Africa/Conakry",
    "countryCode": "GN"
  },
  {
    "name": "Faranah",
    "iso2": "FA",
    "timezone": "Africa/Conakry",
    "countryCode": "GN"
  },
  {
    "name": "Forécariah",
    "iso2": "FO",
    "timezone": "Africa/Conakry",
    "countryCode": "GN"
  },
  {
    "name": "Fria",
    "iso2": "FR",
    "timezone": "Africa/Conakry",
    "countryCode": "GN"
  },
  {
    "name": "Gaoual",
    "iso2": "GA",
    "timezone": "Africa/Conakry",
    "countryCode": "GN"
  },
  {
    "name": "Guéckédou",
    "iso2": "GU",
    "timezone": "Africa/Conakry",
    "countryCode": "GN"
  },
  {
    "name": "Kankan",
    "iso2": "KA",
    "timezone": "Africa/Conakry",
    "countryCode": "GN"
  },
  {
    "name": "Kankan",
    "iso2": "K",
    "timezone": "Africa/Conakry",
    "countryCode": "GN"
  },
  {
    "name": "Kérouané",
    "iso2": "KE",
    "timezone": "Africa/Conakry",
    "countryCode": "GN"
  },
  {
    "name": "Kindia",
    "iso2": "D",
    "timezone": "Africa/Conakry",
    "countryCode": "GN"
  },
  {
    "name": "Kindia",
    "iso2": "KD",
    "timezone": "Africa/Conakry",
    "countryCode": "GN"
  },
  {
    "name": "Kissidougou",
    "iso2": "KS",
    "timezone": "Africa/Conakry",
    "countryCode": "GN"
  },
  {
    "name": "Koubia",
    "iso2": "KB",
    "timezone": "Africa/Conakry",
    "countryCode": "GN"
  },
  {
    "name": "Koundara",
    "iso2": "KN",
    "timezone": "Africa/Conakry",
    "countryCode": "GN"
  },
  {
    "name": "Kouroussa",
    "iso2": "KO",
    "timezone": "Africa/Conakry",
    "countryCode": "GN"
  },
  {
    "name": "Labé",
    "iso2": "LA",
    "timezone": "Africa/Conakry",
    "countryCode": "GN"
  },
  {
    "name": "Labé",
    "iso2": "L",
    "timezone": "Africa/Conakry",
    "countryCode": "GN"
  },
  {
    "name": "Lélouma",
    "iso2": "LE",
    "timezone": "Africa/Conakry",
    "countryCode": "GN"
  },
  {
    "name": "Lola",
    "iso2": "LO",
    "timezone": "Africa/Conakry",
    "countryCode": "GN"
  },
  {
    "name": "Macenta",
    "iso2": "MC",
    "timezone": "Africa/Conakry",
    "countryCode": "GN"
  },
  {
    "name": "Mali",
    "iso2": "ML",
    "timezone": "Africa/Conakry",
    "countryCode": "GN"
  },
  {
    "name": "Mamou",
    "iso2": "M",
    "timezone": "Africa/Conakry",
    "countryCode": "GN"
  },
  {
    "name": "Mamou",
    "iso2": "MM",
    "timezone": "Africa/Conakry",
    "countryCode": "GN"
  },
  {
    "name": "Mandiana",
    "iso2": "MD",
    "timezone": "Africa/Conakry",
    "countryCode": "GN"
  },
  {
    "name": "Nzérékoré",
    "iso2": "N",
    "timezone": "Africa/Conakry",
    "countryCode": "GN"
  },
  {
    "name": "Nzérékoré",
    "iso2": "NZ",
    "timezone": "Africa/Conakry",
    "countryCode": "GN"
  },
  {
    "name": "Pita",
    "iso2": "PI",
    "timezone": "Africa/Conakry",
    "countryCode": "GN"
  },
  {
    "name": "Siguiri",
    "iso2": "SI",
    "timezone": "Africa/Conakry",
    "countryCode": "GN"
  },
  {
    "name": "Télimélé",
    "iso2": "TE",
    "timezone": "Africa/Conakry",
    "countryCode": "GN"
  },
  {
    "name": "Tougué",
    "iso2": "TO",
    "timezone": "Africa/Conakry",
    "countryCode": "GN"
  },
  {
    "name": "Yomou",
    "iso2": "YO",
    "timezone": "Africa/Conakry",
    "countryCode": "GN"
  },
  {
    "name": "Bafatá",
    "iso2": "BA",
    "timezone": "Africa/Bissau",
    "countryCode": "GW"
  },
  {
    "name": "Biombo",
    "iso2": "BM",
    "timezone": "Africa/Bissau",
    "countryCode": "GW"
  },
  {
    "name": "Bissau",
    "iso2": "BS",
    "timezone": "Africa/Bissau",
    "countryCode": "GW"
  },
  {
    "name": "Bolama",
    "iso2": "BL",
    "timezone": "Africa/Bissau",
    "countryCode": "GW"
  },
  {
    "name": "Cacheu",
    "iso2": "CA",
    "timezone": "Africa/Bissau",
    "countryCode": "GW"
  },
  {
    "name": "Gabú",
    "iso2": "GA",
    "timezone": "Africa/Bissau",
    "countryCode": "GW"
  },
  {
    "name": "Leste",
    "iso2": "L",
    "timezone": "Africa/Bissau",
    "countryCode": "GW"
  },
  {
    "name": "Norte",
    "iso2": "N",
    "timezone": "Africa/Bissau",
    "countryCode": "GW"
  },
  {
    "name": "Oio",
    "iso2": "OI",
    "timezone": "Africa/Bissau",
    "countryCode": "GW"
  },
  {
    "name": "Quinara",
    "iso2": "QU",
    "timezone": "Africa/Bissau",
    "countryCode": "GW"
  },
  {
    "name": "Sul",
    "iso2": "S",
    "timezone": "Africa/Bissau",
    "countryCode": "GW"
  },
  {
    "name": "Tombali",
    "iso2": "TO",
    "timezone": "Africa/Bissau",
    "countryCode": "GW"
  },
  {
    "name": "Barima-Waini",
    "iso2": "BA",
    "timezone": "America/Guyana",
    "countryCode": "GY"
  },
  {
    "name": "Cuyuni-Mazaruni",
    "iso2": "CU",
    "timezone": "America/Guyana",
    "countryCode": "GY"
  },
  {
    "name": "Demerara-Mahaica",
    "iso2": "DE",
    "timezone": "America/Guyana",
    "countryCode": "GY"
  },
  {
    "name": "East Berbice-Corentyne",
    "iso2": "EB",
    "timezone": "America/Guyana",
    "countryCode": "GY"
  },
  {
    "name": "Essequibo Islands-West Demerara",
    "iso2": "ES",
    "timezone": "America/Guyana",
    "countryCode": "GY"
  },
  {
    "name": "Mahaica-Berbice",
    "iso2": "MA",
    "timezone": "America/Guyana",
    "countryCode": "GY"
  },
  {
    "name": "Pomeroon-Supenaam",
    "iso2": "PM",
    "timezone": "America/Guyana",
    "countryCode": "GY"
  },
  {
    "name": "Potaro-Siparuni",
    "iso2": "PT",
    "timezone": "America/Guyana",
    "countryCode": "GY"
  },
  {
    "name": "Upper Demerara-Berbice",
    "iso2": "UD",
    "timezone": "America/Guyana",
    "countryCode": "GY"
  },
  {
    "name": "Upper Takutu-Upper Essequibo",
    "iso2": "UT",
    "timezone": "America/Guyana",
    "countryCode": "GY"
  },
  {
    "name": "Artibonite",
    "iso2": "AR",
    "timezone": "America/Port-au-Prince",
    "countryCode": "HT"
  },
  {
    "name": "Centre",
    "iso2": "CE",
    "timezone": "America/Port-au-Prince",
    "countryCode": "HT"
  },
  {
    "name": "Grand'Anse",
    "iso2": "GA",
    "timezone": "America/Port-au-Prince",
    "countryCode": "HT"
  },
  {
    "name": "Nippes",
    "iso2": "NI",
    "timezone": "America/Port-au-Prince",
    "countryCode": "HT"
  },
  {
    "name": "Nord",
    "iso2": "ND",
    "timezone": "America/Port-au-Prince",
    "countryCode": "HT"
  },
  {
    "name": "Nord-Est",
    "iso2": "NE",
    "timezone": "America/Port-au-Prince",
    "countryCode": "HT"
  },
  {
    "name": "Nord-Ouest",
    "iso2": "NO",
    "timezone": "America/Port-au-Prince",
    "countryCode": "HT"
  },
  {
    "name": "Ouest",
    "iso2": "OU",
    "timezone": "America/Port-au-Prince",
    "countryCode": "HT"
  },
  {
    "name": "Sud",
    "iso2": "SD",
    "timezone": "America/Port-au-Prince",
    "countryCode": "HT"
  },
  {
    "name": "Sud-Est",
    "iso2": "SE",
    "timezone": "America/Port-au-Prince",
    "countryCode": "HT"
  },
  {
    "name": "Atlántida",
    "iso2": "AT",
    "timezone": "America/Tegucigalpa",
    "countryCode": "HN"
  },
  {
    "name": "Bay Islands",
    "iso2": "IB",
    "timezone": "America/Tegucigalpa",
    "countryCode": "HN"
  },
  {
    "name": "Choluteca",
    "iso2": "CH",
    "timezone": "America/Tegucigalpa",
    "countryCode": "HN"
  },
  {
    "name": "Colón",
    "iso2": "CL",
    "timezone": "America/Tegucigalpa",
    "countryCode": "HN"
  },
  {
    "name": "Comayagua",
    "iso2": "CM",
    "timezone": "America/Tegucigalpa",
    "countryCode": "HN"
  },
  {
    "name": "Copán",
    "iso2": "CP",
    "timezone": "America/Tegucigalpa",
    "countryCode": "HN"
  },
  {
    "name": "Cortés",
    "iso2": "CR",
    "timezone": "America/Tegucigalpa",
    "countryCode": "HN"
  },
  {
    "name": "El Paraíso",
    "iso2": "EP",
    "timezone": "America/Tegucigalpa",
    "countryCode": "HN"
  },
  {
    "name": "Francisco Morazán",
    "iso2": "FM",
    "timezone": "America/Tegucigalpa",
    "countryCode": "HN"
  },
  {
    "name": "Gracias a Dios",
    "iso2": "GD",
    "timezone": "America/Tegucigalpa",
    "countryCode": "HN"
  },
  {
    "name": "Intibucá",
    "iso2": "IN",
    "timezone": "America/Tegucigalpa",
    "countryCode": "HN"
  },
  {
    "name": "La Paz",
    "iso2": "LP",
    "timezone": "America/Tegucigalpa",
    "countryCode": "HN"
  },
  {
    "name": "Lempira",
    "iso2": "LE",
    "timezone": "America/Tegucigalpa",
    "countryCode": "HN"
  },
  {
    "name": "Ocotepeque",
    "iso2": "OC",
    "timezone": "America/Tegucigalpa",
    "countryCode": "HN"
  },
  {
    "name": "Olancho",
    "iso2": "OL",
    "timezone": "America/Tegucigalpa",
    "countryCode": "HN"
  },
  {
    "name": "Santa Bárbara",
    "iso2": "SB",
    "timezone": "America/Tegucigalpa",
    "countryCode": "HN"
  },
  {
    "name": "Valle",
    "iso2": "VA",
    "timezone": "America/Tegucigalpa",
    "countryCode": "HN"
  },
  {
    "name": "Yoro",
    "iso2": "YO",
    "timezone": "America/Tegucigalpa",
    "countryCode": "HN"
  },
  {
    "name": "Central and Western",
    "iso2": "HCW",
    "timezone": "Asia/Hong_Kong",
    "countryCode": "HK"
  },
  {
    "name": "Eastern",
    "iso2": "HEA",
    "timezone": "Asia/Hong_Kong",
    "countryCode": "HK"
  },
  {
    "name": "Islands",
    "iso2": "NIS",
    "timezone": "Asia/Hong_Kong",
    "countryCode": "HK"
  },
  {
    "name": "Kowloon City",
    "iso2": "KKC",
    "timezone": "Asia/Hong_Kong",
    "countryCode": "HK"
  },
  {
    "name": "Kwai Tsing",
    "iso2": "NKT",
    "timezone": "Asia/Hong_Kong",
    "countryCode": "HK"
  },
  {
    "name": "Kwun Tong",
    "iso2": "KKT",
    "timezone": "Asia/Hong_Kong",
    "countryCode": "HK"
  },
  {
    "name": "North",
    "iso2": "NNO",
    "timezone": "Asia/Hong_Kong",
    "countryCode": "HK"
  },
  {
    "name": "Sai Kung",
    "iso2": "NSK",
    "timezone": "Asia/Hong_Kong",
    "countryCode": "HK"
  },
  {
    "name": "Sha Tin",
    "iso2": "NST",
    "timezone": "Asia/Hong_Kong",
    "countryCode": "HK"
  },
  {
    "name": "Sham Shui Po",
    "iso2": "KSS",
    "timezone": "Asia/Hong_Kong",
    "countryCode": "HK"
  },
  {
    "name": "Southern",
    "iso2": "HSO",
    "timezone": "Asia/Hong_Kong",
    "countryCode": "HK"
  },
  {
    "name": "Tai Po",
    "iso2": "NTP",
    "timezone": "Asia/Hong_Kong",
    "countryCode": "HK"
  },
  {
    "name": "Tsuen Wan",
    "iso2": "NTW",
    "timezone": "Asia/Hong_Kong",
    "countryCode": "HK"
  },
  {
    "name": "Tuen Mun",
    "iso2": "NTM",
    "timezone": "Asia/Hong_Kong",
    "countryCode": "HK"
  },
  {
    "name": "Wan Chai",
    "iso2": "HWC",
    "timezone": "Asia/Hong_Kong",
    "countryCode": "HK"
  },
  {
    "name": "Wong Tai Sin",
    "iso2": "KWT",
    "timezone": "Asia/Hong_Kong",
    "countryCode": "HK"
  },
  {
    "name": "Yau Tsim Mong",
    "iso2": "KYT",
    "timezone": "Asia/Hong_Kong",
    "countryCode": "HK"
  },
  {
    "name": "Yuen Long",
    "iso2": "NYL",
    "timezone": "Asia/Hong_Kong",
    "countryCode": "HK"
  },
  {
    "name": "Bács-Kiskun",
    "iso2": "BK",
    "timezone": "Europe/Budapest",
    "countryCode": "HU"
  },
  {
    "name": "Baranya",
    "iso2": "BA",
    "timezone": "Europe/Budapest",
    "countryCode": "HU"
  },
  {
    "name": "Békés",
    "iso2": "BE",
    "timezone": "Europe/Budapest",
    "countryCode": "HU"
  },
  {
    "name": "Békéscsaba",
    "iso2": "BC",
    "timezone": "Europe/Budapest",
    "countryCode": "HU"
  },
  {
    "name": "Borsod-Abaúj-Zemplén",
    "iso2": "BZ",
    "timezone": "Europe/Budapest",
    "countryCode": "HU"
  },
  {
    "name": "Budapest",
    "iso2": "BU",
    "timezone": "Europe/Budapest",
    "countryCode": "HU"
  },
  {
    "name": "Csongrád County",
    "iso2": "CS",
    "timezone": "Europe/Budapest",
    "countryCode": "HU"
  },
  {
    "name": "Debrecen",
    "iso2": "DE",
    "timezone": "Europe/Budapest",
    "countryCode": "HU"
  },
  {
    "name": "Dunaújváros",
    "iso2": "DU",
    "timezone": "Europe/Budapest",
    "countryCode": "HU"
  },
  {
    "name": "Eger",
    "iso2": "EG",
    "timezone": "Europe/Budapest",
    "countryCode": "HU"
  },
  {
    "name": "Érd",
    "iso2": "ER",
    "timezone": "Europe/Budapest",
    "countryCode": "HU"
  },
  {
    "name": "Fejér County",
    "iso2": "FE",
    "timezone": "Europe/Budapest",
    "countryCode": "HU"
  },
  {
    "name": "Győr",
    "iso2": "GY",
    "timezone": "Europe/Budapest",
    "countryCode": "HU"
  },
  {
    "name": "Győr-Moson-Sopron County",
    "iso2": "GS",
    "timezone": "Europe/Budapest",
    "countryCode": "HU"
  },
  {
    "name": "Hajdú-Bihar County",
    "iso2": "HB",
    "timezone": "Europe/Budapest",
    "countryCode": "HU"
  },
  {
    "name": "Heves County",
    "iso2": "HE",
    "timezone": "Europe/Budapest",
    "countryCode": "HU"
  },
  {
    "name": "Hódmezővásárhely",
    "iso2": "HV",
    "timezone": "Europe/Budapest",
    "countryCode": "HU"
  },
  {
    "name": "Jász-Nagykun-Szolnok County",
    "iso2": "JN",
    "timezone": "Europe/Budapest",
    "countryCode": "HU"
  },
  {
    "name": "Kaposvár",
    "iso2": "KV",
    "timezone": "Europe/Budapest",
    "countryCode": "HU"
  },
  {
    "name": "Kecskemét",
    "iso2": "KM",
    "timezone": "Europe/Budapest",
    "countryCode": "HU"
  },
  {
    "name": "Komárom-Esztergom",
    "iso2": "KE",
    "timezone": "Europe/Budapest",
    "countryCode": "HU"
  },
  {
    "name": "Miskolc",
    "iso2": "MI",
    "timezone": "Europe/Budapest",
    "countryCode": "HU"
  },
  {
    "name": "Nagykanizsa",
    "iso2": "NK",
    "timezone": "Europe/Budapest",
    "countryCode": "HU"
  },
  {
    "name": "Nógrád County",
    "iso2": "NO",
    "timezone": "Europe/Budapest",
    "countryCode": "HU"
  },
  {
    "name": "Nyíregyháza",
    "iso2": "NY",
    "timezone": "Europe/Budapest",
    "countryCode": "HU"
  },
  {
    "name": "Pécs",
    "iso2": "PS",
    "timezone": "Europe/Budapest",
    "countryCode": "HU"
  },
  {
    "name": "Pest County",
    "iso2": "PE",
    "timezone": "Europe/Budapest",
    "countryCode": "HU"
  },
  {
    "name": "Salgótarján",
    "iso2": "ST",
    "timezone": "Europe/Budapest",
    "countryCode": "HU"
  },
  {
    "name": "Somogy County",
    "iso2": "SO",
    "timezone": "Europe/Budapest",
    "countryCode": "HU"
  },
  {
    "name": "Sopron",
    "iso2": "SN",
    "timezone": "Europe/Budapest",
    "countryCode": "HU"
  },
  {
    "name": "Szabolcs-Szatmár-Bereg County",
    "iso2": "SZ",
    "timezone": "Europe/Budapest",
    "countryCode": "HU"
  },
  {
    "name": "Szeged",
    "iso2": "SD",
    "timezone": "Europe/Budapest",
    "countryCode": "HU"
  },
  {
    "name": "Székesfehérvár",
    "iso2": "SF",
    "timezone": "Europe/Budapest",
    "countryCode": "HU"
  },
  {
    "name": "Szekszárd",
    "iso2": "SS",
    "timezone": "Europe/Budapest",
    "countryCode": "HU"
  },
  {
    "name": "Szolnok",
    "iso2": "SK",
    "timezone": "Europe/Budapest",
    "countryCode": "HU"
  },
  {
    "name": "Szombathely",
    "iso2": "SH",
    "timezone": "Europe/Budapest",
    "countryCode": "HU"
  },
  {
    "name": "Tatabánya",
    "iso2": "TB",
    "timezone": "Europe/Budapest",
    "countryCode": "HU"
  },
  {
    "name": "Tolna County",
    "iso2": "TO",
    "timezone": "Europe/Budapest",
    "countryCode": "HU"
  },
  {
    "name": "Vas County",
    "iso2": "VA",
    "timezone": "Europe/Budapest",
    "countryCode": "HU"
  },
  {
    "name": "Veszprém",
    "iso2": "VM",
    "timezone": "Europe/Budapest",
    "countryCode": "HU"
  },
  {
    "name": "Veszprém County",
    "iso2": "VE",
    "timezone": "Europe/Budapest",
    "countryCode": "HU"
  },
  {
    "name": "Zala County",
    "iso2": "ZA",
    "timezone": "Europe/Budapest",
    "countryCode": "HU"
  },
  {
    "name": "Zalaegerszeg",
    "iso2": "ZE",
    "timezone": "Europe/Budapest",
    "countryCode": "HU"
  },
  {
    "name": "Akranes",
    "iso2": "AKN",
    "timezone": "Atlantic/Reykjavik",
    "countryCode": "IS"
  },
  {
    "name": "Akureyri",
    "iso2": "AKU",
    "timezone": "Atlantic/Reykjavik",
    "countryCode": "IS"
  },
  {
    "name": "Árborg",
    "iso2": "SFA",
    "timezone": "Atlantic/Reykjavik",
    "countryCode": "IS"
  },
  {
    "name": "Árneshreppur",
    "iso2": "ARN",
    "timezone": "Atlantic/Reykjavik",
    "countryCode": "IS"
  },
  {
    "name": "Ásahreppur",
    "iso2": "ASA",
    "timezone": "Atlantic/Reykjavik",
    "countryCode": "IS"
  },
  {
    "name": "Bláskógabyggð",
    "iso2": "BLA",
    "timezone": "Atlantic/Reykjavik",
    "countryCode": "IS"
  },
  {
    "name": "Bolungarvík",
    "iso2": "BOL",
    "timezone": "Atlantic/Reykjavik",
    "countryCode": "IS"
  },
  {
    "name": "Borgarbyggð",
    "iso2": "BOG",
    "timezone": "Atlantic/Reykjavik",
    "countryCode": "IS"
  },
  {
    "name": "Capital",
    "iso2": "1",
    "timezone": "Atlantic/Reykjavik",
    "countryCode": "IS"
  },
  {
    "name": "Dalabyggð",
    "iso2": "DAB",
    "timezone": "Atlantic/Reykjavik",
    "countryCode": "IS"
  },
  {
    "name": "Dalvíkurbyggð",
    "iso2": "DAV",
    "timezone": "Atlantic/Reykjavik",
    "countryCode": "IS"
  },
  {
    "name": "Eastern",
    "iso2": "7",
    "timezone": "Atlantic/Reykjavik",
    "countryCode": "IS"
  },
  {
    "name": "Eyja- og Miklaholtshreppur",
    "iso2": "EOM",
    "timezone": "Atlantic/Reykjavik",
    "countryCode": "IS"
  },
  {
    "name": "Eyjafjarðarsveit",
    "iso2": "EYF",
    "timezone": "Atlantic/Reykjavik",
    "countryCode": "IS"
  },
  {
    "name": "Fjallabyggð",
    "iso2": "FJL",
    "timezone": "Atlantic/Reykjavik",
    "countryCode": "IS"
  },
  {
    "name": "Fjarðabyggð",
    "iso2": "FJD",
    "timezone": "Atlantic/Reykjavik",
    "countryCode": "IS"
  },
  {
    "name": "Fljótsdalshreppur",
    "iso2": "FLR",
    "timezone": "Atlantic/Reykjavik",
    "countryCode": "IS"
  },
  {
    "name": "Flóahreppur",
    "iso2": "FLA",
    "timezone": "Atlantic/Reykjavik",
    "countryCode": "IS"
  },
  {
    "name": "Garðabær",
    "iso2": "GAR",
    "timezone": "Atlantic/Reykjavik",
    "countryCode": "IS"
  },
  {
    "name": "Grímsnes- og Grafningshreppur",
    "iso2": "GOG",
    "timezone": "Atlantic/Reykjavik",
    "countryCode": "IS"
  },
  {
    "name": "Grindavík",
    "iso2": "GRN",
    "timezone": "Atlantic/Reykjavik",
    "countryCode": "IS"
  },
  {
    "name": "Grundarfjörður",
    "iso2": "GRU",
    "timezone": "Atlantic/Reykjavik",
    "countryCode": "IS"
  },
  {
    "name": "Grýtubakkahreppur",
    "iso2": "GRY",
    "timezone": "Atlantic/Reykjavik",
    "countryCode": "IS"
  },
  {
    "name": "Hafnarfjörður",
    "iso2": "HAF",
    "timezone": "Atlantic/Reykjavik",
    "countryCode": "IS"
  },
  {
    "name": "Hörðarsveit",
    "iso2": "HRG",
    "timezone": "Atlantic/Reykjavik",
    "countryCode": "IS"
  },
  {
    "name": "Hornafjörður",
    "iso2": "SHF",
    "timezone": "Atlantic/Reykjavik",
    "countryCode": "IS"
  },
  {
    "name": "Hrunamannahreppur",
    "iso2": "HRU",
    "timezone": "Atlantic/Reykjavik",
    "countryCode": "IS"
  },
  {
    "name": "Húnabyggð",
    "iso2": "HUG",
    "timezone": "Atlantic/Reykjavik",
    "countryCode": "IS"
  },
  {
    "name": "Húnaþing vestra",
    "iso2": "HUV",
    "timezone": "Atlantic/Reykjavik",
    "countryCode": "IS"
  },
  {
    "name": "Hvalfjarðarsveit",
    "iso2": "HVA",
    "timezone": "Atlantic/Reykjavik",
    "countryCode": "IS"
  },
  {
    "name": "Hveragerði",
    "iso2": "HVE",
    "timezone": "Atlantic/Reykjavik",
    "countryCode": "IS"
  },
  {
    "name": "Ísafjörður",
    "iso2": "ISA",
    "timezone": "Atlantic/Reykjavik",
    "countryCode": "IS"
  },
  {
    "name": "Kaldrananeshreppur",
    "iso2": "KAL",
    "timezone": "Atlantic/Reykjavik",
    "countryCode": "IS"
  },
  {
    "name": "Kjósarhreppur",
    "iso2": "KJO",
    "timezone": "Atlantic/Reykjavik",
    "countryCode": "IS"
  },
  {
    "name": "Kópavogur",
    "iso2": "KOP",
    "timezone": "Atlantic/Reykjavik",
    "countryCode": "IS"
  },
  {
    "name": "Langanesbyggð",
    "iso2": "LAN",
    "timezone": "Atlantic/Reykjavik",
    "countryCode": "IS"
  },
  {
    "name": "Mosfellsbær",
    "iso2": "MOS",
    "timezone": "Atlantic/Reykjavik",
    "countryCode": "IS"
  },
  {
    "name": "Múlaþing",
    "iso2": "MUL",
    "timezone": "Atlantic/Reykjavik",
    "countryCode": "IS"
  },
  {
    "name": "Mýrdalshreppur",
    "iso2": "MYR",
    "timezone": "Atlantic/Reykjavik",
    "countryCode": "IS"
  },
  {
    "name": "Norðurþing",
    "iso2": "NOR",
    "timezone": "Atlantic/Reykjavik",
    "countryCode": "IS"
  },
  {
    "name": "Northeastern",
    "iso2": "6",
    "timezone": "Atlantic/Reykjavik",
    "countryCode": "IS"
  },
  {
    "name": "Northwestern",
    "iso2": "5",
    "timezone": "Atlantic/Reykjavik",
    "countryCode": "IS"
  },
  {
    "name": "Ölfus",
    "iso2": "SOL",
    "timezone": "Atlantic/Reykjavik",
    "countryCode": "IS"
  },
  {
    "name": "Rangárþing eystra",
    "iso2": "RGE",
    "timezone": "Atlantic/Reykjavik",
    "countryCode": "IS"
  },
  {
    "name": "Rangárþing ytra",
    "iso2": "RGY",
    "timezone": "Atlantic/Reykjavik",
    "countryCode": "IS"
  },
  {
    "name": "Reykhólahreppur",
    "iso2": "RHH",
    "timezone": "Atlantic/Reykjavik",
    "countryCode": "IS"
  },
  {
    "name": "Reykjanesbær",
    "iso2": "RKN",
    "timezone": "Atlantic/Reykjavik",
    "countryCode": "IS"
  },
  {
    "name": "Reykjavík",
    "iso2": "RKV",
    "timezone": "Atlantic/Reykjavik",
    "countryCode": "IS"
  },
  {
    "name": "Seltjarnarnes",
    "iso2": "SEL",
    "timezone": "Atlantic/Reykjavik",
    "countryCode": "IS"
  },
  {
    "name": "Skaftárhreppur",
    "iso2": "SKF",
    "timezone": "Atlantic/Reykjavik",
    "countryCode": "IS"
  },
  {
    "name": "Skagabyggð",
    "iso2": "SKG",
    "timezone": "Atlantic/Reykjavik",
    "countryCode": "IS"
  },
  {
    "name": "Skagafjörður",
    "iso2": "SKR",
    "timezone": "Atlantic/Reykjavik",
    "countryCode": "IS"
  },
  {
    "name": "Skagaströnd",
    "iso2": "SSS",
    "timezone": "Atlantic/Reykjavik",
    "countryCode": "IS"
  },
  {
    "name": "Skeiða- og Gnúpverjahreppur",
    "iso2": "SOG",
    "timezone": "Atlantic/Reykjavik",
    "countryCode": "IS"
  },
  {
    "name": "Skorradalshreppur",
    "iso2": "SKO",
    "timezone": "Atlantic/Reykjavik",
    "countryCode": "IS"
  },
  {
    "name": "Snæfellsbær",
    "iso2": "SNF",
    "timezone": "Atlantic/Reykjavik",
    "countryCode": "IS"
  },
  {
    "name": "Southern",
    "iso2": "8",
    "timezone": "Atlantic/Reykjavik",
    "countryCode": "IS"
  },
  {
    "name": "Southern Peninsula",
    "iso2": "2",
    "timezone": "Atlantic/Reykjavik",
    "countryCode": "IS"
  },
  {
    "name": "Strandabyggð",
    "iso2": "STR",
    "timezone": "Atlantic/Reykjavik",
    "countryCode": "IS"
  },
  {
    "name": "Stykkishólmur",
    "iso2": "STY",
    "timezone": "Atlantic/Reykjavik",
    "countryCode": "IS"
  },
  {
    "name": "Súðavík",
    "iso2": "SDV",
    "timezone": "Atlantic/Reykjavik",
    "countryCode": "IS"
  },
  {
    "name": "Suðurnesjabær",
    "iso2": "SDN",
    "timezone": "Atlantic/Reykjavik",
    "countryCode": "IS"
  },
  {
    "name": "Svalbardsstrandarhreppur",
    "iso2": "SBT",
    "timezone": "Atlantic/Reykjavik",
    "countryCode": "IS"
  },
  {
    "name": "Tálknafjarðarhreppur",
    "iso2": "TAL",
    "timezone": "Atlantic/Reykjavik",
    "countryCode": "IS"
  },
  {
    "name": "Tjörneshreppur",
    "iso2": "TJO",
    "timezone": "Atlantic/Reykjavik",
    "countryCode": "IS"
  },
  {
    "name": "Vestmannaeyjar",
    "iso2": "VEM",
    "timezone": "Atlantic/Reykjavik",
    "countryCode": "IS"
  },
  {
    "name": "Vesturbyggð",
    "iso2": "VER",
    "timezone": "Atlantic/Reykjavik",
    "countryCode": "IS"
  },
  {
    "name": "Vogar",
    "iso2": "SVG",
    "timezone": "Atlantic/Reykjavik",
    "countryCode": "IS"
  },
  {
    "name": "Vopnafjarðarhreppur",
    "iso2": "VOP",
    "timezone": "Atlantic/Reykjavik",
    "countryCode": "IS"
  },
  {
    "name": "Western",
    "iso2": "3",
    "timezone": "Atlantic/Reykjavik",
    "countryCode": "IS"
  },
  {
    "name": "Westfjords",
    "iso2": "4",
    "timezone": "Atlantic/Reykjavik",
    "countryCode": "IS"
  },
  {
    "name": "Þingeyjarsveit",
    "iso2": "THG",
    "timezone": "Atlantic/Reykjavik",
    "countryCode": "IS"
  },
  {
    "name": "Andaman and Nicobar Islands",
    "iso2": "AN",
    "timezone": "Asia/Kolkata",
    "countryCode": "IN"
  },
  {
    "name": "Andhra Pradesh",
    "iso2": "AP",
    "timezone": "Asia/Kolkata",
    "countryCode": "IN"
  },
  {
    "name": "Arunachal Pradesh",
    "iso2": "AR",
    "timezone": "Asia/Kolkata",
    "countryCode": "IN"
  },
  {
    "name": "Assam",
    "iso2": "AS",
    "timezone": "Asia/Kolkata",
    "countryCode": "IN"
  },
  {
    "name": "Bihar",
    "iso2": "BR",
    "timezone": "Asia/Kolkata",
    "countryCode": "IN"
  },
  {
    "name": "Chandigarh",
    "iso2": "CH",
    "timezone": "Asia/Kolkata",
    "countryCode": "IN"
  },
  {
    "name": "Chhattisgarh",
    "iso2": "CT",
    "timezone": "Asia/Kolkata",
    "countryCode": "IN"
  },
  {
    "name": "Dadra and Nagar Haveli and Daman and Diu",
    "iso2": "DH",
    "timezone": "Asia/Kolkata",
    "countryCode": "IN"
  },
  {
    "name": "Delhi",
    "iso2": "DL",
    "timezone": "Asia/Kolkata",
    "countryCode": "IN"
  },
  {
    "name": "Goa",
    "iso2": "GA",
    "timezone": "Asia/Kolkata",
    "countryCode": "IN"
  },
  {
    "name": "Gujarat",
    "iso2": "GJ",
    "timezone": "Asia/Kolkata",
    "countryCode": "IN"
  },
  {
    "name": "Haryana",
    "iso2": "HR",
    "timezone": "Asia/Kolkata",
    "countryCode": "IN"
  },
  {
    "name": "Himachal Pradesh",
    "iso2": "HP",
    "timezone": "Asia/Kolkata",
    "countryCode": "IN"
  },
  {
    "name": "Jammu and Kashmir",
    "iso2": "JK",
    "timezone": "Asia/Kolkata",
    "countryCode": "IN"
  },
  {
    "name": "Jharkhand",
    "iso2": "JH",
    "timezone": "Asia/Kolkata",
    "countryCode": "IN"
  },
  {
    "name": "Karnataka",
    "iso2": "KA",
    "timezone": "Asia/Kolkata",
    "countryCode": "IN"
  },
  {
    "name": "Kerala",
    "iso2": "KL",
    "timezone": "Asia/Kolkata",
    "countryCode": "IN"
  },
  {
    "name": "Ladakh",
    "iso2": "LA",
    "timezone": "Asia/Kolkata",
    "countryCode": "IN"
  },
  {
    "name": "Lakshadweep",
    "iso2": "LD",
    "timezone": "Asia/Kolkata",
    "countryCode": "IN"
  },
  {
    "name": "Madhya Pradesh",
    "iso2": "MP",
    "timezone": "Asia/Kolkata",
    "countryCode": "IN"
  },
  {
    "name": "Maharashtra",
    "iso2": "MH",
    "timezone": "Asia/Kolkata",
    "countryCode": "IN"
  },
  {
    "name": "Manipur",
    "iso2": "MN",
    "timezone": "Asia/Kolkata",
    "countryCode": "IN"
  },
  {
    "name": "Meghalaya",
    "iso2": "ML",
    "timezone": "Asia/Kolkata",
    "countryCode": "IN"
  },
  {
    "name": "Mizoram",
    "iso2": "MZ",
    "timezone": "Asia/Kolkata",
    "countryCode": "IN"
  },
  {
    "name": "Nagaland",
    "iso2": "NL",
    "timezone": "Asia/Kolkata",
    "countryCode": "IN"
  },
  {
    "name": "Odisha",
    "iso2": "OR",
    "timezone": "Asia/Kolkata",
    "countryCode": "IN"
  },
  {
    "name": "Puducherry",
    "iso2": "PY",
    "timezone": "Asia/Kolkata",
    "countryCode": "IN"
  },
  {
    "name": "Punjab",
    "iso2": "PB",
    "timezone": "Asia/Kolkata",
    "countryCode": "IN"
  },
  {
    "name": "Rajasthan",
    "iso2": "RJ",
    "timezone": "Asia/Kolkata",
    "countryCode": "IN"
  },
  {
    "name": "Sikkim",
    "iso2": "SK",
    "timezone": "Asia/Kolkata",
    "countryCode": "IN"
  },
  {
    "name": "Tamil Nadu",
    "iso2": "TN",
    "timezone": "Asia/Kolkata",
    "countryCode": "IN"
  },
  {
    "name": "Telangana",
    "iso2": "TG",
    "timezone": "Asia/Kolkata",
    "countryCode": "IN"
  },
  {
    "name": "Tripura",
    "iso2": "TR",
    "timezone": "Asia/Kolkata",
    "countryCode": "IN"
  },
  {
    "name": "Uttar Pradesh",
    "iso2": "UP",
    "timezone": "Asia/Kolkata",
    "countryCode": "IN"
  },
  {
    "name": "Uttarakhand",
    "iso2": "UK",
    "timezone": "Asia/Kolkata",
    "countryCode": "IN"
  },
  {
    "name": "West Bengal",
    "iso2": "WB",
    "timezone": "Asia/Kolkata",
    "countryCode": "IN"
  },
  {
    "name": "Aceh",
    "iso2": "AC",
    "timezone": "Asia/Jakarta",
    "countryCode": "ID"
  },
  {
    "name": "Bali",
    "iso2": "BA",
    "timezone": "Asia/Makassar",
    "countryCode": "ID"
  },
  {
    "name": "Banten",
    "iso2": "BT",
    "timezone": "Asia/Jakarta",
    "countryCode": "ID"
  },
  {
    "name": "Bengkulu",
    "iso2": "BE",
    "timezone": "Asia/Jakarta",
    "countryCode": "ID"
  },
  {
    "name": "DI Yogyakarta",
    "iso2": "YO",
    "timezone": "Asia/Jakarta",
    "countryCode": "ID"
  },
  {
    "name": "DKI Jakarta",
    "iso2": "JK",
    "timezone": "Asia/Jakarta",
    "countryCode": "ID"
  },
  {
    "name": "Gorontalo",
    "iso2": "GO",
    "timezone": "Asia/Makassar",
    "countryCode": "ID"
  },
  {
    "name": "Jambi",
    "iso2": "JA",
    "timezone": "Asia/Jakarta",
    "countryCode": "ID"
  },
  {
    "name": "Jawa",
    "iso2": "JW",
    "timezone": "Asia/Jakarta",
    "countryCode": "ID"
  },
  {
    "name": "Jawa Barat",
    "iso2": "JB",
    "timezone": "Asia/Jakarta",
    "countryCode": "ID"
  },
  {
    "name": "Jawa Tengah",
    "iso2": "JT",
    "timezone": "Asia/Jakarta",
    "countryCode": "ID"
  },
  {
    "name": "Jawa Timur",
    "iso2": "JI",
    "timezone": "Asia/Jakarta",
    "countryCode": "ID"
  },
  {
    "name": "Kalimantan",
    "iso2": "KA",
    "timezone": "Asia/Jakarta",
    "countryCode": "ID"
  },
  {
    "name": "Kalimantan Barat",
    "iso2": "KB",
    "timezone": "Asia/Jakarta",
    "countryCode": "ID"
  },
  {
    "name": "Kalimantan Selatan",
    "iso2": "KS",
    "timezone": "Asia/Jakarta",
    "countryCode": "ID"
  },
  {
    "name": "Kalimantan Tengah",
    "iso2": "KT",
    "timezone": "Asia/Jakarta",
    "countryCode": "ID"
  },
  {
    "name": "Kalimantan Timur",
    "iso2": "KI",
    "timezone": "Asia/Jakarta",
    "countryCode": "ID"
  },
  {
    "name": "Kalimantan Utara",
    "iso2": "KU",
    "timezone": "Asia/Jakarta",
    "countryCode": "ID"
  },
  {
    "name": "Kepulauan Bangka Belitung",
    "iso2": "BB",
    "timezone": "Asia/Jakarta",
    "countryCode": "ID"
  },
  {
    "name": "Kepulauan Riau",
    "iso2": "KR",
    "timezone": "Asia/Jakarta",
    "countryCode": "ID"
  },
  {
    "name": "Lampung",
    "iso2": "LA",
    "timezone": "Asia/Jakarta",
    "countryCode": "ID"
  },
  {
    "name": "Maluku",
    "iso2": "ML",
    "timezone": "Asia/Jayapura",
    "countryCode": "ID"
  },
  {
    "name": "Maluku",
    "iso2": "MA",
    "timezone": "Asia/Jayapura",
    "countryCode": "ID"
  },
  {
    "name": "Maluku Utara",
    "iso2": "MU",
    "timezone": "Asia/Jakarta",
    "countryCode": "ID"
  },
  {
    "name": "Nusa Tenggara",
    "iso2": "NU",
    "timezone": "Asia/Jakarta",
    "countryCode": "ID"
  },
  {
    "name": "Nusa Tenggara Barat",
    "iso2": "NB",
    "timezone": "Asia/Jakarta",
    "countryCode": "ID"
  },
  {
    "name": "Nusa Tenggara Timur",
    "iso2": "NT",
    "timezone": "Asia/Jakarta",
    "countryCode": "ID"
  },
  {
    "name": "Papua",
    "iso2": "PA",
    "timezone": "Asia/Jayapura",
    "countryCode": "ID"
  },
  {
    "name": "Papua",
    "iso2": "PP",
    "timezone": "Asia/Jayapura",
    "countryCode": "ID"
  },
  {
    "name": "Papua Barat",
    "iso2": "PB",
    "timezone": "Asia/Jakarta",
    "countryCode": "ID"
  },
  {
    "name": "Papua Barat Daya",
    "iso2": "PD",
    "timezone": "Asia/Jakarta",
    "countryCode": "ID"
  },
  {
    "name": "Papua Pegunungan",
    "iso2": "PE",
    "timezone": "Asia/Jakarta",
    "countryCode": "ID"
  },
  {
    "name": "Papua Selatan",
    "iso2": "PS",
    "timezone": "Asia/Jakarta",
    "countryCode": "ID"
  },
  {
    "name": "Papua Tengah",
    "iso2": "PT",
    "timezone": "Asia/Jakarta",
    "countryCode": "ID"
  },
  {
    "name": "Riau",
    "iso2": "RI",
    "timezone": "Asia/Jakarta",
    "countryCode": "ID"
  },
  {
    "name": "Sulawesi",
    "iso2": "SL",
    "timezone": "Asia/Makassar",
    "countryCode": "ID"
  },
  {
    "name": "Sulawesi Barat",
    "iso2": "SR",
    "timezone": "Asia/Jakarta",
    "countryCode": "ID"
  },
  {
    "name": "Sulawesi Selatan",
    "iso2": "SN",
    "timezone": "Asia/Jakarta",
    "countryCode": "ID"
  },
  {
    "name": "Sulawesi Tengah",
    "iso2": "ST",
    "timezone": "Asia/Jakarta",
    "countryCode": "ID"
  },
  {
    "name": "Sulawesi Tenggara",
    "iso2": "SG",
    "timezone": "Asia/Jakarta",
    "countryCode": "ID"
  },
  {
    "name": "Sulawesi Utara",
    "iso2": "SA",
    "timezone": "Asia/Jakarta",
    "countryCode": "ID"
  },
  {
    "name": "Sumatera",
    "iso2": "SM",
    "timezone": "Asia/Jakarta",
    "countryCode": "ID"
  },
  {
    "name": "Sumatera Barat",
    "iso2": "SB",
    "timezone": "Asia/Jakarta",
    "countryCode": "ID"
  },
  {
    "name": "Sumatera Selatan",
    "iso2": "SS",
    "timezone": "Asia/Jakarta",
    "countryCode": "ID"
  },
  {
    "name": "Sumatera Utara",
    "iso2": "SU",
    "timezone": "Asia/Jakarta",
    "countryCode": "ID"
  },
  {
    "name": "Alborz",
    "iso2": "30",
    "timezone": "Asia/Tehran",
    "countryCode": "IR"
  },
  {
    "name": "Ardabil",
    "iso2": "24",
    "timezone": "Asia/Tehran",
    "countryCode": "IR"
  },
  {
    "name": "Bushehr",
    "iso2": "18",
    "timezone": "Asia/Tehran",
    "countryCode": "IR"
  },
  {
    "name": "Chaharmahal and Bakhtiari",
    "iso2": "14",
    "timezone": "Asia/Tehran",
    "countryCode": "IR"
  },
  {
    "name": "East Azerbaijan",
    "iso2": "03",
    "timezone": "Asia/Tehran",
    "countryCode": "IR"
  },
  {
    "name": "Fars",
    "iso2": "07",
    "timezone": "Asia/Tehran",
    "countryCode": "IR"
  },
  {
    "name": "Gilan",
    "iso2": "01",
    "timezone": "Asia/Tehran",
    "countryCode": "IR"
  },
  {
    "name": "Golestan",
    "iso2": "27",
    "timezone": "Asia/Tehran",
    "countryCode": "IR"
  },
  {
    "name": "Hamadan",
    "iso2": "13",
    "timezone": "Asia/Tehran",
    "countryCode": "IR"
  },
  {
    "name": "Hormozgan",
    "iso2": "22",
    "timezone": "Asia/Tehran",
    "countryCode": "IR"
  },
  {
    "name": "Ilam",
    "iso2": "16",
    "timezone": "Asia/Tehran",
    "countryCode": "IR"
  },
  {
    "name": "Isfahan",
    "iso2": "10",
    "timezone": "Asia/Tehran",
    "countryCode": "IR"
  },
  {
    "name": "Kerman",
    "iso2": "08",
    "timezone": "Asia/Tehran",
    "countryCode": "IR"
  },
  {
    "name": "Kermanshah",
    "iso2": "05",
    "timezone": "Asia/Tehran",
    "countryCode": "IR"
  },
  {
    "name": "Khuzestan",
    "iso2": "06",
    "timezone": "Asia/Tehran",
    "countryCode": "IR"
  },
  {
    "name": "Kohgiluyeh and Boyer-Ahmad",
    "iso2": "17",
    "timezone": "Asia/Tehran",
    "countryCode": "IR"
  },
  {
    "name": "Kurdistan",
    "iso2": "12",
    "timezone": "Asia/Tehran",
    "countryCode": "IR"
  },
  {
    "name": "Lorestan",
    "iso2": "15",
    "timezone": "Asia/Tehran",
    "countryCode": "IR"
  },
  {
    "name": "Markazi",
    "iso2": "00",
    "timezone": "Asia/Tehran",
    "countryCode": "IR"
  },
  {
    "name": "Mazandaran",
    "iso2": "02",
    "timezone": "Asia/Tehran",
    "countryCode": "IR"
  },
  {
    "name": "North Khorasan",
    "iso2": "28",
    "timezone": "Asia/Tehran",
    "countryCode": "IR"
  },
  {
    "name": "Qazvin",
    "iso2": "26",
    "timezone": "Asia/Tehran",
    "countryCode": "IR"
  },
  {
    "name": "Qom",
    "iso2": "25",
    "timezone": "Asia/Tehran",
    "countryCode": "IR"
  },
  {
    "name": "Razavi Khorasan",
    "iso2": "09",
    "timezone": "Asia/Tehran",
    "countryCode": "IR"
  },
  {
    "name": "Semnan",
    "iso2": "20",
    "timezone": "Asia/Tehran",
    "countryCode": "IR"
  },
  {
    "name": "Sistan and Baluchestan",
    "iso2": "11",
    "timezone": "Asia/Tehran",
    "countryCode": "IR"
  },
  {
    "name": "South Khorasan",
    "iso2": "29",
    "timezone": "Asia/Tehran",
    "countryCode": "IR"
  },
  {
    "name": "Tehran",
    "iso2": "23",
    "timezone": "Asia/Tehran",
    "countryCode": "IR"
  },
  {
    "name": "West Azarbaijan",
    "iso2": "04",
    "timezone": "Asia/Tehran",
    "countryCode": "IR"
  },
  {
    "name": "Yazd",
    "iso2": "21",
    "timezone": "Asia/Tehran",
    "countryCode": "IR"
  },
  {
    "name": "Zanjan",
    "iso2": "19",
    "timezone": "Asia/Tehran",
    "countryCode": "IR"
  },
  {
    "name": "Al Anbar",
    "iso2": "AN",
    "timezone": "Asia/Baghdad",
    "countryCode": "IQ"
  },
  {
    "name": "Al Muthanna",
    "iso2": "MU",
    "timezone": "Asia/Baghdad",
    "countryCode": "IQ"
  },
  {
    "name": "Al-Qādisiyyah",
    "iso2": "QA",
    "timezone": "Asia/Baghdad",
    "countryCode": "IQ"
  },
  {
    "name": "Babylon",
    "iso2": "BB",
    "timezone": "Asia/Baghdad",
    "countryCode": "IQ"
  },
  {
    "name": "Baghdad",
    "iso2": "BG",
    "timezone": "Asia/Baghdad",
    "countryCode": "IQ"
  },
  {
    "name": "Basra",
    "iso2": "BA",
    "timezone": "Asia/Baghdad",
    "countryCode": "IQ"
  },
  {
    "name": "Dhi Qar",
    "iso2": "DQ",
    "timezone": "Asia/Baghdad",
    "countryCode": "IQ"
  },
  {
    "name": "Diyala",
    "iso2": "DI",
    "timezone": "Asia/Baghdad",
    "countryCode": "IQ"
  },
  {
    "name": "Dohuk",
    "iso2": "DA",
    "timezone": "Asia/Baghdad",
    "countryCode": "IQ"
  },
  {
    "name": "Erbil",
    "iso2": "AR",
    "timezone": "Asia/Baghdad",
    "countryCode": "IQ"
  },
  {
    "name": "Iqlim Kurdistan",
    "iso2": "KR",
    "timezone": "Asia/Baghdad",
    "countryCode": "IQ"
  },
  {
    "name": "Karbala",
    "iso2": "KA",
    "timezone": "Asia/Baghdad",
    "countryCode": "IQ"
  },
  {
    "name": "Kirkuk",
    "iso2": "KI",
    "timezone": "Asia/Baghdad",
    "countryCode": "IQ"
  },
  {
    "name": "Maysan",
    "iso2": "MA",
    "timezone": "Asia/Baghdad",
    "countryCode": "IQ"
  },
  {
    "name": "Najaf",
    "iso2": "NA",
    "timezone": "Asia/Baghdad",
    "countryCode": "IQ"
  },
  {
    "name": "Nineveh",
    "iso2": "NI",
    "timezone": "Asia/Baghdad",
    "countryCode": "IQ"
  },
  {
    "name": "Saladin",
    "iso2": "SD",
    "timezone": "Asia/Baghdad",
    "countryCode": "IQ"
  },
  {
    "name": "Sulaymaniyah",
    "iso2": "SU",
    "timezone": "Asia/Baghdad",
    "countryCode": "IQ"
  },
  {
    "name": "Wasit",
    "iso2": "WA",
    "timezone": "Asia/Baghdad",
    "countryCode": "IQ"
  },
  {
    "name": "Carlow",
    "iso2": "CW",
    "timezone": "Europe/Dublin",
    "countryCode": "IE"
  },
  {
    "name": "Cavan",
    "iso2": "CN",
    "timezone": "Europe/Dublin",
    "countryCode": "IE"
  },
  {
    "name": "Clare",
    "iso2": "CE",
    "timezone": "Europe/Dublin",
    "countryCode": "IE"
  },
  {
    "name": "Connacht",
    "iso2": "C",
    "timezone": "Europe/Dublin",
    "countryCode": "IE"
  },
  {
    "name": "Cork",
    "iso2": "CO",
    "timezone": "Europe/Dublin",
    "countryCode": "IE"
  },
  {
    "name": "Donegal",
    "iso2": "DL",
    "timezone": "Europe/Dublin",
    "countryCode": "IE"
  },
  {
    "name": "Dublin",
    "iso2": "D",
    "timezone": "Europe/Dublin",
    "countryCode": "IE"
  },
  {
    "name": "Galway",
    "iso2": "G",
    "timezone": "Europe/Dublin",
    "countryCode": "IE"
  },
  {
    "name": "Kerry",
    "iso2": "KY",
    "timezone": "Europe/Dublin",
    "countryCode": "IE"
  },
  {
    "name": "Kildare",
    "iso2": "KE",
    "timezone": "Europe/Dublin",
    "countryCode": "IE"
  },
  {
    "name": "Kilkenny",
    "iso2": "KK",
    "timezone": "Europe/Dublin",
    "countryCode": "IE"
  },
  {
    "name": "Laois",
    "iso2": "LS",
    "timezone": "Europe/Dublin",
    "countryCode": "IE"
  },
  {
    "name": "Leinster",
    "iso2": "L",
    "timezone": "Europe/Dublin",
    "countryCode": "IE"
  },
  {
    "name": "Leitrim",
    "iso2": "LM",
    "timezone": "Europe/Dublin",
    "countryCode": "IE"
  },
  {
    "name": "Limerick",
    "iso2": "LK",
    "timezone": "Europe/Dublin",
    "countryCode": "IE"
  },
  {
    "name": "Longford",
    "iso2": "LD",
    "timezone": "Europe/Dublin",
    "countryCode": "IE"
  },
  {
    "name": "Louth",
    "iso2": "LH",
    "timezone": "Europe/Dublin",
    "countryCode": "IE"
  },
  {
    "name": "Mayo",
    "iso2": "MO",
    "timezone": "Europe/Dublin",
    "countryCode": "IE"
  },
  {
    "name": "Meath",
    "iso2": "MH",
    "timezone": "Europe/Dublin",
    "countryCode": "IE"
  },
  {
    "name": "Monaghan",
    "iso2": "MN",
    "timezone": "Europe/Dublin",
    "countryCode": "IE"
  },
  {
    "name": "Munster",
    "iso2": "M",
    "timezone": "Europe/Dublin",
    "countryCode": "IE"
  },
  {
    "name": "Offaly",
    "iso2": "OY",
    "timezone": "Europe/Dublin",
    "countryCode": "IE"
  },
  {
    "name": "Roscommon",
    "iso2": "RN",
    "timezone": "Europe/Dublin",
    "countryCode": "IE"
  },
  {
    "name": "Sligo",
    "iso2": "SO",
    "timezone": "Europe/Dublin",
    "countryCode": "IE"
  },
  {
    "name": "Tipperary",
    "iso2": "TA",
    "timezone": "Europe/Dublin",
    "countryCode": "IE"
  },
  {
    "name": "Ulster",
    "iso2": "U",
    "timezone": "Europe/Dublin",
    "countryCode": "IE"
  },
  {
    "name": "Waterford",
    "iso2": "WD",
    "timezone": "Europe/Dublin",
    "countryCode": "IE"
  },
  {
    "name": "Westmeath",
    "iso2": "WH",
    "timezone": "Europe/Dublin",
    "countryCode": "IE"
  },
  {
    "name": "Wexford",
    "iso2": "WX",
    "timezone": "Europe/Dublin",
    "countryCode": "IE"
  },
  {
    "name": "Wicklow",
    "iso2": "WW",
    "timezone": "Europe/Dublin",
    "countryCode": "IE"
  },
  {
    "name": "Central",
    "iso2": "M",
    "timezone": "Asia/Jerusalem",
    "countryCode": "IL"
  },
  {
    "name": "Haifa",
    "iso2": "HA",
    "timezone": "Asia/Jerusalem",
    "countryCode": "IL"
  },
  {
    "name": "Jerusalem",
    "iso2": "JM",
    "timezone": "Asia/Jerusalem",
    "countryCode": "IL"
  },
  {
    "name": "Northern",
    "iso2": "Z",
    "timezone": "Asia/Jerusalem",
    "countryCode": "IL"
  },
  {
    "name": "Southern",
    "iso2": "D",
    "timezone": "Asia/Jerusalem",
    "countryCode": "IL"
  },
  {
    "name": "Tel Aviv",
    "iso2": "TA",
    "timezone": "Asia/Jerusalem",
    "countryCode": "IL"
  },
  {
    "name": "Abruzzo",
    "iso2": "65",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Agrigento",
    "iso2": "AG",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Alessandria",
    "iso2": "AL",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Ancona",
    "iso2": "AN",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Aosta Valley",
    "iso2": "23",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Apulia",
    "iso2": "75",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Arezzo",
    "iso2": "AR",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Ascoli Piceno",
    "iso2": "AP",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Asti",
    "iso2": "AT",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Avellino",
    "iso2": "AV",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Bari",
    "iso2": "BA",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Barletta-Andria-Trani",
    "iso2": "BT",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Basilicata",
    "iso2": "77",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Belluno",
    "iso2": "BL",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Benevento",
    "iso2": "BN",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Bergamo",
    "iso2": "BG",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Biella",
    "iso2": "BI",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Bologna",
    "iso2": "BO",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Brescia",
    "iso2": "BS",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Brindisi",
    "iso2": "BR",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Cagliari",
    "iso2": "CA",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Calabria",
    "iso2": "78",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Caltanissetta",
    "iso2": "CL",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Campania",
    "iso2": "72",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Campobasso",
    "iso2": "CB",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Caserta",
    "iso2": "CE",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Catania",
    "iso2": "CT",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Catanzaro",
    "iso2": "CZ",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Chieti",
    "iso2": "CH",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Como",
    "iso2": "CO",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Cosenza",
    "iso2": "CS",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Cremona",
    "iso2": "CR",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Crotone",
    "iso2": "KR",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Cuneo",
    "iso2": "CN",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Emilia-Romagna",
    "iso2": "45",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Enna",
    "iso2": "EN",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Fermo",
    "iso2": "FM",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Ferrara",
    "iso2": "FE",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Florence",
    "iso2": "FI",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Foggia",
    "iso2": "FG",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Forlì-Cesena",
    "iso2": "FC",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Friuli–Venezia Giulia",
    "iso2": "36",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Frosinone",
    "iso2": "FR",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Genoa",
    "iso2": "GE",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Gorizia",
    "iso2": "GO",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Grosseto",
    "iso2": "GR",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Imperia",
    "iso2": "IM",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Isernia",
    "iso2": "IS",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "L'Aquila",
    "iso2": "AQ",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "La Spezia",
    "iso2": "SP",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Latina",
    "iso2": "LT",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Lazio",
    "iso2": "62",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Lecce",
    "iso2": "LE",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Lecco",
    "iso2": "LC",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Liguria",
    "iso2": "42",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Livorno",
    "iso2": "LI",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Lodi",
    "iso2": "LO",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Lombardy",
    "iso2": "25",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Lucca",
    "iso2": "LU",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Macerata",
    "iso2": "MC",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Mantua",
    "iso2": "MN",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Marche",
    "iso2": "57",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Massa and Carrara",
    "iso2": "MS",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Matera",
    "iso2": "MT",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Messina",
    "iso2": "ME",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Milan",
    "iso2": "MI",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Modena",
    "iso2": "MO",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Molise",
    "iso2": "67",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Monza and Brianza",
    "iso2": "MB",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Naples",
    "iso2": "NA",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Novara",
    "iso2": "NO",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Nuoro",
    "iso2": "NU",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Oristano",
    "iso2": "OR",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Padua",
    "iso2": "PD",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Palermo",
    "iso2": "PA",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Parma",
    "iso2": "PR",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Pavia",
    "iso2": "PV",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Perugia",
    "iso2": "PG",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Pesaro and Urbino",
    "iso2": "PU",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Pescara",
    "iso2": "PE",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Piacenza",
    "iso2": "PC",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Piedmont",
    "iso2": "21",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Pisa",
    "iso2": "PI",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Pistoia",
    "iso2": "PT",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Pordenone",
    "iso2": "PN",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Potenza",
    "iso2": "PZ",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Prato",
    "iso2": "PO",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Ragusa",
    "iso2": "RG",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Ravenna",
    "iso2": "RA",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Reggio Calabria",
    "iso2": "RC",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Reggio Emilia",
    "iso2": "RE",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Rieti",
    "iso2": "RI",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Rimini",
    "iso2": "RN",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Rome",
    "iso2": "RM",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Rovigo",
    "iso2": "RO",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Salerno",
    "iso2": "SA",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Sardinia",
    "iso2": "88",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Sassari",
    "iso2": "SS",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Savona",
    "iso2": "SV",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Sicily",
    "iso2": "82",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Siena",
    "iso2": "SI",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Siracusa",
    "iso2": "SR",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Sondrio",
    "iso2": "SO",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "South Sardinia",
    "iso2": "SU",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "South Tyrol",
    "iso2": "BZ",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Taranto",
    "iso2": "TA",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Teramo",
    "iso2": "TE",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Terni",
    "iso2": "TR",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Trapani",
    "iso2": "TP",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Trentino",
    "iso2": "TN",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Trentino-South Tyrol",
    "iso2": "32",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Treviso",
    "iso2": "TV",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Trieste",
    "iso2": "TS",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Turin",
    "iso2": "TO",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Tuscany",
    "iso2": "52",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Udine",
    "iso2": "UD",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Umbria",
    "iso2": "55",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Varese",
    "iso2": "VA",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Veneto",
    "iso2": "34",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Venice",
    "iso2": "VE",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Verbano-Cusio-Ossola",
    "iso2": "VB",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Vercelli",
    "iso2": "VC",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Verona",
    "iso2": "VR",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Vibo Valentia",
    "iso2": "VV",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Vicenza",
    "iso2": "VI",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Viterbo",
    "iso2": "VT",
    "timezone": "Europe/Rome",
    "countryCode": "IT"
  },
  {
    "name": "Abidjan",
    "iso2": "AB",
    "timezone": "Africa/Abidjan",
    "countryCode": "CI"
  },
  {
    "name": "Bas-Sassandra",
    "iso2": "BS",
    "timezone": "Africa/Abidjan",
    "countryCode": "CI"
  },
  {
    "name": "Comoé",
    "iso2": "CM",
    "timezone": "Africa/Abidjan",
    "countryCode": "CI"
  },
  {
    "name": "Denguélé",
    "iso2": "DN",
    "timezone": "Africa/Abidjan",
    "countryCode": "CI"
  },
  {
    "name": "Gôh-Djiboua",
    "iso2": "GD",
    "timezone": "Africa/Abidjan",
    "countryCode": "CI"
  },
  {
    "name": "Lacs",
    "iso2": "LC",
    "timezone": "Africa/Abidjan",
    "countryCode": "CI"
  },
  {
    "name": "Lagunes",
    "iso2": "LG",
    "timezone": "Africa/Abidjan",
    "countryCode": "CI"
  },
  {
    "name": "Montagnes",
    "iso2": "MG",
    "timezone": "Africa/Abidjan",
    "countryCode": "CI"
  },
  {
    "name": "Sassandra-Marahoué",
    "iso2": "SM",
    "timezone": "Africa/Abidjan",
    "countryCode": "CI"
  },
  {
    "name": "Savanes",
    "iso2": "SV",
    "timezone": "Africa/Abidjan",
    "countryCode": "CI"
  },
  {
    "name": "Vallée du Bandama",
    "iso2": "VB",
    "timezone": "Africa/Abidjan",
    "countryCode": "CI"
  },
  {
    "name": "Woroba",
    "iso2": "WR",
    "timezone": "Africa/Abidjan",
    "countryCode": "CI"
  },
  {
    "name": "Yamoussoukro",
    "iso2": "YM",
    "timezone": "Africa/Abidjan",
    "countryCode": "CI"
  },
  {
    "name": "Zanzan",
    "iso2": "ZZ",
    "timezone": "Africa/Abidjan",
    "countryCode": "CI"
  },
  {
    "name": "Clarendon",
    "iso2": "13",
    "timezone": "America/Jamaica",
    "countryCode": "JM"
  },
  {
    "name": "Hanover",
    "iso2": "09",
    "timezone": "America/Jamaica",
    "countryCode": "JM"
  },
  {
    "name": "Kingston",
    "iso2": "01",
    "timezone": "America/Jamaica",
    "countryCode": "JM"
  },
  {
    "name": "Manchester",
    "iso2": "12",
    "timezone": "America/Jamaica",
    "countryCode": "JM"
  },
  {
    "name": "Portland",
    "iso2": "04",
    "timezone": "America/Jamaica",
    "countryCode": "JM"
  },
  {
    "name": "Saint Andrew",
    "iso2": "02",
    "timezone": "America/Jamaica",
    "countryCode": "JM"
  },
  {
    "name": "Saint Ann",
    "iso2": "06",
    "timezone": "America/Jamaica",
    "countryCode": "JM"
  },
  {
    "name": "Saint Catherine",
    "iso2": "14",
    "timezone": "America/Jamaica",
    "countryCode": "JM"
  },
  {
    "name": "Saint Elizabeth",
    "iso2": "11",
    "timezone": "America/Jamaica",
    "countryCode": "JM"
  },
  {
    "name": "Saint James",
    "iso2": "08",
    "timezone": "America/Jamaica",
    "countryCode": "JM"
  },
  {
    "name": "Saint Mary",
    "iso2": "05",
    "timezone": "America/Jamaica",
    "countryCode": "JM"
  },
  {
    "name": "Saint Thomas",
    "iso2": "03",
    "timezone": "America/Jamaica",
    "countryCode": "JM"
  },
  {
    "name": "Trelawny",
    "iso2": "07",
    "timezone": "America/Jamaica",
    "countryCode": "JM"
  },
  {
    "name": "Westmoreland",
    "iso2": "10",
    "timezone": "America/Jamaica",
    "countryCode": "JM"
  },
  {
    "name": "Aichi",
    "iso2": "23",
    "timezone": "Asia/Tokyo",
    "countryCode": "JP"
  },
  {
    "name": "Akita",
    "iso2": "05",
    "timezone": "Asia/Tokyo",
    "countryCode": "JP"
  },
  {
    "name": "Aomori",
    "iso2": "02",
    "timezone": "Asia/Tokyo",
    "countryCode": "JP"
  },
  {
    "name": "Chiba",
    "iso2": "12",
    "timezone": "Asia/Tokyo",
    "countryCode": "JP"
  },
  {
    "name": "Ehime",
    "iso2": "38",
    "timezone": "Asia/Tokyo",
    "countryCode": "JP"
  },
  {
    "name": "Fukui",
    "iso2": "18",
    "timezone": "Asia/Tokyo",
    "countryCode": "JP"
  },
  {
    "name": "Fukuoka",
    "iso2": "40",
    "timezone": "Asia/Tokyo",
    "countryCode": "JP"
  },
  {
    "name": "Fukushima",
    "iso2": "07",
    "timezone": "Asia/Tokyo",
    "countryCode": "JP"
  },
  {
    "name": "Gifu",
    "iso2": "21",
    "timezone": "Asia/Tokyo",
    "countryCode": "JP"
  },
  {
    "name": "Gunma",
    "iso2": "10",
    "timezone": "Asia/Tokyo",
    "countryCode": "JP"
  },
  {
    "name": "Hiroshima",
    "iso2": "34",
    "timezone": "Asia/Tokyo",
    "countryCode": "JP"
  },
  {
    "name": "Hokkaidō",
    "iso2": "01",
    "timezone": "Asia/Tokyo",
    "countryCode": "JP"
  },
  {
    "name": "Hyōgo",
    "iso2": "28",
    "timezone": "Asia/Tokyo",
    "countryCode": "JP"
  },
  {
    "name": "Ibaraki",
    "iso2": "08",
    "timezone": "Asia/Tokyo",
    "countryCode": "JP"
  },
  {
    "name": "Ishikawa",
    "iso2": "17",
    "timezone": "Asia/Tokyo",
    "countryCode": "JP"
  },
  {
    "name": "Iwate",
    "iso2": "03",
    "timezone": "Asia/Tokyo",
    "countryCode": "JP"
  },
  {
    "name": "Kagawa",
    "iso2": "37",
    "timezone": "Asia/Tokyo",
    "countryCode": "JP"
  },
  {
    "name": "Kagoshima",
    "iso2": "46",
    "timezone": "Asia/Tokyo",
    "countryCode": "JP"
  },
  {
    "name": "Kanagawa",
    "iso2": "14",
    "timezone": "Asia/Tokyo",
    "countryCode": "JP"
  },
  {
    "name": "Kōchi",
    "iso2": "39",
    "timezone": "Asia/Tokyo",
    "countryCode": "JP"
  },
  {
    "name": "Kumamoto",
    "iso2": "43",
    "timezone": "Asia/Tokyo",
    "countryCode": "JP"
  },
  {
    "name": "Kyōto",
    "iso2": "26",
    "timezone": "Asia/Tokyo",
    "countryCode": "JP"
  },
  {
    "name": "Mie",
    "iso2": "24",
    "timezone": "Asia/Tokyo",
    "countryCode": "JP"
  },
  {
    "name": "Miyagi",
    "iso2": "04",
    "timezone": "Asia/Tokyo",
    "countryCode": "JP"
  },
  {
    "name": "Miyazaki",
    "iso2": "45",
    "timezone": "Asia/Tokyo",
    "countryCode": "JP"
  },
  {
    "name": "Nagano",
    "iso2": "20",
    "timezone": "Asia/Tokyo",
    "countryCode": "JP"
  },
  {
    "name": "Nagasaki",
    "iso2": "42",
    "timezone": "Asia/Tokyo",
    "countryCode": "JP"
  },
  {
    "name": "Nara",
    "iso2": "29",
    "timezone": "Asia/Tokyo",
    "countryCode": "JP"
  },
  {
    "name": "Niigata",
    "iso2": "15",
    "timezone": "Asia/Tokyo",
    "countryCode": "JP"
  },
  {
    "name": "Ōita",
    "iso2": "44",
    "timezone": "Asia/Tokyo",
    "countryCode": "JP"
  },
  {
    "name": "Okayama",
    "iso2": "33",
    "timezone": "Asia/Tokyo",
    "countryCode": "JP"
  },
  {
    "name": "Okinawa",
    "iso2": "47",
    "timezone": "Asia/Tokyo",
    "countryCode": "JP"
  },
  {
    "name": "Ōsaka",
    "iso2": "27",
    "timezone": "Asia/Tokyo",
    "countryCode": "JP"
  },
  {
    "name": "Saga",
    "iso2": "41",
    "timezone": "Asia/Tokyo",
    "countryCode": "JP"
  },
  {
    "name": "Saitama",
    "iso2": "11",
    "timezone": "Asia/Tokyo",
    "countryCode": "JP"
  },
  {
    "name": "Shiga",
    "iso2": "25",
    "timezone": "Asia/Tokyo",
    "countryCode": "JP"
  },
  {
    "name": "Shimane",
    "iso2": "32",
    "timezone": "Asia/Tokyo",
    "countryCode": "JP"
  },
  {
    "name": "Shizuoka",
    "iso2": "22",
    "timezone": "Asia/Tokyo",
    "countryCode": "JP"
  },
  {
    "name": "Tochigi",
    "iso2": "09",
    "timezone": "Asia/Tokyo",
    "countryCode": "JP"
  },
  {
    "name": "Tokushima",
    "iso2": "36",
    "timezone": "Asia/Tokyo",
    "countryCode": "JP"
  },
  {
    "name": "Tokyo",
    "iso2": "13",
    "timezone": "Asia/Tokyo",
    "countryCode": "JP"
  },
  {
    "name": "Tottori",
    "iso2": "31",
    "timezone": "Asia/Tokyo",
    "countryCode": "JP"
  },
  {
    "name": "Toyama",
    "iso2": "16",
    "timezone": "Asia/Tokyo",
    "countryCode": "JP"
  },
  {
    "name": "Wakayama",
    "iso2": "30",
    "timezone": "Asia/Tokyo",
    "countryCode": "JP"
  },
  {
    "name": "Yamagata",
    "iso2": "06",
    "timezone": "Asia/Tokyo",
    "countryCode": "JP"
  },
  {
    "name": "Yamaguchi",
    "iso2": "35",
    "timezone": "Asia/Tokyo",
    "countryCode": "JP"
  },
  {
    "name": "Yamanashi",
    "iso2": "19",
    "timezone": "Asia/Tokyo",
    "countryCode": "JP"
  },
  {
    "name": "Grouville",
    "iso2": "01",
    "timezone": "Europe/Jersey",
    "countryCode": "JE"
  },
  {
    "name": "St Brelade",
    "iso2": "02",
    "timezone": "Europe/Jersey",
    "countryCode": "JE"
  },
  {
    "name": "St Clement",
    "iso2": "03",
    "timezone": "Europe/Jersey",
    "countryCode": "JE"
  },
  {
    "name": "St Helier",
    "iso2": "04",
    "timezone": "Europe/Jersey",
    "countryCode": "JE"
  },
  {
    "name": "St John",
    "iso2": "05",
    "timezone": "Europe/Jersey",
    "countryCode": "JE"
  },
  {
    "name": "St Lawrence",
    "iso2": "06",
    "timezone": "Europe/Jersey",
    "countryCode": "JE"
  },
  {
    "name": "St Martin",
    "iso2": "07",
    "timezone": "Europe/Jersey",
    "countryCode": "JE"
  },
  {
    "name": "St Mary",
    "iso2": "08",
    "timezone": "Europe/Jersey",
    "countryCode": "JE"
  },
  {
    "name": "St Ouen",
    "iso2": "09",
    "timezone": "Europe/Jersey",
    "countryCode": "JE"
  },
  {
    "name": "St Peter",
    "iso2": "10",
    "timezone": "Europe/Jersey",
    "countryCode": "JE"
  },
  {
    "name": "St Saviour",
    "iso2": "11",
    "timezone": "Europe/Jersey",
    "countryCode": "JE"
  },
  {
    "name": "Trinity",
    "iso2": "12",
    "timezone": "Europe/Jersey",
    "countryCode": "JE"
  },
  {
    "name": "Ajloun",
    "iso2": "AJ",
    "timezone": "Asia/Amman",
    "countryCode": "JO"
  },
  {
    "name": "Amman",
    "iso2": "AM",
    "timezone": "Asia/Amman",
    "countryCode": "JO"
  },
  {
    "name": "Aqaba",
    "iso2": "AQ",
    "timezone": "Asia/Amman",
    "countryCode": "JO"
  },
  {
    "name": "Balqa",
    "iso2": "BA",
    "timezone": "Asia/Amman",
    "countryCode": "JO"
  },
  {
    "name": "Irbid",
    "iso2": "IR",
    "timezone": "Asia/Amman",
    "countryCode": "JO"
  },
  {
    "name": "Jerash",
    "iso2": "JA",
    "timezone": "Asia/Amman",
    "countryCode": "JO"
  },
  {
    "name": "Karak",
    "iso2": "KA",
    "timezone": "Asia/Amman",
    "countryCode": "JO"
  },
  {
    "name": "Ma'an",
    "iso2": "MN",
    "timezone": "Asia/Amman",
    "countryCode": "JO"
  },
  {
    "name": "Madaba",
    "iso2": "MD",
    "timezone": "Asia/Amman",
    "countryCode": "JO"
  },
  {
    "name": "Mafraq",
    "iso2": "MA",
    "timezone": "Asia/Amman",
    "countryCode": "JO"
  },
  {
    "name": "Tafilah",
    "iso2": "AT",
    "timezone": "Asia/Amman",
    "countryCode": "JO"
  },
  {
    "name": "Zarqa",
    "iso2": "AZ",
    "timezone": "Asia/Amman",
    "countryCode": "JO"
  },
  {
    "name": "Abai",
    "iso2": "10",
    "timezone": "Asia/Almaty",
    "countryCode": "KZ"
  },
  {
    "name": "Akmola",
    "iso2": "11",
    "timezone": "Asia/Almaty",
    "countryCode": "KZ"
  },
  {
    "name": "Aktobe",
    "iso2": "15",
    "timezone": "Asia/Almaty",
    "countryCode": "KZ"
  },
  {
    "name": "Almaty",
    "iso2": "19",
    "timezone": "Asia/Almaty",
    "countryCode": "KZ"
  },
  {
    "name": "Almaty",
    "iso2": "75",
    "timezone": "Asia/Almaty",
    "countryCode": "KZ"
  },
  {
    "name": "Astana",
    "iso2": "71",
    "timezone": "Asia/Almaty",
    "countryCode": "KZ"
  },
  {
    "name": "Atyrau",
    "iso2": "23",
    "timezone": "Asia/Atyrau",
    "countryCode": "KZ"
  },
  {
    "name": "East Kazakhstan",
    "iso2": "63",
    "timezone": "Asia/Almaty",
    "countryCode": "KZ"
  },
  {
    "name": "Jambyl",
    "iso2": "31",
    "timezone": "Asia/Almaty",
    "countryCode": "KZ"
  },
  {
    "name": "Jetisu",
    "iso2": "33",
    "timezone": "Asia/Almaty",
    "countryCode": "KZ"
  },
  {
    "name": "Karaganda",
    "iso2": "35",
    "timezone": "Asia/Almaty",
    "countryCode": "KZ"
  },
  {
    "name": "Kostanay",
    "iso2": "39",
    "timezone": "Asia/Almaty",
    "countryCode": "KZ"
  },
  {
    "name": "Kyzylorda",
    "iso2": "43",
    "timezone": "Asia/Almaty",
    "countryCode": "KZ"
  },
  {
    "name": "Mangystau",
    "iso2": "47",
    "timezone": "Asia/Almaty",
    "countryCode": "KZ"
  },
  {
    "name": "North Kazakhstan",
    "iso2": "59",
    "timezone": "Asia/Almaty",
    "countryCode": "KZ"
  },
  {
    "name": "Pavlodar",
    "iso2": "55",
    "timezone": "Asia/Almaty",
    "countryCode": "KZ"
  },
  {
    "name": "Shymkent",
    "iso2": "79",
    "timezone": "Asia/Almaty",
    "countryCode": "KZ"
  },
  {
    "name": "Turkistan",
    "iso2": "61",
    "timezone": "Asia/Almaty",
    "countryCode": "KZ"
  },
  {
    "name": "Ulytau",
    "iso2": "62",
    "timezone": "Asia/Almaty",
    "countryCode": "KZ"
  },
  {
    "name": "West Kazakhstan",
    "iso2": "27",
    "timezone": "Asia/Oral",
    "countryCode": "KZ"
  },
  {
    "name": "Baringo",
    "iso2": "01",
    "timezone": "Africa/Nairobi",
    "countryCode": "KE"
  },
  {
    "name": "Bomet",
    "iso2": "02",
    "timezone": "Africa/Nairobi",
    "countryCode": "KE"
  },
  {
    "name": "Bungoma",
    "iso2": "03",
    "timezone": "Africa/Nairobi",
    "countryCode": "KE"
  },
  {
    "name": "Busia",
    "iso2": "04",
    "timezone": "Africa/Nairobi",
    "countryCode": "KE"
  },
  {
    "name": "Elgeyo-Marakwet",
    "iso2": "05",
    "timezone": "Africa/Nairobi",
    "countryCode": "KE"
  },
  {
    "name": "Embu",
    "iso2": "06",
    "timezone": "Africa/Nairobi",
    "countryCode": "KE"
  },
  {
    "name": "Garissa",
    "iso2": "07",
    "timezone": "Africa/Nairobi",
    "countryCode": "KE"
  },
  {
    "name": "Homa Bay",
    "iso2": "08",
    "timezone": "Africa/Nairobi",
    "countryCode": "KE"
  },
  {
    "name": "Isiolo",
    "iso2": "09",
    "timezone": "Africa/Nairobi",
    "countryCode": "KE"
  },
  {
    "name": "Kajiado",
    "iso2": "10",
    "timezone": "Africa/Nairobi",
    "countryCode": "KE"
  },
  {
    "name": "Kakamega",
    "iso2": "11",
    "timezone": "Africa/Nairobi",
    "countryCode": "KE"
  },
  {
    "name": "Kericho",
    "iso2": "12",
    "timezone": "Africa/Nairobi",
    "countryCode": "KE"
  },
  {
    "name": "Kiambu",
    "iso2": "13",
    "timezone": "Africa/Nairobi",
    "countryCode": "KE"
  },
  {
    "name": "Kilifi",
    "iso2": "14",
    "timezone": "Africa/Nairobi",
    "countryCode": "KE"
  },
  {
    "name": "Kirinyaga",
    "iso2": "15",
    "timezone": "Africa/Nairobi",
    "countryCode": "KE"
  },
  {
    "name": "Kisii",
    "iso2": "16",
    "timezone": "Africa/Nairobi",
    "countryCode": "KE"
  },
  {
    "name": "Kisumu",
    "iso2": "17",
    "timezone": "Africa/Nairobi",
    "countryCode": "KE"
  },
  {
    "name": "Kitui",
    "iso2": "18",
    "timezone": "Africa/Nairobi",
    "countryCode": "KE"
  },
  {
    "name": "Kwale",
    "iso2": "19",
    "timezone": "Africa/Nairobi",
    "countryCode": "KE"
  },
  {
    "name": "Laikipia",
    "iso2": "20",
    "timezone": "Africa/Nairobi",
    "countryCode": "KE"
  },
  {
    "name": "Lamu",
    "iso2": "21",
    "timezone": "Africa/Nairobi",
    "countryCode": "KE"
  },
  {
    "name": "Machakos",
    "iso2": "22",
    "timezone": "Africa/Nairobi",
    "countryCode": "KE"
  },
  {
    "name": "Makueni",
    "iso2": "23",
    "timezone": "Africa/Nairobi",
    "countryCode": "KE"
  },
  {
    "name": "Mandera",
    "iso2": "24",
    "timezone": "Africa/Nairobi",
    "countryCode": "KE"
  },
  {
    "name": "Marsabit",
    "iso2": "25",
    "timezone": "Africa/Nairobi",
    "countryCode": "KE"
  },
  {
    "name": "Meru",
    "iso2": "26",
    "timezone": "Africa/Nairobi",
    "countryCode": "KE"
  },
  {
    "name": "Migori",
    "iso2": "27",
    "timezone": "Africa/Nairobi",
    "countryCode": "KE"
  },
  {
    "name": "Mombasa",
    "iso2": "28",
    "timezone": "Africa/Nairobi",
    "countryCode": "KE"
  },
  {
    "name": "Murang'a",
    "iso2": "29",
    "timezone": "Africa/Nairobi",
    "countryCode": "KE"
  },
  {
    "name": "Nairobi City",
    "iso2": "30",
    "timezone": "Africa/Nairobi",
    "countryCode": "KE"
  },
  {
    "name": "Nakuru",
    "iso2": "31",
    "timezone": "Africa/Nairobi",
    "countryCode": "KE"
  },
  {
    "name": "Nandi",
    "iso2": "32",
    "timezone": "Africa/Nairobi",
    "countryCode": "KE"
  },
  {
    "name": "Narok",
    "iso2": "33",
    "timezone": "Africa/Nairobi",
    "countryCode": "KE"
  },
  {
    "name": "Nyamira",
    "iso2": "34",
    "timezone": "Africa/Nairobi",
    "countryCode": "KE"
  },
  {
    "name": "Nyandarua",
    "iso2": "35",
    "timezone": "Africa/Nairobi",
    "countryCode": "KE"
  },
  {
    "name": "Nyeri",
    "iso2": "36",
    "timezone": "Africa/Nairobi",
    "countryCode": "KE"
  },
  {
    "name": "Samburu",
    "iso2": "37",
    "timezone": "Africa/Nairobi",
    "countryCode": "KE"
  },
  {
    "name": "Siaya",
    "iso2": "38",
    "timezone": "Africa/Nairobi",
    "countryCode": "KE"
  },
  {
    "name": "Taita–Taveta",
    "iso2": "39",
    "timezone": "Africa/Nairobi",
    "countryCode": "KE"
  },
  {
    "name": "Tana River",
    "iso2": "40",
    "timezone": "Africa/Nairobi",
    "countryCode": "KE"
  },
  {
    "name": "Tharaka-Nithi",
    "iso2": "41",
    "timezone": "Africa/Nairobi",
    "countryCode": "KE"
  },
  {
    "name": "Trans Nzoia",
    "iso2": "42",
    "timezone": "Africa/Nairobi",
    "countryCode": "KE"
  },
  {
    "name": "Turkana",
    "iso2": "43",
    "timezone": "Africa/Nairobi",
    "countryCode": "KE"
  },
  {
    "name": "Uasin Gishu",
    "iso2": "44",
    "timezone": "Africa/Nairobi",
    "countryCode": "KE"
  },
  {
    "name": "Vihiga",
    "iso2": "45",
    "timezone": "Africa/Nairobi",
    "countryCode": "KE"
  },
  {
    "name": "Wajir",
    "iso2": "46",
    "timezone": "Africa/Nairobi",
    "countryCode": "KE"
  },
  {
    "name": "West Pokot",
    "iso2": "47",
    "timezone": "Africa/Nairobi",
    "countryCode": "KE"
  },
  {
    "name": "Gilbert",
    "iso2": "G",
    "timezone": "Pacific/Enderbury",
    "countryCode": "KI"
  },
  {
    "name": "Line",
    "iso2": "L",
    "timezone": "Pacific/Enderbury",
    "countryCode": "KI"
  },
  {
    "name": "Phoenix",
    "iso2": "P",
    "timezone": "Pacific/Enderbury",
    "countryCode": "KI"
  },
  {
    "name": "Ferizaj",
    "iso2": "XUF",
    "timezone": "Europe/Belgrade",
    "countryCode": "XK"
  },
  {
    "name": "Gjakove",
    "iso2": "XDG",
    "timezone": "Europe/Belgrade",
    "countryCode": "XK"
  },
  {
    "name": "Gjilan",
    "iso2": "XGJ",
    "timezone": "Europe/Belgrade",
    "countryCode": "XK"
  },
  {
    "name": "Mitrovica",
    "iso2": "XKM",
    "timezone": "Europe/Belgrade",
    "countryCode": "XK"
  },
  {
    "name": "Peja",
    "iso2": "PEJ",
    "timezone": "Europe/Belgrade",
    "countryCode": "XK"
  },
  {
    "name": "Pristina",
    "iso2": "XPI",
    "timezone": "Europe/Belgrade",
    "countryCode": "XK"
  },
  {
    "name": "Prizren",
    "iso2": "PRI",
    "timezone": "Europe/Belgrade",
    "countryCode": "XK"
  },
  {
    "name": "Al Ahmadi",
    "iso2": "AH",
    "timezone": "Asia/Kuwait",
    "countryCode": "KW"
  },
  {
    "name": "Al Asimah",
    "iso2": "KU",
    "timezone": "Asia/Kuwait",
    "countryCode": "KW"
  },
  {
    "name": "Al Farwaniyah",
    "iso2": "FA",
    "timezone": "Asia/Kuwait",
    "countryCode": "KW"
  },
  {
    "name": "Al Jahra",
    "iso2": "JA",
    "timezone": "Asia/Kuwait",
    "countryCode": "KW"
  },
  {
    "name": "Hawalli",
    "iso2": "HA",
    "timezone": "Asia/Kuwait",
    "countryCode": "KW"
  },
  {
    "name": "Mubarak Al-Kabeer",
    "iso2": "MU",
    "timezone": "Asia/Kuwait",
    "countryCode": "KW"
  },
  {
    "name": "Batken",
    "iso2": "B",
    "timezone": "Asia/Bishkek",
    "countryCode": "KG"
  },
  {
    "name": "Bishkek",
    "iso2": "GB",
    "timezone": "Asia/Bishkek",
    "countryCode": "KG"
  },
  {
    "name": "Chuy",
    "iso2": "C",
    "timezone": "Asia/Bishkek",
    "countryCode": "KG"
  },
  {
    "name": "Issyk-Kul",
    "iso2": "Y",
    "timezone": "Asia/Bishkek",
    "countryCode": "KG"
  },
  {
    "name": "Jalal-Abad",
    "iso2": "J",
    "timezone": "Asia/Bishkek",
    "countryCode": "KG"
  },
  {
    "name": "Naryn",
    "iso2": "N",
    "timezone": "Asia/Bishkek",
    "countryCode": "KG"
  },
  {
    "name": "Osh",
    "iso2": "GO",
    "timezone": "Asia/Bishkek",
    "countryCode": "KG"
  },
  {
    "name": "Osh",
    "iso2": "O",
    "timezone": "Asia/Bishkek",
    "countryCode": "KG"
  },
  {
    "name": "Talas",
    "iso2": "T",
    "timezone": "Asia/Bishkek",
    "countryCode": "KG"
  },
  {
    "name": "Attapeu",
    "iso2": "AT",
    "timezone": "Asia/Vientiane",
    "countryCode": "LA"
  },
  {
    "name": "Bokeo",
    "iso2": "BK",
    "timezone": "Asia/Vientiane",
    "countryCode": "LA"
  },
  {
    "name": "Bolikhamsai",
    "iso2": "BL",
    "timezone": "Asia/Vientiane",
    "countryCode": "LA"
  },
  {
    "name": "Champasak",
    "iso2": "CH",
    "timezone": "Asia/Vientiane",
    "countryCode": "LA"
  },
  {
    "name": "Houaphanh",
    "iso2": "HO",
    "timezone": "Asia/Vientiane",
    "countryCode": "LA"
  },
  {
    "name": "Khammouane",
    "iso2": "KH",
    "timezone": "Asia/Vientiane",
    "countryCode": "LA"
  },
  {
    "name": "Luang Namtha",
    "iso2": "LM",
    "timezone": "Asia/Vientiane",
    "countryCode": "LA"
  },
  {
    "name": "Luang Prabang",
    "iso2": "LP",
    "timezone": "Asia/Vientiane",
    "countryCode": "LA"
  },
  {
    "name": "Oudomxay",
    "iso2": "OU",
    "timezone": "Asia/Vientiane",
    "countryCode": "LA"
  },
  {
    "name": "Phongsaly",
    "iso2": "PH",
    "timezone": "Asia/Vientiane",
    "countryCode": "LA"
  },
  {
    "name": "Sainyabuli",
    "iso2": "XA",
    "timezone": "Asia/Vientiane",
    "countryCode": "LA"
  },
  {
    "name": "Salavan",
    "iso2": "SL",
    "timezone": "Asia/Vientiane",
    "countryCode": "LA"
  },
  {
    "name": "Savannakhet",
    "iso2": "SV",
    "timezone": "Asia/Vientiane",
    "countryCode": "LA"
  },
  {
    "name": "Sekong",
    "iso2": "XE",
    "timezone": "Asia/Vientiane",
    "countryCode": "LA"
  },
  {
    "name": "Vientiane",
    "iso2": "VI",
    "timezone": "Asia/Vientiane",
    "countryCode": "LA"
  },
  {
    "name": "Vientiane",
    "iso2": "VT",
    "timezone": "Asia/Vientiane",
    "countryCode": "LA"
  },
  {
    "name": "Xaisomboun",
    "iso2": "XS",
    "timezone": "Asia/Vientiane",
    "countryCode": "LA"
  },
  {
    "name": "Xiangkhouang",
    "iso2": "XI",
    "timezone": "Asia/Vientiane",
    "countryCode": "LA"
  },
  {
    "name": "Ādaži",
    "iso2": "011",
    "timezone": "Europe/Riga",
    "countryCode": "LV"
  },
  {
    "name": "Aizkraukle",
    "iso2": "002",
    "timezone": "Europe/Riga",
    "countryCode": "LV"
  },
  {
    "name": "Alūksne",
    "iso2": "007",
    "timezone": "Europe/Riga",
    "countryCode": "LV"
  },
  {
    "name": "Augšdaugava",
    "iso2": "111",
    "timezone": "Europe/Riga",
    "countryCode": "LV"
  },
  {
    "name": "Balvi",
    "iso2": "015",
    "timezone": "Europe/Riga",
    "countryCode": "LV"
  },
  {
    "name": "Bauska",
    "iso2": "016",
    "timezone": "Europe/Riga",
    "countryCode": "LV"
  },
  {
    "name": "Cēsis",
    "iso2": "022",
    "timezone": "Europe/Riga",
    "countryCode": "LV"
  },
  {
    "name": "Daugavpils",
    "iso2": "DGV",
    "timezone": "Europe/Riga",
    "countryCode": "LV"
  },
  {
    "name": "Dienvidkurzemes",
    "iso2": "112",
    "timezone": "Europe/Riga",
    "countryCode": "LV"
  },
  {
    "name": "Dobele",
    "iso2": "026",
    "timezone": "Europe/Riga",
    "countryCode": "LV"
  },
  {
    "name": "Gulbene",
    "iso2": "033",
    "timezone": "Europe/Riga",
    "countryCode": "LV"
  },
  {
    "name": "Jēkabpils",
    "iso2": "042",
    "timezone": "Europe/Riga",
    "countryCode": "LV"
  },
  {
    "name": "Jelgava",
    "iso2": "041",
    "timezone": "Europe/Riga",
    "countryCode": "LV"
  },
  {
    "name": "Jelgava",
    "iso2": "JEL",
    "timezone": "Europe/Riga",
    "countryCode": "LV"
  },
  {
    "name": "Jūrmala",
    "iso2": "JUR",
    "timezone": "Europe/Riga",
    "countryCode": "LV"
  },
  {
    "name": "Ķekava",
    "iso2": "052",
    "timezone": "Europe/Riga",
    "countryCode": "LV"
  },
  {
    "name": "Krāslava",
    "iso2": "047",
    "timezone": "Europe/Riga",
    "countryCode": "LV"
  },
  {
    "name": "Kuldīga",
    "iso2": "050",
    "timezone": "Europe/Riga",
    "countryCode": "LV"
  },
  {
    "name": "Liepāja",
    "iso2": "LPX",
    "timezone": "Europe/Riga",
    "countryCode": "LV"
  },
  {
    "name": "Limbaži",
    "iso2": "054",
    "timezone": "Europe/Riga",
    "countryCode": "LV"
  },
  {
    "name": "Līvāni",
    "iso2": "056",
    "timezone": "Europe/Riga",
    "countryCode": "LV"
  },
  {
    "name": "Ludza",
    "iso2": "058",
    "timezone": "Europe/Riga",
    "countryCode": "LV"
  },
  {
    "name": "Madona",
    "iso2": "059",
    "timezone": "Europe/Riga",
    "countryCode": "LV"
  },
  {
    "name": "Mārupe",
    "iso2": "062",
    "timezone": "Europe/Riga",
    "countryCode": "LV"
  },
  {
    "name": "Ogre",
    "iso2": "067",
    "timezone": "Europe/Riga",
    "countryCode": "LV"
  },
  {
    "name": "Olaine",
    "iso2": "068",
    "timezone": "Europe/Riga",
    "countryCode": "LV"
  },
  {
    "name": "Preiļi",
    "iso2": "073",
    "timezone": "Europe/Riga",
    "countryCode": "LV"
  },
  {
    "name": "Rēzekne",
    "iso2": "REZ",
    "timezone": "Europe/Riga",
    "countryCode": "LV"
  },
  {
    "name": "Rēzekne",
    "iso2": "077",
    "timezone": "Europe/Riga",
    "countryCode": "LV"
  },
  {
    "name": "Riga",
    "iso2": "RIX",
    "timezone": "Europe/Riga",
    "countryCode": "LV"
  },
  {
    "name": "Ropaži",
    "iso2": "080",
    "timezone": "Europe/Riga",
    "countryCode": "LV"
  },
  {
    "name": "Salaspils",
    "iso2": "087",
    "timezone": "Europe/Riga",
    "countryCode": "LV"
  },
  {
    "name": "Saldus",
    "iso2": "088",
    "timezone": "Europe/Riga",
    "countryCode": "LV"
  },
  {
    "name": "Saulkrasti",
    "iso2": "089",
    "timezone": "Europe/Riga",
    "countryCode": "LV"
  },
  {
    "name": "Sigulda",
    "iso2": "091",
    "timezone": "Europe/Riga",
    "countryCode": "LV"
  },
  {
    "name": "Smiltene",
    "iso2": "094",
    "timezone": "Europe/Riga",
    "countryCode": "LV"
  },
  {
    "name": "Talsi",
    "iso2": "097",
    "timezone": "Europe/Riga",
    "countryCode": "LV"
  },
  {
    "name": "Tukums",
    "iso2": "099",
    "timezone": "Europe/Riga",
    "countryCode": "LV"
  },
  {
    "name": "Valka",
    "iso2": "101",
    "timezone": "Europe/Riga",
    "countryCode": "LV"
  },
  {
    "name": "Valmiera",
    "iso2": "113",
    "timezone": "Europe/Riga",
    "countryCode": "LV"
  },
  {
    "name": "Varakļāni",
    "iso2": "102",
    "timezone": "Europe/Riga",
    "countryCode": "LV"
  },
  {
    "name": "Ventspils",
    "iso2": "VEN",
    "timezone": "Europe/Riga",
    "countryCode": "LV"
  },
  {
    "name": "Ventspils",
    "iso2": "106",
    "timezone": "Europe/Riga",
    "countryCode": "LV"
  },
  {
    "name": "Akkar",
    "iso2": "AK",
    "timezone": "Asia/Beirut",
    "countryCode": "LB"
  },
  {
    "name": "Baalbek-Hermel",
    "iso2": "BH",
    "timezone": "Asia/Beirut",
    "countryCode": "LB"
  },
  {
    "name": "Beirut",
    "iso2": "BA",
    "timezone": "Asia/Beirut",
    "countryCode": "LB"
  },
  {
    "name": "Beqaa",
    "iso2": "BI",
    "timezone": "Asia/Beirut",
    "countryCode": "LB"
  },
  {
    "name": "Mount Lebanon",
    "iso2": "JL",
    "timezone": "Asia/Beirut",
    "countryCode": "LB"
  },
  {
    "name": "Nabatieh",
    "iso2": "NA",
    "timezone": "Asia/Beirut",
    "countryCode": "LB"
  },
  {
    "name": "North",
    "iso2": "AS",
    "timezone": "Asia/Beirut",
    "countryCode": "LB"
  },
  {
    "name": "South",
    "iso2": "JA",
    "timezone": "Asia/Beirut",
    "countryCode": "LB"
  },
  {
    "name": "Berea",
    "iso2": "D",
    "timezone": "Africa/Maseru",
    "countryCode": "LS"
  },
  {
    "name": "Butha-Buthe",
    "iso2": "B",
    "timezone": "Africa/Maseru",
    "countryCode": "LS"
  },
  {
    "name": "Leribe",
    "iso2": "C",
    "timezone": "Africa/Maseru",
    "countryCode": "LS"
  },
  {
    "name": "Mafeteng",
    "iso2": "E",
    "timezone": "Africa/Maseru",
    "countryCode": "LS"
  },
  {
    "name": "Maseru",
    "iso2": "A",
    "timezone": "Africa/Maseru",
    "countryCode": "LS"
  },
  {
    "name": "Mohale's Hoek",
    "iso2": "F",
    "timezone": "Africa/Maseru",
    "countryCode": "LS"
  },
  {
    "name": "Mokhotlong",
    "iso2": "J",
    "timezone": "Africa/Maseru",
    "countryCode": "LS"
  },
  {
    "name": "Qacha's Nek",
    "iso2": "H",
    "timezone": "Africa/Maseru",
    "countryCode": "LS"
  },
  {
    "name": "Quthing",
    "iso2": "G",
    "timezone": "Africa/Maseru",
    "countryCode": "LS"
  },
  {
    "name": "Thaba-Tseka",
    "iso2": "K",
    "timezone": "Africa/Maseru",
    "countryCode": "LS"
  },
  {
    "name": "Bomi",
    "iso2": "BM",
    "timezone": "Africa/Monrovia",
    "countryCode": "LR"
  },
  {
    "name": "Bong",
    "iso2": "BG",
    "timezone": "Africa/Monrovia",
    "countryCode": "LR"
  },
  {
    "name": "Gbarpolu",
    "iso2": "GP",
    "timezone": "Africa/Monrovia",
    "countryCode": "LR"
  },
  {
    "name": "Grand Bassa",
    "iso2": "GB",
    "timezone": "Africa/Monrovia",
    "countryCode": "LR"
  },
  {
    "name": "Grand Cape Mount",
    "iso2": "CM",
    "timezone": "Africa/Monrovia",
    "countryCode": "LR"
  },
  {
    "name": "Grand Gedeh",
    "iso2": "GG",
    "timezone": "Africa/Monrovia",
    "countryCode": "LR"
  },
  {
    "name": "Grand Kru",
    "iso2": "GK",
    "timezone": "Africa/Monrovia",
    "countryCode": "LR"
  },
  {
    "name": "Lofa",
    "iso2": "LO",
    "timezone": "Africa/Monrovia",
    "countryCode": "LR"
  },
  {
    "name": "Margibi",
    "iso2": "MG",
    "timezone": "Africa/Monrovia",
    "countryCode": "LR"
  },
  {
    "name": "Maryland",
    "iso2": "MY",
    "timezone": "Africa/Monrovia",
    "countryCode": "LR"
  },
  {
    "name": "Montserrado",
    "iso2": "MO",
    "timezone": "Africa/Monrovia",
    "countryCode": "LR"
  },
  {
    "name": "Nimba",
    "iso2": "NI",
    "timezone": "Africa/Monrovia",
    "countryCode": "LR"
  },
  {
    "name": "River Cess",
    "iso2": "RI",
    "timezone": "Africa/Monrovia",
    "countryCode": "LR"
  },
  {
    "name": "River Gee",
    "iso2": "RG",
    "timezone": "Africa/Monrovia",
    "countryCode": "LR"
  },
  {
    "name": "Sinoe",
    "iso2": "SI",
    "timezone": "Africa/Monrovia",
    "countryCode": "LR"
  },
  {
    "name": "Al Butnan",
    "iso2": "BU",
    "timezone": "Africa/Tripoli",
    "countryCode": "LY"
  },
  {
    "name": "Al Wahat",
    "iso2": "WA",
    "timezone": "Africa/Tripoli",
    "countryCode": "LY"
  },
  {
    "name": "Benghazi",
    "iso2": "BA",
    "timezone": "Africa/Tripoli",
    "countryCode": "LY"
  },
  {
    "name": "Derna",
    "iso2": "DR",
    "timezone": "Africa/Tripoli",
    "countryCode": "LY"
  },
  {
    "name": "Ghat",
    "iso2": "GT",
    "timezone": "Africa/Tripoli",
    "countryCode": "LY"
  },
  {
    "name": "Jabal al Akhdar",
    "iso2": "JA",
    "timezone": "Africa/Tripoli",
    "countryCode": "LY"
  },
  {
    "name": "Jabal al Gharbi",
    "iso2": "JG",
    "timezone": "Africa/Tripoli",
    "countryCode": "LY"
  },
  {
    "name": "Jafara",
    "iso2": "JI",
    "timezone": "Africa/Tripoli",
    "countryCode": "LY"
  },
  {
    "name": "Jufra",
    "iso2": "JU",
    "timezone": "Africa/Tripoli",
    "countryCode": "LY"
  },
  {
    "name": "Kufra",
    "iso2": "KF",
    "timezone": "Africa/Tripoli",
    "countryCode": "LY"
  },
  {
    "name": "Marj",
    "iso2": "MJ",
    "timezone": "Africa/Tripoli",
    "countryCode": "LY"
  },
  {
    "name": "Misrata",
    "iso2": "MI",
    "timezone": "Africa/Tripoli",
    "countryCode": "LY"
  },
  {
    "name": "Murqub",
    "iso2": "MB",
    "timezone": "Africa/Tripoli",
    "countryCode": "LY"
  },
  {
    "name": "Murzuq",
    "iso2": "MQ",
    "timezone": "Africa/Tripoli",
    "countryCode": "LY"
  },
  {
    "name": "Nalut",
    "iso2": "NL",
    "timezone": "Africa/Tripoli",
    "countryCode": "LY"
  },
  {
    "name": "Nuqat al Khams",
    "iso2": "NQ",
    "timezone": "Africa/Tripoli",
    "countryCode": "LY"
  },
  {
    "name": "Sabha",
    "iso2": "SB",
    "timezone": "Africa/Tripoli",
    "countryCode": "LY"
  },
  {
    "name": "Sirte",
    "iso2": "SR",
    "timezone": "Africa/Tripoli",
    "countryCode": "LY"
  },
  {
    "name": "Tripoli",
    "iso2": "TB",
    "timezone": "Africa/Tripoli",
    "countryCode": "LY"
  },
  {
    "name": "Wadi al Hayaa",
    "iso2": "WD",
    "timezone": "Africa/Tripoli",
    "countryCode": "LY"
  },
  {
    "name": "Wadi al Shatii",
    "iso2": "WS",
    "timezone": "Africa/Tripoli",
    "countryCode": "LY"
  },
  {
    "name": "Zawiya",
    "iso2": "ZA",
    "timezone": "Africa/Tripoli",
    "countryCode": "LY"
  },
  {
    "name": "Balzers",
    "iso2": "01",
    "timezone": "Europe/Vaduz",
    "countryCode": "LI"
  },
  {
    "name": "Eschen",
    "iso2": "02",
    "timezone": "Europe/Vaduz",
    "countryCode": "LI"
  },
  {
    "name": "Gamprin",
    "iso2": "03",
    "timezone": "Europe/Vaduz",
    "countryCode": "LI"
  },
  {
    "name": "Mauren",
    "iso2": "04",
    "timezone": "Europe/Vaduz",
    "countryCode": "LI"
  },
  {
    "name": "Planken",
    "iso2": "05",
    "timezone": "Europe/Vaduz",
    "countryCode": "LI"
  },
  {
    "name": "Ruggell",
    "iso2": "06",
    "timezone": "Europe/Vaduz",
    "countryCode": "LI"
  },
  {
    "name": "Schaan",
    "iso2": "07",
    "timezone": "Europe/Vaduz",
    "countryCode": "LI"
  },
  {
    "name": "Schellenberg",
    "iso2": "08",
    "timezone": "Europe/Vaduz",
    "countryCode": "LI"
  },
  {
    "name": "Triesen",
    "iso2": "09",
    "timezone": "Europe/Vaduz",
    "countryCode": "LI"
  },
  {
    "name": "Triesenberg",
    "iso2": "10",
    "timezone": "Europe/Vaduz",
    "countryCode": "LI"
  },
  {
    "name": "Vaduz",
    "iso2": "11",
    "timezone": "Europe/Vaduz",
    "countryCode": "LI"
  },
  {
    "name": "Akmenė",
    "iso2": "01",
    "timezone": "Europe/Vilnius",
    "countryCode": "LT"
  },
  {
    "name": "Alytus",
    "iso2": "03",
    "timezone": "Europe/Vilnius",
    "countryCode": "LT"
  },
  {
    "name": "Alytus",
    "iso2": "02",
    "timezone": "Europe/Vilnius",
    "countryCode": "LT"
  },
  {
    "name": "Alytus",
    "iso2": "AL",
    "timezone": "Europe/Vilnius",
    "countryCode": "LT"
  },
  {
    "name": "Anykščiai",
    "iso2": "04",
    "timezone": "Europe/Vilnius",
    "countryCode": "LT"
  },
  {
    "name": "Birštonas",
    "iso2": "05",
    "timezone": "Europe/Vilnius",
    "countryCode": "LT"
  },
  {
    "name": "Biržai",
    "iso2": "06",
    "timezone": "Europe/Vilnius",
    "countryCode": "LT"
  },
  {
    "name": "Druskininkai",
    "iso2": "07",
    "timezone": "Europe/Vilnius",
    "countryCode": "LT"
  },
  {
    "name": "Elektrėnai",
    "iso2": "08",
    "timezone": "Europe/Vilnius",
    "countryCode": "LT"
  },
  {
    "name": "Ignalina",
    "iso2": "09",
    "timezone": "Europe/Vilnius",
    "countryCode": "LT"
  },
  {
    "name": "Jonava",
    "iso2": "10",
    "timezone": "Europe/Vilnius",
    "countryCode": "LT"
  },
  {
    "name": "Joniškis",
    "iso2": "11",
    "timezone": "Europe/Vilnius",
    "countryCode": "LT"
  },
  {
    "name": "Jurbarkas",
    "iso2": "12",
    "timezone": "Europe/Vilnius",
    "countryCode": "LT"
  },
  {
    "name": "Kaišiadorys",
    "iso2": "13",
    "timezone": "Europe/Vilnius",
    "countryCode": "LT"
  },
  {
    "name": "Kalvarija",
    "iso2": "14",
    "timezone": "Europe/Vilnius",
    "countryCode": "LT"
  },
  {
    "name": "Kaunas",
    "iso2": "KU",
    "timezone": "Europe/Vilnius",
    "countryCode": "LT"
  },
  {
    "name": "Kaunas",
    "iso2": "16",
    "timezone": "Europe/Vilnius",
    "countryCode": "LT"
  },
  {
    "name": "Kaunas",
    "iso2": "15",
    "timezone": "Europe/Vilnius",
    "countryCode": "LT"
  },
  {
    "name": "Kazlų Rūda",
    "iso2": "17",
    "timezone": "Europe/Vilnius",
    "countryCode": "LT"
  },
  {
    "name": "Kėdainiai",
    "iso2": "18",
    "timezone": "Europe/Vilnius",
    "countryCode": "LT"
  },
  {
    "name": "Kelmė",
    "iso2": "19",
    "timezone": "Europe/Vilnius",
    "countryCode": "LT"
  },
  {
    "name": "Klaipėda",
    "iso2": "KL",
    "timezone": "Europe/Vilnius",
    "countryCode": "LT"
  },
  {
    "name": "Klaipėda",
    "iso2": "21",
    "timezone": "Europe/Vilnius",
    "countryCode": "LT"
  },
  {
    "name": "Klaipėdos miestas",
    "iso2": "20",
    "timezone": "Europe/Vilnius",
    "countryCode": "LT"
  },
  {
    "name": "Kretinga",
    "iso2": "22",
    "timezone": "Europe/Vilnius",
    "countryCode": "LT"
  },
  {
    "name": "Kupiškis",
    "iso2": "23",
    "timezone": "Europe/Vilnius",
    "countryCode": "LT"
  },
  {
    "name": "Lazdijai",
    "iso2": "24",
    "timezone": "Europe/Vilnius",
    "countryCode": "LT"
  },
  {
    "name": "Marijampolė",
    "iso2": "25",
    "timezone": "Europe/Vilnius",
    "countryCode": "LT"
  },
  {
    "name": "Marijampolė",
    "iso2": "MR",
    "timezone": "Europe/Vilnius",
    "countryCode": "LT"
  },
  {
    "name": "Mažeikiai",
    "iso2": "26",
    "timezone": "Europe/Vilnius",
    "countryCode": "LT"
  },
  {
    "name": "Molėtai",
    "iso2": "27",
    "timezone": "Europe/Vilnius",
    "countryCode": "LT"
  },
  {
    "name": "Neringa",
    "iso2": "28",
    "timezone": "Europe/Vilnius",
    "countryCode": "LT"
  },
  {
    "name": "Pagėgiai",
    "iso2": "29",
    "timezone": "Europe/Vilnius",
    "countryCode": "LT"
  },
  {
    "name": "Pakruojis",
    "iso2": "30",
    "timezone": "Europe/Vilnius",
    "countryCode": "LT"
  },
  {
    "name": "Palanga",
    "iso2": "31",
    "timezone": "Europe/Vilnius",
    "countryCode": "LT"
  },
  {
    "name": "Panevėžio miestas",
    "iso2": "32",
    "timezone": "Europe/Vilnius",
    "countryCode": "LT"
  },
  {
    "name": "Panevėžys",
    "iso2": "33",
    "timezone": "Europe/Vilnius",
    "countryCode": "LT"
  },
  {
    "name": "Panevėžys",
    "iso2": "PN",
    "timezone": "Europe/Vilnius",
    "countryCode": "LT"
  },
  {
    "name": "Pasvalys",
    "iso2": "34",
    "timezone": "Europe/Vilnius",
    "countryCode": "LT"
  },
  {
    "name": "Plungė",
    "iso2": "35",
    "timezone": "Europe/Vilnius",
    "countryCode": "LT"
  },
  {
    "name": "Prienai",
    "iso2": "36",
    "timezone": "Europe/Vilnius",
    "countryCode": "LT"
  },
  {
    "name": "Radviliškis",
    "iso2": "37",
    "timezone": "Europe/Vilnius",
    "countryCode": "LT"
  },
  {
    "name": "Raseiniai",
    "iso2": "38",
    "timezone": "Europe/Vilnius",
    "countryCode": "LT"
  },
  {
    "name": "Rietavas",
    "iso2": "39",
    "timezone": "Europe/Vilnius",
    "countryCode": "LT"
  },
  {
    "name": "Rokiškis",
    "iso2": "40",
    "timezone": "Europe/Vilnius",
    "countryCode": "LT"
  },
  {
    "name": "Šakiai",
    "iso2": "41",
    "timezone": "Europe/Vilnius",
    "countryCode": "LT"
  },
  {
    "name": "Šalčininkai",
    "iso2": "42",
    "timezone": "Europe/Vilnius",
    "countryCode": "LT"
  },
  {
    "name": "Šiauliai",
    "iso2": "SA",
    "timezone": "Europe/Vilnius",
    "countryCode": "LT"
  },
  {
    "name": "Šiauliai",
    "iso2": "43",
    "timezone": "Europe/Vilnius",
    "countryCode": "LT"
  },
  {
    "name": "Šiauliai",
    "iso2": "44",
    "timezone": "Europe/Vilnius",
    "countryCode": "LT"
  },
  {
    "name": "Šilalė ",
    "iso2": "45",
    "timezone": "Europe/Vilnius",
    "countryCode": "LT"
  },
  {
    "name": "Šilutė",
    "iso2": "46",
    "timezone": "Europe/Vilnius",
    "countryCode": "LT"
  },
  {
    "name": "Širvintos",
    "iso2": "47",
    "timezone": "Europe/Vilnius",
    "countryCode": "LT"
  },
  {
    "name": "Skuodas",
    "iso2": "48",
    "timezone": "Europe/Vilnius",
    "countryCode": "LT"
  },
  {
    "name": "Švenčionys",
    "iso2": "49",
    "timezone": "Europe/Vilnius",
    "countryCode": "LT"
  },
  {
    "name": "Tauragė",
    "iso2": "TA",
    "timezone": "Europe/Vilnius",
    "countryCode": "LT"
  },
  {
    "name": "Tauragė",
    "iso2": "50",
    "timezone": "Europe/Vilnius",
    "countryCode": "LT"
  },
  {
    "name": "Telšiai",
    "iso2": "51",
    "timezone": "Europe/Vilnius",
    "countryCode": "LT"
  },
  {
    "name": "Telšiai",
    "iso2": "TE",
    "timezone": "Europe/Vilnius",
    "countryCode": "LT"
  },
  {
    "name": "Trakai",
    "iso2": "52",
    "timezone": "Europe/Vilnius",
    "countryCode": "LT"
  },
  {
    "name": "Ukmergė",
    "iso2": "53",
    "timezone": "Europe/Vilnius",
    "countryCode": "LT"
  },
  {
    "name": "Utena",
    "iso2": "54",
    "timezone": "Europe/Vilnius",
    "countryCode": "LT"
  },
  {
    "name": "Utena",
    "iso2": "UT",
    "timezone": "Europe/Vilnius",
    "countryCode": "LT"
  },
  {
    "name": "Varėna",
    "iso2": "55",
    "timezone": "Europe/Vilnius",
    "countryCode": "LT"
  },
  {
    "name": "Vilkaviškis",
    "iso2": "56",
    "timezone": "Europe/Vilnius",
    "countryCode": "LT"
  },
  {
    "name": "Vilnius",
    "iso2": "58",
    "timezone": "Europe/Vilnius",
    "countryCode": "LT"
  },
  {
    "name": "Vilnius",
    "iso2": "57",
    "timezone": "Europe/Vilnius",
    "countryCode": "LT"
  },
  {
    "name": "Vilnius",
    "iso2": "VL",
    "timezone": "Europe/Vilnius",
    "countryCode": "LT"
  },
  {
    "name": "Visaginas",
    "iso2": "59",
    "timezone": "Europe/Vilnius",
    "countryCode": "LT"
  },
  {
    "name": "Zarasai",
    "iso2": "60",
    "timezone": "Europe/Vilnius",
    "countryCode": "LT"
  },
  {
    "name": "Capellen",
    "iso2": "CA",
    "timezone": "Europe/Luxembourg",
    "countryCode": "LU"
  },
  {
    "name": "Clervaux",
    "iso2": "CL",
    "timezone": "Europe/Luxembourg",
    "countryCode": "LU"
  },
  {
    "name": "Diekirch",
    "iso2": "DI",
    "timezone": "Europe/Luxembourg",
    "countryCode": "LU"
  },
  {
    "name": "Echternach",
    "iso2": "EC",
    "timezone": "Europe/Luxembourg",
    "countryCode": "LU"
  },
  {
    "name": "Esch-sur-Alzette",
    "iso2": "ES",
    "timezone": "Europe/Luxembourg",
    "countryCode": "LU"
  },
  {
    "name": "Grevenmacher",
    "iso2": "G",
    "timezone": "Europe/Luxembourg",
    "countryCode": "LU"
  },
  {
    "name": "Luxembourg ",
    "iso2": "L",
    "timezone": "Europe/Luxembourg",
    "countryCode": "LU"
  },
  {
    "name": "Mersch",
    "iso2": "ME",
    "timezone": "Europe/Luxembourg",
    "countryCode": "LU"
  },
  {
    "name": "Redange",
    "iso2": "RD",
    "timezone": "Europe/Luxembourg",
    "countryCode": "LU"
  },
  {
    "name": "Remich",
    "iso2": "RM",
    "timezone": "Europe/Luxembourg",
    "countryCode": "LU"
  },
  {
    "name": "Vianden",
    "iso2": "VD",
    "timezone": "Europe/Luxembourg",
    "countryCode": "LU"
  },
  {
    "name": "Wiltz",
    "iso2": "WI",
    "timezone": "Europe/Luxembourg",
    "countryCode": "LU"
  },
  {
    "name": "Antananarivo",
    "iso2": "T",
    "timezone": "Indian/Antananarivo",
    "countryCode": "MG"
  },
  {
    "name": "Antsiranana",
    "iso2": "D",
    "timezone": "Indian/Antananarivo",
    "countryCode": "MG"
  },
  {
    "name": "Fianarantsoa",
    "iso2": "F",
    "timezone": "Indian/Antananarivo",
    "countryCode": "MG"
  },
  {
    "name": "Mahajanga",
    "iso2": "M",
    "timezone": "Indian/Antananarivo",
    "countryCode": "MG"
  },
  {
    "name": "Toamasina",
    "iso2": "A",
    "timezone": "Indian/Antananarivo",
    "countryCode": "MG"
  },
  {
    "name": "Toliara",
    "iso2": "U",
    "timezone": "Indian/Antananarivo",
    "countryCode": "MG"
  },
  {
    "name": "Balaka",
    "iso2": "BA",
    "timezone": "Africa/Blantyre",
    "countryCode": "MW"
  },
  {
    "name": "Blantyre",
    "iso2": "BL",
    "timezone": "Africa/Blantyre",
    "countryCode": "MW"
  },
  {
    "name": "Central",
    "iso2": "C",
    "timezone": "Africa/Blantyre",
    "countryCode": "MW"
  },
  {
    "name": "Chikwawa",
    "iso2": "CK",
    "timezone": "Africa/Blantyre",
    "countryCode": "MW"
  },
  {
    "name": "Chiradzulu",
    "iso2": "CR",
    "timezone": "Africa/Blantyre",
    "countryCode": "MW"
  },
  {
    "name": "Chitipa",
    "iso2": "CT",
    "timezone": "Africa/Blantyre",
    "countryCode": "MW"
  },
  {
    "name": "Dedza",
    "iso2": "DE",
    "timezone": "Africa/Blantyre",
    "countryCode": "MW"
  },
  {
    "name": "Dowa",
    "iso2": "DO",
    "timezone": "Africa/Blantyre",
    "countryCode": "MW"
  },
  {
    "name": "Karonga",
    "iso2": "KR",
    "timezone": "Africa/Blantyre",
    "countryCode": "MW"
  },
  {
    "name": "Kasungu",
    "iso2": "KS",
    "timezone": "Africa/Blantyre",
    "countryCode": "MW"
  },
  {
    "name": "Likoma",
    "iso2": "LK",
    "timezone": "Africa/Blantyre",
    "countryCode": "MW"
  },
  {
    "name": "Lilongwe",
    "iso2": "LI",
    "timezone": "Africa/Blantyre",
    "countryCode": "MW"
  },
  {
    "name": "Machinga",
    "iso2": "MH",
    "timezone": "Africa/Blantyre",
    "countryCode": "MW"
  },
  {
    "name": "Mangochi",
    "iso2": "MG",
    "timezone": "Africa/Blantyre",
    "countryCode": "MW"
  },
  {
    "name": "Mchinji",
    "iso2": "MC",
    "timezone": "Africa/Blantyre",
    "countryCode": "MW"
  },
  {
    "name": "Mulanje",
    "iso2": "MU",
    "timezone": "Africa/Blantyre",
    "countryCode": "MW"
  },
  {
    "name": "Mwanza",
    "iso2": "MW",
    "timezone": "Africa/Blantyre",
    "countryCode": "MW"
  },
  {
    "name": "Mzimba",
    "iso2": "MZ",
    "timezone": "Africa/Blantyre",
    "countryCode": "MW"
  },
  {
    "name": "Neno",
    "iso2": "NE",
    "timezone": "Africa/Blantyre",
    "countryCode": "MW"
  },
  {
    "name": "Nkhata Bay",
    "iso2": "NB",
    "timezone": "Africa/Blantyre",
    "countryCode": "MW"
  },
  {
    "name": "Nkhotakota",
    "iso2": "NK",
    "timezone": "Africa/Blantyre",
    "countryCode": "MW"
  },
  {
    "name": "Northern",
    "iso2": "N",
    "timezone": "Africa/Blantyre",
    "countryCode": "MW"
  },
  {
    "name": "Nsanje",
    "iso2": "NS",
    "timezone": "Africa/Blantyre",
    "countryCode": "MW"
  },
  {
    "name": "Ntcheu",
    "iso2": "NU",
    "timezone": "Africa/Blantyre",
    "countryCode": "MW"
  },
  {
    "name": "Ntchisi",
    "iso2": "NI",
    "timezone": "Africa/Blantyre",
    "countryCode": "MW"
  },
  {
    "name": "Phalombe",
    "iso2": "PH",
    "timezone": "Africa/Blantyre",
    "countryCode": "MW"
  },
  {
    "name": "Rumphi",
    "iso2": "RU",
    "timezone": "Africa/Blantyre",
    "countryCode": "MW"
  },
  {
    "name": "Salima",
    "iso2": "SA",
    "timezone": "Africa/Blantyre",
    "countryCode": "MW"
  },
  {
    "name": "Southern",
    "iso2": "S",
    "timezone": "Africa/Blantyre",
    "countryCode": "MW"
  },
  {
    "name": "Thyolo",
    "iso2": "TH",
    "timezone": "Africa/Blantyre",
    "countryCode": "MW"
  },
  {
    "name": "Zomba",
    "iso2": "ZO",
    "timezone": "Africa/Blantyre",
    "countryCode": "MW"
  },
  {
    "name": "Johor",
    "iso2": "01",
    "timezone": "Asia/Kuala_Lumpur",
    "countryCode": "MY"
  },
  {
    "name": "Kedah",
    "iso2": "02",
    "timezone": "Asia/Kuala_Lumpur",
    "countryCode": "MY"
  },
  {
    "name": "Kelantan",
    "iso2": "03",
    "timezone": "Asia/Kuala_Lumpur",
    "countryCode": "MY"
  },
  {
    "name": "Kuala Lumpur",
    "iso2": "14",
    "timezone": "Asia/Kuala_Lumpur",
    "countryCode": "MY"
  },
  {
    "name": "Labuan",
    "iso2": "15",
    "timezone": "Asia/Kuala_Lumpur",
    "countryCode": "MY"
  },
  {
    "name": "Malacca",
    "iso2": "04",
    "timezone": "Asia/Kuala_Lumpur",
    "countryCode": "MY"
  },
  {
    "name": "Negeri Sembilan",
    "iso2": "05",
    "timezone": "Asia/Kuala_Lumpur",
    "countryCode": "MY"
  },
  {
    "name": "Pahang",
    "iso2": "06",
    "timezone": "Asia/Kuala_Lumpur",
    "countryCode": "MY"
  },
  {
    "name": "Penang",
    "iso2": "07",
    "timezone": "Asia/Kuala_Lumpur",
    "countryCode": "MY"
  },
  {
    "name": "Perak",
    "iso2": "08",
    "timezone": "Asia/Kuala_Lumpur",
    "countryCode": "MY"
  },
  {
    "name": "Perlis",
    "iso2": "09",
    "timezone": "Asia/Kuala_Lumpur",
    "countryCode": "MY"
  },
  {
    "name": "Putrajaya",
    "iso2": "16",
    "timezone": "Asia/Kuala_Lumpur",
    "countryCode": "MY"
  },
  {
    "name": "Sabah",
    "iso2": "12",
    "timezone": "Asia/Kuala_Lumpur",
    "countryCode": "MY"
  },
  {
    "name": "Sarawak",
    "iso2": "13",
    "timezone": "Asia/Kuala_Lumpur",
    "countryCode": "MY"
  },
  {
    "name": "Selangor",
    "iso2": "10",
    "timezone": "Asia/Kuala_Lumpur",
    "countryCode": "MY"
  },
  {
    "name": "Terengganu",
    "iso2": "11",
    "timezone": "Asia/Kuala_Lumpur",
    "countryCode": "MY"
  },
  {
    "name": "Addu",
    "iso2": "01",
    "timezone": "Indian/Maldives",
    "countryCode": "MV"
  },
  {
    "name": "Alif Alif",
    "iso2": "02",
    "timezone": "Indian/Maldives",
    "countryCode": "MV"
  },
  {
    "name": "Alif Dhaal",
    "iso2": "00",
    "timezone": "Indian/Maldives",
    "countryCode": "MV"
  },
  {
    "name": "Baa",
    "iso2": "20",
    "timezone": "Indian/Maldives",
    "countryCode": "MV"
  },
  {
    "name": "Dhaalu",
    "iso2": "17",
    "timezone": "Indian/Maldives",
    "countryCode": "MV"
  },
  {
    "name": "Faafu",
    "iso2": "14",
    "timezone": "Indian/Maldives",
    "countryCode": "MV"
  },
  {
    "name": "Gaafu Alif",
    "iso2": "27",
    "timezone": "Indian/Maldives",
    "countryCode": "MV"
  },
  {
    "name": "Gaafu Dhaalu",
    "iso2": "28",
    "timezone": "Indian/Maldives",
    "countryCode": "MV"
  },
  {
    "name": "Gnaviyani",
    "iso2": "29",
    "timezone": "Indian/Maldives",
    "countryCode": "MV"
  },
  {
    "name": "Haa Alif",
    "iso2": "07",
    "timezone": "Indian/Maldives",
    "countryCode": "MV"
  },
  {
    "name": "Haa Dhaalu",
    "iso2": "23",
    "timezone": "Indian/Maldives",
    "countryCode": "MV"
  },
  {
    "name": "Kaafu",
    "iso2": "26",
    "timezone": "Indian/Maldives",
    "countryCode": "MV"
  },
  {
    "name": "Laamu",
    "iso2": "05",
    "timezone": "Indian/Maldives",
    "countryCode": "MV"
  },
  {
    "name": "Lhaviyani",
    "iso2": "03",
    "timezone": "Indian/Maldives",
    "countryCode": "MV"
  },
  {
    "name": "Malé",
    "iso2": "MLE",
    "timezone": "Indian/Maldives",
    "countryCode": "MV"
  },
  {
    "name": "Meemu",
    "iso2": "12",
    "timezone": "Indian/Maldives",
    "countryCode": "MV"
  },
  {
    "name": "Noonu",
    "iso2": "25",
    "timezone": "Indian/Maldives",
    "countryCode": "MV"
  },
  {
    "name": "Raa",
    "iso2": "13",
    "timezone": "Indian/Maldives",
    "countryCode": "MV"
  },
  {
    "name": "Shaviyani",
    "iso2": "24",
    "timezone": "Indian/Maldives",
    "countryCode": "MV"
  },
  {
    "name": "Thaa",
    "iso2": "08",
    "timezone": "Indian/Maldives",
    "countryCode": "MV"
  },
  {
    "name": "Vaavu",
    "iso2": "04",
    "timezone": "Indian/Maldives",
    "countryCode": "MV"
  },
  {
    "name": "Bamako",
    "iso2": "BKO",
    "timezone": "Africa/Bamako",
    "countryCode": "ML"
  },
  {
    "name": "Gao",
    "iso2": "7",
    "timezone": "Africa/Bamako",
    "countryCode": "ML"
  },
  {
    "name": "Kayes",
    "iso2": "1",
    "timezone": "Africa/Bamako",
    "countryCode": "ML"
  },
  {
    "name": "Kidal",
    "iso2": "8",
    "timezone": "Africa/Bamako",
    "countryCode": "ML"
  },
  {
    "name": "Koulikoro",
    "iso2": "2",
    "timezone": "Africa/Bamako",
    "countryCode": "ML"
  },
  {
    "name": "Ménaka",
    "iso2": "9",
    "timezone": "Africa/Bamako",
    "countryCode": "ML"
  },
  {
    "name": "Mopti",
    "iso2": "5",
    "timezone": "Africa/Bamako",
    "countryCode": "ML"
  },
  {
    "name": "Ségou",
    "iso2": "4",
    "timezone": "Africa/Bamako",
    "countryCode": "ML"
  },
  {
    "name": "Sikasso",
    "iso2": "3",
    "timezone": "Africa/Bamako",
    "countryCode": "ML"
  },
  {
    "name": "Taoudénit",
    "iso2": "10",
    "timezone": "Africa/Bamako",
    "countryCode": "ML"
  },
  {
    "name": "Tombouctou",
    "iso2": "6",
    "timezone": "Africa/Bamako",
    "countryCode": "ML"
  },
  {
    "name": "Attard",
    "iso2": "01",
    "timezone": "Europe/Malta",
    "countryCode": "MT"
  },
  {
    "name": "Balzan",
    "iso2": "02",
    "timezone": "Europe/Malta",
    "countryCode": "MT"
  },
  {
    "name": "Birgu",
    "iso2": "03",
    "timezone": "Europe/Malta",
    "countryCode": "MT"
  },
  {
    "name": "Birkirkara",
    "iso2": "04",
    "timezone": "Europe/Malta",
    "countryCode": "MT"
  },
  {
    "name": "Birżebbuġa",
    "iso2": "05",
    "timezone": "Europe/Malta",
    "countryCode": "MT"
  },
  {
    "name": "Cospicua",
    "iso2": "06",
    "timezone": "Europe/Malta",
    "countryCode": "MT"
  },
  {
    "name": "Dingli",
    "iso2": "07",
    "timezone": "Europe/Malta",
    "countryCode": "MT"
  },
  {
    "name": "Fgura",
    "iso2": "08",
    "timezone": "Europe/Malta",
    "countryCode": "MT"
  },
  {
    "name": "Floriana",
    "iso2": "09",
    "timezone": "Europe/Malta",
    "countryCode": "MT"
  },
  {
    "name": "Fontana",
    "iso2": "10",
    "timezone": "Europe/Malta",
    "countryCode": "MT"
  },
  {
    "name": "Għajnsielem",
    "iso2": "13",
    "timezone": "Europe/Malta",
    "countryCode": "MT"
  },
  {
    "name": "Għarb",
    "iso2": "14",
    "timezone": "Europe/Malta",
    "countryCode": "MT"
  },
  {
    "name": "Għargħur",
    "iso2": "15",
    "timezone": "Europe/Malta",
    "countryCode": "MT"
  },
  {
    "name": "Għasri",
    "iso2": "16",
    "timezone": "Europe/Malta",
    "countryCode": "MT"
  },
  {
    "name": "Għaxaq",
    "iso2": "17",
    "timezone": "Europe/Malta",
    "countryCode": "MT"
  },
  {
    "name": "Gudja",
    "iso2": "11",
    "timezone": "Europe/Malta",
    "countryCode": "MT"
  },
  {
    "name": "Gżira",
    "iso2": "12",
    "timezone": "Europe/Malta",
    "countryCode": "MT"
  },
  {
    "name": "Ħamrun",
    "iso2": "18",
    "timezone": "Europe/Malta",
    "countryCode": "MT"
  },
  {
    "name": "Iklin",
    "iso2": "19",
    "timezone": "Europe/Malta",
    "countryCode": "MT"
  },
  {
    "name": "Kalkara",
    "iso2": "21",
    "timezone": "Europe/Malta",
    "countryCode": "MT"
  },
  {
    "name": "Kerċem",
    "iso2": "22",
    "timezone": "Europe/Malta",
    "countryCode": "MT"
  },
  {
    "name": "Kirkop",
    "iso2": "23",
    "timezone": "Europe/Malta",
    "countryCode": "MT"
  },
  {
    "name": "Lija",
    "iso2": "24",
    "timezone": "Europe/Malta",
    "countryCode": "MT"
  },
  {
    "name": "Luqa",
    "iso2": "25",
    "timezone": "Europe/Malta",
    "countryCode": "MT"
  },
  {
    "name": "Marsa",
    "iso2": "26",
    "timezone": "Europe/Malta",
    "countryCode": "MT"
  },
  {
    "name": "Marsaskala",
    "iso2": "27",
    "timezone": "Europe/Malta",
    "countryCode": "MT"
  },
  {
    "name": "Marsaxlokk",
    "iso2": "28",
    "timezone": "Europe/Malta",
    "countryCode": "MT"
  },
  {
    "name": "Mdina",
    "iso2": "29",
    "timezone": "Europe/Malta",
    "countryCode": "MT"
  },
  {
    "name": "Mellieħa",
    "iso2": "30",
    "timezone": "Europe/Malta",
    "countryCode": "MT"
  },
  {
    "name": "Mġarr",
    "iso2": "31",
    "timezone": "Europe/Malta",
    "countryCode": "MT"
  },
  {
    "name": "Mosta",
    "iso2": "32",
    "timezone": "Europe/Malta",
    "countryCode": "MT"
  },
  {
    "name": "Mqabba",
    "iso2": "33",
    "timezone": "Europe/Malta",
    "countryCode": "MT"
  },
  {
    "name": "Msida",
    "iso2": "34",
    "timezone": "Europe/Malta",
    "countryCode": "MT"
  },
  {
    "name": "Mtarfa",
    "iso2": "35",
    "timezone": "Europe/Malta",
    "countryCode": "MT"
  },
  {
    "name": "Munxar",
    "iso2": "36",
    "timezone": "Europe/Malta",
    "countryCode": "MT"
  },
  {
    "name": "Nadur",
    "iso2": "37",
    "timezone": "Europe/Malta",
    "countryCode": "MT"
  },
  {
    "name": "Naxxar",
    "iso2": "38",
    "timezone": "Europe/Malta",
    "countryCode": "MT"
  },
  {
    "name": "Paola",
    "iso2": "39",
    "timezone": "Europe/Malta",
    "countryCode": "MT"
  },
  {
    "name": "Pembroke",
    "iso2": "40",
    "timezone": "Europe/Malta",
    "countryCode": "MT"
  },
  {
    "name": "Pietà",
    "iso2": "41",
    "timezone": "Europe/Malta",
    "countryCode": "MT"
  },
  {
    "name": "Qala",
    "iso2": "42",
    "timezone": "Europe/Malta",
    "countryCode": "MT"
  },
  {
    "name": "Qormi",
    "iso2": "43",
    "timezone": "Europe/Malta",
    "countryCode": "MT"
  },
  {
    "name": "Qrendi",
    "iso2": "44",
    "timezone": "Europe/Malta",
    "countryCode": "MT"
  },
  {
    "name": "Rabat",
    "iso2": "46",
    "timezone": "Europe/Malta",
    "countryCode": "MT"
  },
  {
    "name": "Safi",
    "iso2": "47",
    "timezone": "Europe/Malta",
    "countryCode": "MT"
  },
  {
    "name": "San Ġwann",
    "iso2": "49",
    "timezone": "Europe/Malta",
    "countryCode": "MT"
  },
  {
    "name": "San Lawrenz",
    "iso2": "50",
    "timezone": "Europe/Malta",
    "countryCode": "MT"
  },
  {
    "name": "Sannat",
    "iso2": "52",
    "timezone": "Europe/Malta",
    "countryCode": "MT"
  },
  {
    "name": "Santa Luċija",
    "iso2": "53",
    "timezone": "Europe/Malta",
    "countryCode": "MT"
  },
  {
    "name": "Santa Venera",
    "iso2": "54",
    "timezone": "Europe/Malta",
    "countryCode": "MT"
  },
  {
    "name": "Senglea",
    "iso2": "20",
    "timezone": "Europe/Malta",
    "countryCode": "MT"
  },
  {
    "name": "Siġġiewi",
    "iso2": "55",
    "timezone": "Europe/Malta",
    "countryCode": "MT"
  },
  {
    "name": "Sliema",
    "iso2": "56",
    "timezone": "Europe/Malta",
    "countryCode": "MT"
  },
  {
    "name": "St. Julian's",
    "iso2": "48",
    "timezone": "Europe/Malta",
    "countryCode": "MT"
  },
  {
    "name": "St. Paul's Bay",
    "iso2": "51",
    "timezone": "Europe/Malta",
    "countryCode": "MT"
  },
  {
    "name": "Swieqi",
    "iso2": "57",
    "timezone": "Europe/Malta",
    "countryCode": "MT"
  },
  {
    "name": "Ta' Xbiex",
    "iso2": "58",
    "timezone": "Europe/Malta",
    "countryCode": "MT"
  },
  {
    "name": "Tarxien",
    "iso2": "59",
    "timezone": "Europe/Malta",
    "countryCode": "MT"
  },
  {
    "name": "Valletta",
    "iso2": "60",
    "timezone": "Europe/Malta",
    "countryCode": "MT"
  },
  {
    "name": "Victoria",
    "iso2": "45",
    "timezone": "Europe/Malta",
    "countryCode": "MT"
  },
  {
    "name": "Xagħra",
    "iso2": "61",
    "timezone": "Europe/Malta",
    "countryCode": "MT"
  },
  {
    "name": "Xewkija",
    "iso2": "62",
    "timezone": "Europe/Malta",
    "countryCode": "MT"
  },
  {
    "name": "Xgħajra",
    "iso2": "63",
    "timezone": "Europe/Malta",
    "countryCode": "MT"
  },
  {
    "name": "Żabbar",
    "iso2": "64",
    "timezone": "Europe/Malta",
    "countryCode": "MT"
  },
  {
    "name": "Żebbuġ Gozo",
    "iso2": "65",
    "timezone": "Europe/Malta",
    "countryCode": "MT"
  },
  {
    "name": "Żebbuġ Malta",
    "iso2": "66",
    "timezone": "Europe/Malta",
    "countryCode": "MT"
  },
  {
    "name": "Żejtun",
    "iso2": "67",
    "timezone": "Europe/Malta",
    "countryCode": "MT"
  },
  {
    "name": "Żurrieq",
    "iso2": "68",
    "timezone": "Europe/Malta",
    "countryCode": "MT"
  },
  {
    "name": "Ayre",
    "iso2": "01",
    "timezone": "Europe/Isle_of_Man",
    "countryCode": "IM"
  },
  {
    "name": "Garff",
    "iso2": "02",
    "timezone": "Europe/Isle_of_Man",
    "countryCode": "IM"
  },
  {
    "name": "Glenfaba",
    "iso2": "03",
    "timezone": "Europe/Isle_of_Man",
    "countryCode": "IM"
  },
  {
    "name": "Michael",
    "iso2": "04",
    "timezone": "Europe/Isle_of_Man",
    "countryCode": "IM"
  },
  {
    "name": "Middle",
    "iso2": "05",
    "timezone": "Europe/Isle_of_Man",
    "countryCode": "IM"
  },
  {
    "name": "Rushen",
    "iso2": "06",
    "timezone": "Europe/Isle_of_Man",
    "countryCode": "IM"
  },
  {
    "name": "Ailinglaplap",
    "iso2": "ALL",
    "timezone": "Pacific/Kwajalein",
    "countryCode": "MH"
  },
  {
    "name": "Ailuk",
    "iso2": "ALK",
    "timezone": "Pacific/Kwajalein",
    "countryCode": "MH"
  },
  {
    "name": "Arno",
    "iso2": "ARN",
    "timezone": "Pacific/Kwajalein",
    "countryCode": "MH"
  },
  {
    "name": "Aur",
    "iso2": "AUR",
    "timezone": "Pacific/Kwajalein",
    "countryCode": "MH"
  },
  {
    "name": "Bikini & Kili",
    "iso2": "KIL",
    "timezone": "Pacific/Kwajalein",
    "countryCode": "MH"
  },
  {
    "name": "Ebon",
    "iso2": "EBO",
    "timezone": "Pacific/Kwajalein",
    "countryCode": "MH"
  },
  {
    "name": "Enewetak & Ujelang",
    "iso2": "ENI",
    "timezone": "Pacific/Kwajalein",
    "countryCode": "MH"
  },
  {
    "name": "Jabat",
    "iso2": "JAB",
    "timezone": "Pacific/Kwajalein",
    "countryCode": "MH"
  },
  {
    "name": "Jaluit",
    "iso2": "JAL",
    "timezone": "Pacific/Kwajalein",
    "countryCode": "MH"
  },
  {
    "name": "Kwajalein",
    "iso2": "KWA",
    "timezone": "Pacific/Kwajalein",
    "countryCode": "MH"
  },
  {
    "name": "Lae",
    "iso2": "LAE",
    "timezone": "Pacific/Kwajalein",
    "countryCode": "MH"
  },
  {
    "name": "Lib",
    "iso2": "LIB",
    "timezone": "Pacific/Kwajalein",
    "countryCode": "MH"
  },
  {
    "name": "Likiep",
    "iso2": "LIK",
    "timezone": "Pacific/Kwajalein",
    "countryCode": "MH"
  },
  {
    "name": "Majuro",
    "iso2": "MAJ",
    "timezone": "Pacific/Kwajalein",
    "countryCode": "MH"
  },
  {
    "name": "Maloelap",
    "iso2": "MAL",
    "timezone": "Pacific/Kwajalein",
    "countryCode": "MH"
  },
  {
    "name": "Mejit",
    "iso2": "MEJ",
    "timezone": "Pacific/Kwajalein",
    "countryCode": "MH"
  },
  {
    "name": "Mili",
    "iso2": "MIL",
    "timezone": "Pacific/Kwajalein",
    "countryCode": "MH"
  },
  {
    "name": "Namdrik",
    "iso2": "NMK",
    "timezone": "Pacific/Kwajalein",
    "countryCode": "MH"
  },
  {
    "name": "Namu",
    "iso2": "NMU",
    "timezone": "Pacific/Kwajalein",
    "countryCode": "MH"
  },
  {
    "name": "Ralik",
    "iso2": "L",
    "timezone": "Pacific/Kwajalein",
    "countryCode": "MH"
  },
  {
    "name": "Ratak",
    "iso2": "T",
    "timezone": "Pacific/Kwajalein",
    "countryCode": "MH"
  },
  {
    "name": "Rongelap",
    "iso2": "RON",
    "timezone": "Pacific/Kwajalein",
    "countryCode": "MH"
  },
  {
    "name": "Ujae",
    "iso2": "UJA",
    "timezone": "Pacific/Kwajalein",
    "countryCode": "MH"
  },
  {
    "name": "Utrik",
    "iso2": "UTI",
    "timezone": "Pacific/Kwajalein",
    "countryCode": "MH"
  },
  {
    "name": "Wotho",
    "iso2": "WTH",
    "timezone": "Pacific/Kwajalein",
    "countryCode": "MH"
  },
  {
    "name": "Wotje",
    "iso2": "WTJ",
    "timezone": "Pacific/Kwajalein",
    "countryCode": "MH"
  },
  {
    "name": "Fort-de-France",
    "iso2": "01",
    "timezone": "America/Martinique",
    "countryCode": "MQ"
  },
  {
    "name": "La Trinité",
    "iso2": "02",
    "timezone": "America/Martinique",
    "countryCode": "MQ"
  },
  {
    "name": "Le Marin",
    "iso2": "03",
    "timezone": "America/Martinique",
    "countryCode": "MQ"
  },
  {
    "name": "Saint-Pierre",
    "iso2": "04",
    "timezone": "America/Martinique",
    "countryCode": "MQ"
  },
  {
    "name": "Adrar",
    "iso2": "07",
    "timezone": "Africa/Nouakchott",
    "countryCode": "MR"
  },
  {
    "name": "Assaba",
    "iso2": "03",
    "timezone": "Africa/Nouakchott",
    "countryCode": "MR"
  },
  {
    "name": "Brakna",
    "iso2": "05",
    "timezone": "Africa/Nouakchott",
    "countryCode": "MR"
  },
  {
    "name": "Dakhlet Nouadhibou",
    "iso2": "08",
    "timezone": "Africa/Nouakchott",
    "countryCode": "MR"
  },
  {
    "name": "Gorgol",
    "iso2": "04",
    "timezone": "Africa/Nouakchott",
    "countryCode": "MR"
  },
  {
    "name": "Guidimaka",
    "iso2": "10",
    "timezone": "Africa/Nouakchott",
    "countryCode": "MR"
  },
  {
    "name": "Hodh Ech Chargui",
    "iso2": "01",
    "timezone": "Africa/Nouakchott",
    "countryCode": "MR"
  },
  {
    "name": "Hodh El Gharbi",
    "iso2": "02",
    "timezone": "Africa/Nouakchott",
    "countryCode": "MR"
  },
  {
    "name": "Inchiri",
    "iso2": "12",
    "timezone": "Africa/Nouakchott",
    "countryCode": "MR"
  },
  {
    "name": "Nouakchott-Nord",
    "iso2": "14",
    "timezone": "Africa/Nouakchott",
    "countryCode": "MR"
  },
  {
    "name": "Nouakchott-Ouest",
    "iso2": "13",
    "timezone": "Africa/Nouakchott",
    "countryCode": "MR"
  },
  {
    "name": "Nouakchott-Sud",
    "iso2": "15",
    "timezone": "Africa/Nouakchott",
    "countryCode": "MR"
  },
  {
    "name": "Tagant",
    "iso2": "09",
    "timezone": "Africa/Nouakchott",
    "countryCode": "MR"
  },
  {
    "name": "Tiris Zemmour",
    "iso2": "11",
    "timezone": "Africa/Nouakchott",
    "countryCode": "MR"
  },
  {
    "name": "Trarza",
    "iso2": "06",
    "timezone": "Africa/Nouakchott",
    "countryCode": "MR"
  },
  {
    "name": "Agalega Islands",
    "iso2": "AG",
    "timezone": "Indian/Mauritius",
    "countryCode": "MU"
  },
  {
    "name": "Black River",
    "iso2": "BL",
    "timezone": "Indian/Mauritius",
    "countryCode": "MU"
  },
  {
    "name": "Flacq",
    "iso2": "FL",
    "timezone": "Indian/Mauritius",
    "countryCode": "MU"
  },
  {
    "name": "Grand Port",
    "iso2": "GP",
    "timezone": "Indian/Mauritius",
    "countryCode": "MU"
  },
  {
    "name": "Moka",
    "iso2": "MO",
    "timezone": "Indian/Mauritius",
    "countryCode": "MU"
  },
  {
    "name": "Pamplemousses",
    "iso2": "PA",
    "timezone": "Indian/Mauritius",
    "countryCode": "MU"
  },
  {
    "name": "Plaines Wilhems",
    "iso2": "PW",
    "timezone": "Indian/Mauritius",
    "countryCode": "MU"
  },
  {
    "name": "Port Louis",
    "iso2": "PL",
    "timezone": "Indian/Mauritius",
    "countryCode": "MU"
  },
  {
    "name": "Rivière du Rempart",
    "iso2": "RR",
    "timezone": "Indian/Mauritius",
    "countryCode": "MU"
  },
  {
    "name": "Rodrigues Island",
    "iso2": "RO",
    "timezone": "Indian/Mauritius",
    "countryCode": "MU"
  },
  {
    "name": "Saint Brandon Islands",
    "iso2": "CC",
    "timezone": "Indian/Mauritius",
    "countryCode": "MU"
  },
  {
    "name": "Savanne",
    "iso2": "SA",
    "timezone": "Indian/Mauritius",
    "countryCode": "MU"
  },
  {
    "name": "Acoua",
    "iso2": "14",
    "timezone": "Indian/Mayotte",
    "countryCode": "YT"
  },
  {
    "name": "Bandraboua",
    "iso2": "16",
    "timezone": "Indian/Mayotte",
    "countryCode": "YT"
  },
  {
    "name": "Bandrélé",
    "iso2": "05",
    "timezone": "Indian/Mayotte",
    "countryCode": "YT"
  },
  {
    "name": "Boueni",
    "iso2": "07",
    "timezone": "Indian/Mayotte",
    "countryCode": "YT"
  },
  {
    "name": "Chiconi",
    "iso2": "11",
    "timezone": "Indian/Mayotte",
    "countryCode": "YT"
  },
  {
    "name": "Chirongui",
    "iso2": "08",
    "timezone": "Indian/Mayotte",
    "countryCode": "YT"
  },
  {
    "name": "Dembeni",
    "iso2": "04",
    "timezone": "Indian/Mayotte",
    "countryCode": "YT"
  },
  {
    "name": "Dzaoudzi",
    "iso2": "01",
    "timezone": "Indian/Mayotte",
    "countryCode": "YT"
  },
  {
    "name": "Kani Keli",
    "iso2": "06",
    "timezone": "Indian/Mayotte",
    "countryCode": "YT"
  },
  {
    "name": "Koungou",
    "iso2": "17",
    "timezone": "Indian/Mayotte",
    "countryCode": "YT"
  },
  {
    "name": "M'Tsangamouji",
    "iso2": "13",
    "timezone": "Indian/Mayotte",
    "countryCode": "YT"
  },
  {
    "name": "Mamoudzou",
    "iso2": "03",
    "timezone": "Indian/Mayotte",
    "countryCode": "YT"
  },
  {
    "name": "Mtsamboro",
    "iso2": "15",
    "timezone": "Indian/Mayotte",
    "countryCode": "YT"
  },
  {
    "name": "Ouangani",
    "iso2": "10",
    "timezone": "Indian/Mayotte",
    "countryCode": "YT"
  },
  {
    "name": "Pamandzi",
    "iso2": "02",
    "timezone": "Indian/Mayotte",
    "countryCode": "YT"
  },
  {
    "name": "Sada",
    "iso2": "09",
    "timezone": "Indian/Mayotte",
    "countryCode": "YT"
  },
  {
    "name": "Tsingoni",
    "iso2": "12",
    "timezone": "Indian/Mayotte",
    "countryCode": "YT"
  },
  {
    "name": "Aguascalientes",
    "iso2": "AGU",
    "timezone": "America/Mexico_City",
    "countryCode": "MX"
  },
  {
    "name": "Baja California",
    "iso2": "BCN",
    "timezone": "America/Tijuana",
    "countryCode": "MX"
  },
  {
    "name": "Baja California Sur",
    "iso2": "BCS",
    "timezone": "America/Mazatlan",
    "countryCode": "MX"
  },
  {
    "name": "Campeche",
    "iso2": "CAM",
    "timezone": "America/Merida",
    "countryCode": "MX"
  },
  {
    "name": "Chiapas",
    "iso2": "CHP",
    "timezone": "America/Mexico_City",
    "countryCode": "MX"
  },
  {
    "name": "Chihuahua",
    "iso2": "CHH",
    "timezone": "America/Chihuahua",
    "countryCode": "MX"
  },
  {
    "name": "Ciudad de México",
    "iso2": "CMX",
    "timezone": "America/Mexico_City",
    "countryCode": "MX"
  },
  {
    "name": "Coahuila de Zaragoza",
    "iso2": "COA",
    "timezone": "America/Mexico_City",
    "countryCode": "MX"
  },
  {
    "name": "Colima",
    "iso2": "COL",
    "timezone": "America/Mexico_City",
    "countryCode": "MX"
  },
  {
    "name": "Durango",
    "iso2": "DUR",
    "timezone": "America/Monterrey",
    "countryCode": "MX"
  },
  {
    "name": "Estado de México",
    "iso2": "MEX",
    "timezone": "America/Mexico_City",
    "countryCode": "MX"
  },
  {
    "name": "Guanajuato",
    "iso2": "GUA",
    "timezone": "America/Mexico_City",
    "countryCode": "MX"
  },
  {
    "name": "Guerrero",
    "iso2": "GRO",
    "timezone": "America/Mexico_City",
    "countryCode": "MX"
  },
  {
    "name": "Hidalgo",
    "iso2": "HID",
    "timezone": "America/Mexico_City",
    "countryCode": "MX"
  },
  {
    "name": "Jalisco",
    "iso2": "JAL",
    "timezone": "America/Mexico_City",
    "countryCode": "MX"
  },
  {
    "name": "Michoacán de Ocampo",
    "iso2": "MIC",
    "timezone": "America/Mexico_City",
    "countryCode": "MX"
  },
  {
    "name": "Morelos",
    "iso2": "MOR",
    "timezone": "America/Mexico_City",
    "countryCode": "MX"
  },
  {
    "name": "Nayarit",
    "iso2": "NAY",
    "timezone": "America/Mazatlan",
    "countryCode": "MX"
  },
  {
    "name": "Nuevo León",
    "iso2": "NLE",
    "timezone": "America/Monterrey",
    "countryCode": "MX"
  },
  {
    "name": "Oaxaca",
    "iso2": "OAX",
    "timezone": "America/Mexico_City",
    "countryCode": "MX"
  },
  {
    "name": "Puebla",
    "iso2": "PUE",
    "timezone": "America/Mexico_City",
    "countryCode": "MX"
  },
  {
    "name": "Querétaro",
    "iso2": "QUE",
    "timezone": "America/Mexico_City",
    "countryCode": "MX"
  },
  {
    "name": "Quintana Roo",
    "iso2": "ROO",
    "timezone": "America/Cancun",
    "countryCode": "MX"
  },
  {
    "name": "San Luis Potosí",
    "iso2": "SLP",
    "timezone": "America/Mexico_City",
    "countryCode": "MX"
  },
  {
    "name": "Sinaloa",
    "iso2": "SIN",
    "timezone": "America/Mazatlan",
    "countryCode": "MX"
  },
  {
    "name": "Sonora",
    "iso2": "SON",
    "timezone": "America/Hermosillo",
    "countryCode": "MX"
  },
  {
    "name": "Tabasco",
    "iso2": "TAB",
    "timezone": "America/Mexico_City",
    "countryCode": "MX"
  },
  {
    "name": "Tamaulipas",
    "iso2": "TAM",
    "timezone": "America/Matamoros",
    "countryCode": "MX"
  },
  {
    "name": "Tlaxcala",
    "iso2": "TLA",
    "timezone": "America/Mexico_City",
    "countryCode": "MX"
  },
  {
    "name": "Veracruz de Ignacio de la Llave",
    "iso2": "VER",
    "timezone": "America/Mexico_City",
    "countryCode": "MX"
  },
  {
    "name": "Yucatán",
    "iso2": "YUC",
    "timezone": "America/Merida",
    "countryCode": "MX"
  },
  {
    "name": "Zacatecas",
    "iso2": "ZAC",
    "timezone": "America/Mexico_City",
    "countryCode": "MX"
  },
  {
    "name": "Chuuk",
    "iso2": "TRK",
    "timezone": "Pacific/Chuuk",
    "countryCode": "FM"
  },
  {
    "name": "Kosrae",
    "iso2": "KSA",
    "timezone": "Pacific/Chuuk",
    "countryCode": "FM"
  },
  {
    "name": "Pohnpei",
    "iso2": "PNI",
    "timezone": "Pacific/Chuuk",
    "countryCode": "FM"
  },
  {
    "name": "Yap",
    "iso2": "YAP",
    "timezone": "Pacific/Chuuk",
    "countryCode": "FM"
  },
  {
    "name": "Anenii Noi",
    "iso2": "AN",
    "timezone": "Europe/Chisinau",
    "countryCode": "MD"
  },
  {
    "name": "Bălți",
    "iso2": "BA",
    "timezone": "Europe/Chisinau",
    "countryCode": "MD"
  },
  {
    "name": "Basarabeasca",
    "iso2": "BS",
    "timezone": "Europe/Chisinau",
    "countryCode": "MD"
  },
  {
    "name": "Bender",
    "iso2": "BD",
    "timezone": "Europe/Chisinau",
    "countryCode": "MD"
  },
  {
    "name": "Briceni",
    "iso2": "BR",
    "timezone": "Europe/Chisinau",
    "countryCode": "MD"
  },
  {
    "name": "Cahul",
    "iso2": "CA",
    "timezone": "Europe/Chisinau",
    "countryCode": "MD"
  },
  {
    "name": "Călărași",
    "iso2": "CL",
    "timezone": "Europe/Chisinau",
    "countryCode": "MD"
  },
  {
    "name": "Cantemir",
    "iso2": "CT",
    "timezone": "Europe/Chisinau",
    "countryCode": "MD"
  },
  {
    "name": "Căușeni",
    "iso2": "CS",
    "timezone": "Europe/Chisinau",
    "countryCode": "MD"
  },
  {
    "name": "Chișinău",
    "iso2": "CU",
    "timezone": "Europe/Chisinau",
    "countryCode": "MD"
  },
  {
    "name": "Cimișlia",
    "iso2": "CM",
    "timezone": "Europe/Chisinau",
    "countryCode": "MD"
  },
  {
    "name": "Criuleni",
    "iso2": "CR",
    "timezone": "Europe/Chisinau",
    "countryCode": "MD"
  },
  {
    "name": "Dondușeni",
    "iso2": "DO",
    "timezone": "Europe/Chisinau",
    "countryCode": "MD"
  },
  {
    "name": "Drochia",
    "iso2": "DR",
    "timezone": "Europe/Chisinau",
    "countryCode": "MD"
  },
  {
    "name": "Dubăsari",
    "iso2": "DU",
    "timezone": "Europe/Chisinau",
    "countryCode": "MD"
  },
  {
    "name": "Edineț",
    "iso2": "ED",
    "timezone": "Europe/Chisinau",
    "countryCode": "MD"
  },
  {
    "name": "Fălești",
    "iso2": "FA",
    "timezone": "Europe/Chisinau",
    "countryCode": "MD"
  },
  {
    "name": "Florești",
    "iso2": "FL",
    "timezone": "Europe/Chisinau",
    "countryCode": "MD"
  },
  {
    "name": "Gagauzia",
    "iso2": "GA",
    "timezone": "Europe/Chisinau",
    "countryCode": "MD"
  },
  {
    "name": "Glodeni",
    "iso2": "GL",
    "timezone": "Europe/Chisinau",
    "countryCode": "MD"
  },
  {
    "name": "Hîncești",
    "iso2": "HI",
    "timezone": "Europe/Chisinau",
    "countryCode": "MD"
  },
  {
    "name": "Ialoveni",
    "iso2": "IA",
    "timezone": "Europe/Chisinau",
    "countryCode": "MD"
  },
  {
    "name": "Leova",
    "iso2": "LE",
    "timezone": "Europe/Chisinau",
    "countryCode": "MD"
  },
  {
    "name": "Nisporeni",
    "iso2": "NI",
    "timezone": "Europe/Chisinau",
    "countryCode": "MD"
  },
  {
    "name": "Ocnița",
    "iso2": "OC",
    "timezone": "Europe/Chisinau",
    "countryCode": "MD"
  },
  {
    "name": "Orhei",
    "iso2": "OR",
    "timezone": "Europe/Chisinau",
    "countryCode": "MD"
  },
  {
    "name": "Rezina",
    "iso2": "RE",
    "timezone": "Europe/Chisinau",
    "countryCode": "MD"
  },
  {
    "name": "Rîșcani",
    "iso2": "RI",
    "timezone": "Europe/Chisinau",
    "countryCode": "MD"
  },
  {
    "name": "Sîngerei",
    "iso2": "SI",
    "timezone": "Europe/Chisinau",
    "countryCode": "MD"
  },
  {
    "name": "Șoldănești",
    "iso2": "SD",
    "timezone": "Europe/Chisinau",
    "countryCode": "MD"
  },
  {
    "name": "Soroca",
    "iso2": "SO",
    "timezone": "Europe/Chisinau",
    "countryCode": "MD"
  },
  {
    "name": "Ștefan Vodă",
    "iso2": "SV",
    "timezone": "Europe/Chisinau",
    "countryCode": "MD"
  },
  {
    "name": "Strășeni",
    "iso2": "ST",
    "timezone": "Europe/Chisinau",
    "countryCode": "MD"
  },
  {
    "name": "Taraclia",
    "iso2": "TA",
    "timezone": "Europe/Chisinau",
    "countryCode": "MD"
  },
  {
    "name": "Telenești",
    "iso2": "TE",
    "timezone": "Europe/Chisinau",
    "countryCode": "MD"
  },
  {
    "name": "Transnistria",
    "iso2": "SN",
    "timezone": "Europe/Chisinau",
    "countryCode": "MD"
  },
  {
    "name": "Ungheni",
    "iso2": "UN",
    "timezone": "Europe/Chisinau",
    "countryCode": "MD"
  },
  {
    "name": "Fontvieille",
    "iso2": "FO",
    "timezone": "Europe/Monaco",
    "countryCode": "MC"
  },
  {
    "name": "Jardin Exotique",
    "iso2": "JE",
    "timezone": "Europe/Monaco",
    "countryCode": "MC"
  },
  {
    "name": "La Colle",
    "iso2": "CL",
    "timezone": "Europe/Monaco",
    "countryCode": "MC"
  },
  {
    "name": "La Condamine",
    "iso2": "CO",
    "timezone": "Europe/Monaco",
    "countryCode": "MC"
  },
  {
    "name": "La Gare",
    "iso2": "GA",
    "timezone": "Europe/Monaco",
    "countryCode": "MC"
  },
  {
    "name": "La Source",
    "iso2": "SO",
    "timezone": "Europe/Monaco",
    "countryCode": "MC"
  },
  {
    "name": "Larvotto",
    "iso2": "LA",
    "timezone": "Europe/Monaco",
    "countryCode": "MC"
  },
  {
    "name": "Malbousquet",
    "iso2": "MA",
    "timezone": "Europe/Monaco",
    "countryCode": "MC"
  },
  {
    "name": "Monaco-Ville",
    "iso2": "MO",
    "timezone": "Europe/Monaco",
    "countryCode": "MC"
  },
  {
    "name": "Moneghetti",
    "iso2": "MG",
    "timezone": "Europe/Monaco",
    "countryCode": "MC"
  },
  {
    "name": "Monte-Carlo",
    "iso2": "MC",
    "timezone": "Europe/Monaco",
    "countryCode": "MC"
  },
  {
    "name": "Moulins",
    "iso2": "MU",
    "timezone": "Europe/Monaco",
    "countryCode": "MC"
  },
  {
    "name": "Port-Hercule",
    "iso2": "PH",
    "timezone": "Europe/Monaco",
    "countryCode": "MC"
  },
  {
    "name": "Saint-Roman",
    "iso2": "SR",
    "timezone": "Europe/Monaco",
    "countryCode": "MC"
  },
  {
    "name": "Sainte-Dévote",
    "iso2": "SD",
    "timezone": "Europe/Monaco",
    "countryCode": "MC"
  },
  {
    "name": "Spélugues",
    "iso2": "SP",
    "timezone": "Europe/Monaco",
    "countryCode": "MC"
  },
  {
    "name": "Vallon de la Rousse",
    "iso2": "VR",
    "timezone": "Europe/Monaco",
    "countryCode": "MC"
  },
  {
    "name": "Arkhangai",
    "iso2": "073",
    "timezone": "Asia/Choibalsan",
    "countryCode": "MN"
  },
  {
    "name": "Bayan-Ölgii",
    "iso2": "071",
    "timezone": "Asia/Choibalsan",
    "countryCode": "MN"
  },
  {
    "name": "Bayankhongor",
    "iso2": "069",
    "timezone": "Asia/Choibalsan",
    "countryCode": "MN"
  },
  {
    "name": "Bulgan",
    "iso2": "067",
    "timezone": "Asia/Choibalsan",
    "countryCode": "MN"
  },
  {
    "name": "Darkhan-Uul",
    "iso2": "037",
    "timezone": "Asia/Choibalsan",
    "countryCode": "MN"
  },
  {
    "name": "Dornod",
    "iso2": "061",
    "timezone": "Asia/Choibalsan",
    "countryCode": "MN"
  },
  {
    "name": "Dornogovi",
    "iso2": "063",
    "timezone": "Asia/Choibalsan",
    "countryCode": "MN"
  },
  {
    "name": "Dundgovi",
    "iso2": "059",
    "timezone": "Asia/Choibalsan",
    "countryCode": "MN"
  },
  {
    "name": "Govi-Altai",
    "iso2": "065",
    "timezone": "Asia/Choibalsan",
    "countryCode": "MN"
  },
  {
    "name": "Govisümber",
    "iso2": "064",
    "timezone": "Asia/Choibalsan",
    "countryCode": "MN"
  },
  {
    "name": "Khentii",
    "iso2": "039",
    "timezone": "Asia/Choibalsan",
    "countryCode": "MN"
  },
  {
    "name": "Khovd",
    "iso2": "043",
    "timezone": "Asia/Choibalsan",
    "countryCode": "MN"
  },
  {
    "name": "Khövsgöl",
    "iso2": "041",
    "timezone": "Asia/Choibalsan",
    "countryCode": "MN"
  },
  {
    "name": "Ömnögovi",
    "iso2": "053",
    "timezone": "Asia/Choibalsan",
    "countryCode": "MN"
  },
  {
    "name": "Orkhon",
    "iso2": "035",
    "timezone": "Asia/Choibalsan",
    "countryCode": "MN"
  },
  {
    "name": "Övörkhangai",
    "iso2": "055",
    "timezone": "Asia/Choibalsan",
    "countryCode": "MN"
  },
  {
    "name": "Selenge",
    "iso2": "049",
    "timezone": "Asia/Choibalsan",
    "countryCode": "MN"
  },
  {
    "name": "Sükhbaatar",
    "iso2": "051",
    "timezone": "Asia/Choibalsan",
    "countryCode": "MN"
  },
  {
    "name": "Töv",
    "iso2": "047",
    "timezone": "Asia/Choibalsan",
    "countryCode": "MN"
  },
  {
    "name": "Ulaanbaatar",
    "iso2": "001",
    "timezone": "Asia/Choibalsan",
    "countryCode": "MN"
  },
  {
    "name": "Uvs",
    "iso2": "046",
    "timezone": "Asia/Choibalsan",
    "countryCode": "MN"
  },
  {
    "name": "Zavkhan",
    "iso2": "057",
    "timezone": "Asia/Choibalsan",
    "countryCode": "MN"
  },
  {
    "name": "Andrijevica",
    "iso2": "01",
    "timezone": "Europe/Podgorica",
    "countryCode": "ME"
  },
  {
    "name": "Bar",
    "iso2": "02",
    "timezone": "Europe/Podgorica",
    "countryCode": "ME"
  },
  {
    "name": "Berane",
    "iso2": "03",
    "timezone": "Europe/Podgorica",
    "countryCode": "ME"
  },
  {
    "name": "Bijelo Polje",
    "iso2": "04",
    "timezone": "Europe/Podgorica",
    "countryCode": "ME"
  },
  {
    "name": "Budva",
    "iso2": "05",
    "timezone": "Europe/Podgorica",
    "countryCode": "ME"
  },
  {
    "name": "Danilovgrad",
    "iso2": "07",
    "timezone": "Europe/Podgorica",
    "countryCode": "ME"
  },
  {
    "name": "Gusinje",
    "iso2": "22",
    "timezone": "Europe/Podgorica",
    "countryCode": "ME"
  },
  {
    "name": "Herceg-Novi",
    "iso2": "08",
    "timezone": "Europe/Podgorica",
    "countryCode": "ME"
  },
  {
    "name": "Kolašin",
    "iso2": "09",
    "timezone": "Europe/Podgorica",
    "countryCode": "ME"
  },
  {
    "name": "Kotor",
    "iso2": "10",
    "timezone": "Europe/Podgorica",
    "countryCode": "ME"
  },
  {
    "name": "Mojkovac",
    "iso2": "11",
    "timezone": "Europe/Podgorica",
    "countryCode": "ME"
  },
  {
    "name": "Nikšić",
    "iso2": "12",
    "timezone": "Europe/Podgorica",
    "countryCode": "ME"
  },
  {
    "name": "Old Royal Capital Cetinje",
    "iso2": "06",
    "timezone": "Europe/Podgorica",
    "countryCode": "ME"
  },
  {
    "name": "Petnjica",
    "iso2": "23",
    "timezone": "Europe/Podgorica",
    "countryCode": "ME"
  },
  {
    "name": "Plav",
    "iso2": "13",
    "timezone": "Europe/Podgorica",
    "countryCode": "ME"
  },
  {
    "name": "Pljevlja",
    "iso2": "14",
    "timezone": "Europe/Podgorica",
    "countryCode": "ME"
  },
  {
    "name": "Plužine",
    "iso2": "15",
    "timezone": "Europe/Podgorica",
    "countryCode": "ME"
  },
  {
    "name": "Podgorica",
    "iso2": "16",
    "timezone": "Europe/Podgorica",
    "countryCode": "ME"
  },
  {
    "name": "Rožaje",
    "iso2": "17",
    "timezone": "Europe/Podgorica",
    "countryCode": "ME"
  },
  {
    "name": "Šavnik",
    "iso2": "18",
    "timezone": "Europe/Podgorica",
    "countryCode": "ME"
  },
  {
    "name": "Tivat",
    "iso2": "19",
    "timezone": "Europe/Podgorica",
    "countryCode": "ME"
  },
  {
    "name": "Tuzi",
    "iso2": "24",
    "timezone": "Europe/Podgorica",
    "countryCode": "ME"
  },
  {
    "name": "Ulcinj",
    "iso2": "20",
    "timezone": "Europe/Podgorica",
    "countryCode": "ME"
  },
  {
    "name": "Žabljak",
    "iso2": "21",
    "timezone": "Europe/Podgorica",
    "countryCode": "ME"
  },
  {
    "name": "Zeta",
    "iso2": "25",
    "timezone": "Europe/Podgorica",
    "countryCode": "ME"
  },
  {
    "name": "Saint Anthony",
    "iso2": "03",
    "timezone": "America/Montserrat",
    "countryCode": "MS"
  },
  {
    "name": "Saint Georges",
    "iso2": "02",
    "timezone": "America/Montserrat",
    "countryCode": "MS"
  },
  {
    "name": "Saint Peter",
    "iso2": "01",
    "timezone": "America/Montserrat",
    "countryCode": "MS"
  },
  {
    "name": "Agadir-Ida-Ou-Tanane",
    "iso2": "AGD",
    "timezone": "Africa/Casablanca",
    "countryCode": "MA"
  },
  {
    "name": "Al Haouz",
    "iso2": "HAO",
    "timezone": "Africa/Casablanca",
    "countryCode": "MA"
  },
  {
    "name": "Al Hoceïma",
    "iso2": "HOC",
    "timezone": "Africa/Casablanca",
    "countryCode": "MA"
  },
  {
    "name": "Aousserd (EH)",
    "iso2": "AOU",
    "timezone": "Africa/Casablanca",
    "countryCode": "MA"
  },
  {
    "name": "Assa-Zag (EH-partial)",
    "iso2": "ASZ",
    "timezone": "Africa/Casablanca",
    "countryCode": "MA"
  },
  {
    "name": "Azilal",
    "iso2": "AZI",
    "timezone": "Africa/Casablanca",
    "countryCode": "MA"
  },
  {
    "name": "Béni Mellal",
    "iso2": "BEM",
    "timezone": "Africa/Casablanca",
    "countryCode": "MA"
  },
  {
    "name": "Béni Mellal-Khénifra",
    "iso2": "05",
    "timezone": "Africa/Casablanca",
    "countryCode": "MA"
  },
  {
    "name": "Benslimane",
    "iso2": "BES",
    "timezone": "Africa/Casablanca",
    "countryCode": "MA"
  },
  {
    "name": "Berkane",
    "iso2": "BER",
    "timezone": "Africa/Casablanca",
    "countryCode": "MA"
  },
  {
    "name": "Berrechid",
    "iso2": "BRR",
    "timezone": "Africa/Casablanca",
    "countryCode": "MA"
  },
  {
    "name": "Boujdour (EH)",
    "iso2": "BOD",
    "timezone": "Africa/Casablanca",
    "countryCode": "MA"
  },
  {
    "name": "Boulemane",
    "iso2": "BOM",
    "timezone": "Africa/Casablanca",
    "countryCode": "MA"
  },
  {
    "name": "Casablanca",
    "iso2": "CAS",
    "timezone": "Africa/Casablanca",
    "countryCode": "MA"
  },
  {
    "name": "Casablanca-Settat",
    "iso2": "06",
    "timezone": "Africa/Casablanca",
    "countryCode": "MA"
  },
  {
    "name": "Chefchaouen",
    "iso2": "CHE",
    "timezone": "Africa/Casablanca",
    "countryCode": "MA"
  },
  {
    "name": "Chichaoua",
    "iso2": "CHI",
    "timezone": "Africa/Casablanca",
    "countryCode": "MA"
  },
  {
    "name": "Chtouka-Ait Baha",
    "iso2": "CHT",
    "timezone": "Africa/Casablanca",
    "countryCode": "MA"
  },
  {
    "name": "Dakhla-Oued Ed-Dahab (EH)",
    "iso2": "12",
    "timezone": "Africa/Casablanca",
    "countryCode": "MA"
  },
  {
    "name": "Drâa-Tafilalet",
    "iso2": "08",
    "timezone": "Africa/Casablanca",
    "countryCode": "MA"
  },
  {
    "name": "Driouch",
    "iso2": "DRI",
    "timezone": "Africa/Casablanca",
    "countryCode": "MA"
  },
  {
    "name": "El Hajeb",
    "iso2": "HAJ",
    "timezone": "Africa/Casablanca",
    "countryCode": "MA"
  },
  {
    "name": "El Jadida",
    "iso2": "JDI",
    "timezone": "Africa/Casablanca",
    "countryCode": "MA"
  },
  {
    "name": "El Kelâa des Sraghna",
    "iso2": "KES",
    "timezone": "Africa/Casablanca",
    "countryCode": "MA"
  },
  {
    "name": "Errachidia",
    "iso2": "ERR",
    "timezone": "Africa/Casablanca",
    "countryCode": "MA"
  },
  {
    "name": "Es-Semara (EH-partial)",
    "iso2": "ESM",
    "timezone": "Africa/Casablanca",
    "countryCode": "MA"
  },
  {
    "name": "Essaouira",
    "iso2": "ESI",
    "timezone": "Africa/Casablanca",
    "countryCode": "MA"
  },
  {
    "name": "Fahs-Anjra",
    "iso2": "FAH",
    "timezone": "Africa/Casablanca",
    "countryCode": "MA"
  },
  {
    "name": "Fès",
    "iso2": "FES",
    "timezone": "Africa/Casablanca",
    "countryCode": "MA"
  },
  {
    "name": "Fès-Meknès",
    "iso2": "03",
    "timezone": "Africa/Casablanca",
    "countryCode": "MA"
  },
  {
    "name": "Figuig",
    "iso2": "FIG",
    "timezone": "Africa/Casablanca",
    "countryCode": "MA"
  },
  {
    "name": "Fquih Ben Salah",
    "iso2": "FQH",
    "timezone": "Africa/Casablanca",
    "countryCode": "MA"
  },
  {
    "name": "Guelmim",
    "iso2": "GUE",
    "timezone": "Africa/Casablanca",
    "countryCode": "MA"
  },
  {
    "name": "Guelmim-Oued Noun (EH-partial)",
    "iso2": "10",
    "timezone": "Africa/Casablanca",
    "countryCode": "MA"
  },
  {
    "name": "Guercif",
    "iso2": "GUF",
    "timezone": "Africa/Casablanca",
    "countryCode": "MA"
  },
  {
    "name": "Ifrane",
    "iso2": "IFR",
    "timezone": "Africa/Casablanca",
    "countryCode": "MA"
  },
  {
    "name": "Inezgane-Ait Melloul",
    "iso2": "INE",
    "timezone": "Africa/Casablanca",
    "countryCode": "MA"
  },
  {
    "name": "Jerada",
    "iso2": "JRA",
    "timezone": "Africa/Casablanca",
    "countryCode": "MA"
  },
  {
    "name": "Kénitra",
    "iso2": "KEN",
    "timezone": "Africa/Casablanca",
    "countryCode": "MA"
  },
  {
    "name": "Khémisset",
    "iso2": "KHE",
    "timezone": "Africa/Casablanca",
    "countryCode": "MA"
  },
  {
    "name": "Khénifra",
    "iso2": "KHN",
    "timezone": "Africa/Casablanca",
    "countryCode": "MA"
  },
  {
    "name": "Khouribga",
    "iso2": "KHO",
    "timezone": "Africa/Casablanca",
    "countryCode": "MA"
  },
  {
    "name": "L'Oriental",
    "iso2": "02",
    "timezone": "Africa/Casablanca",
    "countryCode": "MA"
  },
  {
    "name": "Laâyoune (EH)",
    "iso2": "LAA",
    "timezone": "Africa/Casablanca",
    "countryCode": "MA"
  },
  {
    "name": "Laâyoune-Sakia El Hamra (EH-partial)",
    "iso2": "11",
    "timezone": "Africa/Casablanca",
    "countryCode": "MA"
  },
  {
    "name": "Larache",
    "iso2": "LAR",
    "timezone": "Africa/Casablanca",
    "countryCode": "MA"
  },
  {
    "name": "M’diq-Fnideq",
    "iso2": "MDF",
    "timezone": "Africa/Casablanca",
    "countryCode": "MA"
  },
  {
    "name": "Marrakech",
    "iso2": "MAR",
    "timezone": "Africa/Casablanca",
    "countryCode": "MA"
  },
  {
    "name": "Marrakesh-Safi",
    "iso2": "07",
    "timezone": "Africa/Casablanca",
    "countryCode": "MA"
  },
  {
    "name": "Médiouna",
    "iso2": "MED",
    "timezone": "Africa/Casablanca",
    "countryCode": "MA"
  },
  {
    "name": "Meknès",
    "iso2": "MEK",
    "timezone": "Africa/Casablanca",
    "countryCode": "MA"
  },
  {
    "name": "Midelt",
    "iso2": "MID",
    "timezone": "Africa/Casablanca",
    "countryCode": "MA"
  },
  {
    "name": "Mohammadia",
    "iso2": "MOH",
    "timezone": "Africa/Casablanca",
    "countryCode": "MA"
  },
  {
    "name": "Moulay Yacoub",
    "iso2": "MOU",
    "timezone": "Africa/Casablanca",
    "countryCode": "MA"
  },
  {
    "name": "Nador",
    "iso2": "NAD",
    "timezone": "Africa/Casablanca",
    "countryCode": "MA"
  },
  {
    "name": "Nouaceur",
    "iso2": "NOU",
    "timezone": "Africa/Casablanca",
    "countryCode": "MA"
  },
  {
    "name": "Ouarzazate",
    "iso2": "OUA",
    "timezone": "Africa/Casablanca",
    "countryCode": "MA"
  },
  {
    "name": "Oued Ed-Dahab (EH)",
    "iso2": "OUD",
    "timezone": "Africa/Casablanca",
    "countryCode": "MA"
  },
  {
    "name": "Ouezzane",
    "iso2": "OUZ",
    "timezone": "Africa/Casablanca",
    "countryCode": "MA"
  },
  {
    "name": "Oujda-Angad",
    "iso2": "OUJ",
    "timezone": "Africa/Casablanca",
    "countryCode": "MA"
  },
  {
    "name": "Rabat",
    "iso2": "RAB",
    "timezone": "Africa/Casablanca",
    "countryCode": "MA"
  },
  {
    "name": "Rabat-Salé-Kénitra",
    "iso2": "04",
    "timezone": "Africa/Casablanca",
    "countryCode": "MA"
  },
  {
    "name": "Rehamna",
    "iso2": "REH",
    "timezone": "Africa/Casablanca",
    "countryCode": "MA"
  },
  {
    "name": "Safi",
    "iso2": "SAF",
    "timezone": "Africa/Casablanca",
    "countryCode": "MA"
  },
  {
    "name": "Salé",
    "iso2": "SAL",
    "timezone": "Africa/Casablanca",
    "countryCode": "MA"
  },
  {
    "name": "Sefrou",
    "iso2": "SEF",
    "timezone": "Africa/Casablanca",
    "countryCode": "MA"
  },
  {
    "name": "Settat",
    "iso2": "SET",
    "timezone": "Africa/Casablanca",
    "countryCode": "MA"
  },
  {
    "name": "Sidi Bennour",
    "iso2": "SIB",
    "timezone": "Africa/Casablanca",
    "countryCode": "MA"
  },
  {
    "name": "Sidi Ifni",
    "iso2": "SIF",
    "timezone": "Africa/Casablanca",
    "countryCode": "MA"
  },
  {
    "name": "Sidi Kacem",
    "iso2": "SIK",
    "timezone": "Africa/Casablanca",
    "countryCode": "MA"
  },
  {
    "name": "Sidi Slimane",
    "iso2": "SIL",
    "timezone": "Africa/Casablanca",
    "countryCode": "MA"
  },
  {
    "name": "Skhirate-Témara",
    "iso2": "SKH",
    "timezone": "Africa/Casablanca",
    "countryCode": "MA"
  },
  {
    "name": "Souss-Massa",
    "iso2": "09",
    "timezone": "Africa/Casablanca",
    "countryCode": "MA"
  },
  {
    "name": "Tan-Tan (EH-partial)",
    "iso2": "TNT",
    "timezone": "Africa/Casablanca",
    "countryCode": "MA"
  },
  {
    "name": "Tanger-Assilah",
    "iso2": "TNG",
    "timezone": "Africa/Casablanca",
    "countryCode": "MA"
  },
  {
    "name": "Tanger-Tétouan-Al Hoceïma",
    "iso2": "01",
    "timezone": "Africa/Casablanca",
    "countryCode": "MA"
  },
  {
    "name": "Taounate",
    "iso2": "TAO",
    "timezone": "Africa/Casablanca",
    "countryCode": "MA"
  },
  {
    "name": "Taourirt",
    "iso2": "TAI",
    "timezone": "Africa/Casablanca",
    "countryCode": "MA"
  },
  {
    "name": "Tarfaya (EH-partial)",
    "iso2": "TAF",
    "timezone": "Africa/Casablanca",
    "countryCode": "MA"
  },
  {
    "name": "Taroudannt",
    "iso2": "TAR",
    "timezone": "Africa/Casablanca",
    "countryCode": "MA"
  },
  {
    "name": "Tata",
    "iso2": "TAT",
    "timezone": "Africa/Casablanca",
    "countryCode": "MA"
  },
  {
    "name": "Taza",
    "iso2": "TAZ",
    "timezone": "Africa/Casablanca",
    "countryCode": "MA"
  },
  {
    "name": "Tétouan",
    "iso2": "TET",
    "timezone": "Africa/Casablanca",
    "countryCode": "MA"
  },
  {
    "name": "Tinghir",
    "iso2": "TIN",
    "timezone": "Africa/Casablanca",
    "countryCode": "MA"
  },
  {
    "name": "Tiznit",
    "iso2": "TIZ",
    "timezone": "Africa/Casablanca",
    "countryCode": "MA"
  },
  {
    "name": "Youssoufia",
    "iso2": "YUS",
    "timezone": "Africa/Casablanca",
    "countryCode": "MA"
  },
  {
    "name": "Zagora",
    "iso2": "ZAG",
    "timezone": "Africa/Casablanca",
    "countryCode": "MA"
  },
  {
    "name": "Cabo Delgado",
    "iso2": "P",
    "timezone": "Africa/Maputo",
    "countryCode": "MZ"
  },
  {
    "name": "Gaza",
    "iso2": "G",
    "timezone": "Africa/Maputo",
    "countryCode": "MZ"
  },
  {
    "name": "Inhambane",
    "iso2": "I",
    "timezone": "Africa/Maputo",
    "countryCode": "MZ"
  },
  {
    "name": "Manica",
    "iso2": "B",
    "timezone": "Africa/Maputo",
    "countryCode": "MZ"
  },
  {
    "name": "Maputo",
    "iso2": "L",
    "timezone": "Africa/Maputo",
    "countryCode": "MZ"
  },
  {
    "name": "Maputo",
    "iso2": "MPM",
    "timezone": "Africa/Maputo",
    "countryCode": "MZ"
  },
  {
    "name": "Nampula",
    "iso2": "N",
    "timezone": "Africa/Maputo",
    "countryCode": "MZ"
  },
  {
    "name": "Niassa",
    "iso2": "A",
    "timezone": "Africa/Maputo",
    "countryCode": "MZ"
  },
  {
    "name": "Sofala",
    "iso2": "S",
    "timezone": "Africa/Maputo",
    "countryCode": "MZ"
  },
  {
    "name": "Tete",
    "iso2": "T",
    "timezone": "Africa/Maputo",
    "countryCode": "MZ"
  },
  {
    "name": "Zambezia",
    "iso2": "Q",
    "timezone": "Africa/Maputo",
    "countryCode": "MZ"
  },
  {
    "name": "Ayeyarwady",
    "iso2": "07",
    "timezone": "Asia/Yangon",
    "countryCode": "MM"
  },
  {
    "name": "Bago",
    "iso2": "02",
    "timezone": "Asia/Yangon",
    "countryCode": "MM"
  },
  {
    "name": "Chin",
    "iso2": "14",
    "timezone": "Asia/Yangon",
    "countryCode": "MM"
  },
  {
    "name": "Kachin",
    "iso2": "11",
    "timezone": "Asia/Yangon",
    "countryCode": "MM"
  },
  {
    "name": "Kayah",
    "iso2": "12",
    "timezone": "Asia/Yangon",
    "countryCode": "MM"
  },
  {
    "name": "Kayin",
    "iso2": "13",
    "timezone": "Asia/Yangon",
    "countryCode": "MM"
  },
  {
    "name": "Magway",
    "iso2": "03",
    "timezone": "Asia/Yangon",
    "countryCode": "MM"
  },
  {
    "name": "Mandalay",
    "iso2": "04",
    "timezone": "Asia/Yangon",
    "countryCode": "MM"
  },
  {
    "name": "Mon State",
    "iso2": "15",
    "timezone": "Asia/Yangon",
    "countryCode": "MM"
  },
  {
    "name": "Naypyidaw",
    "iso2": "18",
    "timezone": "Asia/Yangon",
    "countryCode": "MM"
  },
  {
    "name": "Rakhine",
    "iso2": "16",
    "timezone": "Asia/Yangon",
    "countryCode": "MM"
  },
  {
    "name": "Sagaing",
    "iso2": "01",
    "timezone": "Asia/Yangon",
    "countryCode": "MM"
  },
  {
    "name": "Shan",
    "iso2": "17",
    "timezone": "Asia/Yangon",
    "countryCode": "MM"
  },
  {
    "name": "Tanintharyi",
    "iso2": "05",
    "timezone": "Asia/Yangon",
    "countryCode": "MM"
  },
  {
    "name": "Yangon",
    "iso2": "06",
    "timezone": "Asia/Yangon",
    "countryCode": "MM"
  },
  {
    "name": "Erongo",
    "iso2": "ER",
    "timezone": "Africa/Windhoek",
    "countryCode": "NA"
  },
  {
    "name": "Hardap",
    "iso2": "HA",
    "timezone": "Africa/Windhoek",
    "countryCode": "NA"
  },
  {
    "name": "Karas",
    "iso2": "KA",
    "timezone": "Africa/Windhoek",
    "countryCode": "NA"
  },
  {
    "name": "Kavango East",
    "iso2": "KE",
    "timezone": "Africa/Windhoek",
    "countryCode": "NA"
  },
  {
    "name": "Kavango West",
    "iso2": "KW",
    "timezone": "Africa/Windhoek",
    "countryCode": "NA"
  },
  {
    "name": "Khomas",
    "iso2": "KH",
    "timezone": "Africa/Windhoek",
    "countryCode": "NA"
  },
  {
    "name": "Kunene",
    "iso2": "KU",
    "timezone": "Africa/Windhoek",
    "countryCode": "NA"
  },
  {
    "name": "Ohangwena",
    "iso2": "OW",
    "timezone": "Africa/Windhoek",
    "countryCode": "NA"
  },
  {
    "name": "Omaheke",
    "iso2": "OH",
    "timezone": "Africa/Windhoek",
    "countryCode": "NA"
  },
  {
    "name": "Omusati",
    "iso2": "OS",
    "timezone": "Africa/Windhoek",
    "countryCode": "NA"
  },
  {
    "name": "Oshana",
    "iso2": "ON",
    "timezone": "Africa/Windhoek",
    "countryCode": "NA"
  },
  {
    "name": "Oshikoto",
    "iso2": "OT",
    "timezone": "Africa/Windhoek",
    "countryCode": "NA"
  },
  {
    "name": "Otjozondjupa",
    "iso2": "OD",
    "timezone": "Africa/Windhoek",
    "countryCode": "NA"
  },
  {
    "name": "Zambezi",
    "iso2": "CA",
    "timezone": "Africa/Windhoek",
    "countryCode": "NA"
  },
  {
    "name": "Aiwo",
    "iso2": "01",
    "timezone": "Pacific/Nauru",
    "countryCode": "NR"
  },
  {
    "name": "Anabar",
    "iso2": "02",
    "timezone": "Pacific/Nauru",
    "countryCode": "NR"
  },
  {
    "name": "Anetan",
    "iso2": "03",
    "timezone": "Pacific/Nauru",
    "countryCode": "NR"
  },
  {
    "name": "Anibare",
    "iso2": "04",
    "timezone": "Pacific/Nauru",
    "countryCode": "NR"
  },
  {
    "name": "Baiti",
    "iso2": "05",
    "timezone": "Pacific/Nauru",
    "countryCode": "NR"
  },
  {
    "name": "Boe",
    "iso2": "06",
    "timezone": "Pacific/Nauru",
    "countryCode": "NR"
  },
  {
    "name": "Buada",
    "iso2": "07",
    "timezone": "Pacific/Nauru",
    "countryCode": "NR"
  },
  {
    "name": "Denigomodu",
    "iso2": "08",
    "timezone": "Pacific/Nauru",
    "countryCode": "NR"
  },
  {
    "name": "Ewa",
    "iso2": "09",
    "timezone": "Pacific/Nauru",
    "countryCode": "NR"
  },
  {
    "name": "Ijuw",
    "iso2": "10",
    "timezone": "Pacific/Nauru",
    "countryCode": "NR"
  },
  {
    "name": "Meneng",
    "iso2": "11",
    "timezone": "Pacific/Nauru",
    "countryCode": "NR"
  },
  {
    "name": "Nibok",
    "iso2": "12",
    "timezone": "Pacific/Nauru",
    "countryCode": "NR"
  },
  {
    "name": "Uaboe",
    "iso2": "13",
    "timezone": "Pacific/Nauru",
    "countryCode": "NR"
  },
  {
    "name": "Yaren",
    "iso2": "14",
    "timezone": "Pacific/Nauru",
    "countryCode": "NR"
  },
  {
    "name": "Bagmati",
    "iso2": "P3",
    "timezone": "Asia/Kathmandu",
    "countryCode": "NP"
  },
  {
    "name": "Gandaki",
    "iso2": "P4",
    "timezone": "Asia/Kathmandu",
    "countryCode": "NP"
  },
  {
    "name": "Karnali",
    "iso2": "P6",
    "timezone": "Asia/Kathmandu",
    "countryCode": "NP"
  },
  {
    "name": "Koshi",
    "iso2": "P1",
    "timezone": "Asia/Kathmandu",
    "countryCode": "NP"
  },
  {
    "name": "Lumbini",
    "iso2": "P5",
    "timezone": "Asia/Kathmandu",
    "countryCode": "NP"
  },
  {
    "name": "Madhesh",
    "iso2": "P2",
    "timezone": "Asia/Kathmandu",
    "countryCode": "NP"
  },
  {
    "name": "Sudurpashchim",
    "iso2": "P7",
    "timezone": "Asia/Kathmandu",
    "countryCode": "NP"
  },
  {
    "name": "Drenthe",
    "iso2": "DR",
    "timezone": "Europe/Amsterdam",
    "countryCode": "NL"
  },
  {
    "name": "Flevoland",
    "iso2": "FL",
    "timezone": "Europe/Amsterdam",
    "countryCode": "NL"
  },
  {
    "name": "Friesland",
    "iso2": "FR",
    "timezone": "Europe/Amsterdam",
    "countryCode": "NL"
  },
  {
    "name": "Gelderland",
    "iso2": "GE",
    "timezone": "Europe/Amsterdam",
    "countryCode": "NL"
  },
  {
    "name": "Groningen",
    "iso2": "GR",
    "timezone": "Europe/Amsterdam",
    "countryCode": "NL"
  },
  {
    "name": "Limburg",
    "iso2": "LI",
    "timezone": "Europe/Amsterdam",
    "countryCode": "NL"
  },
  {
    "name": "North Brabant",
    "iso2": "NB",
    "timezone": "Europe/Amsterdam",
    "countryCode": "NL"
  },
  {
    "name": "North Holland",
    "iso2": "NH",
    "timezone": "Europe/Amsterdam",
    "countryCode": "NL"
  },
  {
    "name": "Overijssel",
    "iso2": "OV",
    "timezone": "Europe/Amsterdam",
    "countryCode": "NL"
  },
  {
    "name": "South Holland",
    "iso2": "ZH",
    "timezone": "Europe/Amsterdam",
    "countryCode": "NL"
  },
  {
    "name": "Utrecht",
    "iso2": "UT",
    "timezone": "Europe/Amsterdam",
    "countryCode": "NL"
  },
  {
    "name": "Zeeland",
    "iso2": "ZE",
    "timezone": "Europe/Amsterdam",
    "countryCode": "NL"
  },
  {
    "name": "Loyalty Islands Province",
    "iso2": "03",
    "timezone": "Pacific/Noumea",
    "countryCode": "NC"
  },
  {
    "name": "North Province",
    "iso2": "02",
    "timezone": "Pacific/Noumea",
    "countryCode": "NC"
  },
  {
    "name": "South Province",
    "iso2": "01",
    "timezone": "Pacific/Noumea",
    "countryCode": "NC"
  },
  {
    "name": "Auckland",
    "iso2": "AUK",
    "timezone": "Pacific/Auckland",
    "countryCode": "NZ"
  },
  {
    "name": "Bay of Plenty",
    "iso2": "BOP",
    "timezone": "Pacific/Auckland",
    "countryCode": "NZ"
  },
  {
    "name": "Canterbury",
    "iso2": "CAN",
    "timezone": "Pacific/Auckland",
    "countryCode": "NZ"
  },
  {
    "name": "Chatham Islands",
    "iso2": "CIT",
    "timezone": "Pacific/Chatham",
    "countryCode": "NZ"
  },
  {
    "name": "Gisborne",
    "iso2": "GIS",
    "timezone": "Pacific/Auckland",
    "countryCode": "NZ"
  },
  {
    "name": "Hawke's Bay",
    "iso2": "HKB",
    "timezone": "Pacific/Auckland",
    "countryCode": "NZ"
  },
  {
    "name": "Manawatu-Whanganui",
    "iso2": "MWT",
    "timezone": "Pacific/Auckland",
    "countryCode": "NZ"
  },
  {
    "name": "Marlborough",
    "iso2": "MBH",
    "timezone": "Pacific/Auckland",
    "countryCode": "NZ"
  },
  {
    "name": "Nelson",
    "iso2": "NSN",
    "timezone": "Pacific/Auckland",
    "countryCode": "NZ"
  },
  {
    "name": "Northland",
    "iso2": "NTL",
    "timezone": "Pacific/Auckland",
    "countryCode": "NZ"
  },
  {
    "name": "Otago",
    "iso2": "OTA",
    "timezone": "Pacific/Auckland",
    "countryCode": "NZ"
  },
  {
    "name": "Southland",
    "iso2": "STL",
    "timezone": "Pacific/Auckland",
    "countryCode": "NZ"
  },
  {
    "name": "Taranaki",
    "iso2": "TKI",
    "timezone": "Pacific/Auckland",
    "countryCode": "NZ"
  },
  {
    "name": "Tasman",
    "iso2": "TAS",
    "timezone": "Pacific/Auckland",
    "countryCode": "NZ"
  },
  {
    "name": "Waikato",
    "iso2": "WKO",
    "timezone": "Pacific/Auckland",
    "countryCode": "NZ"
  },
  {
    "name": "Wellington",
    "iso2": "WGN",
    "timezone": "Pacific/Auckland",
    "countryCode": "NZ"
  },
  {
    "name": "West Coast",
    "iso2": "WTC",
    "timezone": "Pacific/Auckland",
    "countryCode": "NZ"
  },
  {
    "name": "Boaco",
    "iso2": "BO",
    "timezone": "America/Managua",
    "countryCode": "NI"
  },
  {
    "name": "Carazo",
    "iso2": "CA",
    "timezone": "America/Managua",
    "countryCode": "NI"
  },
  {
    "name": "Chinandega",
    "iso2": "CI",
    "timezone": "America/Managua",
    "countryCode": "NI"
  },
  {
    "name": "Chontales",
    "iso2": "CO",
    "timezone": "America/Managua",
    "countryCode": "NI"
  },
  {
    "name": "Estelí",
    "iso2": "ES",
    "timezone": "America/Managua",
    "countryCode": "NI"
  },
  {
    "name": "Granada",
    "iso2": "GR",
    "timezone": "America/Managua",
    "countryCode": "NI"
  },
  {
    "name": "Jinotega",
    "iso2": "JI",
    "timezone": "America/Managua",
    "countryCode": "NI"
  },
  {
    "name": "León",
    "iso2": "LE",
    "timezone": "America/Managua",
    "countryCode": "NI"
  },
  {
    "name": "Madriz",
    "iso2": "MD",
    "timezone": "America/Managua",
    "countryCode": "NI"
  },
  {
    "name": "Managua",
    "iso2": "MN",
    "timezone": "America/Managua",
    "countryCode": "NI"
  },
  {
    "name": "Masaya",
    "iso2": "MS",
    "timezone": "America/Managua",
    "countryCode": "NI"
  },
  {
    "name": "Matagalpa",
    "iso2": "MT",
    "timezone": "America/Managua",
    "countryCode": "NI"
  },
  {
    "name": "North Caribbean Coast",
    "iso2": "AN",
    "timezone": "America/Managua",
    "countryCode": "NI"
  },
  {
    "name": "Nueva Segovia",
    "iso2": "NS",
    "timezone": "America/Managua",
    "countryCode": "NI"
  },
  {
    "name": "Río San Juan",
    "iso2": "SJ",
    "timezone": "America/Managua",
    "countryCode": "NI"
  },
  {
    "name": "Rivas",
    "iso2": "RI",
    "timezone": "America/Managua",
    "countryCode": "NI"
  },
  {
    "name": "South Caribbean Coast",
    "iso2": "AS",
    "timezone": "America/Managua",
    "countryCode": "NI"
  },
  {
    "name": "Agadez",
    "iso2": "1",
    "timezone": "Africa/Niamey",
    "countryCode": "NE"
  },
  {
    "name": "Diffa",
    "iso2": "2",
    "timezone": "Africa/Niamey",
    "countryCode": "NE"
  },
  {
    "name": "Dosso",
    "iso2": "3",
    "timezone": "Africa/Niamey",
    "countryCode": "NE"
  },
  {
    "name": "Maradi",
    "iso2": "4",
    "timezone": "Africa/Niamey",
    "countryCode": "NE"
  },
  {
    "name": "Niamey",
    "iso2": "8",
    "timezone": "Africa/Niamey",
    "countryCode": "NE"
  },
  {
    "name": "Tahoua",
    "iso2": "5",
    "timezone": "Africa/Niamey",
    "countryCode": "NE"
  },
  {
    "name": "Tillabéri",
    "iso2": "6",
    "timezone": "Africa/Niamey",
    "countryCode": "NE"
  },
  {
    "name": "Zinder",
    "iso2": "7",
    "timezone": "Africa/Niamey",
    "countryCode": "NE"
  },
  {
    "name": "Abia",
    "iso2": "AB",
    "timezone": "Africa/Lagos",
    "countryCode": "NG"
  },
  {
    "name": "Abuja Federal Capital Territory",
    "iso2": "FC",
    "timezone": "Africa/Lagos",
    "countryCode": "NG"
  },
  {
    "name": "Adamawa",
    "iso2": "AD",
    "timezone": "Africa/Lagos",
    "countryCode": "NG"
  },
  {
    "name": "Akwa Ibom",
    "iso2": "AK",
    "timezone": "Africa/Lagos",
    "countryCode": "NG"
  },
  {
    "name": "Anambra",
    "iso2": "AN",
    "timezone": "Africa/Lagos",
    "countryCode": "NG"
  },
  {
    "name": "Bauchi",
    "iso2": "BA",
    "timezone": "Africa/Lagos",
    "countryCode": "NG"
  },
  {
    "name": "Bayelsa",
    "iso2": "BY",
    "timezone": "Africa/Lagos",
    "countryCode": "NG"
  },
  {
    "name": "Benue",
    "iso2": "BE",
    "timezone": "Africa/Lagos",
    "countryCode": "NG"
  },
  {
    "name": "Borno",
    "iso2": "BO",
    "timezone": "Africa/Lagos",
    "countryCode": "NG"
  },
  {
    "name": "Cross River",
    "iso2": "CR",
    "timezone": "Africa/Lagos",
    "countryCode": "NG"
  },
  {
    "name": "Delta",
    "iso2": "DE",
    "timezone": "Africa/Lagos",
    "countryCode": "NG"
  },
  {
    "name": "Ebonyi",
    "iso2": "EB",
    "timezone": "Africa/Lagos",
    "countryCode": "NG"
  },
  {
    "name": "Edo",
    "iso2": "ED",
    "timezone": "Africa/Lagos",
    "countryCode": "NG"
  },
  {
    "name": "Ekiti",
    "iso2": "EK",
    "timezone": "Africa/Lagos",
    "countryCode": "NG"
  },
  {
    "name": "Enugu",
    "iso2": "EN",
    "timezone": "Africa/Lagos",
    "countryCode": "NG"
  },
  {
    "name": "Gombe",
    "iso2": "GO",
    "timezone": "Africa/Lagos",
    "countryCode": "NG"
  },
  {
    "name": "Imo",
    "iso2": "IM",
    "timezone": "Africa/Lagos",
    "countryCode": "NG"
  },
  {
    "name": "Jigawa",
    "iso2": "JI",
    "timezone": "Africa/Lagos",
    "countryCode": "NG"
  },
  {
    "name": "Kaduna",
    "iso2": "KD",
    "timezone": "Africa/Lagos",
    "countryCode": "NG"
  },
  {
    "name": "Kano",
    "iso2": "KN",
    "timezone": "Africa/Lagos",
    "countryCode": "NG"
  },
  {
    "name": "Katsina",
    "iso2": "KT",
    "timezone": "Africa/Lagos",
    "countryCode": "NG"
  },
  {
    "name": "Kebbi",
    "iso2": "KE",
    "timezone": "Africa/Lagos",
    "countryCode": "NG"
  },
  {
    "name": "Kogi",
    "iso2": "KO",
    "timezone": "Africa/Lagos",
    "countryCode": "NG"
  },
  {
    "name": "Kwara",
    "iso2": "KW",
    "timezone": "Africa/Lagos",
    "countryCode": "NG"
  },
  {
    "name": "Lagos",
    "iso2": "LA",
    "timezone": "Africa/Lagos",
    "countryCode": "NG"
  },
  {
    "name": "Nasarawa",
    "iso2": "NA",
    "timezone": "Africa/Lagos",
    "countryCode": "NG"
  },
  {
    "name": "Niger",
    "iso2": "NI",
    "timezone": "Africa/Lagos",
    "countryCode": "NG"
  },
  {
    "name": "Ogun",
    "iso2": "OG",
    "timezone": "Africa/Lagos",
    "countryCode": "NG"
  },
  {
    "name": "Ondo",
    "iso2": "ON",
    "timezone": "Africa/Lagos",
    "countryCode": "NG"
  },
  {
    "name": "Osun",
    "iso2": "OS",
    "timezone": "Africa/Lagos",
    "countryCode": "NG"
  },
  {
    "name": "Oyo",
    "iso2": "OY",
    "timezone": "Africa/Lagos",
    "countryCode": "NG"
  },
  {
    "name": "Plateau",
    "iso2": "PL",
    "timezone": "Africa/Lagos",
    "countryCode": "NG"
  },
  {
    "name": "Rivers",
    "iso2": "RI",
    "timezone": "Africa/Lagos",
    "countryCode": "NG"
  },
  {
    "name": "Sokoto",
    "iso2": "SO",
    "timezone": "Africa/Lagos",
    "countryCode": "NG"
  },
  {
    "name": "Taraba",
    "iso2": "TA",
    "timezone": "Africa/Lagos",
    "countryCode": "NG"
  },
  {
    "name": "Yobe",
    "iso2": "YO",
    "timezone": "Africa/Lagos",
    "countryCode": "NG"
  },
  {
    "name": "Zamfara",
    "iso2": "ZA",
    "timezone": "Africa/Lagos",
    "countryCode": "NG"
  },
  {
    "name": "Alofi North",
    "iso2": "14",
    "timezone": "Pacific/Niue",
    "countryCode": "NU"
  },
  {
    "name": "Alofi South",
    "iso2": "13",
    "timezone": "Pacific/Niue",
    "countryCode": "NU"
  },
  {
    "name": "Avatele",
    "iso2": "11",
    "timezone": "Pacific/Niue",
    "countryCode": "NU"
  },
  {
    "name": "Hakupu",
    "iso2": "09",
    "timezone": "Pacific/Niue",
    "countryCode": "NU"
  },
  {
    "name": "Hikutavake",
    "iso2": "04",
    "timezone": "Pacific/Niue",
    "countryCode": "NU"
  },
  {
    "name": "Lakepa",
    "iso2": "07",
    "timezone": "Pacific/Niue",
    "countryCode": "NU"
  },
  {
    "name": "Liku",
    "iso2": "08",
    "timezone": "Pacific/Niue",
    "countryCode": "NU"
  },
  {
    "name": "Makefu",
    "iso2": "01",
    "timezone": "Pacific/Niue",
    "countryCode": "NU"
  },
  {
    "name": "Mutalau",
    "iso2": "06",
    "timezone": "Pacific/Niue",
    "countryCode": "NU"
  },
  {
    "name": "Namukulu",
    "iso2": "03",
    "timezone": "Pacific/Niue",
    "countryCode": "NU"
  },
  {
    "name": "Tamakautoga",
    "iso2": "12",
    "timezone": "Pacific/Niue",
    "countryCode": "NU"
  },
  {
    "name": "Toi",
    "iso2": "05",
    "timezone": "Pacific/Niue",
    "countryCode": "NU"
  },
  {
    "name": "Tuapa",
    "iso2": "02",
    "timezone": "Pacific/Niue",
    "countryCode": "NU"
  },
  {
    "name": "Vaiea",
    "iso2": "10",
    "timezone": "Pacific/Niue",
    "countryCode": "NU"
  },
  {
    "name": "Chagang",
    "iso2": "04",
    "timezone": "Asia/Pyongyang",
    "countryCode": "KP"
  },
  {
    "name": "Kaesong",
    "iso2": "15",
    "timezone": "Asia/Pyongyang",
    "countryCode": "KP"
  },
  {
    "name": "Kangwon",
    "iso2": "07",
    "timezone": "Asia/Pyongyang",
    "countryCode": "KP"
  },
  {
    "name": "Nampho",
    "iso2": "14",
    "timezone": "Asia/Pyongyang",
    "countryCode": "KP"
  },
  {
    "name": "North Hamgyong",
    "iso2": "09",
    "timezone": "Asia/Pyongyang",
    "countryCode": "KP"
  },
  {
    "name": "North Hwanghae",
    "iso2": "06",
    "timezone": "Asia/Pyongyang",
    "countryCode": "KP"
  },
  {
    "name": "North Pyongan",
    "iso2": "03",
    "timezone": "Asia/Pyongyang",
    "countryCode": "KP"
  },
  {
    "name": "Pyongyang",
    "iso2": "01",
    "timezone": "Asia/Pyongyang",
    "countryCode": "KP"
  },
  {
    "name": "Rason",
    "iso2": "13",
    "timezone": "Asia/Pyongyang",
    "countryCode": "KP"
  },
  {
    "name": "Ryanggang",
    "iso2": "10",
    "timezone": "Asia/Pyongyang",
    "countryCode": "KP"
  },
  {
    "name": "South Hamgyong",
    "iso2": "08",
    "timezone": "Asia/Pyongyang",
    "countryCode": "KP"
  },
  {
    "name": "South Hwanghae",
    "iso2": "05",
    "timezone": "Asia/Pyongyang",
    "countryCode": "KP"
  },
  {
    "name": "South Pyongan",
    "iso2": "02",
    "timezone": "Asia/Pyongyang",
    "countryCode": "KP"
  },
  {
    "name": "Aerodrom",
    "iso2": "801",
    "timezone": "Europe/Skopje",
    "countryCode": "MK"
  },
  {
    "name": "Aračinovo",
    "iso2": "802",
    "timezone": "Europe/Skopje",
    "countryCode": "MK"
  },
  {
    "name": "Berovo",
    "iso2": "201",
    "timezone": "Europe/Skopje",
    "countryCode": "MK"
  },
  {
    "name": "Bitola",
    "iso2": "501",
    "timezone": "Europe/Skopje",
    "countryCode": "MK"
  },
  {
    "name": "Bogdanci",
    "iso2": "401",
    "timezone": "Europe/Skopje",
    "countryCode": "MK"
  },
  {
    "name": "Bogovinje",
    "iso2": "601",
    "timezone": "Europe/Skopje",
    "countryCode": "MK"
  },
  {
    "name": "Bosilovo",
    "iso2": "402",
    "timezone": "Europe/Skopje",
    "countryCode": "MK"
  },
  {
    "name": "Brvenica",
    "iso2": "602",
    "timezone": "Europe/Skopje",
    "countryCode": "MK"
  },
  {
    "name": "Butel",
    "iso2": "803",
    "timezone": "Europe/Skopje",
    "countryCode": "MK"
  },
  {
    "name": "Čair",
    "iso2": "815",
    "timezone": "Europe/Skopje",
    "countryCode": "MK"
  },
  {
    "name": "Čaška",
    "iso2": "109",
    "timezone": "Europe/Skopje",
    "countryCode": "MK"
  },
  {
    "name": "Centar",
    "iso2": "814",
    "timezone": "Europe/Skopje",
    "countryCode": "MK"
  },
  {
    "name": "Centar Župa",
    "iso2": "313",
    "timezone": "Europe/Skopje",
    "countryCode": "MK"
  },
  {
    "name": "Češinovo-Obleševo",
    "iso2": "210",
    "timezone": "Europe/Skopje",
    "countryCode": "MK"
  },
  {
    "name": "Čučer-Sandevo",
    "iso2": "816",
    "timezone": "Europe/Skopje",
    "countryCode": "MK"
  },
  {
    "name": "Debar",
    "iso2": "303",
    "timezone": "Europe/Skopje",
    "countryCode": "MK"
  },
  {
    "name": "Debarca",
    "iso2": "304",
    "timezone": "Europe/Skopje",
    "countryCode": "MK"
  },
  {
    "name": "Delčevo",
    "iso2": "203",
    "timezone": "Europe/Skopje",
    "countryCode": "MK"
  },
  {
    "name": "Demir Hisar",
    "iso2": "502",
    "timezone": "Europe/Skopje",
    "countryCode": "MK"
  },
  {
    "name": "Demir Kapija",
    "iso2": "103",
    "timezone": "Europe/Skopje",
    "countryCode": "MK"
  },
  {
    "name": "Dojran",
    "iso2": "406",
    "timezone": "Europe/Skopje",
    "countryCode": "MK"
  },
  {
    "name": "Dolneni",
    "iso2": "503",
    "timezone": "Europe/Skopje",
    "countryCode": "MK"
  },
  {
    "name": "Gazi Baba",
    "iso2": "804",
    "timezone": "Europe/Skopje",
    "countryCode": "MK"
  },
  {
    "name": "Gevgelija",
    "iso2": "405",
    "timezone": "Europe/Skopje",
    "countryCode": "MK"
  },
  {
    "name": "Gjorče Petrov",
    "iso2": "805",
    "timezone": "Europe/Skopje",
    "countryCode": "MK"
  },
  {
    "name": "Gostivar",
    "iso2": "604",
    "timezone": "Europe/Skopje",
    "countryCode": "MK"
  },
  {
    "name": "Gradsko",
    "iso2": "102",
    "timezone": "Europe/Skopje",
    "countryCode": "MK"
  },
  {
    "name": "Ilinden",
    "iso2": "807",
    "timezone": "Europe/Skopje",
    "countryCode": "MK"
  },
  {
    "name": "Jegunovce",
    "iso2": "606",
    "timezone": "Europe/Skopje",
    "countryCode": "MK"
  },
  {
    "name": "Karbinci",
    "iso2": "205",
    "timezone": "Europe/Skopje",
    "countryCode": "MK"
  },
  {
    "name": "Karpoš",
    "iso2": "808",
    "timezone": "Europe/Skopje",
    "countryCode": "MK"
  },
  {
    "name": "Kavadarci",
    "iso2": "104",
    "timezone": "Europe/Skopje",
    "countryCode": "MK"
  },
  {
    "name": "Kičevo",
    "iso2": "307",
    "timezone": "Europe/Skopje",
    "countryCode": "MK"
  },
  {
    "name": "Kisela Voda",
    "iso2": "809",
    "timezone": "Europe/Skopje",
    "countryCode": "MK"
  },
  {
    "name": "Kočani",
    "iso2": "206",
    "timezone": "Europe/Skopje",
    "countryCode": "MK"
  },
  {
    "name": "Konče",
    "iso2": "407",
    "timezone": "Europe/Skopje",
    "countryCode": "MK"
  },
  {
    "name": "Kratovo",
    "iso2": "701",
    "timezone": "Europe/Skopje",
    "countryCode": "MK"
  },
  {
    "name": "Kriva Palanka",
    "iso2": "702",
    "timezone": "Europe/Skopje",
    "countryCode": "MK"
  },
  {
    "name": "Krivogaštani",
    "iso2": "504",
    "timezone": "Europe/Skopje",
    "countryCode": "MK"
  },
  {
    "name": "Kruševo",
    "iso2": "505",
    "timezone": "Europe/Skopje",
    "countryCode": "MK"
  },
  {
    "name": "Kumanovo",
    "iso2": "703",
    "timezone": "Europe/Skopje",
    "countryCode": "MK"
  },
  {
    "name": "Lipkovo",
    "iso2": "704",
    "timezone": "Europe/Skopje",
    "countryCode": "MK"
  },
  {
    "name": "Lozovo",
    "iso2": "105",
    "timezone": "Europe/Skopje",
    "countryCode": "MK"
  },
  {
    "name": "Makedonska Kamenica",
    "iso2": "207",
    "timezone": "Europe/Skopje",
    "countryCode": "MK"
  },
  {
    "name": "Makedonski Brod",
    "iso2": "308",
    "timezone": "Europe/Skopje",
    "countryCode": "MK"
  },
  {
    "name": "Mavrovo and Rostuša",
    "iso2": "607",
    "timezone": "Europe/Skopje",
    "countryCode": "MK"
  },
  {
    "name": "Mogila",
    "iso2": "506",
    "timezone": "Europe/Skopje",
    "countryCode": "MK"
  },
  {
    "name": "Negotino",
    "iso2": "106",
    "timezone": "Europe/Skopje",
    "countryCode": "MK"
  },
  {
    "name": "Novaci",
    "iso2": "507",
    "timezone": "Europe/Skopje",
    "countryCode": "MK"
  },
  {
    "name": "Novo Selo",
    "iso2": "408",
    "timezone": "Europe/Skopje",
    "countryCode": "MK"
  },
  {
    "name": "Ohrid",
    "iso2": "310",
    "timezone": "Europe/Skopje",
    "countryCode": "MK"
  },
  {
    "name": "Pehčevo",
    "iso2": "208",
    "timezone": "Europe/Skopje",
    "countryCode": "MK"
  },
  {
    "name": "Petrovec",
    "iso2": "810",
    "timezone": "Europe/Skopje",
    "countryCode": "MK"
  },
  {
    "name": "Plasnica",
    "iso2": "311",
    "timezone": "Europe/Skopje",
    "countryCode": "MK"
  },
  {
    "name": "Prilep",
    "iso2": "508",
    "timezone": "Europe/Skopje",
    "countryCode": "MK"
  },
  {
    "name": "Probištip",
    "iso2": "209",
    "timezone": "Europe/Skopje",
    "countryCode": "MK"
  },
  {
    "name": "Radoviš",
    "iso2": "409",
    "timezone": "Europe/Skopje",
    "countryCode": "MK"
  },
  {
    "name": "Rankovce",
    "iso2": "705",
    "timezone": "Europe/Skopje",
    "countryCode": "MK"
  },
  {
    "name": "Resen",
    "iso2": "509",
    "timezone": "Europe/Skopje",
    "countryCode": "MK"
  },
  {
    "name": "Rosoman",
    "iso2": "107",
    "timezone": "Europe/Skopje",
    "countryCode": "MK"
  },
  {
    "name": "Saraj",
    "iso2": "811",
    "timezone": "Europe/Skopje",
    "countryCode": "MK"
  },
  {
    "name": "Sopište",
    "iso2": "812",
    "timezone": "Europe/Skopje",
    "countryCode": "MK"
  },
  {
    "name": "Staro Nagoričane",
    "iso2": "706",
    "timezone": "Europe/Skopje",
    "countryCode": "MK"
  },
  {
    "name": "Štip",
    "iso2": "211",
    "timezone": "Europe/Skopje",
    "countryCode": "MK"
  },
  {
    "name": "Struga",
    "iso2": "312",
    "timezone": "Europe/Skopje",
    "countryCode": "MK"
  },
  {
    "name": "Strumica",
    "iso2": "410",
    "timezone": "Europe/Skopje",
    "countryCode": "MK"
  },
  {
    "name": "Studeničani",
    "iso2": "813",
    "timezone": "Europe/Skopje",
    "countryCode": "MK"
  },
  {
    "name": "Šuto Orizari",
    "iso2": "817",
    "timezone": "Europe/Skopje",
    "countryCode": "MK"
  },
  {
    "name": "Sveti Nikole",
    "iso2": "108",
    "timezone": "Europe/Skopje",
    "countryCode": "MK"
  },
  {
    "name": "Tearce",
    "iso2": "608",
    "timezone": "Europe/Skopje",
    "countryCode": "MK"
  },
  {
    "name": "Tetovo",
    "iso2": "609",
    "timezone": "Europe/Skopje",
    "countryCode": "MK"
  },
  {
    "name": "Valandovo",
    "iso2": "403",
    "timezone": "Europe/Skopje",
    "countryCode": "MK"
  },
  {
    "name": "Vasilevo",
    "iso2": "404",
    "timezone": "Europe/Skopje",
    "countryCode": "MK"
  },
  {
    "name": "Veles",
    "iso2": "101",
    "timezone": "Europe/Skopje",
    "countryCode": "MK"
  },
  {
    "name": "Vevčani",
    "iso2": "301",
    "timezone": "Europe/Skopje",
    "countryCode": "MK"
  },
  {
    "name": "Vinica",
    "iso2": "202",
    "timezone": "Europe/Skopje",
    "countryCode": "MK"
  },
  {
    "name": "Vrapčište",
    "iso2": "603",
    "timezone": "Europe/Skopje",
    "countryCode": "MK"
  },
  {
    "name": "Zelenikovo",
    "iso2": "806",
    "timezone": "Europe/Skopje",
    "countryCode": "MK"
  },
  {
    "name": "Želino",
    "iso2": "605",
    "timezone": "Europe/Skopje",
    "countryCode": "MK"
  },
  {
    "name": "Zrnovci",
    "iso2": "204",
    "timezone": "Europe/Skopje",
    "countryCode": "MK"
  },
  {
    "name": "Agder",
    "iso2": "42",
    "timezone": "Europe/Oslo",
    "countryCode": "NO"
  },
  {
    "name": "Akershus",
    "iso2": "32",
    "timezone": "Europe/Oslo",
    "countryCode": "NO"
  },
  {
    "name": "Buskerud",
    "iso2": "33",
    "timezone": "Europe/Oslo",
    "countryCode": "NO"
  },
  {
    "name": "Finnmark",
    "iso2": "56",
    "timezone": "Europe/Oslo",
    "countryCode": "NO"
  },
  {
    "name": "Innlandet",
    "iso2": "34",
    "timezone": "Europe/Oslo",
    "countryCode": "NO"
  },
  {
    "name": "Jan Mayen",
    "iso2": "22",
    "timezone": "Europe/Oslo",
    "countryCode": "NO"
  },
  {
    "name": "Møre og Romsdal",
    "iso2": "15",
    "timezone": "Europe/Oslo",
    "countryCode": "NO"
  },
  {
    "name": "Nordland",
    "iso2": "18",
    "timezone": "Europe/Oslo",
    "countryCode": "NO"
  },
  {
    "name": "Oslo",
    "iso2": "03",
    "timezone": "Europe/Oslo",
    "countryCode": "NO"
  },
  {
    "name": "Østfold",
    "iso2": "31",
    "timezone": "Europe/Oslo",
    "countryCode": "NO"
  },
  {
    "name": "Rogaland",
    "iso2": "11",
    "timezone": "Europe/Oslo",
    "countryCode": "NO"
  },
  {
    "name": "Svalbard",
    "iso2": "21",
    "timezone": "Europe/Oslo",
    "countryCode": "NO"
  },
  {
    "name": "Telemark",
    "iso2": "40",
    "timezone": "Europe/Oslo",
    "countryCode": "NO"
  },
  {
    "name": "Troms",
    "iso2": "55",
    "timezone": "Europe/Oslo",
    "countryCode": "NO"
  },
  {
    "name": "Trøndelag",
    "iso2": "50",
    "timezone": "Europe/Oslo",
    "countryCode": "NO"
  },
  {
    "name": "Vestfold",
    "iso2": "39",
    "timezone": "Europe/Oslo",
    "countryCode": "NO"
  },
  {
    "name": "Vestland",
    "iso2": "46",
    "timezone": "Europe/Oslo",
    "countryCode": "NO"
  },
  {
    "name": "Ad Dakhiliyah",
    "iso2": "DA",
    "timezone": "Asia/Muscat",
    "countryCode": "OM"
  },
  {
    "name": "Ad Dhahirah",
    "iso2": "ZA",
    "timezone": "Asia/Muscat",
    "countryCode": "OM"
  },
  {
    "name": "Al Batinah North",
    "iso2": "BS",
    "timezone": "Asia/Muscat",
    "countryCode": "OM"
  },
  {
    "name": "Al Batinah South",
    "iso2": "BJ",
    "timezone": "Asia/Muscat",
    "countryCode": "OM"
  },
  {
    "name": "Al Buraimi",
    "iso2": "BU",
    "timezone": "Asia/Muscat",
    "countryCode": "OM"
  },
  {
    "name": "Al Wusta",
    "iso2": "WU",
    "timezone": "Asia/Muscat",
    "countryCode": "OM"
  },
  {
    "name": "Ash Sharqiyah North",
    "iso2": "SS",
    "timezone": "Asia/Muscat",
    "countryCode": "OM"
  },
  {
    "name": "Ash Sharqiyah South",
    "iso2": "SJ",
    "timezone": "Asia/Muscat",
    "countryCode": "OM"
  },
  {
    "name": "Dhofar",
    "iso2": "ZU",
    "timezone": "Asia/Muscat",
    "countryCode": "OM"
  },
  {
    "name": "Musandam",
    "iso2": "MU",
    "timezone": "Asia/Muscat",
    "countryCode": "OM"
  },
  {
    "name": "Muscat",
    "iso2": "MA",
    "timezone": "Asia/Muscat",
    "countryCode": "OM"
  },
  {
    "name": "Azad Kashmir",
    "iso2": "JK",
    "timezone": "Asia/Karachi",
    "countryCode": "PK"
  },
  {
    "name": "Balochistan",
    "iso2": "BA",
    "timezone": "Asia/Karachi",
    "countryCode": "PK"
  },
  {
    "name": "Gilgit-Baltistan",
    "iso2": "GB",
    "timezone": "Asia/Karachi",
    "countryCode": "PK"
  },
  {
    "name": "Islamabad",
    "iso2": "IS",
    "timezone": "Asia/Karachi",
    "countryCode": "PK"
  },
  {
    "name": "Khyber Pakhtunkhwa",
    "iso2": "KP",
    "timezone": "Asia/Karachi",
    "countryCode": "PK"
  },
  {
    "name": "Punjab",
    "iso2": "PB",
    "timezone": "Asia/Karachi",
    "countryCode": "PK"
  },
  {
    "name": "Sindh",
    "iso2": "SD",
    "timezone": "Asia/Karachi",
    "countryCode": "PK"
  },
  {
    "name": "Aimeliik",
    "iso2": "002",
    "timezone": "Pacific/Palau",
    "countryCode": "PW"
  },
  {
    "name": "Airai",
    "iso2": "004",
    "timezone": "Pacific/Palau",
    "countryCode": "PW"
  },
  {
    "name": "Angaur",
    "iso2": "010",
    "timezone": "Pacific/Palau",
    "countryCode": "PW"
  },
  {
    "name": "Hatohobei",
    "iso2": "050",
    "timezone": "Pacific/Palau",
    "countryCode": "PW"
  },
  {
    "name": "Kayangel",
    "iso2": "100",
    "timezone": "Pacific/Palau",
    "countryCode": "PW"
  },
  {
    "name": "Koror",
    "iso2": "150",
    "timezone": "Pacific/Palau",
    "countryCode": "PW"
  },
  {
    "name": "Melekeok",
    "iso2": "212",
    "timezone": "Pacific/Palau",
    "countryCode": "PW"
  },
  {
    "name": "Ngaraard",
    "iso2": "214",
    "timezone": "Pacific/Palau",
    "countryCode": "PW"
  },
  {
    "name": "Ngarchelong",
    "iso2": "218",
    "timezone": "Pacific/Palau",
    "countryCode": "PW"
  },
  {
    "name": "Ngardmau",
    "iso2": "222",
    "timezone": "Pacific/Palau",
    "countryCode": "PW"
  },
  {
    "name": "Ngatpang",
    "iso2": "224",
    "timezone": "Pacific/Palau",
    "countryCode": "PW"
  },
  {
    "name": "Ngchesar",
    "iso2": "226",
    "timezone": "Pacific/Palau",
    "countryCode": "PW"
  },
  {
    "name": "Ngeremlengui",
    "iso2": "227",
    "timezone": "Pacific/Palau",
    "countryCode": "PW"
  },
  {
    "name": "Ngiwal",
    "iso2": "228",
    "timezone": "Pacific/Palau",
    "countryCode": "PW"
  },
  {
    "name": "Peleliu",
    "iso2": "350",
    "timezone": "Pacific/Palau",
    "countryCode": "PW"
  },
  {
    "name": "Sonsorol",
    "iso2": "370",
    "timezone": "Pacific/Palau",
    "countryCode": "PW"
  },
  {
    "name": "Bethlehem",
    "iso2": "BTH",
    "timezone": "Asia/Gaza",
    "countryCode": "PS"
  },
  {
    "name": "Deir El Balah",
    "iso2": "DEB",
    "timezone": "Asia/Gaza",
    "countryCode": "PS"
  },
  {
    "name": "Gaza",
    "iso2": "GZA",
    "timezone": "Asia/Gaza",
    "countryCode": "PS"
  },
  {
    "name": "Hebron",
    "iso2": "HBN",
    "timezone": "Asia/Gaza",
    "countryCode": "PS"
  },
  {
    "name": "Jenin",
    "iso2": "JEN",
    "timezone": "Asia/Gaza",
    "countryCode": "PS"
  },
  {
    "name": "Jericho ",
    "iso2": "JRH",
    "timezone": "Asia/Gaza",
    "countryCode": "PS"
  },
  {
    "name": "Jerusalem (Quds)",
    "iso2": "JEM",
    "timezone": "Asia/Gaza",
    "countryCode": "PS"
  },
  {
    "name": "Khan Yunis",
    "iso2": "KYS",
    "timezone": "Asia/Gaza",
    "countryCode": "PS"
  },
  {
    "name": "Nablus",
    "iso2": "NBS",
    "timezone": "Asia/Gaza",
    "countryCode": "PS"
  },
  {
    "name": "North Gaza",
    "iso2": "NGZ",
    "timezone": "Asia/Gaza",
    "countryCode": "PS"
  },
  {
    "name": "Qalqilya",
    "iso2": "QQA",
    "timezone": "Asia/Gaza",
    "countryCode": "PS"
  },
  {
    "name": "Rafah",
    "iso2": "RFH",
    "timezone": "Asia/Gaza",
    "countryCode": "PS"
  },
  {
    "name": "Ramallah",
    "iso2": "RBH",
    "timezone": "Asia/Gaza",
    "countryCode": "PS"
  },
  {
    "name": "Salfit",
    "iso2": "SLT",
    "timezone": "Asia/Gaza",
    "countryCode": "PS"
  },
  {
    "name": "Tubas",
    "iso2": "TBS",
    "timezone": "Asia/Gaza",
    "countryCode": "PS"
  },
  {
    "name": "Tulkarm",
    "iso2": "TKM",
    "timezone": "Asia/Gaza",
    "countryCode": "PS"
  },
  {
    "name": "Bocas del Toro",
    "iso2": "1",
    "timezone": "America/Panama",
    "countryCode": "PA"
  },
  {
    "name": "Chiriquí Province",
    "iso2": "4",
    "timezone": "America/Panama",
    "countryCode": "PA"
  },
  {
    "name": "Coclé",
    "iso2": "2",
    "timezone": "America/Panama",
    "countryCode": "PA"
  },
  {
    "name": "Colón",
    "iso2": "3",
    "timezone": "America/Panama",
    "countryCode": "PA"
  },
  {
    "name": "Darién",
    "iso2": "5",
    "timezone": "America/Panama",
    "countryCode": "PA"
  },
  {
    "name": "Emberá-Wounaan Comarca",
    "iso2": "EM",
    "timezone": "America/Panama",
    "countryCode": "PA"
  },
  {
    "name": "Guna",
    "iso2": "KY",
    "timezone": "America/Panama",
    "countryCode": "PA"
  },
  {
    "name": "Herrera",
    "iso2": "6",
    "timezone": "America/Panama",
    "countryCode": "PA"
  },
  {
    "name": "Los Santos",
    "iso2": "7",
    "timezone": "America/Panama",
    "countryCode": "PA"
  },
  {
    "name": "Naso Tjër Di",
    "iso2": "NT",
    "timezone": "America/Panama",
    "countryCode": "PA"
  },
  {
    "name": "Ngöbe-Buglé Comarca",
    "iso2": "NB",
    "timezone": "America/Panama",
    "countryCode": "PA"
  },
  {
    "name": "Panamá",
    "iso2": "8",
    "timezone": "America/Panama",
    "countryCode": "PA"
  },
  {
    "name": "Panamá Oeste",
    "iso2": "10",
    "timezone": "America/Panama",
    "countryCode": "PA"
  },
  {
    "name": "Veraguas",
    "iso2": "9",
    "timezone": "America/Panama",
    "countryCode": "PA"
  },
  {
    "name": "Bougainville",
    "iso2": "NSB",
    "timezone": "Pacific/Bougainville",
    "countryCode": "PG"
  },
  {
    "name": "Central",
    "iso2": "CPM",
    "timezone": "Pacific/Bougainville",
    "countryCode": "PG"
  },
  {
    "name": "Chimbu",
    "iso2": "CPK",
    "timezone": "Pacific/Bougainville",
    "countryCode": "PG"
  },
  {
    "name": "East New Britain",
    "iso2": "EBR",
    "timezone": "Pacific/Bougainville",
    "countryCode": "PG"
  },
  {
    "name": "East Sepik",
    "iso2": "ESW",
    "timezone": "Pacific/Bougainville",
    "countryCode": "PG"
  },
  {
    "name": "Eastern Highlands",
    "iso2": "EHG",
    "timezone": "Pacific/Bougainville",
    "countryCode": "PG"
  },
  {
    "name": "Enga",
    "iso2": "EPW",
    "timezone": "Pacific/Bougainville",
    "countryCode": "PG"
  },
  {
    "name": "Gulf",
    "iso2": "GPK",
    "timezone": "Pacific/Bougainville",
    "countryCode": "PG"
  },
  {
    "name": "Hela",
    "iso2": "HLA",
    "timezone": "Pacific/Bougainville",
    "countryCode": "PG"
  },
  {
    "name": "Jiwaka",
    "iso2": "JWK",
    "timezone": "Pacific/Bougainville",
    "countryCode": "PG"
  },
  {
    "name": "Madang",
    "iso2": "MPM",
    "timezone": "Pacific/Bougainville",
    "countryCode": "PG"
  },
  {
    "name": "Manus",
    "iso2": "MRL",
    "timezone": "Pacific/Bougainville",
    "countryCode": "PG"
  },
  {
    "name": "Milne Bay",
    "iso2": "MBA",
    "timezone": "Pacific/Bougainville",
    "countryCode": "PG"
  },
  {
    "name": "Morobe",
    "iso2": "MPL",
    "timezone": "Pacific/Bougainville",
    "countryCode": "PG"
  },
  {
    "name": "New Ireland",
    "iso2": "NIK",
    "timezone": "Pacific/Bougainville",
    "countryCode": "PG"
  },
  {
    "name": "Oro",
    "iso2": "NPP",
    "timezone": "Pacific/Bougainville",
    "countryCode": "PG"
  },
  {
    "name": "Port Moresby",
    "iso2": "NCD",
    "timezone": "Pacific/Bougainville",
    "countryCode": "PG"
  },
  {
    "name": "Sandaun",
    "iso2": "SAN",
    "timezone": "Pacific/Bougainville",
    "countryCode": "PG"
  },
  {
    "name": "Southern Highlands",
    "iso2": "SHM",
    "timezone": "Pacific/Bougainville",
    "countryCode": "PG"
  },
  {
    "name": "West New Britain",
    "iso2": "WBK",
    "timezone": "Pacific/Bougainville",
    "countryCode": "PG"
  },
  {
    "name": "Western",
    "iso2": "WPD",
    "timezone": "Pacific/Bougainville",
    "countryCode": "PG"
  },
  {
    "name": "Western Highlands",
    "iso2": "WHM",
    "timezone": "Pacific/Bougainville",
    "countryCode": "PG"
  },
  {
    "name": "Alto Paraguay",
    "iso2": "16",
    "timezone": "America/Asuncion",
    "countryCode": "PY"
  },
  {
    "name": "Alto Paraná",
    "iso2": "10",
    "timezone": "America/Asuncion",
    "countryCode": "PY"
  },
  {
    "name": "Amambay",
    "iso2": "13",
    "timezone": "America/Asuncion",
    "countryCode": "PY"
  },
  {
    "name": "Asuncion",
    "iso2": "ASU",
    "timezone": "America/Asuncion",
    "countryCode": "PY"
  },
  {
    "name": "Boquerón",
    "iso2": "19",
    "timezone": "America/Asuncion",
    "countryCode": "PY"
  },
  {
    "name": "Caaguazú",
    "iso2": "5",
    "timezone": "America/Asuncion",
    "countryCode": "PY"
  },
  {
    "name": "Caazapá",
    "iso2": "6",
    "timezone": "America/Asuncion",
    "countryCode": "PY"
  },
  {
    "name": "Canindeyú",
    "iso2": "14",
    "timezone": "America/Asuncion",
    "countryCode": "PY"
  },
  {
    "name": "Central",
    "iso2": "11",
    "timezone": "America/Asuncion",
    "countryCode": "PY"
  },
  {
    "name": "Concepción",
    "iso2": "1",
    "timezone": "America/Asuncion",
    "countryCode": "PY"
  },
  {
    "name": "Cordillera",
    "iso2": "3",
    "timezone": "America/Asuncion",
    "countryCode": "PY"
  },
  {
    "name": "Guairá",
    "iso2": "4",
    "timezone": "America/Asuncion",
    "countryCode": "PY"
  },
  {
    "name": "Itapúa",
    "iso2": "7",
    "timezone": "America/Asuncion",
    "countryCode": "PY"
  },
  {
    "name": "Misiones",
    "iso2": "8",
    "timezone": "America/Asuncion",
    "countryCode": "PY"
  },
  {
    "name": "Ñeembucú",
    "iso2": "12",
    "timezone": "America/Asuncion",
    "countryCode": "PY"
  },
  {
    "name": "Paraguarí",
    "iso2": "9",
    "timezone": "America/Asuncion",
    "countryCode": "PY"
  },
  {
    "name": "Presidente Hayes",
    "iso2": "15",
    "timezone": "America/Asuncion",
    "countryCode": "PY"
  },
  {
    "name": "San Pedro",
    "iso2": "2",
    "timezone": "America/Asuncion",
    "countryCode": "PY"
  },
  {
    "name": "Amazonas",
    "iso2": "AMA",
    "timezone": "America/Lima",
    "countryCode": "PE"
  },
  {
    "name": "Áncash",
    "iso2": "ANC",
    "timezone": "America/Lima",
    "countryCode": "PE"
  },
  {
    "name": "Apurímac",
    "iso2": "APU",
    "timezone": "America/Lima",
    "countryCode": "PE"
  },
  {
    "name": "Arequipa",
    "iso2": "ARE",
    "timezone": "America/Lima",
    "countryCode": "PE"
  },
  {
    "name": "Ayacucho",
    "iso2": "AYA",
    "timezone": "America/Lima",
    "countryCode": "PE"
  },
  {
    "name": "Cajamarca",
    "iso2": "CAJ",
    "timezone": "America/Lima",
    "countryCode": "PE"
  },
  {
    "name": "Callao",
    "iso2": "CAL",
    "timezone": "America/Lima",
    "countryCode": "PE"
  },
  {
    "name": "Cusco",
    "iso2": "CUS",
    "timezone": "America/Lima",
    "countryCode": "PE"
  },
  {
    "name": "Huancavelica",
    "iso2": "HUV",
    "timezone": "America/Lima",
    "countryCode": "PE"
  },
  {
    "name": "Huanuco",
    "iso2": "HUC",
    "timezone": "America/Lima",
    "countryCode": "PE"
  },
  {
    "name": "Ica",
    "iso2": "ICA",
    "timezone": "America/Lima",
    "countryCode": "PE"
  },
  {
    "name": "Junín",
    "iso2": "JUN",
    "timezone": "America/Lima",
    "countryCode": "PE"
  },
  {
    "name": "La Libertad",
    "iso2": "LAL",
    "timezone": "America/Lima",
    "countryCode": "PE"
  },
  {
    "name": "Lambayeque",
    "iso2": "LAM",
    "timezone": "America/Lima",
    "countryCode": "PE"
  },
  {
    "name": "Lima",
    "iso2": "LIM",
    "timezone": "America/Lima",
    "countryCode": "PE"
  },
  {
    "name": "Loreto",
    "iso2": "LOR",
    "timezone": "America/Lima",
    "countryCode": "PE"
  },
  {
    "name": "Madre de Dios",
    "iso2": "MDD",
    "timezone": "America/Lima",
    "countryCode": "PE"
  },
  {
    "name": "Moquegua",
    "iso2": "MOQ",
    "timezone": "America/Lima",
    "countryCode": "PE"
  },
  {
    "name": "Municipalidad Metropolitana de Lima",
    "iso2": "LMA",
    "timezone": "America/Lima",
    "countryCode": "PE"
  },
  {
    "name": "Pasco",
    "iso2": "PAS",
    "timezone": "America/Lima",
    "countryCode": "PE"
  },
  {
    "name": "Piura",
    "iso2": "PIU",
    "timezone": "America/Lima",
    "countryCode": "PE"
  },
  {
    "name": "Puno",
    "iso2": "PUN",
    "timezone": "America/Lima",
    "countryCode": "PE"
  },
  {
    "name": "San Martín",
    "iso2": "SAM",
    "timezone": "America/Lima",
    "countryCode": "PE"
  },
  {
    "name": "Tacna",
    "iso2": "TAC",
    "timezone": "America/Lima",
    "countryCode": "PE"
  },
  {
    "name": "Tumbes",
    "iso2": "TUM",
    "timezone": "America/Lima",
    "countryCode": "PE"
  },
  {
    "name": "Ucayali",
    "iso2": "UCA",
    "timezone": "America/Lima",
    "countryCode": "PE"
  },
  {
    "name": "Abra",
    "iso2": "ABR",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Agusan del Norte",
    "iso2": "AGN",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Agusan del Sur",
    "iso2": "AGS",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Aklan",
    "iso2": "AKL",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Albay",
    "iso2": "ALB",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Antique",
    "iso2": "ANT",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Apayao",
    "iso2": "APA",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Aurora",
    "iso2": "AUR",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Autonomous Region in Muslim Mindanao",
    "iso2": "14",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Basilan",
    "iso2": "BAS",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Bataan",
    "iso2": "BAN",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Batanes",
    "iso2": "BTN",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Batangas",
    "iso2": "BTG",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Benguet",
    "iso2": "BEN",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Bicol",
    "iso2": "05",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Biliran",
    "iso2": "BIL",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Bohol",
    "iso2": "BOH",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Bukidnon",
    "iso2": "BUK",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Bulacan",
    "iso2": "BUL",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Cagayan",
    "iso2": "CAG",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Cagayan Valley",
    "iso2": "02",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Calabarzon",
    "iso2": "40",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Camarines Norte",
    "iso2": "CAN",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Camarines Sur",
    "iso2": "CAS",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Camiguin",
    "iso2": "CAM",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Capiz",
    "iso2": "CAP",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Caraga",
    "iso2": "13",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Catanduanes",
    "iso2": "CAT",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Cavite",
    "iso2": "CAV",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Cebu",
    "iso2": "CEB",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Central Luzon",
    "iso2": "03",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Central Visayas",
    "iso2": "07",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Cordillera Administrative",
    "iso2": "15",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Cotabato",
    "iso2": "NCO",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Davao",
    "iso2": "11",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Davao de Oro",
    "iso2": "COM",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Davao del Norte",
    "iso2": "DAV",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Davao del Sur",
    "iso2": "DAS",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Davao Occidental",
    "iso2": "DVO",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Davao Oriental",
    "iso2": "DAO",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Dinagat Islands",
    "iso2": "DIN",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Eastern Samar",
    "iso2": "EAS",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Eastern Visayas",
    "iso2": "08",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Guimaras",
    "iso2": "GUI",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Ifugao",
    "iso2": "IFU",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Ilocos",
    "iso2": "01",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Ilocos Norte",
    "iso2": "ILN",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Ilocos Sur",
    "iso2": "ILS",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Iloilo",
    "iso2": "ILI",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Isabela",
    "iso2": "ISA",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Kalinga",
    "iso2": "KAL",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "La Union",
    "iso2": "LUN",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Laguna",
    "iso2": "LAG",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Lanao del Norte",
    "iso2": "LAN",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Lanao del Sur",
    "iso2": "LAS",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Leyte",
    "iso2": "LEY",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Maguindanao del Norte",
    "iso2": "MGN",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Maguindanao del Sur",
    "iso2": "MGS",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Marinduque",
    "iso2": "MAD",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Masbate",
    "iso2": "MAS",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Mimaropa",
    "iso2": "41",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Misamis Occidental",
    "iso2": "MSC",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Misamis Oriental",
    "iso2": "MSR",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Mountain Province",
    "iso2": "MOU",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "National Capital Region (Metro Manila)",
    "iso2": "00",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Negros Occidental",
    "iso2": "NEC",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Negros Oriental",
    "iso2": "NER",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Northern Mindanao",
    "iso2": "10",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Northern Samar",
    "iso2": "NSA",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Nueva Ecija",
    "iso2": "NUE",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Nueva Vizcaya",
    "iso2": "NUV",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Occidental Mindoro",
    "iso2": "MDC",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Oriental Mindoro",
    "iso2": "MDR",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Palawan",
    "iso2": "PLW",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Pampanga",
    "iso2": "PAM",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Pangasinan",
    "iso2": "PAN",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Quezon",
    "iso2": "QUE",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Quirino",
    "iso2": "QUI",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Rizal",
    "iso2": "RIZ",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Romblon",
    "iso2": "ROM",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Sarangani",
    "iso2": "SAR",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Siquijor",
    "iso2": "SIG",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Soccsksargen",
    "iso2": "12",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Sorsogon",
    "iso2": "SOR",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "South Cotabato",
    "iso2": "SCO",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Southern Leyte",
    "iso2": "SLE",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Sultan Kudarat",
    "iso2": "SUK",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Sulu",
    "iso2": "SLU",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Surigao del Norte",
    "iso2": "SUN",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Surigao del Sur",
    "iso2": "SUR",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Tarlac",
    "iso2": "TAR",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Tawi-Tawi",
    "iso2": "TAW",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Western Samar",
    "iso2": "WSA",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Western Visayas",
    "iso2": "06",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Zambales",
    "iso2": "ZMB",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Zamboanga del Norte",
    "iso2": "ZAN",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Zamboanga del Sur",
    "iso2": "ZAS",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Zamboanga Peninsula",
    "iso2": "09",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Zamboanga Sibugay",
    "iso2": "ZSI",
    "timezone": "Asia/Manila",
    "countryCode": "PH"
  },
  {
    "name": "Greater Poland",
    "iso2": "30",
    "timezone": "Europe/Warsaw",
    "countryCode": "PL"
  },
  {
    "name": "Holy Cross",
    "iso2": "26",
    "timezone": "Europe/Warsaw",
    "countryCode": "PL"
  },
  {
    "name": "Kuyavia-Pomerania",
    "iso2": "04",
    "timezone": "Europe/Warsaw",
    "countryCode": "PL"
  },
  {
    "name": "Lesser Poland",
    "iso2": "12",
    "timezone": "Europe/Warsaw",
    "countryCode": "PL"
  },
  {
    "name": "Lower Silesia",
    "iso2": "02",
    "timezone": "Europe/Warsaw",
    "countryCode": "PL"
  },
  {
    "name": "Lublin",
    "iso2": "06",
    "timezone": "Europe/Warsaw",
    "countryCode": "PL"
  },
  {
    "name": "Lubusz",
    "iso2": "08",
    "timezone": "Europe/Warsaw",
    "countryCode": "PL"
  },
  {
    "name": "Łódź",
    "iso2": "10",
    "timezone": "Europe/Warsaw",
    "countryCode": "PL"
  },
  {
    "name": "Mazovia",
    "iso2": "14",
    "timezone": "Europe/Warsaw",
    "countryCode": "PL"
  },
  {
    "name": "Podlaskie",
    "iso2": "20",
    "timezone": "Europe/Warsaw",
    "countryCode": "PL"
  },
  {
    "name": "Pomerania",
    "iso2": "22",
    "timezone": "Europe/Warsaw",
    "countryCode": "PL"
  },
  {
    "name": "Silesia",
    "iso2": "24",
    "timezone": "Europe/Warsaw",
    "countryCode": "PL"
  },
  {
    "name": "Subcarpathia",
    "iso2": "18",
    "timezone": "Europe/Warsaw",
    "countryCode": "PL"
  },
  {
    "name": "Upper Silesia",
    "iso2": "16",
    "timezone": "Europe/Warsaw",
    "countryCode": "PL"
  },
  {
    "name": "Warmia-Masuria",
    "iso2": "28",
    "timezone": "Europe/Warsaw",
    "countryCode": "PL"
  },
  {
    "name": "West Pomerania",
    "iso2": "32",
    "timezone": "Europe/Warsaw",
    "countryCode": "PL"
  },
  {
    "name": "Açores",
    "iso2": "20",
    "timezone": "Atlantic/Azores",
    "countryCode": "PT"
  },
  {
    "name": "Aveiro",
    "iso2": "01",
    "timezone": "Europe/Lisbon",
    "countryCode": "PT"
  },
  {
    "name": "Beja",
    "iso2": "02",
    "timezone": "Europe/Lisbon",
    "countryCode": "PT"
  },
  {
    "name": "Braga",
    "iso2": "03",
    "timezone": "Europe/Lisbon",
    "countryCode": "PT"
  },
  {
    "name": "Bragança",
    "iso2": "04",
    "timezone": "Europe/Lisbon",
    "countryCode": "PT"
  },
  {
    "name": "Castelo Branco",
    "iso2": "05",
    "timezone": "Europe/Lisbon",
    "countryCode": "PT"
  },
  {
    "name": "Coimbra",
    "iso2": "06",
    "timezone": "Europe/Lisbon",
    "countryCode": "PT"
  },
  {
    "name": "Évora",
    "iso2": "07",
    "timezone": "Europe/Lisbon",
    "countryCode": "PT"
  },
  {
    "name": "Faro",
    "iso2": "08",
    "timezone": "Europe/Lisbon",
    "countryCode": "PT"
  },
  {
    "name": "Guarda",
    "iso2": "09",
    "timezone": "Europe/Lisbon",
    "countryCode": "PT"
  },
  {
    "name": "Leiria",
    "iso2": "10",
    "timezone": "Europe/Lisbon",
    "countryCode": "PT"
  },
  {
    "name": "Lisbon",
    "iso2": "11",
    "timezone": "Europe/Lisbon",
    "countryCode": "PT"
  },
  {
    "name": "Madeira",
    "iso2": "30",
    "timezone": "Europe/Lisbon",
    "countryCode": "PT"
  },
  {
    "name": "Portalegre",
    "iso2": "12",
    "timezone": "Europe/Lisbon",
    "countryCode": "PT"
  },
  {
    "name": "Porto",
    "iso2": "13",
    "timezone": "Europe/Lisbon",
    "countryCode": "PT"
  },
  {
    "name": "Santarém",
    "iso2": "14",
    "timezone": "Europe/Lisbon",
    "countryCode": "PT"
  },
  {
    "name": "Setúbal",
    "iso2": "15",
    "timezone": "Europe/Lisbon",
    "countryCode": "PT"
  },
  {
    "name": "Viana do Castelo",
    "iso2": "16",
    "timezone": "Europe/Lisbon",
    "countryCode": "PT"
  },
  {
    "name": "Vila Real",
    "iso2": "17",
    "timezone": "Europe/Lisbon",
    "countryCode": "PT"
  },
  {
    "name": "Viseu",
    "iso2": "18",
    "timezone": "Europe/Lisbon",
    "countryCode": "PT"
  },
  {
    "name": "Adjuntas",
    "iso2": "001",
    "timezone": "America/Puerto_Rico",
    "countryCode": "PR"
  },
  {
    "name": "Aguada",
    "iso2": "003",
    "timezone": "America/Puerto_Rico",
    "countryCode": "PR"
  },
  {
    "name": "Aguadilla",
    "iso2": "005",
    "timezone": "America/Puerto_Rico",
    "countryCode": "PR"
  },
  {
    "name": "Aguas Buenas",
    "iso2": "007",
    "timezone": "America/Puerto_Rico",
    "countryCode": "PR"
  },
  {
    "name": "Aibonito",
    "iso2": "009",
    "timezone": "America/Puerto_Rico",
    "countryCode": "PR"
  },
  {
    "name": "Añasco",
    "iso2": "011",
    "timezone": "America/Puerto_Rico",
    "countryCode": "PR"
  },
  {
    "name": "Arecibo",
    "iso2": "AR",
    "timezone": "America/Puerto_Rico",
    "countryCode": "PR"
  },
  {
    "name": "Arroyo",
    "iso2": "015",
    "timezone": "America/Puerto_Rico",
    "countryCode": "PR"
  },
  {
    "name": "Barceloneta",
    "iso2": "017",
    "timezone": "America/Puerto_Rico",
    "countryCode": "PR"
  },
  {
    "name": "Barranquitas",
    "iso2": "019",
    "timezone": "America/Puerto_Rico",
    "countryCode": "PR"
  },
  {
    "name": "Bayamon",
    "iso2": "BY",
    "timezone": "America/Puerto_Rico",
    "countryCode": "PR"
  },
  {
    "name": "Cabo Rojo",
    "iso2": "023",
    "timezone": "America/Puerto_Rico",
    "countryCode": "PR"
  },
  {
    "name": "Caguas",
    "iso2": "CG",
    "timezone": "America/Puerto_Rico",
    "countryCode": "PR"
  },
  {
    "name": "Camuy",
    "iso2": "027",
    "timezone": "America/Puerto_Rico",
    "countryCode": "PR"
  },
  {
    "name": "Canóvanas",
    "iso2": "029",
    "timezone": "America/Puerto_Rico",
    "countryCode": "PR"
  },
  {
    "name": "Carolina",
    "iso2": "CL",
    "timezone": "America/Puerto_Rico",
    "countryCode": "PR"
  },
  {
    "name": "Cataño",
    "iso2": "033",
    "timezone": "America/Puerto_Rico",
    "countryCode": "PR"
  },
  {
    "name": "Cayey",
    "iso2": "035",
    "timezone": "America/Puerto_Rico",
    "countryCode": "PR"
  },
  {
    "name": "Ceiba",
    "iso2": "037",
    "timezone": "America/Puerto_Rico",
    "countryCode": "PR"
  },
  {
    "name": "Ciales",
    "iso2": "039",
    "timezone": "America/Puerto_Rico",
    "countryCode": "PR"
  },
  {
    "name": "Cidra",
    "iso2": "041",
    "timezone": "America/Puerto_Rico",
    "countryCode": "PR"
  },
  {
    "name": "Coamo",
    "iso2": "043",
    "timezone": "America/Puerto_Rico",
    "countryCode": "PR"
  },
  {
    "name": "Comerío",
    "iso2": "045",
    "timezone": "America/Puerto_Rico",
    "countryCode": "PR"
  },
  {
    "name": "Corozal",
    "iso2": "047",
    "timezone": "America/Puerto_Rico",
    "countryCode": "PR"
  },
  {
    "name": "Culebra",
    "iso2": "049",
    "timezone": "America/Puerto_Rico",
    "countryCode": "PR"
  },
  {
    "name": "Dorado",
    "iso2": "051",
    "timezone": "America/Puerto_Rico",
    "countryCode": "PR"
  },
  {
    "name": "Fajardo",
    "iso2": "053",
    "timezone": "America/Puerto_Rico",
    "countryCode": "PR"
  },
  {
    "name": "Florida",
    "iso2": "054",
    "timezone": "America/Puerto_Rico",
    "countryCode": "PR"
  },
  {
    "name": "Guánica",
    "iso2": "055",
    "timezone": "America/Puerto_Rico",
    "countryCode": "PR"
  },
  {
    "name": "Guayama",
    "iso2": "057",
    "timezone": "America/Puerto_Rico",
    "countryCode": "PR"
  },
  {
    "name": "Guayanilla",
    "iso2": "059",
    "timezone": "America/Puerto_Rico",
    "countryCode": "PR"
  },
  {
    "name": "Guaynabo",
    "iso2": "GN",
    "timezone": "America/Puerto_Rico",
    "countryCode": "PR"
  },
  {
    "name": "Gurabo",
    "iso2": "063",
    "timezone": "America/Puerto_Rico",
    "countryCode": "PR"
  },
  {
    "name": "Hatillo",
    "iso2": "065",
    "timezone": "America/Puerto_Rico",
    "countryCode": "PR"
  },
  {
    "name": "Hormigueros",
    "iso2": "067",
    "timezone": "America/Puerto_Rico",
    "countryCode": "PR"
  },
  {
    "name": "Humacao",
    "iso2": "069",
    "timezone": "America/Puerto_Rico",
    "countryCode": "PR"
  },
  {
    "name": "Isabela",
    "iso2": "071",
    "timezone": "America/Puerto_Rico",
    "countryCode": "PR"
  },
  {
    "name": "Jayuya",
    "iso2": "073",
    "timezone": "America/Puerto_Rico",
    "countryCode": "PR"
  },
  {
    "name": "Juana Díaz",
    "iso2": "075",
    "timezone": "America/Puerto_Rico",
    "countryCode": "PR"
  },
  {
    "name": "Juncos",
    "iso2": "077",
    "timezone": "America/Puerto_Rico",
    "countryCode": "PR"
  },
  {
    "name": "Lajas",
    "iso2": "079",
    "timezone": "America/Puerto_Rico",
    "countryCode": "PR"
  },
  {
    "name": "Lares",
    "iso2": "081",
    "timezone": "America/Puerto_Rico",
    "countryCode": "PR"
  },
  {
    "name": "Las Marías",
    "iso2": "083",
    "timezone": "America/Puerto_Rico",
    "countryCode": "PR"
  },
  {
    "name": "Las Piedras",
    "iso2": "085",
    "timezone": "America/Puerto_Rico",
    "countryCode": "PR"
  },
  {
    "name": "Loíza",
    "iso2": "087",
    "timezone": "America/Puerto_Rico",
    "countryCode": "PR"
  },
  {
    "name": "Luquillo",
    "iso2": "089",
    "timezone": "America/Puerto_Rico",
    "countryCode": "PR"
  },
  {
    "name": "Manatí",
    "iso2": "091",
    "timezone": "America/Puerto_Rico",
    "countryCode": "PR"
  },
  {
    "name": "Maricao",
    "iso2": "093",
    "timezone": "America/Puerto_Rico",
    "countryCode": "PR"
  },
  {
    "name": "Maunabo",
    "iso2": "095",
    "timezone": "America/Puerto_Rico",
    "countryCode": "PR"
  },
  {
    "name": "Mayagüez",
    "iso2": "MG",
    "timezone": "America/Puerto_Rico",
    "countryCode": "PR"
  },
  {
    "name": "Moca",
    "iso2": "099",
    "timezone": "America/Puerto_Rico",
    "countryCode": "PR"
  },
  {
    "name": "Morovis",
    "iso2": "101",
    "timezone": "America/Puerto_Rico",
    "countryCode": "PR"
  },
  {
    "name": "Naguabo",
    "iso2": "103",
    "timezone": "America/Puerto_Rico",
    "countryCode": "PR"
  },
  {
    "name": "Naranjito",
    "iso2": "105",
    "timezone": "America/Puerto_Rico",
    "countryCode": "PR"
  },
  {
    "name": "Orocovis",
    "iso2": "107",
    "timezone": "America/Puerto_Rico",
    "countryCode": "PR"
  },
  {
    "name": "Patillas",
    "iso2": "109",
    "timezone": "America/Puerto_Rico",
    "countryCode": "PR"
  },
  {
    "name": "Peñuelas",
    "iso2": "111",
    "timezone": "America/Puerto_Rico",
    "countryCode": "PR"
  },
  {
    "name": "Ponce",
    "iso2": "PO",
    "timezone": "America/Puerto_Rico",
    "countryCode": "PR"
  },
  {
    "name": "Quebradillas",
    "iso2": "115",
    "timezone": "America/Puerto_Rico",
    "countryCode": "PR"
  },
  {
    "name": "Rincón",
    "iso2": "117",
    "timezone": "America/Puerto_Rico",
    "countryCode": "PR"
  },
  {
    "name": "Río Grande",
    "iso2": "119",
    "timezone": "America/Puerto_Rico",
    "countryCode": "PR"
  },
  {
    "name": "Sabana Grande",
    "iso2": "121",
    "timezone": "America/Puerto_Rico",
    "countryCode": "PR"
  },
  {
    "name": "Salinas",
    "iso2": "123",
    "timezone": "America/Puerto_Rico",
    "countryCode": "PR"
  },
  {
    "name": "San Germán",
    "iso2": "125",
    "timezone": "America/Puerto_Rico",
    "countryCode": "PR"
  },
  {
    "name": "San Juan",
    "iso2": "SJ",
    "timezone": "America/Puerto_Rico",
    "countryCode": "PR"
  },
  {
    "name": "San Lorenzo",
    "iso2": "129",
    "timezone": "America/Puerto_Rico",
    "countryCode": "PR"
  },
  {
    "name": "San Sebastián",
    "iso2": "131",
    "timezone": "America/Puerto_Rico",
    "countryCode": "PR"
  },
  {
    "name": "Santa Isabel",
    "iso2": "133",
    "timezone": "America/Puerto_Rico",
    "countryCode": "PR"
  },
  {
    "name": "Toa Alta",
    "iso2": "135",
    "timezone": "America/Puerto_Rico",
    "countryCode": "PR"
  },
  {
    "name": "Toa Baja",
    "iso2": "TB",
    "timezone": "America/Puerto_Rico",
    "countryCode": "PR"
  },
  {
    "name": "Trujillo Alto",
    "iso2": "TA",
    "timezone": "America/Puerto_Rico",
    "countryCode": "PR"
  },
  {
    "name": "Utuado",
    "iso2": "141",
    "timezone": "America/Puerto_Rico",
    "countryCode": "PR"
  },
  {
    "name": "Vega Alta",
    "iso2": "143",
    "timezone": "America/Puerto_Rico",
    "countryCode": "PR"
  },
  {
    "name": "Vega Baja",
    "iso2": "145",
    "timezone": "America/Puerto_Rico",
    "countryCode": "PR"
  },
  {
    "name": "Vieques",
    "iso2": "147",
    "timezone": "America/Puerto_Rico",
    "countryCode": "PR"
  },
  {
    "name": "Villalba",
    "iso2": "149",
    "timezone": "America/Puerto_Rico",
    "countryCode": "PR"
  },
  {
    "name": "Yabucoa",
    "iso2": "151",
    "timezone": "America/Puerto_Rico",
    "countryCode": "PR"
  },
  {
    "name": "Yauco",
    "iso2": "153",
    "timezone": "America/Puerto_Rico",
    "countryCode": "PR"
  },
  {
    "name": "Al Daayen",
    "iso2": "ZA",
    "timezone": "Asia/Qatar",
    "countryCode": "QA"
  },
  {
    "name": "Al Khor",
    "iso2": "KH",
    "timezone": "Asia/Qatar",
    "countryCode": "QA"
  },
  {
    "name": "Al Rayyan",
    "iso2": "RA",
    "timezone": "Asia/Qatar",
    "countryCode": "QA"
  },
  {
    "name": "Al Wakrah",
    "iso2": "WA",
    "timezone": "Asia/Qatar",
    "countryCode": "QA"
  },
  {
    "name": "Al-Shahaniya",
    "iso2": "SH",
    "timezone": "Asia/Qatar",
    "countryCode": "QA"
  },
  {
    "name": "Doha",
    "iso2": "DA",
    "timezone": "Asia/Qatar",
    "countryCode": "QA"
  },
  {
    "name": "Madinat ash Shamal",
    "iso2": "MS",
    "timezone": "Asia/Qatar",
    "countryCode": "QA"
  },
  {
    "name": "Umm Salal",
    "iso2": "US",
    "timezone": "Asia/Qatar",
    "countryCode": "QA"
  },
  {
    "name": "Saint-Benoît",
    "iso2": "01",
    "timezone": "Indian/Reunion",
    "countryCode": "RE"
  },
  {
    "name": "Saint-Denis",
    "iso2": "02",
    "timezone": "Indian/Reunion",
    "countryCode": "RE"
  },
  {
    "name": "Saint-Paul",
    "iso2": "03",
    "timezone": "Indian/Reunion",
    "countryCode": "RE"
  },
  {
    "name": "Saint-Pierre",
    "iso2": "04",
    "timezone": "Indian/Reunion",
    "countryCode": "RE"
  },
  {
    "name": "Alba",
    "iso2": "AB",
    "timezone": "Europe/Bucharest",
    "countryCode": "RO"
  },
  {
    "name": "Arad",
    "iso2": "AR",
    "timezone": "Europe/Bucharest",
    "countryCode": "RO"
  },
  {
    "name": "Arges",
    "iso2": "AG",
    "timezone": "Europe/Bucharest",
    "countryCode": "RO"
  },
  {
    "name": "Bacău",
    "iso2": "BC",
    "timezone": "Europe/Bucharest",
    "countryCode": "RO"
  },
  {
    "name": "Bihor",
    "iso2": "BH",
    "timezone": "Europe/Bucharest",
    "countryCode": "RO"
  },
  {
    "name": "Bistrița-Năsăud",
    "iso2": "BN",
    "timezone": "Europe/Bucharest",
    "countryCode": "RO"
  },
  {
    "name": "Botoșani",
    "iso2": "BT",
    "timezone": "Europe/Bucharest",
    "countryCode": "RO"
  },
  {
    "name": "Braila",
    "iso2": "BR",
    "timezone": "Europe/Bucharest",
    "countryCode": "RO"
  },
  {
    "name": "Brașov",
    "iso2": "BV",
    "timezone": "Europe/Bucharest",
    "countryCode": "RO"
  },
  {
    "name": "Bucharest",
    "iso2": "B",
    "timezone": "Europe/Bucharest",
    "countryCode": "RO"
  },
  {
    "name": "Buzău",
    "iso2": "BZ",
    "timezone": "Europe/Bucharest",
    "countryCode": "RO"
  },
  {
    "name": "Călărași",
    "iso2": "CL",
    "timezone": "Europe/Bucharest",
    "countryCode": "RO"
  },
  {
    "name": "Caraș-Severin",
    "iso2": "CS",
    "timezone": "Europe/Bucharest",
    "countryCode": "RO"
  },
  {
    "name": "Cluj",
    "iso2": "CJ",
    "timezone": "Europe/Bucharest",
    "countryCode": "RO"
  },
  {
    "name": "Constanța",
    "iso2": "CT",
    "timezone": "Europe/Bucharest",
    "countryCode": "RO"
  },
  {
    "name": "Covasna",
    "iso2": "CV",
    "timezone": "Europe/Bucharest",
    "countryCode": "RO"
  },
  {
    "name": "Dâmbovița",
    "iso2": "DB",
    "timezone": "Europe/Bucharest",
    "countryCode": "RO"
  },
  {
    "name": "Dolj",
    "iso2": "DJ",
    "timezone": "Europe/Bucharest",
    "countryCode": "RO"
  },
  {
    "name": "Galați",
    "iso2": "GL",
    "timezone": "Europe/Bucharest",
    "countryCode": "RO"
  },
  {
    "name": "Giurgiu",
    "iso2": "GR",
    "timezone": "Europe/Bucharest",
    "countryCode": "RO"
  },
  {
    "name": "Gorj",
    "iso2": "GJ",
    "timezone": "Europe/Bucharest",
    "countryCode": "RO"
  },
  {
    "name": "Harghita",
    "iso2": "HR",
    "timezone": "Europe/Bucharest",
    "countryCode": "RO"
  },
  {
    "name": "Hunedoara",
    "iso2": "HD",
    "timezone": "Europe/Bucharest",
    "countryCode": "RO"
  },
  {
    "name": "Ialomița",
    "iso2": "IL",
    "timezone": "Europe/Bucharest",
    "countryCode": "RO"
  },
  {
    "name": "Iași",
    "iso2": "IS",
    "timezone": "Europe/Bucharest",
    "countryCode": "RO"
  },
  {
    "name": "Ilfov",
    "iso2": "IF",
    "timezone": "Europe/Bucharest",
    "countryCode": "RO"
  },
  {
    "name": "Maramureș",
    "iso2": "MM",
    "timezone": "Europe/Bucharest",
    "countryCode": "RO"
  },
  {
    "name": "Mehedinți",
    "iso2": "MH",
    "timezone": "Europe/Bucharest",
    "countryCode": "RO"
  },
  {
    "name": "Mureș",
    "iso2": "MS",
    "timezone": "Europe/Bucharest",
    "countryCode": "RO"
  },
  {
    "name": "Neamț",
    "iso2": "NT",
    "timezone": "Europe/Bucharest",
    "countryCode": "RO"
  },
  {
    "name": "Olt",
    "iso2": "OT",
    "timezone": "Europe/Bucharest",
    "countryCode": "RO"
  },
  {
    "name": "Prahova",
    "iso2": "PH",
    "timezone": "Europe/Bucharest",
    "countryCode": "RO"
  },
  {
    "name": "Sălaj",
    "iso2": "SJ",
    "timezone": "Europe/Bucharest",
    "countryCode": "RO"
  },
  {
    "name": "Satu Mare",
    "iso2": "SM",
    "timezone": "Europe/Bucharest",
    "countryCode": "RO"
  },
  {
    "name": "Sibiu",
    "iso2": "SB",
    "timezone": "Europe/Bucharest",
    "countryCode": "RO"
  },
  {
    "name": "Suceava",
    "iso2": "SV",
    "timezone": "Europe/Bucharest",
    "countryCode": "RO"
  },
  {
    "name": "Teleorman",
    "iso2": "TR",
    "timezone": "Europe/Bucharest",
    "countryCode": "RO"
  },
  {
    "name": "Timiș",
    "iso2": "TM",
    "timezone": "Europe/Bucharest",
    "countryCode": "RO"
  },
  {
    "name": "Tulcea",
    "iso2": "TL",
    "timezone": "Europe/Bucharest",
    "countryCode": "RO"
  },
  {
    "name": "Vâlcea",
    "iso2": "VL",
    "timezone": "Europe/Bucharest",
    "countryCode": "RO"
  },
  {
    "name": "Vaslui",
    "iso2": "VS",
    "timezone": "Europe/Bucharest",
    "countryCode": "RO"
  },
  {
    "name": "Vrancea",
    "iso2": "VN",
    "timezone": "Europe/Bucharest",
    "countryCode": "RO"
  },
  {
    "name": "Adygea",
    "iso2": "AD",
    "timezone": "Europe/Moscow",
    "countryCode": "RU"
  },
  {
    "name": "Altai",
    "iso2": "ALT",
    "timezone": "Europe/Moscow",
    "countryCode": "RU"
  },
  {
    "name": "Altai",
    "iso2": "AL",
    "timezone": "Europe/Moscow",
    "countryCode": "RU"
  },
  {
    "name": "Amur",
    "iso2": "AMU",
    "timezone": "Europe/Moscow",
    "countryCode": "RU"
  },
  {
    "name": "Arkhangelsk",
    "iso2": "ARK",
    "timezone": "Europe/Moscow",
    "countryCode": "RU"
  },
  {
    "name": "Astrakhan",
    "iso2": "AST",
    "timezone": "Europe/Moscow",
    "countryCode": "RU"
  },
  {
    "name": "Bashkortostan",
    "iso2": "BA",
    "timezone": "Europe/Moscow",
    "countryCode": "RU"
  },
  {
    "name": "Belgorod",
    "iso2": "BEL",
    "timezone": "Europe/Moscow",
    "countryCode": "RU"
  },
  {
    "name": "Bryansk",
    "iso2": "BRY",
    "timezone": "Europe/Moscow",
    "countryCode": "RU"
  },
  {
    "name": "Buryatia",
    "iso2": "BU",
    "timezone": "Europe/Moscow",
    "countryCode": "RU"
  },
  {
    "name": "Chechen",
    "iso2": "CE",
    "timezone": "Europe/Moscow",
    "countryCode": "RU"
  },
  {
    "name": "Chelyabinsk",
    "iso2": "CHE",
    "timezone": "Europe/Moscow",
    "countryCode": "RU"
  },
  {
    "name": "Chukotka",
    "iso2": "CHU",
    "timezone": "Asia/Anadyr",
    "countryCode": "RU"
  },
  {
    "name": "Chuvash",
    "iso2": "CU",
    "timezone": "Europe/Moscow",
    "countryCode": "RU"
  },
  {
    "name": "Dagestan",
    "iso2": "DA",
    "timezone": "Europe/Moscow",
    "countryCode": "RU"
  },
  {
    "name": "Ingushetia",
    "iso2": "IN",
    "timezone": "Europe/Moscow",
    "countryCode": "RU"
  },
  {
    "name": "Irkutsk",
    "iso2": "IRK",
    "timezone": "Asia/Irkutsk",
    "countryCode": "RU"
  },
  {
    "name": "Ivanovo",
    "iso2": "IVA",
    "timezone": "Europe/Moscow",
    "countryCode": "RU"
  },
  {
    "name": "Jewish",
    "iso2": "YEV",
    "timezone": "Europe/Moscow",
    "countryCode": "RU"
  },
  {
    "name": "Kabardino-Balkar",
    "iso2": "KB",
    "timezone": "Europe/Moscow",
    "countryCode": "RU"
  },
  {
    "name": "Kaliningrad",
    "iso2": "KGD",
    "timezone": "Europe/Kaliningrad",
    "countryCode": "RU"
  },
  {
    "name": "Kalmykia",
    "iso2": "KL",
    "timezone": "Europe/Moscow",
    "countryCode": "RU"
  },
  {
    "name": "Kaluga",
    "iso2": "KLU",
    "timezone": "Europe/Moscow",
    "countryCode": "RU"
  },
  {
    "name": "Kamchatka",
    "iso2": "KAM",
    "timezone": "Asia/Kamchatka",
    "countryCode": "RU"
  },
  {
    "name": "Karachay-Cherkess",
    "iso2": "KC",
    "timezone": "Europe/Moscow",
    "countryCode": "RU"
  },
  {
    "name": "Karelia",
    "iso2": "KR",
    "timezone": "Europe/Moscow",
    "countryCode": "RU"
  },
  {
    "name": "Kemerovo",
    "iso2": "KEM",
    "timezone": "Europe/Moscow",
    "countryCode": "RU"
  },
  {
    "name": "Khabarovsk",
    "iso2": "KHA",
    "timezone": "Europe/Moscow",
    "countryCode": "RU"
  },
  {
    "name": "Khakassia",
    "iso2": "KK",
    "timezone": "Europe/Moscow",
    "countryCode": "RU"
  },
  {
    "name": "Khanty-Mansi",
    "iso2": "KHM",
    "timezone": "Europe/Moscow",
    "countryCode": "RU"
  },
  {
    "name": "Kirov",
    "iso2": "KIR",
    "timezone": "Europe/Moscow",
    "countryCode": "RU"
  },
  {
    "name": "Komi",
    "iso2": "KO",
    "timezone": "Europe/Moscow",
    "countryCode": "RU"
  },
  {
    "name": "Kostroma",
    "iso2": "KOS",
    "timezone": "Europe/Moscow",
    "countryCode": "RU"
  },
  {
    "name": "Krasnodar",
    "iso2": "KDA",
    "timezone": "Europe/Moscow",
    "countryCode": "RU"
  },
  {
    "name": "Krasnoyarsk",
    "iso2": "KYA",
    "timezone": "Asia/Krasnoyarsk",
    "countryCode": "RU"
  },
  {
    "name": "Kurgan",
    "iso2": "KGN",
    "timezone": "Europe/Moscow",
    "countryCode": "RU"
  },
  {
    "name": "Kursk",
    "iso2": "KRS",
    "timezone": "Europe/Moscow",
    "countryCode": "RU"
  },
  {
    "name": "Leningrad",
    "iso2": "LEN",
    "timezone": "Europe/Moscow",
    "countryCode": "RU"
  },
  {
    "name": "Lipetsk",
    "iso2": "LIP",
    "timezone": "Europe/Moscow",
    "countryCode": "RU"
  },
  {
    "name": "Magadan",
    "iso2": "MAG",
    "timezone": "Asia/Magadan",
    "countryCode": "RU"
  },
  {
    "name": "Mari El",
    "iso2": "ME",
    "timezone": "Europe/Moscow",
    "countryCode": "RU"
  },
  {
    "name": "Mordovia",
    "iso2": "MO",
    "timezone": "Europe/Moscow",
    "countryCode": "RU"
  },
  {
    "name": "Moscow",
    "iso2": "MOS",
    "timezone": "Europe/Moscow",
    "countryCode": "RU"
  },
  {
    "name": "Moscow",
    "iso2": "MOW",
    "timezone": "Europe/Moscow",
    "countryCode": "RU"
  },
  {
    "name": "Murmansk",
    "iso2": "MUR",
    "timezone": "Europe/Moscow",
    "countryCode": "RU"
  },
  {
    "name": "Nenets",
    "iso2": "NEN",
    "timezone": "Europe/Moscow",
    "countryCode": "RU"
  },
  {
    "name": "Nizhny Novgorod",
    "iso2": "NIZ",
    "timezone": "Europe/Moscow",
    "countryCode": "RU"
  },
  {
    "name": "North Ossetia-Alania",
    "iso2": "SE",
    "timezone": "Europe/Moscow",
    "countryCode": "RU"
  },
  {
    "name": "Novgorod",
    "iso2": "NGR",
    "timezone": "Europe/Moscow",
    "countryCode": "RU"
  },
  {
    "name": "Novosibirsk",
    "iso2": "NVS",
    "timezone": "Europe/Moscow",
    "countryCode": "RU"
  },
  {
    "name": "Omsk",
    "iso2": "OMS",
    "timezone": "Asia/Omsk",
    "countryCode": "RU"
  },
  {
    "name": "Orenburg",
    "iso2": "ORE",
    "timezone": "Europe/Moscow",
    "countryCode": "RU"
  },
  {
    "name": "Oryol",
    "iso2": "ORL",
    "timezone": "Europe/Moscow",
    "countryCode": "RU"
  },
  {
    "name": "Penza",
    "iso2": "PNZ",
    "timezone": "Europe/Moscow",
    "countryCode": "RU"
  },
  {
    "name": "Perm",
    "iso2": "PER",
    "timezone": "Europe/Moscow",
    "countryCode": "RU"
  },
  {
    "name": "Primorsky",
    "iso2": "PRI",
    "timezone": "Europe/Moscow",
    "countryCode": "RU"
  },
  {
    "name": "Pskov",
    "iso2": "PSK",
    "timezone": "Europe/Moscow",
    "countryCode": "RU"
  },
  {
    "name": "Rostov",
    "iso2": "ROS",
    "timezone": "Europe/Moscow",
    "countryCode": "RU"
  },
  {
    "name": "Ryazan",
    "iso2": "RYA",
    "timezone": "Europe/Moscow",
    "countryCode": "RU"
  },
  {
    "name": "Saint Petersburg",
    "iso2": "SPE",
    "timezone": "Europe/Moscow",
    "countryCode": "RU"
  },
  {
    "name": "Sakha",
    "iso2": "SA",
    "timezone": "Europe/Moscow",
    "countryCode": "RU"
  },
  {
    "name": "Sakhalin",
    "iso2": "SAK",
    "timezone": "Asia/Sakhalin",
    "countryCode": "RU"
  },
  {
    "name": "Samara",
    "iso2": "SAM",
    "timezone": "Europe/Samara",
    "countryCode": "RU"
  },
  {
    "name": "Saratov",
    "iso2": "SAR",
    "timezone": "Europe/Moscow",
    "countryCode": "RU"
  },
  {
    "name": "Smolensk",
    "iso2": "SMO",
    "timezone": "Europe/Moscow",
    "countryCode": "RU"
  },
  {
    "name": "Stavropol",
    "iso2": "STA",
    "timezone": "Europe/Moscow",
    "countryCode": "RU"
  },
  {
    "name": "Sverdlovsk",
    "iso2": "SVE",
    "timezone": "Europe/Moscow",
    "countryCode": "RU"
  },
  {
    "name": "Tambov",
    "iso2": "TAM",
    "timezone": "Europe/Moscow",
    "countryCode": "RU"
  },
  {
    "name": "Tatarstan",
    "iso2": "TA",
    "timezone": "Europe/Moscow",
    "countryCode": "RU"
  },
  {
    "name": "Tomsk",
    "iso2": "TOM",
    "timezone": "Europe/Moscow",
    "countryCode": "RU"
  },
  {
    "name": "Tula",
    "iso2": "TUL",
    "timezone": "Europe/Moscow",
    "countryCode": "RU"
  },
  {
    "name": "Tuva",
    "iso2": "TY",
    "timezone": "Europe/Moscow",
    "countryCode": "RU"
  },
  {
    "name": "Tver",
    "iso2": "TVE",
    "timezone": "Europe/Moscow",
    "countryCode": "RU"
  },
  {
    "name": "Tyumen",
    "iso2": "TYU",
    "timezone": "Europe/Moscow",
    "countryCode": "RU"
  },
  {
    "name": "Udmurt",
    "iso2": "UD",
    "timezone": "Europe/Moscow",
    "countryCode": "RU"
  },
  {
    "name": "Ulyanovsk",
    "iso2": "ULY",
    "timezone": "Europe/Moscow",
    "countryCode": "RU"
  },
  {
    "name": "Vladimir",
    "iso2": "VLA",
    "timezone": "Europe/Moscow",
    "countryCode": "RU"
  },
  {
    "name": "Volgograd Oblast",
    "iso2": "VGG",
    "timezone": "Europe/Moscow",
    "countryCode": "RU"
  },
  {
    "name": "Vologda",
    "iso2": "VLG",
    "timezone": "Europe/Moscow",
    "countryCode": "RU"
  },
  {
    "name": "Voronezh",
    "iso2": "VOR",
    "timezone": "Europe/Moscow",
    "countryCode": "RU"
  },
  {
    "name": "Yamalo-Nenets",
    "iso2": "YAN",
    "timezone": "Europe/Moscow",
    "countryCode": "RU"
  },
  {
    "name": "Yaroslavl",
    "iso2": "YAR",
    "timezone": "Europe/Moscow",
    "countryCode": "RU"
  },
  {
    "name": "Zabaykalsky",
    "iso2": "ZAB",
    "timezone": "Europe/Moscow",
    "countryCode": "RU"
  },
  {
    "name": "Eastern",
    "iso2": "02",
    "timezone": "Africa/Kigali",
    "countryCode": "RW"
  },
  {
    "name": "Kigali",
    "iso2": "01",
    "timezone": "Africa/Kigali",
    "countryCode": "RW"
  },
  {
    "name": "Northern",
    "iso2": "03",
    "timezone": "Africa/Kigali",
    "countryCode": "RW"
  },
  {
    "name": "Southern",
    "iso2": "05",
    "timezone": "Africa/Kigali",
    "countryCode": "RW"
  },
  {
    "name": "Western",
    "iso2": "04",
    "timezone": "Africa/Kigali",
    "countryCode": "RW"
  },
  {
    "name": "Alarm Forest",
    "iso2": "01",
    "timezone": "Atlantic/St_Helena",
    "countryCode": "SH"
  },
  {
    "name": "Blue Hill",
    "iso2": "02",
    "timezone": "Atlantic/St_Helena",
    "countryCode": "SH"
  },
  {
    "name": "Half Tree Hollow",
    "iso2": "03",
    "timezone": "Atlantic/St_Helena",
    "countryCode": "SH"
  },
  {
    "name": "Jamestown",
    "iso2": "04",
    "timezone": "Atlantic/St_Helena",
    "countryCode": "SH"
  },
  {
    "name": "Levelwood",
    "iso2": "05",
    "timezone": "Atlantic/St_Helena",
    "countryCode": "SH"
  },
  {
    "name": "Longwood",
    "iso2": "06",
    "timezone": "Atlantic/St_Helena",
    "countryCode": "SH"
  },
  {
    "name": "Saint Paul's",
    "iso2": "08",
    "timezone": "Atlantic/St_Helena",
    "countryCode": "SH"
  },
  {
    "name": "Sandy Bay",
    "iso2": "07",
    "timezone": "Atlantic/St_Helena",
    "countryCode": "SH"
  },
  {
    "name": "Christ Church Nichola Town",
    "iso2": "01",
    "timezone": "America/St_Kitts",
    "countryCode": "KN"
  },
  {
    "name": "Nevis",
    "iso2": "N",
    "timezone": "America/St_Kitts",
    "countryCode": "KN"
  },
  {
    "name": "Saint Anne Sandy Point",
    "iso2": "02",
    "timezone": "America/St_Kitts",
    "countryCode": "KN"
  },
  {
    "name": "Saint George Basseterre",
    "iso2": "03",
    "timezone": "America/St_Kitts",
    "countryCode": "KN"
  },
  {
    "name": "Saint George Gingerland",
    "iso2": "04",
    "timezone": "America/St_Kitts",
    "countryCode": "KN"
  },
  {
    "name": "Saint James Windward",
    "iso2": "05",
    "timezone": "America/St_Kitts",
    "countryCode": "KN"
  },
  {
    "name": "Saint John Capisterre",
    "iso2": "06",
    "timezone": "America/St_Kitts",
    "countryCode": "KN"
  },
  {
    "name": "Saint John Figtree",
    "iso2": "07",
    "timezone": "America/St_Kitts",
    "countryCode": "KN"
  },
  {
    "name": "Saint Kitts",
    "iso2": "K",
    "timezone": "America/St_Kitts",
    "countryCode": "KN"
  },
  {
    "name": "Saint Mary Cayon",
    "iso2": "08",
    "timezone": "America/St_Kitts",
    "countryCode": "KN"
  },
  {
    "name": "Saint Paul Capisterre",
    "iso2": "09",
    "timezone": "America/St_Kitts",
    "countryCode": "KN"
  },
  {
    "name": "Saint Paul Charlestown",
    "iso2": "10",
    "timezone": "America/St_Kitts",
    "countryCode": "KN"
  },
  {
    "name": "Saint Peter Basseterre",
    "iso2": "11",
    "timezone": "America/St_Kitts",
    "countryCode": "KN"
  },
  {
    "name": "Saint Thomas Lowland",
    "iso2": "12",
    "timezone": "America/St_Kitts",
    "countryCode": "KN"
  },
  {
    "name": "Saint Thomas Middle Island",
    "iso2": "13",
    "timezone": "America/St_Kitts",
    "countryCode": "KN"
  },
  {
    "name": "Trinity Palmetto Point",
    "iso2": "15",
    "timezone": "America/St_Kitts",
    "countryCode": "KN"
  },
  {
    "name": "Anse la Raye",
    "iso2": "01",
    "timezone": "America/St_Lucia",
    "countryCode": "LC"
  },
  {
    "name": "Canaries",
    "iso2": "12",
    "timezone": "America/St_Lucia",
    "countryCode": "LC"
  },
  {
    "name": "Castries",
    "iso2": "02",
    "timezone": "America/St_Lucia",
    "countryCode": "LC"
  },
  {
    "name": "Choiseul",
    "iso2": "03",
    "timezone": "America/St_Lucia",
    "countryCode": "LC"
  },
  {
    "name": "Dennery",
    "iso2": "05",
    "timezone": "America/St_Lucia",
    "countryCode": "LC"
  },
  {
    "name": "Gros Islet",
    "iso2": "06",
    "timezone": "America/St_Lucia",
    "countryCode": "LC"
  },
  {
    "name": "Laborie",
    "iso2": "07",
    "timezone": "America/St_Lucia",
    "countryCode": "LC"
  },
  {
    "name": "Micoud",
    "iso2": "08",
    "timezone": "America/St_Lucia",
    "countryCode": "LC"
  },
  {
    "name": "Soufrière",
    "iso2": "10",
    "timezone": "America/St_Lucia",
    "countryCode": "LC"
  },
  {
    "name": "Vieux Fort",
    "iso2": "11",
    "timezone": "America/St_Lucia",
    "countryCode": "LC"
  },
  {
    "name": "Saint-Pierre and Miquelon",
    "iso2": "01",
    "timezone": "America/Miquelon",
    "countryCode": "PM"
  },
  {
    "name": "Charlotte",
    "iso2": "01",
    "timezone": "America/St_Vincent",
    "countryCode": "VC"
  },
  {
    "name": "Grenadines",
    "iso2": "06",
    "timezone": "America/St_Vincent",
    "countryCode": "VC"
  },
  {
    "name": "Saint Andrew",
    "iso2": "02",
    "timezone": "America/St_Vincent",
    "countryCode": "VC"
  },
  {
    "name": "Saint David",
    "iso2": "03",
    "timezone": "America/St_Vincent",
    "countryCode": "VC"
  },
  {
    "name": "Saint George",
    "iso2": "04",
    "timezone": "America/St_Vincent",
    "countryCode": "VC"
  },
  {
    "name": "Saint Patrick",
    "iso2": "05",
    "timezone": "America/St_Vincent",
    "countryCode": "VC"
  },
  {
    "name": "Saint-Barthélemy",
    "iso2": "01",
    "timezone": "America/St_Barthelemy",
    "countryCode": "BL"
  },
  {
    "name": "Saint-Martin",
    "iso2": "01",
    "timezone": "America/Marigot",
    "countryCode": "MF"
  },
  {
    "name": "A'ana",
    "iso2": "AA",
    "timezone": "Pacific/Apia",
    "countryCode": "WS"
  },
  {
    "name": "Aiga-i-le-Tai",
    "iso2": "AL",
    "timezone": "Pacific/Apia",
    "countryCode": "WS"
  },
  {
    "name": "Atua",
    "iso2": "AT",
    "timezone": "Pacific/Apia",
    "countryCode": "WS"
  },
  {
    "name": "Fa'asaleleaga",
    "iso2": "FA",
    "timezone": "Pacific/Apia",
    "countryCode": "WS"
  },
  {
    "name": "Gaga'emauga",
    "iso2": "GE",
    "timezone": "Pacific/Apia",
    "countryCode": "WS"
  },
  {
    "name": "Gaga'ifomauga",
    "iso2": "GI",
    "timezone": "Pacific/Apia",
    "countryCode": "WS"
  },
  {
    "name": "Palauli",
    "iso2": "PA",
    "timezone": "Pacific/Apia",
    "countryCode": "WS"
  },
  {
    "name": "Satupa'itea",
    "iso2": "SA",
    "timezone": "Pacific/Apia",
    "countryCode": "WS"
  },
  {
    "name": "Tuamasaga",
    "iso2": "TU",
    "timezone": "Pacific/Apia",
    "countryCode": "WS"
  },
  {
    "name": "Va'a-o-Fonoti",
    "iso2": "VF",
    "timezone": "Pacific/Apia",
    "countryCode": "WS"
  },
  {
    "name": "Vaisigano",
    "iso2": "VS",
    "timezone": "Pacific/Apia",
    "countryCode": "WS"
  },
  {
    "name": "Acquaviva",
    "iso2": "01",
    "timezone": "Europe/San_Marino",
    "countryCode": "SM"
  },
  {
    "name": "Borgo Maggiore",
    "iso2": "06",
    "timezone": "Europe/San_Marino",
    "countryCode": "SM"
  },
  {
    "name": "Chiesanuova",
    "iso2": "02",
    "timezone": "Europe/San_Marino",
    "countryCode": "SM"
  },
  {
    "name": "Domagnano",
    "iso2": "03",
    "timezone": "Europe/San_Marino",
    "countryCode": "SM"
  },
  {
    "name": "Faetano",
    "iso2": "04",
    "timezone": "Europe/San_Marino",
    "countryCode": "SM"
  },
  {
    "name": "Fiorentino",
    "iso2": "05",
    "timezone": "Europe/San_Marino",
    "countryCode": "SM"
  },
  {
    "name": "Montegiardino",
    "iso2": "08",
    "timezone": "Europe/San_Marino",
    "countryCode": "SM"
  },
  {
    "name": "San Marino",
    "iso2": "07",
    "timezone": "Europe/San_Marino",
    "countryCode": "SM"
  },
  {
    "name": "Serravalle",
    "iso2": "09",
    "timezone": "Europe/San_Marino",
    "countryCode": "SM"
  },
  {
    "name": "Água Grande",
    "iso2": "01",
    "timezone": "Africa/Sao_Tome",
    "countryCode": "ST"
  },
  {
    "name": "Cantagalo",
    "iso2": "02",
    "timezone": "Africa/Sao_Tome",
    "countryCode": "ST"
  },
  {
    "name": "Caué",
    "iso2": "03",
    "timezone": "Africa/Sao_Tome",
    "countryCode": "ST"
  },
  {
    "name": "Lemba",
    "iso2": "04",
    "timezone": "Africa/Sao_Tome",
    "countryCode": "ST"
  },
  {
    "name": "Lobata",
    "iso2": "05",
    "timezone": "Africa/Sao_Tome",
    "countryCode": "ST"
  },
  {
    "name": "Mé-Zóchi",
    "iso2": "06",
    "timezone": "Africa/Sao_Tome",
    "countryCode": "ST"
  },
  {
    "name": "Príncipe",
    "iso2": "P",
    "timezone": "Africa/Sao_Tome",
    "countryCode": "ST"
  },
  {
    "name": "Al Bahah",
    "iso2": "11",
    "timezone": "Asia/Riyadh",
    "countryCode": "SA"
  },
  {
    "name": "Al Jawf",
    "iso2": "12",
    "timezone": "Asia/Riyadh",
    "countryCode": "SA"
  },
  {
    "name": "Al Madinah",
    "iso2": "03",
    "timezone": "Asia/Riyadh",
    "countryCode": "SA"
  },
  {
    "name": "Al-Qassim",
    "iso2": "05",
    "timezone": "Asia/Riyadh",
    "countryCode": "SA"
  },
  {
    "name": "Asir",
    "iso2": "14",
    "timezone": "Asia/Riyadh",
    "countryCode": "SA"
  },
  {
    "name": "Eastern Province",
    "iso2": "04",
    "timezone": "Asia/Riyadh",
    "countryCode": "SA"
  },
  {
    "name": "Ha'il",
    "iso2": "06",
    "timezone": "Asia/Riyadh",
    "countryCode": "SA"
  },
  {
    "name": "Jizan",
    "iso2": "09",
    "timezone": "Asia/Riyadh",
    "countryCode": "SA"
  },
  {
    "name": "Makkah",
    "iso2": "02",
    "timezone": "Asia/Riyadh",
    "countryCode": "SA"
  },
  {
    "name": "Najran",
    "iso2": "10",
    "timezone": "Asia/Riyadh",
    "countryCode": "SA"
  },
  {
    "name": "Northern Borders",
    "iso2": "08",
    "timezone": "Asia/Riyadh",
    "countryCode": "SA"
  },
  {
    "name": "Riyadh",
    "iso2": "01",
    "timezone": "Asia/Riyadh",
    "countryCode": "SA"
  },
  {
    "name": "Tabuk",
    "iso2": "07",
    "timezone": "Asia/Riyadh",
    "countryCode": "SA"
  },
  {
    "name": "Dakar",
    "iso2": "DK",
    "timezone": "Africa/Dakar",
    "countryCode": "SN"
  },
  {
    "name": "Diourbel Region",
    "iso2": "DB",
    "timezone": "Africa/Dakar",
    "countryCode": "SN"
  },
  {
    "name": "Fatick",
    "iso2": "FK",
    "timezone": "Africa/Dakar",
    "countryCode": "SN"
  },
  {
    "name": "Kaffrine",
    "iso2": "KA",
    "timezone": "Africa/Dakar",
    "countryCode": "SN"
  },
  {
    "name": "Kaolack",
    "iso2": "KL",
    "timezone": "Africa/Dakar",
    "countryCode": "SN"
  },
  {
    "name": "Kédougou",
    "iso2": "KE",
    "timezone": "Africa/Dakar",
    "countryCode": "SN"
  },
  {
    "name": "Kolda",
    "iso2": "KD",
    "timezone": "Africa/Dakar",
    "countryCode": "SN"
  },
  {
    "name": "Louga",
    "iso2": "LG",
    "timezone": "Africa/Dakar",
    "countryCode": "SN"
  },
  {
    "name": "Matam",
    "iso2": "MT",
    "timezone": "Africa/Dakar",
    "countryCode": "SN"
  },
  {
    "name": "Saint-Louis",
    "iso2": "SL",
    "timezone": "Africa/Dakar",
    "countryCode": "SN"
  },
  {
    "name": "Sédhiou",
    "iso2": "SE",
    "timezone": "Africa/Dakar",
    "countryCode": "SN"
  },
  {
    "name": "Tambacounda Region",
    "iso2": "TC",
    "timezone": "Africa/Dakar",
    "countryCode": "SN"
  },
  {
    "name": "Thiès Region",
    "iso2": "TH",
    "timezone": "Africa/Dakar",
    "countryCode": "SN"
  },
  {
    "name": "Ziguinchor",
    "iso2": "ZG",
    "timezone": "Africa/Dakar",
    "countryCode": "SN"
  },
  {
    "name": "Belgrade",
    "iso2": "00",
    "timezone": "Europe/Belgrade",
    "countryCode": "RS"
  },
  {
    "name": "Bor",
    "iso2": "14",
    "timezone": "Europe/Belgrade",
    "countryCode": "RS"
  },
  {
    "name": "Braničevo",
    "iso2": "11",
    "timezone": "Europe/Belgrade",
    "countryCode": "RS"
  },
  {
    "name": "Central Banat",
    "iso2": "02",
    "timezone": "Europe/Belgrade",
    "countryCode": "RS"
  },
  {
    "name": "Jablanica",
    "iso2": "23",
    "timezone": "Europe/Belgrade",
    "countryCode": "RS"
  },
  {
    "name": "Kolubara",
    "iso2": "09",
    "timezone": "Europe/Belgrade",
    "countryCode": "RS"
  },
  {
    "name": "Kosovo",
    "iso2": "25",
    "timezone": "Europe/Belgrade",
    "countryCode": "RS"
  },
  {
    "name": "Kosovo-Metohija",
    "iso2": "KM",
    "timezone": "Europe/Belgrade",
    "countryCode": "RS"
  },
  {
    "name": "Kosovo-Pomoravlje",
    "iso2": "29",
    "timezone": "Europe/Belgrade",
    "countryCode": "RS"
  },
  {
    "name": "Kosovska Mitrovica",
    "iso2": "28",
    "timezone": "Europe/Belgrade",
    "countryCode": "RS"
  },
  {
    "name": "Mačva",
    "iso2": "08",
    "timezone": "Europe/Belgrade",
    "countryCode": "RS"
  },
  {
    "name": "Moravica",
    "iso2": "17",
    "timezone": "Europe/Belgrade",
    "countryCode": "RS"
  },
  {
    "name": "Nišava",
    "iso2": "20",
    "timezone": "Europe/Belgrade",
    "countryCode": "RS"
  },
  {
    "name": "North Bačka",
    "iso2": "01",
    "timezone": "Europe/Belgrade",
    "countryCode": "RS"
  },
  {
    "name": "North Banat",
    "iso2": "03",
    "timezone": "Europe/Belgrade",
    "countryCode": "RS"
  },
  {
    "name": "Pčinja",
    "iso2": "24",
    "timezone": "Europe/Belgrade",
    "countryCode": "RS"
  },
  {
    "name": "Peć",
    "iso2": "26",
    "timezone": "Europe/Belgrade",
    "countryCode": "RS"
  },
  {
    "name": "Pirot",
    "iso2": "22",
    "timezone": "Europe/Belgrade",
    "countryCode": "RS"
  },
  {
    "name": "Podunavlje",
    "iso2": "10",
    "timezone": "Europe/Belgrade",
    "countryCode": "RS"
  },
  {
    "name": "Pomoravlje",
    "iso2": "13",
    "timezone": "Europe/Belgrade",
    "countryCode": "RS"
  },
  {
    "name": "Prizren",
    "iso2": "27",
    "timezone": "Europe/Belgrade",
    "countryCode": "RS"
  },
  {
    "name": "Rasina",
    "iso2": "19",
    "timezone": "Europe/Belgrade",
    "countryCode": "RS"
  },
  {
    "name": "Raška",
    "iso2": "18",
    "timezone": "Europe/Belgrade",
    "countryCode": "RS"
  },
  {
    "name": "South Bačka",
    "iso2": "06",
    "timezone": "Europe/Belgrade",
    "countryCode": "RS"
  },
  {
    "name": "South Banat",
    "iso2": "04",
    "timezone": "Europe/Belgrade",
    "countryCode": "RS"
  },
  {
    "name": "Srem",
    "iso2": "07",
    "timezone": "Europe/Belgrade",
    "countryCode": "RS"
  },
  {
    "name": "Šumadija",
    "iso2": "12",
    "timezone": "Europe/Belgrade",
    "countryCode": "RS"
  },
  {
    "name": "Toplica",
    "iso2": "21",
    "timezone": "Europe/Belgrade",
    "countryCode": "RS"
  },
  {
    "name": "Vojvodina",
    "iso2": "VO",
    "timezone": "Europe/Belgrade",
    "countryCode": "RS"
  },
  {
    "name": "West Bačka",
    "iso2": "05",
    "timezone": "Europe/Belgrade",
    "countryCode": "RS"
  },
  {
    "name": "Zaječar",
    "iso2": "15",
    "timezone": "Europe/Belgrade",
    "countryCode": "RS"
  },
  {
    "name": "Zlatibor",
    "iso2": "16",
    "timezone": "Europe/Belgrade",
    "countryCode": "RS"
  },
  {
    "name": "Anse Boileau",
    "iso2": "02",
    "timezone": "Indian/Mahe",
    "countryCode": "SC"
  },
  {
    "name": "Anse Etoile",
    "iso2": "03",
    "timezone": "Indian/Mahe",
    "countryCode": "SC"
  },
  {
    "name": "Anse Royale",
    "iso2": "05",
    "timezone": "Indian/Mahe",
    "countryCode": "SC"
  },
  {
    "name": "Anse-aux-Pins",
    "iso2": "01",
    "timezone": "Indian/Mahe",
    "countryCode": "SC"
  },
  {
    "name": "Au Cap",
    "iso2": "04",
    "timezone": "Indian/Mahe",
    "countryCode": "SC"
  },
  {
    "name": "Baie Lazare",
    "iso2": "06",
    "timezone": "Indian/Mahe",
    "countryCode": "SC"
  },
  {
    "name": "Baie Sainte Anne",
    "iso2": "07",
    "timezone": "Indian/Mahe",
    "countryCode": "SC"
  },
  {
    "name": "Beau Vallon",
    "iso2": "08",
    "timezone": "Indian/Mahe",
    "countryCode": "SC"
  },
  {
    "name": "Bel Air",
    "iso2": "09",
    "timezone": "Indian/Mahe",
    "countryCode": "SC"
  },
  {
    "name": "Bel Ombre",
    "iso2": "10",
    "timezone": "Indian/Mahe",
    "countryCode": "SC"
  },
  {
    "name": "Cascade",
    "iso2": "11",
    "timezone": "Indian/Mahe",
    "countryCode": "SC"
  },
  {
    "name": "Glacis",
    "iso2": "12",
    "timezone": "Indian/Mahe",
    "countryCode": "SC"
  },
  {
    "name": "Grand'Anse Mahé",
    "iso2": "13",
    "timezone": "Indian/Mahe",
    "countryCode": "SC"
  },
  {
    "name": "Grand'Anse Praslin",
    "iso2": "14",
    "timezone": "Indian/Mahe",
    "countryCode": "SC"
  },
  {
    "name": "Ile Perseverance I",
    "iso2": "26",
    "timezone": "Indian/Mahe",
    "countryCode": "SC"
  },
  {
    "name": "Ile Perseverance II",
    "iso2": "27",
    "timezone": "Indian/Mahe",
    "countryCode": "SC"
  },
  {
    "name": "La Digue",
    "iso2": "15",
    "timezone": "Indian/Mahe",
    "countryCode": "SC"
  },
  {
    "name": "La Rivière Anglaise",
    "iso2": "16",
    "timezone": "Indian/Mahe",
    "countryCode": "SC"
  },
  {
    "name": "Les Mamelles",
    "iso2": "24",
    "timezone": "Indian/Mahe",
    "countryCode": "SC"
  },
  {
    "name": "Mont Buxton",
    "iso2": "17",
    "timezone": "Indian/Mahe",
    "countryCode": "SC"
  },
  {
    "name": "Mont Fleuri",
    "iso2": "18",
    "timezone": "Indian/Mahe",
    "countryCode": "SC"
  },
  {
    "name": "Plaisance",
    "iso2": "19",
    "timezone": "Indian/Mahe",
    "countryCode": "SC"
  },
  {
    "name": "Pointe La Rue",
    "iso2": "20",
    "timezone": "Indian/Mahe",
    "countryCode": "SC"
  },
  {
    "name": "Port Glaud",
    "iso2": "21",
    "timezone": "Indian/Mahe",
    "countryCode": "SC"
  },
  {
    "name": "Roche Caiman",
    "iso2": "25",
    "timezone": "Indian/Mahe",
    "countryCode": "SC"
  },
  {
    "name": "Saint Louis",
    "iso2": "22",
    "timezone": "Indian/Mahe",
    "countryCode": "SC"
  },
  {
    "name": "Takamaka",
    "iso2": "23",
    "timezone": "Indian/Mahe",
    "countryCode": "SC"
  },
  {
    "name": "Eastern",
    "iso2": "E",
    "timezone": "Africa/Freetown",
    "countryCode": "SL"
  },
  {
    "name": "North Western",
    "iso2": "NW",
    "timezone": "Africa/Freetown",
    "countryCode": "SL"
  },
  {
    "name": "Northern",
    "iso2": "N",
    "timezone": "Africa/Freetown",
    "countryCode": "SL"
  },
  {
    "name": "Southern",
    "iso2": "S",
    "timezone": "Africa/Freetown",
    "countryCode": "SL"
  },
  {
    "name": "Western",
    "iso2": "W",
    "timezone": "Africa/Freetown",
    "countryCode": "SL"
  },
  {
    "name": "Central Singapore",
    "iso2": "01",
    "timezone": "Asia/Singapore",
    "countryCode": "SG"
  },
  {
    "name": "North East",
    "iso2": "02",
    "timezone": "Asia/Singapore",
    "countryCode": "SG"
  },
  {
    "name": "North West",
    "iso2": "03",
    "timezone": "Asia/Singapore",
    "countryCode": "SG"
  },
  {
    "name": "South East",
    "iso2": "04",
    "timezone": "Asia/Singapore",
    "countryCode": "SG"
  },
  {
    "name": "South West",
    "iso2": "05",
    "timezone": "Asia/Singapore",
    "countryCode": "SG"
  },
  {
    "name": "Banská Bystrica",
    "iso2": "BC",
    "timezone": "Europe/Bratislava",
    "countryCode": "SK"
  },
  {
    "name": "Bratislava",
    "iso2": "BL",
    "timezone": "Europe/Bratislava",
    "countryCode": "SK"
  },
  {
    "name": "Košice",
    "iso2": "KI",
    "timezone": "Europe/Bratislava",
    "countryCode": "SK"
  },
  {
    "name": "Nitra",
    "iso2": "NI",
    "timezone": "Europe/Bratislava",
    "countryCode": "SK"
  },
  {
    "name": "Prešov",
    "iso2": "PV",
    "timezone": "Europe/Bratislava",
    "countryCode": "SK"
  },
  {
    "name": "Trenčín",
    "iso2": "TC",
    "timezone": "Europe/Bratislava",
    "countryCode": "SK"
  },
  {
    "name": "Trnava",
    "iso2": "TA",
    "timezone": "Europe/Bratislava",
    "countryCode": "SK"
  },
  {
    "name": "Žilina",
    "iso2": "ZI",
    "timezone": "Europe/Bratislava",
    "countryCode": "SK"
  },
  {
    "name": "Ajdovščina",
    "iso2": "001",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Ankaran",
    "iso2": "213",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Apače",
    "iso2": "195",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Beltinci",
    "iso2": "002",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Benedikt",
    "iso2": "148",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Bistrica ob Sotli",
    "iso2": "149",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Bled",
    "iso2": "003",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Bloke",
    "iso2": "150",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Bohinj",
    "iso2": "004",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Borovnica",
    "iso2": "005",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Bovec",
    "iso2": "006",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Braslovče",
    "iso2": "151",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Brda",
    "iso2": "007",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Brežice",
    "iso2": "009",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Brezovica",
    "iso2": "008",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Cankova",
    "iso2": "152",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Celje",
    "iso2": "011",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Cerklje na Gorenjskem",
    "iso2": "012",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Cerknica",
    "iso2": "013",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Cerkno",
    "iso2": "014",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Cerkvenjak",
    "iso2": "153",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Cirkulane",
    "iso2": "196",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Črenšovci",
    "iso2": "015",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Črna na Koroškem",
    "iso2": "016",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Črnomelj",
    "iso2": "017",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Destrnik",
    "iso2": "018",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Divača",
    "iso2": "019",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Dobje",
    "iso2": "154",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Dobrepolje",
    "iso2": "020",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Dobrna",
    "iso2": "155",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Dobrova–Polhov Gradec",
    "iso2": "021",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Dobrovnik",
    "iso2": "156",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Dol pri Ljubljani",
    "iso2": "022",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Dolenjske Toplice",
    "iso2": "157",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Domžale",
    "iso2": "023",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Dornava",
    "iso2": "024",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Dravograd",
    "iso2": "025",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Duplek",
    "iso2": "026",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Gorenja Vas–Poljane",
    "iso2": "027",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Gorišnica",
    "iso2": "028",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Gorje",
    "iso2": "207",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Gornja Radgona",
    "iso2": "029",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Gornji Grad",
    "iso2": "030",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Gornji Petrovci",
    "iso2": "031",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Grad",
    "iso2": "158",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Grosuplje",
    "iso2": "032",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Hajdina",
    "iso2": "159",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Hoče–Slivnica",
    "iso2": "160",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Hodoš",
    "iso2": "161",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Horjul",
    "iso2": "162",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Hrastnik",
    "iso2": "034",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Hrpelje–Kozina",
    "iso2": "035",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Idrija",
    "iso2": "036",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Ig",
    "iso2": "037",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Ilirska Bistrica",
    "iso2": "038",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Ivančna Gorica",
    "iso2": "039",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Izola",
    "iso2": "040",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Jesenice",
    "iso2": "041",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Jezersko",
    "iso2": "163",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Juršinci",
    "iso2": "042",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Kamnik",
    "iso2": "043",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Kanal ob Soči",
    "iso2": "044",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Kidričevo",
    "iso2": "045",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Kobarid",
    "iso2": "046",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Kobilje",
    "iso2": "047",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Kočevje",
    "iso2": "048",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Komen",
    "iso2": "049",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Komenda",
    "iso2": "164",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Koper",
    "iso2": "050",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Kostanjevica na Krki",
    "iso2": "197",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Kostel",
    "iso2": "165",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Kozje",
    "iso2": "051",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Kranj",
    "iso2": "052",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Kranjska Gora",
    "iso2": "053",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Križevci",
    "iso2": "166",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Krško",
    "iso2": "054",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Kungota",
    "iso2": "055",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Kuzma",
    "iso2": "056",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Laško",
    "iso2": "057",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Lenart",
    "iso2": "058",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Lendava",
    "iso2": "059",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Litija",
    "iso2": "060",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Ljubljana",
    "iso2": "061",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Ljubno",
    "iso2": "062",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Ljutomer",
    "iso2": "063",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Log–Dragomer",
    "iso2": "208",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Logatec",
    "iso2": "064",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Loška Dolina",
    "iso2": "065",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Loški Potok",
    "iso2": "066",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Lovrenc na Pohorju",
    "iso2": "167",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Luče",
    "iso2": "067",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Lukovica",
    "iso2": "068",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Majšperk",
    "iso2": "069",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Makole",
    "iso2": "198",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Maribor",
    "iso2": "070",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Markovci",
    "iso2": "168",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Medvode",
    "iso2": "071",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Mengeš",
    "iso2": "072",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Metlika",
    "iso2": "073",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Mežica",
    "iso2": "074",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Miklavž na Dravskem Polju",
    "iso2": "169",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Miren–Kostanjevica",
    "iso2": "075",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Mirna",
    "iso2": "212",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Mirna Peč",
    "iso2": "170",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Mislinja",
    "iso2": "076",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Mokronog–Trebelno",
    "iso2": "199",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Moravče",
    "iso2": "077",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Moravske Toplice",
    "iso2": "078",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Mozirje",
    "iso2": "079",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Murska Sobota",
    "iso2": "080",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Muta",
    "iso2": "081",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Naklo",
    "iso2": "082",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Nazarje",
    "iso2": "083",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Nova Gorica",
    "iso2": "084",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Novo Mesto",
    "iso2": "085",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Odranci",
    "iso2": "086",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Oplotnica",
    "iso2": "171",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Ormož",
    "iso2": "087",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Osilnica",
    "iso2": "088",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Pesnica",
    "iso2": "089",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Piran",
    "iso2": "090",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Pivka",
    "iso2": "091",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Podčetrtek",
    "iso2": "092",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Podlehnik",
    "iso2": "172",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Podvelka",
    "iso2": "093",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Poljčane",
    "iso2": "200",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Polzela",
    "iso2": "173",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Postojna",
    "iso2": "094",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Prebold",
    "iso2": "174",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Preddvor",
    "iso2": "095",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Prevalje",
    "iso2": "175",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Ptuj",
    "iso2": "096",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Puconci",
    "iso2": "097",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Rače–Fram",
    "iso2": "098",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Radeče",
    "iso2": "099",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Radenci",
    "iso2": "100",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Radlje ob Dravi",
    "iso2": "101",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Radovljica",
    "iso2": "102",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Ravne na Koroškem",
    "iso2": "103",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Razkrižje",
    "iso2": "176",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Rečica ob Savinji",
    "iso2": "209",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Renče–Vogrsko",
    "iso2": "201",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Ribnica",
    "iso2": "104",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Ribnica na Pohorju",
    "iso2": "177",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Rogaška Slatina",
    "iso2": "106",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Rogašovci",
    "iso2": "105",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Rogatec",
    "iso2": "107",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Ruše",
    "iso2": "108",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Šalovci",
    "iso2": "033",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Selnica ob Dravi",
    "iso2": "178",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Semič",
    "iso2": "109",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Šempeter–Vrtojba",
    "iso2": "183",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Šenčur",
    "iso2": "117",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Šentilj",
    "iso2": "118",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Šentjernej",
    "iso2": "119",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Šentjur",
    "iso2": "120",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Šentrupert",
    "iso2": "211",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Sevnica",
    "iso2": "110",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Sežana",
    "iso2": "111",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Škocjan",
    "iso2": "121",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Škofja Loka",
    "iso2": "122",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Škofljica",
    "iso2": "123",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Slovenj Gradec",
    "iso2": "112",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Slovenska Bistrica",
    "iso2": "113",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Slovenske Konjice",
    "iso2": "114",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Šmarje pri Jelšah",
    "iso2": "124",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Šmarješke Toplice",
    "iso2": "206",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Šmartno ob Paki",
    "iso2": "125",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Šmartno pri Litiji",
    "iso2": "194",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Sodražica",
    "iso2": "179",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Solčava",
    "iso2": "180",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Šoštanj",
    "iso2": "126",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Središče ob Dravi",
    "iso2": "202",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Starše",
    "iso2": "115",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Štore",
    "iso2": "127",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Straža",
    "iso2": "203",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Sveta Ana",
    "iso2": "181",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Sveta Trojica v Slovenskih Goricah",
    "iso2": "204",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Sveti Andraž v Slovenskih Goricah",
    "iso2": "182",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Sveti Jurij ob Ščavnici",
    "iso2": "116",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Sveti Jurij v Slovenskih Goricah",
    "iso2": "210",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Sveti Tomaž",
    "iso2": "205",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Tabor",
    "iso2": "184",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Tišina",
    "iso2": "010",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Tolmin",
    "iso2": "128",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Trbovlje",
    "iso2": "129",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Trebnje",
    "iso2": "130",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Trnovska Vas",
    "iso2": "185",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Tržič",
    "iso2": "131",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Trzin",
    "iso2": "186",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Turnišče",
    "iso2": "132",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Velenje",
    "iso2": "133",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Velika Polana",
    "iso2": "187",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Velike Lašče",
    "iso2": "134",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Veržej",
    "iso2": "188",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Videm",
    "iso2": "135",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Vipava",
    "iso2": "136",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Vitanje",
    "iso2": "137",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Vodice",
    "iso2": "138",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Vojnik",
    "iso2": "139",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Vransko",
    "iso2": "189",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Vrhnika",
    "iso2": "140",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Vuzenica",
    "iso2": "141",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Zagorje ob Savi",
    "iso2": "142",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Žalec",
    "iso2": "190",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Zavrč",
    "iso2": "143",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Železniki",
    "iso2": "146",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Žetale",
    "iso2": "191",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Žiri",
    "iso2": "147",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Žirovnica",
    "iso2": "192",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Zreče",
    "iso2": "144",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Žužemberk",
    "iso2": "193",
    "timezone": "Europe/Ljubljana",
    "countryCode": "SI"
  },
  {
    "name": "Central",
    "iso2": "CE",
    "timezone": "Pacific/Guadalcanal",
    "countryCode": "SB"
  },
  {
    "name": "Choiseul",
    "iso2": "CH",
    "timezone": "Pacific/Guadalcanal",
    "countryCode": "SB"
  },
  {
    "name": "Guadalcanal",
    "iso2": "GU",
    "timezone": "Pacific/Guadalcanal",
    "countryCode": "SB"
  },
  {
    "name": "Honiara",
    "iso2": "CT",
    "timezone": "Pacific/Guadalcanal",
    "countryCode": "SB"
  },
  {
    "name": "Isabel",
    "iso2": "IS",
    "timezone": "Pacific/Guadalcanal",
    "countryCode": "SB"
  },
  {
    "name": "Makira-Ulawa",
    "iso2": "MK",
    "timezone": "Pacific/Guadalcanal",
    "countryCode": "SB"
  },
  {
    "name": "Malaita",
    "iso2": "ML",
    "timezone": "Pacific/Guadalcanal",
    "countryCode": "SB"
  },
  {
    "name": "Rennell and Bellona",
    "iso2": "RB",
    "timezone": "Pacific/Guadalcanal",
    "countryCode": "SB"
  },
  {
    "name": "Temotu",
    "iso2": "TE",
    "timezone": "Pacific/Guadalcanal",
    "countryCode": "SB"
  },
  {
    "name": "Western",
    "iso2": "WE",
    "timezone": "Pacific/Guadalcanal",
    "countryCode": "SB"
  },
  {
    "name": "Awdal",
    "iso2": "AW",
    "timezone": "Africa/Mogadishu",
    "countryCode": "SO"
  },
  {
    "name": "Bakool",
    "iso2": "BK",
    "timezone": "Africa/Mogadishu",
    "countryCode": "SO"
  },
  {
    "name": "Banaadir",
    "iso2": "BN",
    "timezone": "Africa/Mogadishu",
    "countryCode": "SO"
  },
  {
    "name": "Bari",
    "iso2": "BR",
    "timezone": "Africa/Mogadishu",
    "countryCode": "SO"
  },
  {
    "name": "Bay",
    "iso2": "BY",
    "timezone": "Africa/Mogadishu",
    "countryCode": "SO"
  },
  {
    "name": "Galguduud",
    "iso2": "GA",
    "timezone": "Africa/Mogadishu",
    "countryCode": "SO"
  },
  {
    "name": "Gedo",
    "iso2": "GE",
    "timezone": "Africa/Mogadishu",
    "countryCode": "SO"
  },
  {
    "name": "Hiran",
    "iso2": "HI",
    "timezone": "Africa/Mogadishu",
    "countryCode": "SO"
  },
  {
    "name": "Lower Juba",
    "iso2": "JH",
    "timezone": "Africa/Mogadishu",
    "countryCode": "SO"
  },
  {
    "name": "Lower Shebelle",
    "iso2": "SH",
    "timezone": "Africa/Mogadishu",
    "countryCode": "SO"
  },
  {
    "name": "Middle Juba",
    "iso2": "JD",
    "timezone": "Africa/Mogadishu",
    "countryCode": "SO"
  },
  {
    "name": "Middle Shebelle",
    "iso2": "SD",
    "timezone": "Africa/Mogadishu",
    "countryCode": "SO"
  },
  {
    "name": "Mudug",
    "iso2": "MU",
    "timezone": "Africa/Mogadishu",
    "countryCode": "SO"
  },
  {
    "name": "Nugal",
    "iso2": "NU",
    "timezone": "Africa/Mogadishu",
    "countryCode": "SO"
  },
  {
    "name": "Sanaag",
    "iso2": "SA",
    "timezone": "Africa/Mogadishu",
    "countryCode": "SO"
  },
  {
    "name": "Sool",
    "iso2": "SO",
    "timezone": "Africa/Mogadishu",
    "countryCode": "SO"
  },
  {
    "name": "Togdheer",
    "iso2": "TO",
    "timezone": "Africa/Mogadishu",
    "countryCode": "SO"
  },
  {
    "name": "Woqooyi Galbeed",
    "iso2": "WO",
    "timezone": "Africa/Mogadishu",
    "countryCode": "SO"
  },
  {
    "name": "Eastern Cape",
    "iso2": "EC",
    "timezone": "Africa/Johannesburg",
    "countryCode": "ZA"
  },
  {
    "name": "Free State",
    "iso2": "FS",
    "timezone": "Africa/Johannesburg",
    "countryCode": "ZA"
  },
  {
    "name": "Gauteng",
    "iso2": "GP",
    "timezone": "Africa/Johannesburg",
    "countryCode": "ZA"
  },
  {
    "name": "KwaZulu-Natal",
    "iso2": "KZN",
    "timezone": "Africa/Johannesburg",
    "countryCode": "ZA"
  },
  {
    "name": "Limpopo",
    "iso2": "LP",
    "timezone": "Africa/Johannesburg",
    "countryCode": "ZA"
  },
  {
    "name": "Mpumalanga",
    "iso2": "MP",
    "timezone": "Africa/Johannesburg",
    "countryCode": "ZA"
  },
  {
    "name": "North West",
    "iso2": "NW",
    "timezone": "Africa/Johannesburg",
    "countryCode": "ZA"
  },
  {
    "name": "Northern Cape",
    "iso2": "NC",
    "timezone": "Africa/Johannesburg",
    "countryCode": "ZA"
  },
  {
    "name": "Western Cape",
    "iso2": "WC",
    "timezone": "Africa/Johannesburg",
    "countryCode": "ZA"
  },
  {
    "name": "Busan",
    "iso2": "26",
    "timezone": "Asia/Seoul",
    "countryCode": "KR"
  },
  {
    "name": "Daegu",
    "iso2": "27",
    "timezone": "Asia/Seoul",
    "countryCode": "KR"
  },
  {
    "name": "Daejeon",
    "iso2": "30",
    "timezone": "Asia/Seoul",
    "countryCode": "KR"
  },
  {
    "name": "Gangwon",
    "iso2": "42",
    "timezone": "Asia/Seoul",
    "countryCode": "KR"
  },
  {
    "name": "Gwangju",
    "iso2": "29",
    "timezone": "Asia/Seoul",
    "countryCode": "KR"
  },
  {
    "name": "Gyeonggi",
    "iso2": "41",
    "timezone": "Asia/Seoul",
    "countryCode": "KR"
  },
  {
    "name": "Incheon",
    "iso2": "28",
    "timezone": "Asia/Seoul",
    "countryCode": "KR"
  },
  {
    "name": "Jeju",
    "iso2": "49",
    "timezone": "Asia/Seoul",
    "countryCode": "KR"
  },
  {
    "name": "North Chungcheong",
    "iso2": "43",
    "timezone": "Asia/Seoul",
    "countryCode": "KR"
  },
  {
    "name": "North Gyeongsang",
    "iso2": "47",
    "timezone": "Asia/Seoul",
    "countryCode": "KR"
  },
  {
    "name": "North Jeolla",
    "iso2": "45",
    "timezone": "Asia/Seoul",
    "countryCode": "KR"
  },
  {
    "name": "Sejong City",
    "iso2": "50",
    "timezone": "Asia/Seoul",
    "countryCode": "KR"
  },
  {
    "name": "Seoul",
    "iso2": "11",
    "timezone": "Asia/Seoul",
    "countryCode": "KR"
  },
  {
    "name": "South Chungcheong",
    "iso2": "44",
    "timezone": "Asia/Seoul",
    "countryCode": "KR"
  },
  {
    "name": "South Gyeongsang",
    "iso2": "48",
    "timezone": "Asia/Seoul",
    "countryCode": "KR"
  },
  {
    "name": "South Jeolla",
    "iso2": "46",
    "timezone": "Asia/Seoul",
    "countryCode": "KR"
  },
  {
    "name": "Ulsan",
    "iso2": "31",
    "timezone": "Asia/Seoul",
    "countryCode": "KR"
  },
  {
    "name": "Central Equatoria",
    "iso2": "EC",
    "timezone": "Africa/Juba",
    "countryCode": "SS"
  },
  {
    "name": "Eastern Equatoria",
    "iso2": "EE",
    "timezone": "Africa/Juba",
    "countryCode": "SS"
  },
  {
    "name": "Jonglei State",
    "iso2": "JG",
    "timezone": "Africa/Juba",
    "countryCode": "SS"
  },
  {
    "name": "Lakes",
    "iso2": "LK",
    "timezone": "Africa/Juba",
    "countryCode": "SS"
  },
  {
    "name": "Northern Bahr el Ghazal",
    "iso2": "BN",
    "timezone": "Africa/Juba",
    "countryCode": "SS"
  },
  {
    "name": "Unity",
    "iso2": "UY",
    "timezone": "Africa/Juba",
    "countryCode": "SS"
  },
  {
    "name": "Upper Nile",
    "iso2": "NU",
    "timezone": "Africa/Juba",
    "countryCode": "SS"
  },
  {
    "name": "Warrap",
    "iso2": "WR",
    "timezone": "Africa/Juba",
    "countryCode": "SS"
  },
  {
    "name": "Western Bahr el Ghazal",
    "iso2": "BW",
    "timezone": "Africa/Juba",
    "countryCode": "SS"
  },
  {
    "name": "Western Equatoria",
    "iso2": "EW",
    "timezone": "Africa/Juba",
    "countryCode": "SS"
  },
  {
    "name": "A Coruña",
    "iso2": "C",
    "timezone": "Europe/Madrid",
    "countryCode": "ES"
  },
  {
    "name": "Albacete",
    "iso2": "AB",
    "timezone": "Europe/Madrid",
    "countryCode": "ES"
  },
  {
    "name": "Alicante",
    "iso2": "A",
    "timezone": "Europe/Madrid",
    "countryCode": "ES"
  },
  {
    "name": "Almeria",
    "iso2": "AL",
    "timezone": "Europe/Madrid",
    "countryCode": "ES"
  },
  {
    "name": "Andalusia",
    "iso2": "AN",
    "timezone": "Europe/Madrid",
    "countryCode": "ES"
  },
  {
    "name": "Araba",
    "iso2": "VI",
    "timezone": "Europe/Madrid",
    "countryCode": "ES"
  },
  {
    "name": "Aragon",
    "iso2": "AR",
    "timezone": "Europe/Madrid",
    "countryCode": "ES"
  },
  {
    "name": "Asturias",
    "iso2": "O",
    "timezone": "Europe/Madrid",
    "countryCode": "ES"
  },
  {
    "name": "Asturias, Principality of",
    "iso2": "AS",
    "timezone": "Europe/Madrid",
    "countryCode": "ES"
  },
  {
    "name": "Ávila",
    "iso2": "AV",
    "timezone": "Europe/Madrid",
    "countryCode": "ES"
  },
  {
    "name": "Badajoz",
    "iso2": "BA",
    "timezone": "Europe/Madrid",
    "countryCode": "ES"
  },
  {
    "name": "Balearic Islands",
    "iso2": "IB",
    "timezone": "Europe/Madrid",
    "countryCode": "ES"
  },
  {
    "name": "Barcelona",
    "iso2": "B",
    "timezone": "Europe/Madrid",
    "countryCode": "ES"
  },
  {
    "name": "Basque Country",
    "iso2": "PV",
    "timezone": "Europe/Madrid",
    "countryCode": "ES"
  },
  {
    "name": "Bizkaia",
    "iso2": "BI",
    "timezone": "Europe/Madrid",
    "countryCode": "ES"
  },
  {
    "name": "Burgos",
    "iso2": "BU",
    "timezone": "Europe/Madrid",
    "countryCode": "ES"
  },
  {
    "name": "Caceres",
    "iso2": "CC",
    "timezone": "Europe/Madrid",
    "countryCode": "ES"
  },
  {
    "name": "Cádiz",
    "iso2": "CA",
    "timezone": "Europe/Madrid",
    "countryCode": "ES"
  },
  {
    "name": "Canary Islands",
    "iso2": "CN",
    "timezone": "Atlantic/Canary",
    "countryCode": "ES"
  },
  {
    "name": "Cantabria",
    "iso2": "S",
    "timezone": "Europe/Madrid",
    "countryCode": "ES"
  },
  {
    "name": "Cantabria",
    "iso2": "CB",
    "timezone": "Europe/Madrid",
    "countryCode": "ES"
  },
  {
    "name": "Castellón",
    "iso2": "CS",
    "timezone": "Europe/Madrid",
    "countryCode": "ES"
  },
  {
    "name": "Castile and Leon",
    "iso2": "CL",
    "timezone": "Europe/Madrid",
    "countryCode": "ES"
  },
  {
    "name": "Castilla-La Mancha",
    "iso2": "CM",
    "timezone": "Europe/Madrid",
    "countryCode": "ES"
  },
  {
    "name": "Catalonia",
    "iso2": "CT",
    "timezone": "Europe/Madrid",
    "countryCode": "ES"
  },
  {
    "name": "Ceuta",
    "iso2": "CE",
    "timezone": "Africa/Ceuta",
    "countryCode": "ES"
  },
  {
    "name": "Ciudad Real",
    "iso2": "CR",
    "timezone": "Europe/Madrid",
    "countryCode": "ES"
  },
  {
    "name": "Community of Madrid",
    "iso2": "MD",
    "timezone": "Europe/Madrid",
    "countryCode": "ES"
  },
  {
    "name": "Córdoba",
    "iso2": "CO",
    "timezone": "Europe/Madrid",
    "countryCode": "ES"
  },
  {
    "name": "Cuenca",
    "iso2": "CU",
    "timezone": "Europe/Madrid",
    "countryCode": "ES"
  },
  {
    "name": "Estremadura",
    "iso2": "EX",
    "timezone": "Europe/Madrid",
    "countryCode": "ES"
  },
  {
    "name": "Galicia",
    "iso2": "GA",
    "timezone": "Europe/Madrid",
    "countryCode": "ES"
  },
  {
    "name": "Gipuzkoa",
    "iso2": "SS",
    "timezone": "Europe/Madrid",
    "countryCode": "ES"
  },
  {
    "name": "Girona",
    "iso2": "GI",
    "timezone": "Europe/Madrid",
    "countryCode": "ES"
  },
  {
    "name": "Granada",
    "iso2": "GR",
    "timezone": "Europe/Madrid",
    "countryCode": "ES"
  },
  {
    "name": "Guadalajara",
    "iso2": "GU",
    "timezone": "Europe/Madrid",
    "countryCode": "ES"
  },
  {
    "name": "Huelva",
    "iso2": "H",
    "timezone": "Europe/Madrid",
    "countryCode": "ES"
  },
  {
    "name": "Huesca",
    "iso2": "HU",
    "timezone": "Europe/Madrid",
    "countryCode": "ES"
  },
  {
    "name": "Islas Baleares",
    "iso2": "PM",
    "timezone": "Europe/Madrid",
    "countryCode": "ES"
  },
  {
    "name": "Jaén",
    "iso2": "J",
    "timezone": "Europe/Madrid",
    "countryCode": "ES"
  },
  {
    "name": "La Rioja",
    "iso2": "RI",
    "timezone": "Europe/Madrid",
    "countryCode": "ES"
  },
  {
    "name": "La Rioja",
    "iso2": "LO",
    "timezone": "Europe/Madrid",
    "countryCode": "ES"
  },
  {
    "name": "Las Palmas",
    "iso2": "GC",
    "timezone": "Atlantic/Canary",
    "countryCode": "ES"
  },
  {
    "name": "León",
    "iso2": "LE",
    "timezone": "Europe/Madrid",
    "countryCode": "ES"
  },
  {
    "name": "Lleida",
    "iso2": "L",
    "timezone": "Europe/Madrid",
    "countryCode": "ES"
  },
  {
    "name": "Lugo",
    "iso2": "LU",
    "timezone": "Europe/Madrid",
    "countryCode": "ES"
  },
  {
    "name": "Madrid",
    "iso2": "M",
    "timezone": "Europe/Madrid",
    "countryCode": "ES"
  },
  {
    "name": "Málaga",
    "iso2": "MA",
    "timezone": "Europe/Madrid",
    "countryCode": "ES"
  },
  {
    "name": "Melilla",
    "iso2": "ML",
    "timezone": "Africa/Ceuta",
    "countryCode": "ES"
  },
  {
    "name": "Murcia",
    "iso2": "MU",
    "timezone": "Europe/Madrid",
    "countryCode": "ES"
  },
  {
    "name": "Navarra",
    "iso2": "NA",
    "timezone": "Europe/Madrid",
    "countryCode": "ES"
  },
  {
    "name": "Navarre",
    "iso2": "NC",
    "timezone": "Europe/Madrid",
    "countryCode": "ES"
  },
  {
    "name": "Ourense",
    "iso2": "OR",
    "timezone": "Europe/Madrid",
    "countryCode": "ES"
  },
  {
    "name": "Palencia",
    "iso2": "P",
    "timezone": "Europe/Madrid",
    "countryCode": "ES"
  },
  {
    "name": "Pontevedra",
    "iso2": "PO",
    "timezone": "Europe/Madrid",
    "countryCode": "ES"
  },
  {
    "name": "Region of Murcia",
    "iso2": "MC",
    "timezone": "Europe/Madrid",
    "countryCode": "ES"
  },
  {
    "name": "Salamanca",
    "iso2": "SA",
    "timezone": "Europe/Madrid",
    "countryCode": "ES"
  },
  {
    "name": "Santa Cruz de Tenerife",
    "iso2": "TF",
    "timezone": "Atlantic/Canary",
    "countryCode": "ES"
  },
  {
    "name": "Segovia",
    "iso2": "SG",
    "timezone": "Europe/Madrid",
    "countryCode": "ES"
  },
  {
    "name": "Sevilla",
    "iso2": "SE",
    "timezone": "Europe/Madrid",
    "countryCode": "ES"
  },
  {
    "name": "Soria",
    "iso2": "SO",
    "timezone": "Europe/Madrid",
    "countryCode": "ES"
  },
  {
    "name": "Tarragona",
    "iso2": "T",
    "timezone": "Europe/Madrid",
    "countryCode": "ES"
  },
  {
    "name": "Teruel",
    "iso2": "TE",
    "timezone": "Europe/Madrid",
    "countryCode": "ES"
  },
  {
    "name": "Toledo",
    "iso2": "TO",
    "timezone": "Europe/Madrid",
    "countryCode": "ES"
  },
  {
    "name": "Valencia",
    "iso2": "V",
    "timezone": "Europe/Madrid",
    "countryCode": "ES"
  },
  {
    "name": "Valencian Community",
    "iso2": "VC",
    "timezone": "Europe/Madrid",
    "countryCode": "ES"
  },
  {
    "name": "Valladolid",
    "iso2": "VA",
    "timezone": "Europe/Madrid",
    "countryCode": "ES"
  },
  {
    "name": "Zamora",
    "iso2": "ZA",
    "timezone": "Europe/Madrid",
    "countryCode": "ES"
  },
  {
    "name": "Zaragoza",
    "iso2": "Z",
    "timezone": "Europe/Madrid",
    "countryCode": "ES"
  },
  {
    "name": "Ampara",
    "iso2": "52",
    "timezone": "Asia/Colombo",
    "countryCode": "LK"
  },
  {
    "name": "Anuradhapura",
    "iso2": "71",
    "timezone": "Asia/Colombo",
    "countryCode": "LK"
  },
  {
    "name": "Badulla",
    "iso2": "81",
    "timezone": "Asia/Colombo",
    "countryCode": "LK"
  },
  {
    "name": "Batticaloa",
    "iso2": "51",
    "timezone": "Asia/Colombo",
    "countryCode": "LK"
  },
  {
    "name": "Central",
    "iso2": "2",
    "timezone": "Asia/Colombo",
    "countryCode": "LK"
  },
  {
    "name": "Colombo",
    "iso2": "11",
    "timezone": "Asia/Colombo",
    "countryCode": "LK"
  },
  {
    "name": "Eastern",
    "iso2": "5",
    "timezone": "Asia/Colombo",
    "countryCode": "LK"
  },
  {
    "name": "Galle",
    "iso2": "31",
    "timezone": "Asia/Colombo",
    "countryCode": "LK"
  },
  {
    "name": "Gampaha",
    "iso2": "12",
    "timezone": "Asia/Colombo",
    "countryCode": "LK"
  },
  {
    "name": "Hambantota",
    "iso2": "33",
    "timezone": "Asia/Colombo",
    "countryCode": "LK"
  },
  {
    "name": "Jaffna",
    "iso2": "41",
    "timezone": "Asia/Colombo",
    "countryCode": "LK"
  },
  {
    "name": "Kalutara",
    "iso2": "13",
    "timezone": "Asia/Colombo",
    "countryCode": "LK"
  },
  {
    "name": "Kandy",
    "iso2": "21",
    "timezone": "Asia/Colombo",
    "countryCode": "LK"
  },
  {
    "name": "Kegalle",
    "iso2": "92",
    "timezone": "Asia/Colombo",
    "countryCode": "LK"
  },
  {
    "name": "Kilinochchi",
    "iso2": "42",
    "timezone": "Asia/Colombo",
    "countryCode": "LK"
  },
  {
    "name": "Kurunegala",
    "iso2": "61",
    "timezone": "Asia/Colombo",
    "countryCode": "LK"
  },
  {
    "name": "Mannar",
    "iso2": "43",
    "timezone": "Asia/Colombo",
    "countryCode": "LK"
  },
  {
    "name": "Matale",
    "iso2": "22",
    "timezone": "Asia/Colombo",
    "countryCode": "LK"
  },
  {
    "name": "Matara",
    "iso2": "32",
    "timezone": "Asia/Colombo",
    "countryCode": "LK"
  },
  {
    "name": "Monaragala",
    "iso2": "82",
    "timezone": "Asia/Colombo",
    "countryCode": "LK"
  },
  {
    "name": "Mullaitivu",
    "iso2": "45",
    "timezone": "Asia/Colombo",
    "countryCode": "LK"
  },
  {
    "name": "North Central",
    "iso2": "7",
    "timezone": "Asia/Colombo",
    "countryCode": "LK"
  },
  {
    "name": "North Western",
    "iso2": "6",
    "timezone": "Asia/Colombo",
    "countryCode": "LK"
  },
  {
    "name": "Northern",
    "iso2": "4",
    "timezone": "Asia/Colombo",
    "countryCode": "LK"
  },
  {
    "name": "Nuwara Eliya",
    "iso2": "23",
    "timezone": "Asia/Colombo",
    "countryCode": "LK"
  },
  {
    "name": "Polonnaruwa",
    "iso2": "72",
    "timezone": "Asia/Colombo",
    "countryCode": "LK"
  },
  {
    "name": "Puttalam",
    "iso2": "62",
    "timezone": "Asia/Colombo",
    "countryCode": "LK"
  },
  {
    "name": "Ratnapura",
    "iso2": "91",
    "timezone": "Asia/Colombo",
    "countryCode": "LK"
  },
  {
    "name": "Sabaragamuwa",
    "iso2": "9",
    "timezone": "Asia/Colombo",
    "countryCode": "LK"
  },
  {
    "name": "Southern",
    "iso2": "3",
    "timezone": "Asia/Colombo",
    "countryCode": "LK"
  },
  {
    "name": "Trincomalee",
    "iso2": "53",
    "timezone": "Asia/Colombo",
    "countryCode": "LK"
  },
  {
    "name": "Uva",
    "iso2": "8",
    "timezone": "Asia/Colombo",
    "countryCode": "LK"
  },
  {
    "name": "Vavuniya",
    "iso2": "44",
    "timezone": "Asia/Colombo",
    "countryCode": "LK"
  },
  {
    "name": "Western",
    "iso2": "1",
    "timezone": "Asia/Colombo",
    "countryCode": "LK"
  },
  {
    "name": "Al Jazirah",
    "iso2": "GZ",
    "timezone": "Africa/Khartoum",
    "countryCode": "SD"
  },
  {
    "name": "Al Qadarif",
    "iso2": "GD",
    "timezone": "Africa/Khartoum",
    "countryCode": "SD"
  },
  {
    "name": "Blue Nile",
    "iso2": "NB",
    "timezone": "Africa/Khartoum",
    "countryCode": "SD"
  },
  {
    "name": "Central Darfur",
    "iso2": "DC",
    "timezone": "Africa/Khartoum",
    "countryCode": "SD"
  },
  {
    "name": "East Darfur",
    "iso2": "DE",
    "timezone": "Africa/Khartoum",
    "countryCode": "SD"
  },
  {
    "name": "Kassala",
    "iso2": "KA",
    "timezone": "Africa/Khartoum",
    "countryCode": "SD"
  },
  {
    "name": "Khartoum",
    "iso2": "KH",
    "timezone": "Africa/Khartoum",
    "countryCode": "SD"
  },
  {
    "name": "North Darfur",
    "iso2": "DN",
    "timezone": "Africa/Khartoum",
    "countryCode": "SD"
  },
  {
    "name": "North Kordofan",
    "iso2": "KN",
    "timezone": "Africa/Khartoum",
    "countryCode": "SD"
  },
  {
    "name": "Northern",
    "iso2": "NO",
    "timezone": "Africa/Khartoum",
    "countryCode": "SD"
  },
  {
    "name": "Red Sea",
    "iso2": "RS",
    "timezone": "Africa/Khartoum",
    "countryCode": "SD"
  },
  {
    "name": "River Nile",
    "iso2": "NR",
    "timezone": "Africa/Khartoum",
    "countryCode": "SD"
  },
  {
    "name": "Sennar",
    "iso2": "SI",
    "timezone": "Africa/Khartoum",
    "countryCode": "SD"
  },
  {
    "name": "South Darfur",
    "iso2": "DS",
    "timezone": "Africa/Khartoum",
    "countryCode": "SD"
  },
  {
    "name": "South Kordofan",
    "iso2": "KS",
    "timezone": "Africa/Khartoum",
    "countryCode": "SD"
  },
  {
    "name": "West Darfur",
    "iso2": "DW",
    "timezone": "Africa/Khartoum",
    "countryCode": "SD"
  },
  {
    "name": "West Kordofan",
    "iso2": "GK",
    "timezone": "Africa/Khartoum",
    "countryCode": "SD"
  },
  {
    "name": "White Nile",
    "iso2": "NW",
    "timezone": "Africa/Khartoum",
    "countryCode": "SD"
  },
  {
    "name": "Brokopondo",
    "iso2": "BR",
    "timezone": "America/Paramaribo",
    "countryCode": "SR"
  },
  {
    "name": "Commewijne",
    "iso2": "CM",
    "timezone": "America/Paramaribo",
    "countryCode": "SR"
  },
  {
    "name": "Coronie",
    "iso2": "CR",
    "timezone": "America/Paramaribo",
    "countryCode": "SR"
  },
  {
    "name": "Marowijne",
    "iso2": "MA",
    "timezone": "America/Paramaribo",
    "countryCode": "SR"
  },
  {
    "name": "Nickerie",
    "iso2": "NI",
    "timezone": "America/Paramaribo",
    "countryCode": "SR"
  },
  {
    "name": "Para",
    "iso2": "PR",
    "timezone": "America/Paramaribo",
    "countryCode": "SR"
  },
  {
    "name": "Paramaribo",
    "iso2": "PM",
    "timezone": "America/Paramaribo",
    "countryCode": "SR"
  },
  {
    "name": "Saramacca",
    "iso2": "SA",
    "timezone": "America/Paramaribo",
    "countryCode": "SR"
  },
  {
    "name": "Sipaliwini",
    "iso2": "SI",
    "timezone": "America/Paramaribo",
    "countryCode": "SR"
  },
  {
    "name": "Wanica",
    "iso2": "WA",
    "timezone": "America/Paramaribo",
    "countryCode": "SR"
  },
  {
    "name": "Blekinge",
    "iso2": "K",
    "timezone": "Europe/Stockholm",
    "countryCode": "SE"
  },
  {
    "name": "Dalarna",
    "iso2": "W",
    "timezone": "Europe/Stockholm",
    "countryCode": "SE"
  },
  {
    "name": "Gävleborg",
    "iso2": "X",
    "timezone": "Europe/Stockholm",
    "countryCode": "SE"
  },
  {
    "name": "Gotland",
    "iso2": "I",
    "timezone": "Europe/Stockholm",
    "countryCode": "SE"
  },
  {
    "name": "Halland",
    "iso2": "N",
    "timezone": "Europe/Stockholm",
    "countryCode": "SE"
  },
  {
    "name": "Jämtland",
    "iso2": "Z",
    "timezone": "Europe/Stockholm",
    "countryCode": "SE"
  },
  {
    "name": "Jönköping",
    "iso2": "F",
    "timezone": "Europe/Stockholm",
    "countryCode": "SE"
  },
  {
    "name": "Kalmar",
    "iso2": "H",
    "timezone": "Europe/Stockholm",
    "countryCode": "SE"
  },
  {
    "name": "Kronoberg",
    "iso2": "G",
    "timezone": "Europe/Stockholm",
    "countryCode": "SE"
  },
  {
    "name": "Norrbotten",
    "iso2": "BD",
    "timezone": "Europe/Stockholm",
    "countryCode": "SE"
  },
  {
    "name": "Örebro",
    "iso2": "T",
    "timezone": "Europe/Stockholm",
    "countryCode": "SE"
  },
  {
    "name": "Östergötland",
    "iso2": "E",
    "timezone": "Europe/Stockholm",
    "countryCode": "SE"
  },
  {
    "name": "Skåne",
    "iso2": "M",
    "timezone": "Europe/Stockholm",
    "countryCode": "SE"
  },
  {
    "name": "Södermanland",
    "iso2": "D",
    "timezone": "Europe/Stockholm",
    "countryCode": "SE"
  },
  {
    "name": "Stockholm",
    "iso2": "AB",
    "timezone": "Europe/Stockholm",
    "countryCode": "SE"
  },
  {
    "name": "Uppsala",
    "iso2": "C",
    "timezone": "Europe/Stockholm",
    "countryCode": "SE"
  },
  {
    "name": "Värmland",
    "iso2": "S",
    "timezone": "Europe/Stockholm",
    "countryCode": "SE"
  },
  {
    "name": "Västerbotten",
    "iso2": "AC",
    "timezone": "Europe/Stockholm",
    "countryCode": "SE"
  },
  {
    "name": "Västernorrland",
    "iso2": "Y",
    "timezone": "Europe/Stockholm",
    "countryCode": "SE"
  },
  {
    "name": "Västmanland",
    "iso2": "U",
    "timezone": "Europe/Stockholm",
    "countryCode": "SE"
  },
  {
    "name": "Västra Götaland",
    "iso2": "O",
    "timezone": "Europe/Stockholm",
    "countryCode": "SE"
  },
  {
    "name": "Aargau",
    "iso2": "AG",
    "timezone": "Europe/Zurich",
    "countryCode": "CH"
  },
  {
    "name": "Appenzell Ausserrhoden",
    "iso2": "AR",
    "timezone": "Europe/Zurich",
    "countryCode": "CH"
  },
  {
    "name": "Appenzell Innerrhoden",
    "iso2": "AI",
    "timezone": "Europe/Zurich",
    "countryCode": "CH"
  },
  {
    "name": "Basel-Land",
    "iso2": "BL",
    "timezone": "Europe/Zurich",
    "countryCode": "CH"
  },
  {
    "name": "Basel-Stadt",
    "iso2": "BS",
    "timezone": "Europe/Zurich",
    "countryCode": "CH"
  },
  {
    "name": "Bern",
    "iso2": "BE",
    "timezone": "Europe/Zurich",
    "countryCode": "CH"
  },
  {
    "name": "Fribourg",
    "iso2": "FR",
    "timezone": "Europe/Zurich",
    "countryCode": "CH"
  },
  {
    "name": "Geneva",
    "iso2": "GE",
    "timezone": "Europe/Zurich",
    "countryCode": "CH"
  },
  {
    "name": "Glarus",
    "iso2": "GL",
    "timezone": "Europe/Zurich",
    "countryCode": "CH"
  },
  {
    "name": "Graubünden",
    "iso2": "GR",
    "timezone": "Europe/Zurich",
    "countryCode": "CH"
  },
  {
    "name": "Jura",
    "iso2": "JU",
    "timezone": "Europe/Zurich",
    "countryCode": "CH"
  },
  {
    "name": "Lucerne",
    "iso2": "LU",
    "timezone": "Europe/Zurich",
    "countryCode": "CH"
  },
  {
    "name": "Neuchâtel",
    "iso2": "NE",
    "timezone": "Europe/Zurich",
    "countryCode": "CH"
  },
  {
    "name": "Nidwalden",
    "iso2": "NW",
    "timezone": "Europe/Zurich",
    "countryCode": "CH"
  },
  {
    "name": "Obwalden",
    "iso2": "OW",
    "timezone": "Europe/Zurich",
    "countryCode": "CH"
  },
  {
    "name": "Schaffhausen",
    "iso2": "SH",
    "timezone": "Europe/Zurich",
    "countryCode": "CH"
  },
  {
    "name": "Schwyz",
    "iso2": "SZ",
    "timezone": "Europe/Zurich",
    "countryCode": "CH"
  },
  {
    "name": "Solothurn",
    "iso2": "SO",
    "timezone": "Europe/Zurich",
    "countryCode": "CH"
  },
  {
    "name": "St. Gallen",
    "iso2": "SG",
    "timezone": "Europe/Zurich",
    "countryCode": "CH"
  },
  {
    "name": "Thurgau",
    "iso2": "TG",
    "timezone": "Europe/Zurich",
    "countryCode": "CH"
  },
  {
    "name": "Ticino",
    "iso2": "TI",
    "timezone": "Europe/Zurich",
    "countryCode": "CH"
  },
  {
    "name": "Uri",
    "iso2": "UR",
    "timezone": "Europe/Zurich",
    "countryCode": "CH"
  },
  {
    "name": "Valais",
    "iso2": "VS",
    "timezone": "Europe/Zurich",
    "countryCode": "CH"
  },
  {
    "name": "Vaud",
    "iso2": "VD",
    "timezone": "Europe/Zurich",
    "countryCode": "CH"
  },
  {
    "name": "Zug",
    "iso2": "ZG",
    "timezone": "Europe/Zurich",
    "countryCode": "CH"
  },
  {
    "name": "Zürich",
    "iso2": "ZH",
    "timezone": "Europe/Zurich",
    "countryCode": "CH"
  },
  {
    "name": "Al-Hasakah",
    "iso2": "HA",
    "timezone": "Asia/Damascus",
    "countryCode": "SY"
  },
  {
    "name": "Al-Raqqah",
    "iso2": "RA",
    "timezone": "Asia/Damascus",
    "countryCode": "SY"
  },
  {
    "name": "Aleppo",
    "iso2": "HL",
    "timezone": "Asia/Damascus",
    "countryCode": "SY"
  },
  {
    "name": "As-Suwayda",
    "iso2": "SU",
    "timezone": "Asia/Damascus",
    "countryCode": "SY"
  },
  {
    "name": "Damascus",
    "iso2": "DI",
    "timezone": "Asia/Damascus",
    "countryCode": "SY"
  },
  {
    "name": "Daraa",
    "iso2": "DR",
    "timezone": "Asia/Damascus",
    "countryCode": "SY"
  },
  {
    "name": "Deir ez-Zor",
    "iso2": "DY",
    "timezone": "Asia/Damascus",
    "countryCode": "SY"
  },
  {
    "name": "Hama",
    "iso2": "HM",
    "timezone": "Asia/Damascus",
    "countryCode": "SY"
  },
  {
    "name": "Homs",
    "iso2": "HI",
    "timezone": "Asia/Damascus",
    "countryCode": "SY"
  },
  {
    "name": "Idlib",
    "iso2": "ID",
    "timezone": "Asia/Damascus",
    "countryCode": "SY"
  },
  {
    "name": "Latakia",
    "iso2": "LA",
    "timezone": "Asia/Damascus",
    "countryCode": "SY"
  },
  {
    "name": "Quneitra",
    "iso2": "QU",
    "timezone": "Asia/Damascus",
    "countryCode": "SY"
  },
  {
    "name": "Rif Dimashq",
    "iso2": "RD",
    "timezone": "Asia/Damascus",
    "countryCode": "SY"
  },
  {
    "name": "Tartus",
    "iso2": "TA",
    "timezone": "Asia/Damascus",
    "countryCode": "SY"
  },
  {
    "name": "Changhua",
    "iso2": "CHA",
    "timezone": "Asia/Taipei",
    "countryCode": "TW"
  },
  {
    "name": "Chiayi",
    "iso2": "CYI",
    "timezone": "Asia/Taipei",
    "countryCode": "TW"
  },
  {
    "name": "Chiayi County",
    "iso2": "CYQ",
    "timezone": "Asia/Taipei",
    "countryCode": "TW"
  },
  {
    "name": "Hsinchu",
    "iso2": "HSZ",
    "timezone": "Asia/Taipei",
    "countryCode": "TW"
  },
  {
    "name": "Hsinchu County",
    "iso2": "HSQ",
    "timezone": "Asia/Taipei",
    "countryCode": "TW"
  },
  {
    "name": "Hualien",
    "iso2": "HUA",
    "timezone": "Asia/Taipei",
    "countryCode": "TW"
  },
  {
    "name": "Kaohsiung",
    "iso2": "KHH",
    "timezone": "Asia/Taipei",
    "countryCode": "TW"
  },
  {
    "name": "Keelung",
    "iso2": "KEE",
    "timezone": "Asia/Taipei",
    "countryCode": "TW"
  },
  {
    "name": "Kinmen",
    "iso2": "KIN",
    "timezone": "Asia/Taipei",
    "countryCode": "TW"
  },
  {
    "name": "Lienchiang",
    "iso2": "LIE",
    "timezone": "Asia/Taipei",
    "countryCode": "TW"
  },
  {
    "name": "Miaoli",
    "iso2": "MIA",
    "timezone": "Asia/Taipei",
    "countryCode": "TW"
  },
  {
    "name": "Nantou",
    "iso2": "NAN",
    "timezone": "Asia/Taipei",
    "countryCode": "TW"
  },
  {
    "name": "New Taipei",
    "iso2": "NWT",
    "timezone": "Asia/Taipei",
    "countryCode": "TW"
  },
  {
    "name": "Penghu",
    "iso2": "PEN",
    "timezone": "Asia/Taipei",
    "countryCode": "TW"
  },
  {
    "name": "Pingtung",
    "iso2": "PIF",
    "timezone": "Asia/Taipei",
    "countryCode": "TW"
  },
  {
    "name": "Taichung",
    "iso2": "TXG",
    "timezone": "Asia/Taipei",
    "countryCode": "TW"
  },
  {
    "name": "Tainan",
    "iso2": "TNN",
    "timezone": "Asia/Taipei",
    "countryCode": "TW"
  },
  {
    "name": "Taipei",
    "iso2": "TPE",
    "timezone": "Asia/Taipei",
    "countryCode": "TW"
  },
  {
    "name": "Taitung",
    "iso2": "TTT",
    "timezone": "Asia/Taipei",
    "countryCode": "TW"
  },
  {
    "name": "Taoyuan",
    "iso2": "TAO",
    "timezone": "Asia/Taipei",
    "countryCode": "TW"
  },
  {
    "name": "Yilan",
    "iso2": "ILA",
    "timezone": "Asia/Taipei",
    "countryCode": "TW"
  },
  {
    "name": "Yunlin",
    "iso2": "YUN",
    "timezone": "Asia/Taipei",
    "countryCode": "TW"
  },
  {
    "name": "Dushanbe",
    "iso2": "DU",
    "timezone": "Asia/Dushanbe",
    "countryCode": "TJ"
  },
  {
    "name": "Gorno-Badakhshan",
    "iso2": "GB",
    "timezone": "Asia/Dushanbe",
    "countryCode": "TJ"
  },
  {
    "name": "Khatlon",
    "iso2": "KT",
    "timezone": "Asia/Dushanbe",
    "countryCode": "TJ"
  },
  {
    "name": "Nohiyahoi Tobei Jumhurí ",
    "iso2": "RA",
    "timezone": "Asia/Dushanbe",
    "countryCode": "TJ"
  },
  {
    "name": "Sughd ",
    "iso2": "SU",
    "timezone": "Asia/Dushanbe",
    "countryCode": "TJ"
  },
  {
    "name": "Arusha",
    "iso2": "01",
    "timezone": "Africa/Dar_es_Salaam",
    "countryCode": "TZ"
  },
  {
    "name": "Dar es Salaam",
    "iso2": "02",
    "timezone": "Africa/Dar_es_Salaam",
    "countryCode": "TZ"
  },
  {
    "name": "Dodoma",
    "iso2": "03",
    "timezone": "Africa/Dar_es_Salaam",
    "countryCode": "TZ"
  },
  {
    "name": "Geita",
    "iso2": "27",
    "timezone": "Africa/Dar_es_Salaam",
    "countryCode": "TZ"
  },
  {
    "name": "Iringa",
    "iso2": "04",
    "timezone": "Africa/Dar_es_Salaam",
    "countryCode": "TZ"
  },
  {
    "name": "Kagera",
    "iso2": "05",
    "timezone": "Africa/Dar_es_Salaam",
    "countryCode": "TZ"
  },
  {
    "name": "Katavi",
    "iso2": "28",
    "timezone": "Africa/Dar_es_Salaam",
    "countryCode": "TZ"
  },
  {
    "name": "Kigoma",
    "iso2": "08",
    "timezone": "Africa/Dar_es_Salaam",
    "countryCode": "TZ"
  },
  {
    "name": "Kilimanjaro",
    "iso2": "09",
    "timezone": "Africa/Dar_es_Salaam",
    "countryCode": "TZ"
  },
  {
    "name": "Lindi",
    "iso2": "12",
    "timezone": "Africa/Dar_es_Salaam",
    "countryCode": "TZ"
  },
  {
    "name": "Manyara",
    "iso2": "26",
    "timezone": "Africa/Dar_es_Salaam",
    "countryCode": "TZ"
  },
  {
    "name": "Mara",
    "iso2": "13",
    "timezone": "Africa/Dar_es_Salaam",
    "countryCode": "TZ"
  },
  {
    "name": "Mbeya",
    "iso2": "14",
    "timezone": "Africa/Dar_es_Salaam",
    "countryCode": "TZ"
  },
  {
    "name": "Morogoro",
    "iso2": "16",
    "timezone": "Africa/Dar_es_Salaam",
    "countryCode": "TZ"
  },
  {
    "name": "Mtwara",
    "iso2": "17",
    "timezone": "Africa/Dar_es_Salaam",
    "countryCode": "TZ"
  },
  {
    "name": "Mwanza",
    "iso2": "18",
    "timezone": "Africa/Dar_es_Salaam",
    "countryCode": "TZ"
  },
  {
    "name": "Njombe",
    "iso2": "29",
    "timezone": "Africa/Dar_es_Salaam",
    "countryCode": "TZ"
  },
  {
    "name": "Pemba North",
    "iso2": "06",
    "timezone": "Africa/Dar_es_Salaam",
    "countryCode": "TZ"
  },
  {
    "name": "Pemba South",
    "iso2": "10",
    "timezone": "Africa/Dar_es_Salaam",
    "countryCode": "TZ"
  },
  {
    "name": "Pwani",
    "iso2": "19",
    "timezone": "Africa/Dar_es_Salaam",
    "countryCode": "TZ"
  },
  {
    "name": "Rukwa",
    "iso2": "20",
    "timezone": "Africa/Dar_es_Salaam",
    "countryCode": "TZ"
  },
  {
    "name": "Ruvuma",
    "iso2": "21",
    "timezone": "Africa/Dar_es_Salaam",
    "countryCode": "TZ"
  },
  {
    "name": "Shinyanga",
    "iso2": "22",
    "timezone": "Africa/Dar_es_Salaam",
    "countryCode": "TZ"
  },
  {
    "name": "Simiyu",
    "iso2": "30",
    "timezone": "Africa/Dar_es_Salaam",
    "countryCode": "TZ"
  },
  {
    "name": "Singida",
    "iso2": "23",
    "timezone": "Africa/Dar_es_Salaam",
    "countryCode": "TZ"
  },
  {
    "name": "Songwe",
    "iso2": "31",
    "timezone": "Africa/Dar_es_Salaam",
    "countryCode": "TZ"
  },
  {
    "name": "Tabora",
    "iso2": "24",
    "timezone": "Africa/Dar_es_Salaam",
    "countryCode": "TZ"
  },
  {
    "name": "Tanga",
    "iso2": "25",
    "timezone": "Africa/Dar_es_Salaam",
    "countryCode": "TZ"
  },
  {
    "name": "Zanzibar North",
    "iso2": "07",
    "timezone": "Africa/Dar_es_Salaam",
    "countryCode": "TZ"
  },
  {
    "name": "Zanzibar South",
    "iso2": "11",
    "timezone": "Africa/Dar_es_Salaam",
    "countryCode": "TZ"
  },
  {
    "name": "Zanzibar West",
    "iso2": "15",
    "timezone": "Africa/Dar_es_Salaam",
    "countryCode": "TZ"
  },
  {
    "name": "Amnat Charoen",
    "iso2": "37",
    "timezone": "Asia/Bangkok",
    "countryCode": "TH"
  },
  {
    "name": "Ang Thong",
    "iso2": "15",
    "timezone": "Asia/Bangkok",
    "countryCode": "TH"
  },
  {
    "name": "Bangkok",
    "iso2": "10",
    "timezone": "Asia/Bangkok",
    "countryCode": "TH"
  },
  {
    "name": "Bueng Kan",
    "iso2": "38",
    "timezone": "Asia/Bangkok",
    "countryCode": "TH"
  },
  {
    "name": "Buri Ram",
    "iso2": "31",
    "timezone": "Asia/Bangkok",
    "countryCode": "TH"
  },
  {
    "name": "Chachoengsao",
    "iso2": "24",
    "timezone": "Asia/Bangkok",
    "countryCode": "TH"
  },
  {
    "name": "Chai Nat",
    "iso2": "18",
    "timezone": "Asia/Bangkok",
    "countryCode": "TH"
  },
  {
    "name": "Chaiyaphum",
    "iso2": "36",
    "timezone": "Asia/Bangkok",
    "countryCode": "TH"
  },
  {
    "name": "Chanthaburi",
    "iso2": "22",
    "timezone": "Asia/Bangkok",
    "countryCode": "TH"
  },
  {
    "name": "Chiang Mai",
    "iso2": "50",
    "timezone": "Asia/Bangkok",
    "countryCode": "TH"
  },
  {
    "name": "Chiang Rai",
    "iso2": "57",
    "timezone": "Asia/Bangkok",
    "countryCode": "TH"
  },
  {
    "name": "Chon Buri",
    "iso2": "20",
    "timezone": "Asia/Bangkok",
    "countryCode": "TH"
  },
  {
    "name": "Chumphon",
    "iso2": "86",
    "timezone": "Asia/Bangkok",
    "countryCode": "TH"
  },
  {
    "name": "Kalasin",
    "iso2": "46",
    "timezone": "Asia/Bangkok",
    "countryCode": "TH"
  },
  {
    "name": "Kamphaeng Phet",
    "iso2": "62",
    "timezone": "Asia/Bangkok",
    "countryCode": "TH"
  },
  {
    "name": "Kanchanaburi",
    "iso2": "71",
    "timezone": "Asia/Bangkok",
    "countryCode": "TH"
  },
  {
    "name": "Khon Kaen",
    "iso2": "40",
    "timezone": "Asia/Bangkok",
    "countryCode": "TH"
  },
  {
    "name": "Krabi",
    "iso2": "81",
    "timezone": "Asia/Bangkok",
    "countryCode": "TH"
  },
  {
    "name": "Lampang",
    "iso2": "52",
    "timezone": "Asia/Bangkok",
    "countryCode": "TH"
  },
  {
    "name": "Lamphun",
    "iso2": "51",
    "timezone": "Asia/Bangkok",
    "countryCode": "TH"
  },
  {
    "name": "Loei",
    "iso2": "42",
    "timezone": "Asia/Bangkok",
    "countryCode": "TH"
  },
  {
    "name": "Lop Buri",
    "iso2": "16",
    "timezone": "Asia/Bangkok",
    "countryCode": "TH"
  },
  {
    "name": "Mae Hong Son",
    "iso2": "58",
    "timezone": "Asia/Bangkok",
    "countryCode": "TH"
  },
  {
    "name": "Maha Sarakham",
    "iso2": "44",
    "timezone": "Asia/Bangkok",
    "countryCode": "TH"
  },
  {
    "name": "Mukdahan",
    "iso2": "49",
    "timezone": "Asia/Bangkok",
    "countryCode": "TH"
  },
  {
    "name": "Nakhon Nayok",
    "iso2": "26",
    "timezone": "Asia/Bangkok",
    "countryCode": "TH"
  },
  {
    "name": "Nakhon Pathom",
    "iso2": "73",
    "timezone": "Asia/Bangkok",
    "countryCode": "TH"
  },
  {
    "name": "Nakhon Phanom",
    "iso2": "48",
    "timezone": "Asia/Bangkok",
    "countryCode": "TH"
  },
  {
    "name": "Nakhon Ratchasima",
    "iso2": "30",
    "timezone": "Asia/Bangkok",
    "countryCode": "TH"
  },
  {
    "name": "Nakhon Sawan",
    "iso2": "60",
    "timezone": "Asia/Bangkok",
    "countryCode": "TH"
  },
  {
    "name": "Nakhon Si Thammarat",
    "iso2": "80",
    "timezone": "Asia/Bangkok",
    "countryCode": "TH"
  },
  {
    "name": "Nan",
    "iso2": "55",
    "timezone": "Asia/Bangkok",
    "countryCode": "TH"
  },
  {
    "name": "Narathiwat",
    "iso2": "96",
    "timezone": "Asia/Bangkok",
    "countryCode": "TH"
  },
  {
    "name": "Nong Bua Lam Phu",
    "iso2": "39",
    "timezone": "Asia/Bangkok",
    "countryCode": "TH"
  },
  {
    "name": "Nong Khai",
    "iso2": "43",
    "timezone": "Asia/Bangkok",
    "countryCode": "TH"
  },
  {
    "name": "Nonthaburi",
    "iso2": "12",
    "timezone": "Asia/Bangkok",
    "countryCode": "TH"
  },
  {
    "name": "Pathum Thani",
    "iso2": "13",
    "timezone": "Asia/Bangkok",
    "countryCode": "TH"
  },
  {
    "name": "Pattani",
    "iso2": "94",
    "timezone": "Asia/Bangkok",
    "countryCode": "TH"
  },
  {
    "name": "Pattaya",
    "iso2": "S",
    "timezone": "Asia/Bangkok",
    "countryCode": "TH"
  },
  {
    "name": "Phangnga",
    "iso2": "82",
    "timezone": "Asia/Bangkok",
    "countryCode": "TH"
  },
  {
    "name": "Phatthalung",
    "iso2": "93",
    "timezone": "Asia/Bangkok",
    "countryCode": "TH"
  },
  {
    "name": "Phayao",
    "iso2": "56",
    "timezone": "Asia/Bangkok",
    "countryCode": "TH"
  },
  {
    "name": "Phetchabun",
    "iso2": "67",
    "timezone": "Asia/Bangkok",
    "countryCode": "TH"
  },
  {
    "name": "Phetchaburi",
    "iso2": "76",
    "timezone": "Asia/Bangkok",
    "countryCode": "TH"
  },
  {
    "name": "Phichit",
    "iso2": "66",
    "timezone": "Asia/Bangkok",
    "countryCode": "TH"
  },
  {
    "name": "Phitsanulok",
    "iso2": "65",
    "timezone": "Asia/Bangkok",
    "countryCode": "TH"
  },
  {
    "name": "Phra Nakhon Si Ayutthaya",
    "iso2": "14",
    "timezone": "Asia/Bangkok",
    "countryCode": "TH"
  },
  {
    "name": "Phrae",
    "iso2": "54",
    "timezone": "Asia/Bangkok",
    "countryCode": "TH"
  },
  {
    "name": "Phuket",
    "iso2": "83",
    "timezone": "Asia/Bangkok",
    "countryCode": "TH"
  },
  {
    "name": "Prachin Buri",
    "iso2": "25",
    "timezone": "Asia/Bangkok",
    "countryCode": "TH"
  },
  {
    "name": "Prachuap Khiri Khan",
    "iso2": "77",
    "timezone": "Asia/Bangkok",
    "countryCode": "TH"
  },
  {
    "name": "Ranong",
    "iso2": "85",
    "timezone": "Asia/Bangkok",
    "countryCode": "TH"
  },
  {
    "name": "Ratchaburi",
    "iso2": "70",
    "timezone": "Asia/Bangkok",
    "countryCode": "TH"
  },
  {
    "name": "Rayong",
    "iso2": "21",
    "timezone": "Asia/Bangkok",
    "countryCode": "TH"
  },
  {
    "name": "Roi Et",
    "iso2": "45",
    "timezone": "Asia/Bangkok",
    "countryCode": "TH"
  },
  {
    "name": "Sa Kaeo",
    "iso2": "27",
    "timezone": "Asia/Bangkok",
    "countryCode": "TH"
  },
  {
    "name": "Sakon Nakhon",
    "iso2": "47",
    "timezone": "Asia/Bangkok",
    "countryCode": "TH"
  },
  {
    "name": "Samut Prakan",
    "iso2": "11",
    "timezone": "Asia/Bangkok",
    "countryCode": "TH"
  },
  {
    "name": "Samut Sakhon",
    "iso2": "74",
    "timezone": "Asia/Bangkok",
    "countryCode": "TH"
  },
  {
    "name": "Samut Songkhram",
    "iso2": "75",
    "timezone": "Asia/Bangkok",
    "countryCode": "TH"
  },
  {
    "name": "Saraburi",
    "iso2": "19",
    "timezone": "Asia/Bangkok",
    "countryCode": "TH"
  },
  {
    "name": "Satun",
    "iso2": "91",
    "timezone": "Asia/Bangkok",
    "countryCode": "TH"
  },
  {
    "name": "Si Sa Ket",
    "iso2": "33",
    "timezone": "Asia/Bangkok",
    "countryCode": "TH"
  },
  {
    "name": "Sing Buri",
    "iso2": "17",
    "timezone": "Asia/Bangkok",
    "countryCode": "TH"
  },
  {
    "name": "Songkhla",
    "iso2": "90",
    "timezone": "Asia/Bangkok",
    "countryCode": "TH"
  },
  {
    "name": "Sukhothai",
    "iso2": "64",
    "timezone": "Asia/Bangkok",
    "countryCode": "TH"
  },
  {
    "name": "Suphan Buri",
    "iso2": "72",
    "timezone": "Asia/Bangkok",
    "countryCode": "TH"
  },
  {
    "name": "Surat Thani",
    "iso2": "84",
    "timezone": "Asia/Bangkok",
    "countryCode": "TH"
  },
  {
    "name": "Surin",
    "iso2": "32",
    "timezone": "Asia/Bangkok",
    "countryCode": "TH"
  },
  {
    "name": "Tak",
    "iso2": "63",
    "timezone": "Asia/Bangkok",
    "countryCode": "TH"
  },
  {
    "name": "Trang",
    "iso2": "92",
    "timezone": "Asia/Bangkok",
    "countryCode": "TH"
  },
  {
    "name": "Trat",
    "iso2": "23",
    "timezone": "Asia/Bangkok",
    "countryCode": "TH"
  },
  {
    "name": "Ubon Ratchathani",
    "iso2": "34",
    "timezone": "Asia/Bangkok",
    "countryCode": "TH"
  },
  {
    "name": "Udon Thani",
    "iso2": "41",
    "timezone": "Asia/Bangkok",
    "countryCode": "TH"
  },
  {
    "name": "Uthai Thani",
    "iso2": "61",
    "timezone": "Asia/Bangkok",
    "countryCode": "TH"
  },
  {
    "name": "Uttaradit",
    "iso2": "53",
    "timezone": "Asia/Bangkok",
    "countryCode": "TH"
  },
  {
    "name": "Yala",
    "iso2": "95",
    "timezone": "Asia/Bangkok",
    "countryCode": "TH"
  },
  {
    "name": "Yasothon",
    "iso2": "35",
    "timezone": "Asia/Bangkok",
    "countryCode": "TH"
  },
  {
    "name": "Acklins",
    "iso2": "AK",
    "timezone": "America/Nassau",
    "countryCode": "BS"
  },
  {
    "name": "Berry Islands",
    "iso2": "BY",
    "timezone": "America/Nassau",
    "countryCode": "BS"
  },
  {
    "name": "Bimini",
    "iso2": "BI",
    "timezone": "America/Nassau",
    "countryCode": "BS"
  },
  {
    "name": "Black Point",
    "iso2": "BP",
    "timezone": "America/Nassau",
    "countryCode": "BS"
  },
  {
    "name": "Cat Island",
    "iso2": "CI",
    "timezone": "America/Nassau",
    "countryCode": "BS"
  },
  {
    "name": "Central Abaco",
    "iso2": "CO",
    "timezone": "America/Nassau",
    "countryCode": "BS"
  },
  {
    "name": "Central Andros",
    "iso2": "CS",
    "timezone": "America/Nassau",
    "countryCode": "BS"
  },
  {
    "name": "Central Eleuthera",
    "iso2": "CE",
    "timezone": "America/Nassau",
    "countryCode": "BS"
  },
  {
    "name": "Crooked Island",
    "iso2": "CK",
    "timezone": "America/Nassau",
    "countryCode": "BS"
  },
  {
    "name": "East Grand Bahama",
    "iso2": "EG",
    "timezone": "America/Nassau",
    "countryCode": "BS"
  },
  {
    "name": "Exuma",
    "iso2": "EX",
    "timezone": "America/Nassau",
    "countryCode": "BS"
  },
  {
    "name": "Freeport",
    "iso2": "FP",
    "timezone": "America/Nassau",
    "countryCode": "BS"
  },
  {
    "name": "Grand Cay",
    "iso2": "GC",
    "timezone": "America/Nassau",
    "countryCode": "BS"
  },
  {
    "name": "Harbour Island",
    "iso2": "HI",
    "timezone": "America/Nassau",
    "countryCode": "BS"
  },
  {
    "name": "Hope Town",
    "iso2": "HT",
    "timezone": "America/Nassau",
    "countryCode": "BS"
  },
  {
    "name": "Inagua",
    "iso2": "IN",
    "timezone": "America/Nassau",
    "countryCode": "BS"
  },
  {
    "name": "Long Island",
    "iso2": "LI",
    "timezone": "America/Nassau",
    "countryCode": "BS"
  },
  {
    "name": "Mangrove Cay",
    "iso2": "MC",
    "timezone": "America/Nassau",
    "countryCode": "BS"
  },
  {
    "name": "Mayaguana",
    "iso2": "MG",
    "timezone": "America/Nassau",
    "countryCode": "BS"
  },
  {
    "name": "Moore's Island",
    "iso2": "MI",
    "timezone": "America/Nassau",
    "countryCode": "BS"
  },
  {
    "name": "New Providence",
    "iso2": "NP",
    "timezone": "America/Nassau",
    "countryCode": "BS"
  },
  {
    "name": "North Abaco",
    "iso2": "NO",
    "timezone": "America/Nassau",
    "countryCode": "BS"
  },
  {
    "name": "North Andros",
    "iso2": "NS",
    "timezone": "America/Nassau",
    "countryCode": "BS"
  },
  {
    "name": "North Eleuthera",
    "iso2": "NE",
    "timezone": "America/Nassau",
    "countryCode": "BS"
  },
  {
    "name": "Ragged Island",
    "iso2": "RI",
    "timezone": "America/Nassau",
    "countryCode": "BS"
  },
  {
    "name": "Rum Cay",
    "iso2": "RC",
    "timezone": "America/Nassau",
    "countryCode": "BS"
  },
  {
    "name": "San Salvador Island",
    "iso2": "SS",
    "timezone": "America/Nassau",
    "countryCode": "BS"
  },
  {
    "name": "South Abaco",
    "iso2": "SO",
    "timezone": "America/Nassau",
    "countryCode": "BS"
  },
  {
    "name": "South Andros",
    "iso2": "SA",
    "timezone": "America/Nassau",
    "countryCode": "BS"
  },
  {
    "name": "South Eleuthera",
    "iso2": "SE",
    "timezone": "America/Nassau",
    "countryCode": "BS"
  },
  {
    "name": "Spanish Wells",
    "iso2": "SW",
    "timezone": "America/Nassau",
    "countryCode": "BS"
  },
  {
    "name": "West Grand Bahama",
    "iso2": "WG",
    "timezone": "America/Nassau",
    "countryCode": "BS"
  },
  {
    "name": "Banjul",
    "iso2": "B",
    "timezone": "Africa/Banjul",
    "countryCode": "GM"
  },
  {
    "name": "Central River",
    "iso2": "M",
    "timezone": "Africa/Banjul",
    "countryCode": "GM"
  },
  {
    "name": "Lower River",
    "iso2": "L",
    "timezone": "Africa/Banjul",
    "countryCode": "GM"
  },
  {
    "name": "North Bank",
    "iso2": "N",
    "timezone": "Africa/Banjul",
    "countryCode": "GM"
  },
  {
    "name": "Upper River",
    "iso2": "U",
    "timezone": "Africa/Banjul",
    "countryCode": "GM"
  },
  {
    "name": "West Coast",
    "iso2": "W",
    "timezone": "Africa/Banjul",
    "countryCode": "GM"
  },
  {
    "name": "Aileu",
    "iso2": "AL",
    "timezone": "Asia/Dili",
    "countryCode": "TL"
  },
  {
    "name": "Ainaro",
    "iso2": "AN",
    "timezone": "Asia/Dili",
    "countryCode": "TL"
  },
  {
    "name": "Baucau",
    "iso2": "BA",
    "timezone": "Asia/Dili",
    "countryCode": "TL"
  },
  {
    "name": "Bobonaro",
    "iso2": "BO",
    "timezone": "Asia/Dili",
    "countryCode": "TL"
  },
  {
    "name": "Cova Lima",
    "iso2": "CO",
    "timezone": "Asia/Dili",
    "countryCode": "TL"
  },
  {
    "name": "Dili",
    "iso2": "DI",
    "timezone": "Asia/Dili",
    "countryCode": "TL"
  },
  {
    "name": "Ermera",
    "iso2": "ER",
    "timezone": "Asia/Dili",
    "countryCode": "TL"
  },
  {
    "name": "Lautém",
    "iso2": "LA",
    "timezone": "Asia/Dili",
    "countryCode": "TL"
  },
  {
    "name": "Liquiçá",
    "iso2": "LI",
    "timezone": "Asia/Dili",
    "countryCode": "TL"
  },
  {
    "name": "Manatuto",
    "iso2": "MT",
    "timezone": "Asia/Dili",
    "countryCode": "TL"
  },
  {
    "name": "Manufahi",
    "iso2": "MF",
    "timezone": "Asia/Dili",
    "countryCode": "TL"
  },
  {
    "name": "Oecusse",
    "iso2": "OE",
    "timezone": "Asia/Dili",
    "countryCode": "TL"
  },
  {
    "name": "Viqueque",
    "iso2": "VI",
    "timezone": "Asia/Dili",
    "countryCode": "TL"
  },
  {
    "name": "Centrale",
    "iso2": "C",
    "timezone": "Africa/Lome",
    "countryCode": "TG"
  },
  {
    "name": "Kara",
    "iso2": "K",
    "timezone": "Africa/Lome",
    "countryCode": "TG"
  },
  {
    "name": "Maritime",
    "iso2": "M",
    "timezone": "Africa/Lome",
    "countryCode": "TG"
  },
  {
    "name": "Plateaux",
    "iso2": "P",
    "timezone": "Africa/Lome",
    "countryCode": "TG"
  },
  {
    "name": "Savanes",
    "iso2": "S",
    "timezone": "Africa/Lome",
    "countryCode": "TG"
  },
  {
    "name": "Haʻapai",
    "iso2": "02",
    "timezone": "Pacific/Tongatapu",
    "countryCode": "TO"
  },
  {
    "name": "ʻEua",
    "iso2": "01",
    "timezone": "Pacific/Tongatapu",
    "countryCode": "TO"
  },
  {
    "name": "Niuas",
    "iso2": "03",
    "timezone": "Pacific/Tongatapu",
    "countryCode": "TO"
  },
  {
    "name": "Tongatapu",
    "iso2": "04",
    "timezone": "Pacific/Tongatapu",
    "countryCode": "TO"
  },
  {
    "name": "Vavaʻu",
    "iso2": "05",
    "timezone": "Pacific/Tongatapu",
    "countryCode": "TO"
  },
  {
    "name": "Arima",
    "iso2": "ARI",
    "timezone": "America/Port_of_Spain",
    "countryCode": "TT"
  },
  {
    "name": "Chaguanas",
    "iso2": "CHA",
    "timezone": "America/Port_of_Spain",
    "countryCode": "TT"
  },
  {
    "name": "Couva-Tabaquite-Talparo",
    "iso2": "CTT",
    "timezone": "America/Port_of_Spain",
    "countryCode": "TT"
  },
  {
    "name": "Diego Martin",
    "iso2": "DMN",
    "timezone": "America/Port_of_Spain",
    "countryCode": "TT"
  },
  {
    "name": "Eastern Tobago",
    "iso2": "ETO",
    "timezone": "America/Port_of_Spain",
    "countryCode": "TT"
  },
  {
    "name": "Penal-Debe",
    "iso2": "PED",
    "timezone": "America/Port_of_Spain",
    "countryCode": "TT"
  },
  {
    "name": "Point Fortin",
    "iso2": "PTF",
    "timezone": "America/Port_of_Spain",
    "countryCode": "TT"
  },
  {
    "name": "Port of Spain",
    "iso2": "POS",
    "timezone": "America/Port_of_Spain",
    "countryCode": "TT"
  },
  {
    "name": "Princes Town",
    "iso2": "PRT",
    "timezone": "America/Port_of_Spain",
    "countryCode": "TT"
  },
  {
    "name": "Rio Claro-Mayaro",
    "iso2": "MRC",
    "timezone": "America/Port_of_Spain",
    "countryCode": "TT"
  },
  {
    "name": "San Fernando",
    "iso2": "SFO",
    "timezone": "America/Port_of_Spain",
    "countryCode": "TT"
  },
  {
    "name": "San Juan-Laventille",
    "iso2": "SJL",
    "timezone": "America/Port_of_Spain",
    "countryCode": "TT"
  },
  {
    "name": "Sangre Grande",
    "iso2": "SGE",
    "timezone": "America/Port_of_Spain",
    "countryCode": "TT"
  },
  {
    "name": "Siparia",
    "iso2": "SIP",
    "timezone": "America/Port_of_Spain",
    "countryCode": "TT"
  },
  {
    "name": "Tobago",
    "iso2": "TOB",
    "timezone": "America/Port_of_Spain",
    "countryCode": "TT"
  },
  {
    "name": "Tunapuna-Piarco",
    "iso2": "TUP",
    "timezone": "America/Port_of_Spain",
    "countryCode": "TT"
  },
  {
    "name": "Western Tobago",
    "iso2": "WTO",
    "timezone": "America/Port_of_Spain",
    "countryCode": "TT"
  },
  {
    "name": "Ariana",
    "iso2": "12",
    "timezone": "Africa/Tunis",
    "countryCode": "TN"
  },
  {
    "name": "Béja",
    "iso2": "31",
    "timezone": "Africa/Tunis",
    "countryCode": "TN"
  },
  {
    "name": "Ben Arous",
    "iso2": "13",
    "timezone": "Africa/Tunis",
    "countryCode": "TN"
  },
  {
    "name": "Bizerte",
    "iso2": "23",
    "timezone": "Africa/Tunis",
    "countryCode": "TN"
  },
  {
    "name": "Gabès",
    "iso2": "81",
    "timezone": "Africa/Tunis",
    "countryCode": "TN"
  },
  {
    "name": "Gafsa",
    "iso2": "71",
    "timezone": "Africa/Tunis",
    "countryCode": "TN"
  },
  {
    "name": "Jendouba",
    "iso2": "32",
    "timezone": "Africa/Tunis",
    "countryCode": "TN"
  },
  {
    "name": "Kairouan",
    "iso2": "41",
    "timezone": "Africa/Tunis",
    "countryCode": "TN"
  },
  {
    "name": "Kasserine",
    "iso2": "42",
    "timezone": "Africa/Tunis",
    "countryCode": "TN"
  },
  {
    "name": "Kebili",
    "iso2": "73",
    "timezone": "Africa/Tunis",
    "countryCode": "TN"
  },
  {
    "name": "Kef",
    "iso2": "33",
    "timezone": "Africa/Tunis",
    "countryCode": "TN"
  },
  {
    "name": "Mahdia",
    "iso2": "53",
    "timezone": "Africa/Tunis",
    "countryCode": "TN"
  },
  {
    "name": "Manouba",
    "iso2": "14",
    "timezone": "Africa/Tunis",
    "countryCode": "TN"
  },
  {
    "name": "Medenine",
    "iso2": "82",
    "timezone": "Africa/Tunis",
    "countryCode": "TN"
  },
  {
    "name": "Monastir",
    "iso2": "52",
    "timezone": "Africa/Tunis",
    "countryCode": "TN"
  },
  {
    "name": "Nabeul",
    "iso2": "21",
    "timezone": "Africa/Tunis",
    "countryCode": "TN"
  },
  {
    "name": "Sfax",
    "iso2": "61",
    "timezone": "Africa/Tunis",
    "countryCode": "TN"
  },
  {
    "name": "Sidi Bouzid",
    "iso2": "43",
    "timezone": "Africa/Tunis",
    "countryCode": "TN"
  },
  {
    "name": "Siliana",
    "iso2": "34",
    "timezone": "Africa/Tunis",
    "countryCode": "TN"
  },
  {
    "name": "Sousse",
    "iso2": "51",
    "timezone": "Africa/Tunis",
    "countryCode": "TN"
  },
  {
    "name": "Tataouine",
    "iso2": "83",
    "timezone": "Africa/Tunis",
    "countryCode": "TN"
  },
  {
    "name": "Tozeur",
    "iso2": "72",
    "timezone": "Africa/Tunis",
    "countryCode": "TN"
  },
  {
    "name": "Tunis",
    "iso2": "11",
    "timezone": "Africa/Tunis",
    "countryCode": "TN"
  },
  {
    "name": "Zaghouan",
    "iso2": "22",
    "timezone": "Africa/Tunis",
    "countryCode": "TN"
  },
  {
    "name": "Adana",
    "iso2": "01",
    "timezone": "Europe/Istanbul",
    "countryCode": "TR"
  },
  {
    "name": "Adıyaman",
    "iso2": "02",
    "timezone": "Europe/Istanbul",
    "countryCode": "TR"
  },
  {
    "name": "Afyonkarahisar",
    "iso2": "03",
    "timezone": "Europe/Istanbul",
    "countryCode": "TR"
  },
  {
    "name": "Ağrı",
    "iso2": "04",
    "timezone": "Europe/Istanbul",
    "countryCode": "TR"
  },
  {
    "name": "Aksaray",
    "iso2": "68",
    "timezone": "Europe/Istanbul",
    "countryCode": "TR"
  },
  {
    "name": "Amasya",
    "iso2": "05",
    "timezone": "Europe/Istanbul",
    "countryCode": "TR"
  },
  {
    "name": "Ankara",
    "iso2": "06",
    "timezone": "Europe/Istanbul",
    "countryCode": "TR"
  },
  {
    "name": "Antalya",
    "iso2": "07",
    "timezone": "Europe/Istanbul",
    "countryCode": "TR"
  },
  {
    "name": "Ardahan",
    "iso2": "75",
    "timezone": "Europe/Istanbul",
    "countryCode": "TR"
  },
  {
    "name": "Artvin",
    "iso2": "08",
    "timezone": "Europe/Istanbul",
    "countryCode": "TR"
  },
  {
    "name": "Aydın",
    "iso2": "09",
    "timezone": "Europe/Istanbul",
    "countryCode": "TR"
  },
  {
    "name": "Balıkesir",
    "iso2": "10",
    "timezone": "Europe/Istanbul",
    "countryCode": "TR"
  },
  {
    "name": "Bartın",
    "iso2": "74",
    "timezone": "Europe/Istanbul",
    "countryCode": "TR"
  },
  {
    "name": "Batman",
    "iso2": "72",
    "timezone": "Europe/Istanbul",
    "countryCode": "TR"
  },
  {
    "name": "Bayburt",
    "iso2": "69",
    "timezone": "Europe/Istanbul",
    "countryCode": "TR"
  },
  {
    "name": "Bilecik",
    "iso2": "11",
    "timezone": "Europe/Istanbul",
    "countryCode": "TR"
  },
  {
    "name": "Bingöl",
    "iso2": "12",
    "timezone": "Europe/Istanbul",
    "countryCode": "TR"
  },
  {
    "name": "Bitlis",
    "iso2": "13",
    "timezone": "Europe/Istanbul",
    "countryCode": "TR"
  },
  {
    "name": "Bolu",
    "iso2": "14",
    "timezone": "Europe/Istanbul",
    "countryCode": "TR"
  },
  {
    "name": "Burdur",
    "iso2": "15",
    "timezone": "Europe/Istanbul",
    "countryCode": "TR"
  },
  {
    "name": "Bursa",
    "iso2": "16",
    "timezone": "Europe/Istanbul",
    "countryCode": "TR"
  },
  {
    "name": "Çanakkale",
    "iso2": "17",
    "timezone": "Europe/Istanbul",
    "countryCode": "TR"
  },
  {
    "name": "Çankırı",
    "iso2": "18",
    "timezone": "Europe/Istanbul",
    "countryCode": "TR"
  },
  {
    "name": "Çorum",
    "iso2": "19",
    "timezone": "Europe/Istanbul",
    "countryCode": "TR"
  },
  {
    "name": "Denizli",
    "iso2": "20",
    "timezone": "Europe/Istanbul",
    "countryCode": "TR"
  },
  {
    "name": "Diyarbakır",
    "iso2": "21",
    "timezone": "Europe/Istanbul",
    "countryCode": "TR"
  },
  {
    "name": "Düzce",
    "iso2": "81",
    "timezone": "Europe/Istanbul",
    "countryCode": "TR"
  },
  {
    "name": "Edirne",
    "iso2": "22",
    "timezone": "Europe/Istanbul",
    "countryCode": "TR"
  },
  {
    "name": "Elazığ",
    "iso2": "23",
    "timezone": "Europe/Istanbul",
    "countryCode": "TR"
  },
  {
    "name": "Erzincan",
    "iso2": "24",
    "timezone": "Europe/Istanbul",
    "countryCode": "TR"
  },
  {
    "name": "Erzurum",
    "iso2": "25",
    "timezone": "Europe/Istanbul",
    "countryCode": "TR"
  },
  {
    "name": "Eskişehir",
    "iso2": "26",
    "timezone": "Europe/Istanbul",
    "countryCode": "TR"
  },
  {
    "name": "Gaziantep",
    "iso2": "27",
    "timezone": "Europe/Istanbul",
    "countryCode": "TR"
  },
  {
    "name": "Giresun",
    "iso2": "28",
    "timezone": "Europe/Istanbul",
    "countryCode": "TR"
  },
  {
    "name": "Gümüşhane",
    "iso2": "29",
    "timezone": "Europe/Istanbul",
    "countryCode": "TR"
  },
  {
    "name": "Hakkâri",
    "iso2": "30",
    "timezone": "Europe/Istanbul",
    "countryCode": "TR"
  },
  {
    "name": "Hatay",
    "iso2": "31",
    "timezone": "Europe/Istanbul",
    "countryCode": "TR"
  },
  {
    "name": "Iğdır",
    "iso2": "76",
    "timezone": "Europe/Istanbul",
    "countryCode": "TR"
  },
  {
    "name": "Isparta",
    "iso2": "32",
    "timezone": "Europe/Istanbul",
    "countryCode": "TR"
  },
  {
    "name": "İstanbul",
    "iso2": "34",
    "timezone": "Europe/Istanbul",
    "countryCode": "TR"
  },
  {
    "name": "İzmir",
    "iso2": "35",
    "timezone": "Europe/Istanbul",
    "countryCode": "TR"
  },
  {
    "name": "Kahramanmaraş",
    "iso2": "46",
    "timezone": "Europe/Istanbul",
    "countryCode": "TR"
  },
  {
    "name": "Karabük",
    "iso2": "78",
    "timezone": "Europe/Istanbul",
    "countryCode": "TR"
  },
  {
    "name": "Karaman",
    "iso2": "70",
    "timezone": "Europe/Istanbul",
    "countryCode": "TR"
  },
  {
    "name": "Kars",
    "iso2": "36",
    "timezone": "Europe/Istanbul",
    "countryCode": "TR"
  },
  {
    "name": "Kastamonu",
    "iso2": "37",
    "timezone": "Europe/Istanbul",
    "countryCode": "TR"
  },
  {
    "name": "Kayseri",
    "iso2": "38",
    "timezone": "Europe/Istanbul",
    "countryCode": "TR"
  },
  {
    "name": "Kilis",
    "iso2": "79",
    "timezone": "Europe/Istanbul",
    "countryCode": "TR"
  },
  {
    "name": "Kırıkkale",
    "iso2": "71",
    "timezone": "Europe/Istanbul",
    "countryCode": "TR"
  },
  {
    "name": "Kırklareli",
    "iso2": "39",
    "timezone": "Europe/Istanbul",
    "countryCode": "TR"
  },
  {
    "name": "Kırşehir",
    "iso2": "40",
    "timezone": "Europe/Istanbul",
    "countryCode": "TR"
  },
  {
    "name": "Kocaeli",
    "iso2": "41",
    "timezone": "Europe/Istanbul",
    "countryCode": "TR"
  },
  {
    "name": "Konya",
    "iso2": "42",
    "timezone": "Europe/Istanbul",
    "countryCode": "TR"
  },
  {
    "name": "Kütahya",
    "iso2": "43",
    "timezone": "Europe/Istanbul",
    "countryCode": "TR"
  },
  {
    "name": "Malatya",
    "iso2": "44",
    "timezone": "Europe/Istanbul",
    "countryCode": "TR"
  },
  {
    "name": "Manisa",
    "iso2": "45",
    "timezone": "Europe/Istanbul",
    "countryCode": "TR"
  },
  {
    "name": "Mardin",
    "iso2": "47",
    "timezone": "Europe/Istanbul",
    "countryCode": "TR"
  },
  {
    "name": "Mersin",
    "iso2": "33",
    "timezone": "Europe/Istanbul",
    "countryCode": "TR"
  },
  {
    "name": "Muğla",
    "iso2": "48",
    "timezone": "Europe/Istanbul",
    "countryCode": "TR"
  },
  {
    "name": "Muş",
    "iso2": "49",
    "timezone": "Europe/Istanbul",
    "countryCode": "TR"
  },
  {
    "name": "Nevşehir",
    "iso2": "50",
    "timezone": "Europe/Istanbul",
    "countryCode": "TR"
  },
  {
    "name": "Niğde",
    "iso2": "51",
    "timezone": "Europe/Istanbul",
    "countryCode": "TR"
  },
  {
    "name": "Ordu",
    "iso2": "52",
    "timezone": "Europe/Istanbul",
    "countryCode": "TR"
  },
  {
    "name": "Osmaniye",
    "iso2": "80",
    "timezone": "Europe/Istanbul",
    "countryCode": "TR"
  },
  {
    "name": "Rize",
    "iso2": "53",
    "timezone": "Europe/Istanbul",
    "countryCode": "TR"
  },
  {
    "name": "Sakarya",
    "iso2": "54",
    "timezone": "Europe/Istanbul",
    "countryCode": "TR"
  },
  {
    "name": "Samsun",
    "iso2": "55",
    "timezone": "Europe/Istanbul",
    "countryCode": "TR"
  },
  {
    "name": "Şanlıurfa",
    "iso2": "63",
    "timezone": "Europe/Istanbul",
    "countryCode": "TR"
  },
  {
    "name": "Siirt",
    "iso2": "56",
    "timezone": "Europe/Istanbul",
    "countryCode": "TR"
  },
  {
    "name": "Sinop",
    "iso2": "57",
    "timezone": "Europe/Istanbul",
    "countryCode": "TR"
  },
  {
    "name": "Sivas",
    "iso2": "58",
    "timezone": "Europe/Istanbul",
    "countryCode": "TR"
  },
  {
    "name": "Şırnak",
    "iso2": "73",
    "timezone": "Europe/Istanbul",
    "countryCode": "TR"
  },
  {
    "name": "Tekirdağ",
    "iso2": "59",
    "timezone": "Europe/Istanbul",
    "countryCode": "TR"
  },
  {
    "name": "Tokat",
    "iso2": "60",
    "timezone": "Europe/Istanbul",
    "countryCode": "TR"
  },
  {
    "name": "Trabzon",
    "iso2": "61",
    "timezone": "Europe/Istanbul",
    "countryCode": "TR"
  },
  {
    "name": "Tunceli",
    "iso2": "62",
    "timezone": "Europe/Istanbul",
    "countryCode": "TR"
  },
  {
    "name": "Uşak",
    "iso2": "64",
    "timezone": "Europe/Istanbul",
    "countryCode": "TR"
  },
  {
    "name": "Van",
    "iso2": "65",
    "timezone": "Europe/Istanbul",
    "countryCode": "TR"
  },
  {
    "name": "Yalova",
    "iso2": "77",
    "timezone": "Europe/Istanbul",
    "countryCode": "TR"
  },
  {
    "name": "Yozgat",
    "iso2": "66",
    "timezone": "Europe/Istanbul",
    "countryCode": "TR"
  },
  {
    "name": "Zonguldak",
    "iso2": "67",
    "timezone": "Europe/Istanbul",
    "countryCode": "TR"
  },
  {
    "name": "Ahal",
    "iso2": "A",
    "timezone": "Asia/Ashgabat",
    "countryCode": "TM"
  },
  {
    "name": "Ashgabat",
    "iso2": "S",
    "timezone": "Asia/Ashgabat",
    "countryCode": "TM"
  },
  {
    "name": "Balkan",
    "iso2": "B",
    "timezone": "Asia/Ashgabat",
    "countryCode": "TM"
  },
  {
    "name": "Daşoguz",
    "iso2": "D",
    "timezone": "Asia/Ashgabat",
    "countryCode": "TM"
  },
  {
    "name": "Lebap",
    "iso2": "L",
    "timezone": "Asia/Ashgabat",
    "countryCode": "TM"
  },
  {
    "name": "Mary",
    "iso2": "M",
    "timezone": "Asia/Ashgabat",
    "countryCode": "TM"
  },
  {
    "name": "Grand Turk",
    "iso2": "05",
    "timezone": "America/Grand_Turk",
    "countryCode": "TC"
  },
  {
    "name": "Middle Caicos",
    "iso2": "03",
    "timezone": "America/Grand_Turk",
    "countryCode": "TC"
  },
  {
    "name": "North Caicos",
    "iso2": "02",
    "timezone": "America/Grand_Turk",
    "countryCode": "TC"
  },
  {
    "name": "Providenciales",
    "iso2": "01",
    "timezone": "America/Grand_Turk",
    "countryCode": "TC"
  },
  {
    "name": "Salt Cay",
    "iso2": "06",
    "timezone": "America/Grand_Turk",
    "countryCode": "TC"
  },
  {
    "name": "South Caicos",
    "iso2": "04",
    "timezone": "America/Grand_Turk",
    "countryCode": "TC"
  },
  {
    "name": "Funafuti",
    "iso2": "FUN",
    "timezone": "Pacific/Funafuti",
    "countryCode": "TV"
  },
  {
    "name": "Nanumanga",
    "iso2": "NMG",
    "timezone": "Pacific/Funafuti",
    "countryCode": "TV"
  },
  {
    "name": "Nanumea",
    "iso2": "NMA",
    "timezone": "Pacific/Funafuti",
    "countryCode": "TV"
  },
  {
    "name": "Niutao Island Council",
    "iso2": "NIT",
    "timezone": "Pacific/Funafuti",
    "countryCode": "TV"
  },
  {
    "name": "Nui",
    "iso2": "NUI",
    "timezone": "Pacific/Funafuti",
    "countryCode": "TV"
  },
  {
    "name": "Nukufetau",
    "iso2": "NKF",
    "timezone": "Pacific/Funafuti",
    "countryCode": "TV"
  },
  {
    "name": "Nukulaelae",
    "iso2": "NKL",
    "timezone": "Pacific/Funafuti",
    "countryCode": "TV"
  },
  {
    "name": "Vaitupu",
    "iso2": "VAI",
    "timezone": "Pacific/Funafuti",
    "countryCode": "TV"
  },
  {
    "name": "Abim",
    "iso2": "314",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Adjumani",
    "iso2": "301",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Agago",
    "iso2": "322",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Alebtong",
    "iso2": "323",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Amolatar",
    "iso2": "315",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Amudat",
    "iso2": "324",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Amuria",
    "iso2": "216",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Amuru",
    "iso2": "316",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Apac",
    "iso2": "302",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Arua",
    "iso2": "303",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Budaka",
    "iso2": "217",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Bududa",
    "iso2": "218",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Bugiri",
    "iso2": "201",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Bugweri",
    "iso2": "235",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Buhweju",
    "iso2": "420",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Buikwe",
    "iso2": "117",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Bukedea",
    "iso2": "219",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Bukomansimbi",
    "iso2": "118",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Bukwo",
    "iso2": "220",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Bulambuli",
    "iso2": "225",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Buliisa",
    "iso2": "416",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Bundibugyo",
    "iso2": "401",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Bunyangabu",
    "iso2": "430",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Bushenyi",
    "iso2": "402",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Busia",
    "iso2": "202",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Butaleja",
    "iso2": "221",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Butambala",
    "iso2": "119",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Butebo",
    "iso2": "233",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Buvuma",
    "iso2": "120",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Buyende",
    "iso2": "226",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Central",
    "iso2": "C",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Dokolo",
    "iso2": "317",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Eastern",
    "iso2": "E",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Gomba",
    "iso2": "121",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Gulu",
    "iso2": "304",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Hoima",
    "iso2": "403",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Ibanda",
    "iso2": "417",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Iganga",
    "iso2": "203",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Isingiro",
    "iso2": "418",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Jinja",
    "iso2": "204",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Kaabong",
    "iso2": "318",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Kabale",
    "iso2": "404",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Kabarole",
    "iso2": "405",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Kaberamaido",
    "iso2": "213",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Kagadi",
    "iso2": "427",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Kakumiro",
    "iso2": "428",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Kalaki",
    "iso2": "237",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Kalangala",
    "iso2": "101",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Kaliro",
    "iso2": "222",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Kalungu",
    "iso2": "122",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Kampala",
    "iso2": "102",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Kamuli",
    "iso2": "205",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Kamwenge",
    "iso2": "413",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Kanungu",
    "iso2": "414",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Kapchorwa",
    "iso2": "206",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Kapelebyong",
    "iso2": "236",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Karenga",
    "iso2": "335",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Kasanda",
    "iso2": "126",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Kasese",
    "iso2": "406",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Katakwi",
    "iso2": "207",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Kayunga",
    "iso2": "112",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Kazo",
    "iso2": "433",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Kibaale",
    "iso2": "407",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Kiboga",
    "iso2": "103",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Kibuku",
    "iso2": "227",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Kikuube",
    "iso2": "432",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Kiruhura",
    "iso2": "419",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Kiryandongo",
    "iso2": "421",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Kisoro",
    "iso2": "408",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Kitagwenda",
    "iso2": "434",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Kitgum",
    "iso2": "305",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Koboko",
    "iso2": "319",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Kole",
    "iso2": "325",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Kotido",
    "iso2": "306",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Kumi",
    "iso2": "208",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Kwania",
    "iso2": "333",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Kween",
    "iso2": "228",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Kyankwanzi",
    "iso2": "123",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Kyegegwa",
    "iso2": "422",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Kyenjojo",
    "iso2": "415",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Kyotera",
    "iso2": "125",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Lamwo",
    "iso2": "326",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Lira",
    "iso2": "307",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Luuka",
    "iso2": "229",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Luwero",
    "iso2": "104",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Lwengo",
    "iso2": "124",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Lyantonde",
    "iso2": "114",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Madi-Okollo",
    "iso2": "336",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Manafwa",
    "iso2": "223",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Maracha",
    "iso2": "320",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Masaka",
    "iso2": "105",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Masindi",
    "iso2": "409",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Mayuge",
    "iso2": "214",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Mbale",
    "iso2": "209",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Mbarara",
    "iso2": "410",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Mitooma",
    "iso2": "423",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Mityana",
    "iso2": "115",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Moroto",
    "iso2": "308",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Moyo",
    "iso2": "309",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Mpigi",
    "iso2": "106",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Mubende",
    "iso2": "107",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Mukono",
    "iso2": "108",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Nabilatuk",
    "iso2": "334",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Nakapiripirit",
    "iso2": "311",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Nakaseke",
    "iso2": "116",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Nakasongola",
    "iso2": "109",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Namayingo",
    "iso2": "230",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Namisindwa",
    "iso2": "234",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Namutumba",
    "iso2": "224",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Napak",
    "iso2": "327",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Nebbi",
    "iso2": "310",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Ngora",
    "iso2": "231",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Northern",
    "iso2": "N",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Ntoroko",
    "iso2": "424",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Ntungamo",
    "iso2": "411",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Nwoya",
    "iso2": "328",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Obongi",
    "iso2": "337",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Omoro",
    "iso2": "331",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Otuke",
    "iso2": "329",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Oyam",
    "iso2": "321",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Pader",
    "iso2": "312",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Pakwach",
    "iso2": "332",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Pallisa",
    "iso2": "210",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Rakai",
    "iso2": "110",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Rubanda",
    "iso2": "429",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Rubirizi",
    "iso2": "425",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Rukiga",
    "iso2": "431",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Rukungiri",
    "iso2": "412",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Rwampara",
    "iso2": "435",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Sembabule",
    "iso2": "111",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Serere",
    "iso2": "232",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Sheema",
    "iso2": "426",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Sironko",
    "iso2": "215",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Soroti",
    "iso2": "211",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Tororo",
    "iso2": "212",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Wakiso",
    "iso2": "113",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Western",
    "iso2": "W",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Yumbe",
    "iso2": "313",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Zombo",
    "iso2": "330",
    "timezone": "Africa/Kampala",
    "countryCode": "UG"
  },
  {
    "name": "Autonomous Republic of Crimea",
    "iso2": "43",
    "timezone": "Europe/Kiev",
    "countryCode": "UA"
  },
  {
    "name": "Cherkaska",
    "iso2": "71",
    "timezone": "Europe/Kiev",
    "countryCode": "UA"
  },
  {
    "name": "Chernihivska",
    "iso2": "74",
    "timezone": "Europe/Kiev",
    "countryCode": "UA"
  },
  {
    "name": "Chernivetska",
    "iso2": "77",
    "timezone": "Europe/Kiev",
    "countryCode": "UA"
  },
  {
    "name": "Dnipropetrovska",
    "iso2": "12",
    "timezone": "Europe/Kiev",
    "countryCode": "UA"
  },
  {
    "name": "Donetska",
    "iso2": "14",
    "timezone": "Europe/Kiev",
    "countryCode": "UA"
  },
  {
    "name": "Ivano-Frankivska",
    "iso2": "26",
    "timezone": "Europe/Kiev",
    "countryCode": "UA"
  },
  {
    "name": "Kharkivska",
    "iso2": "63",
    "timezone": "Europe/Kiev",
    "countryCode": "UA"
  },
  {
    "name": "Khersonska",
    "iso2": "65",
    "timezone": "Europe/Kiev",
    "countryCode": "UA"
  },
  {
    "name": "Khmelnytska",
    "iso2": "68",
    "timezone": "Europe/Kiev",
    "countryCode": "UA"
  },
  {
    "name": "Kirovohradska",
    "iso2": "35",
    "timezone": "Europe/Kiev",
    "countryCode": "UA"
  },
  {
    "name": "Kyiv",
    "iso2": "30",
    "timezone": "Europe/Kiev",
    "countryCode": "UA"
  },
  {
    "name": "Kyivska",
    "iso2": "32",
    "timezone": "Europe/Kiev",
    "countryCode": "UA"
  },
  {
    "name": "Luhanska",
    "iso2": "09",
    "timezone": "Europe/Kiev",
    "countryCode": "UA"
  },
  {
    "name": "Lvivska",
    "iso2": "46",
    "timezone": "Europe/Kiev",
    "countryCode": "UA"
  },
  {
    "name": "Mykolaivska",
    "iso2": "48",
    "timezone": "Europe/Kiev",
    "countryCode": "UA"
  },
  {
    "name": "Odeska",
    "iso2": "51",
    "timezone": "Europe/Kiev",
    "countryCode": "UA"
  },
  {
    "name": "Poltavska",
    "iso2": "53",
    "timezone": "Europe/Kiev",
    "countryCode": "UA"
  },
  {
    "name": "Rivnenska",
    "iso2": "56",
    "timezone": "Europe/Kiev",
    "countryCode": "UA"
  },
  {
    "name": "Sevastopol",
    "iso2": "40",
    "timezone": "Europe/Kiev",
    "countryCode": "UA"
  },
  {
    "name": "Sumska",
    "iso2": "59",
    "timezone": "Europe/Kiev",
    "countryCode": "UA"
  },
  {
    "name": "Ternopilska",
    "iso2": "61",
    "timezone": "Europe/Kiev",
    "countryCode": "UA"
  },
  {
    "name": "Vinnytska",
    "iso2": "05",
    "timezone": "Europe/Kiev",
    "countryCode": "UA"
  },
  {
    "name": "Volynska",
    "iso2": "07",
    "timezone": "Europe/Kiev",
    "countryCode": "UA"
  },
  {
    "name": "Zakarpatska",
    "iso2": "21",
    "timezone": "Europe/Kiev",
    "countryCode": "UA"
  },
  {
    "name": "Zaporizka",
    "iso2": "23",
    "timezone": "Europe/Kiev",
    "countryCode": "UA"
  },
  {
    "name": "Zhytomyrska",
    "iso2": "18",
    "timezone": "Europe/Kiev",
    "countryCode": "UA"
  },
  {
    "name": "Abu Dhabi",
    "iso2": "AZ",
    "timezone": "Asia/Dubai",
    "countryCode": "AE"
  },
  {
    "name": "Ajman",
    "iso2": "AJ",
    "timezone": "Asia/Dubai",
    "countryCode": "AE"
  },
  {
    "name": "Dubai",
    "iso2": "DU",
    "timezone": "Asia/Dubai",
    "countryCode": "AE"
  },
  {
    "name": "Fujairah",
    "iso2": "FU",
    "timezone": "Asia/Dubai",
    "countryCode": "AE"
  },
  {
    "name": "Ras Al Khaimah",
    "iso2": "RK",
    "timezone": "Asia/Dubai",
    "countryCode": "AE"
  },
  {
    "name": "Sharjah",
    "iso2": "SH",
    "timezone": "Asia/Dubai",
    "countryCode": "AE"
  },
  {
    "name": "Umm Al Quwain",
    "iso2": "UQ",
    "timezone": "Asia/Dubai",
    "countryCode": "AE"
  },
  {
    "name": "Aberdeen",
    "iso2": "ABE",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Aberdeenshire",
    "iso2": "ABD",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Angus",
    "iso2": "ANS",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Antrim and Newtownabbey",
    "iso2": "ANN",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Ards and North Down",
    "iso2": "AND",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Argyll and Bute",
    "iso2": "AGB",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Armagh, Banbridge and Craigavon",
    "iso2": "ABC",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Barking and Dagenham",
    "iso2": "BDG",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Barnet",
    "iso2": "BNE",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Barnsley",
    "iso2": "BNS",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Bath and North East Somerset",
    "iso2": "BAS",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Bedford",
    "iso2": "BDF",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Belfast",
    "iso2": "BFS",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Bexley",
    "iso2": "BEX",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Birmingham",
    "iso2": "BIR",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Blackburn with Darwen",
    "iso2": "BBD",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Blackpool",
    "iso2": "BPL",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Blaenau Gwent",
    "iso2": "BGW",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Bolton",
    "iso2": "BOL",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Bournemouth, Christchurch and Poole",
    "iso2": "BCP",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Bracknell Forest",
    "iso2": "BRC",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Bradford",
    "iso2": "BRD",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Brent",
    "iso2": "BEN",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Bridgend",
    "iso2": "BGE",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Brighton and Hove",
    "iso2": "BNH",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Bristol",
    "iso2": "BST",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Bromley",
    "iso2": "BRY",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Buckinghamshire",
    "iso2": "BKM",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Bury",
    "iso2": "BUR",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Caerphilly",
    "iso2": "CAY",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Calderdale",
    "iso2": "CLD",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Cambridgeshire",
    "iso2": "CAM",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Camden",
    "iso2": "CMD",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Cardiff",
    "iso2": "CRF",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Carmarthenshire",
    "iso2": "CMN",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Causeway Coast and Glens",
    "iso2": "CCG",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Central Bedfordshire",
    "iso2": "CBF",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Ceredigion",
    "iso2": "CGN",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Cheshire East",
    "iso2": "CHE",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Cheshire West and Chester",
    "iso2": "CHW",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "City of Kingston upon Hull",
    "iso2": "KHL",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "City of Southampton",
    "iso2": "STH",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Clackmannanshire",
    "iso2": "CLK",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Conwy",
    "iso2": "CWY",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Cornwall",
    "iso2": "CON",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Coventry",
    "iso2": "COV",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Croydon",
    "iso2": "CRY",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Cumbria",
    "iso2": "CMA",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Darlington",
    "iso2": "DAL",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Denbighshire",
    "iso2": "DEN",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Derby",
    "iso2": "DER",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Derbyshire",
    "iso2": "DBY",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Derry City and Strabane",
    "iso2": "DRS",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Devon",
    "iso2": "DEV",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Doncaster",
    "iso2": "DNC",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Dorset",
    "iso2": "DOR",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Dudley",
    "iso2": "DUD",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Dumfries and Galloway",
    "iso2": "DGY",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Dundee",
    "iso2": "DND",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Durham",
    "iso2": "DUR",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Ealing",
    "iso2": "EAL",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "East Ayrshire",
    "iso2": "EAY",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "East Dunbartonshire",
    "iso2": "EDU",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "East Lothian",
    "iso2": "ELN",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "East Renfrewshire",
    "iso2": "ERW",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "East Riding of Yorkshire",
    "iso2": "ERY",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "East Sussex",
    "iso2": "ESX",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Edinburgh",
    "iso2": "EDH",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Enfield",
    "iso2": "ENF",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "England",
    "iso2": "ENG",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Essex",
    "iso2": "ESS",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Falkirk",
    "iso2": "FAL",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Fermanagh and Omagh",
    "iso2": "FMO",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Fife",
    "iso2": "FIF",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Flintshire",
    "iso2": "FLN",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Gateshead",
    "iso2": "GAT",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Glasgow",
    "iso2": "GLG",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Gloucestershire",
    "iso2": "GLS",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Greenwich",
    "iso2": "GRE",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Gwynedd",
    "iso2": "GWN",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Hackney",
    "iso2": "HCK",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Halton",
    "iso2": "HAL",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Hammersmith and Fulham",
    "iso2": "HMF",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Hampshire",
    "iso2": "HAM",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Haringey",
    "iso2": "HRY",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Harrow",
    "iso2": "HRW",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Hartlepool",
    "iso2": "HPL",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Havering",
    "iso2": "HAV",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Herefordshire",
    "iso2": "HEF",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Hertfordshire",
    "iso2": "HRT",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Highland",
    "iso2": "HLD",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Hillingdon",
    "iso2": "HIL",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Hounslow",
    "iso2": "HNS",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Inverclyde",
    "iso2": "IVC",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Isle of Anglesey",
    "iso2": "AGY",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Isle of Wight",
    "iso2": "IOW",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Isles of Scilly",
    "iso2": "IOS",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Islington",
    "iso2": "ISL",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Kensington and Chelsea",
    "iso2": "KEC",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Kent",
    "iso2": "KEN",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Kingston upon Thames",
    "iso2": "KTT",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Kirklees",
    "iso2": "KIR",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Knowsley",
    "iso2": "KWL",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Lambeth",
    "iso2": "LBH",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Lancashire",
    "iso2": "LAN",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Leeds",
    "iso2": "LDS",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Leicester",
    "iso2": "LCE",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Leicestershire",
    "iso2": "LEC",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Lewisham",
    "iso2": "LEW",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Lincolnshire",
    "iso2": "LIN",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Lisburn and Castlereagh",
    "iso2": "LBC",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Liverpool",
    "iso2": "LIV",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "London",
    "iso2": "LND",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Luton",
    "iso2": "LUT",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Manchester",
    "iso2": "MAN",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Medway",
    "iso2": "MDW",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Merthyr Tydfil",
    "iso2": "MTY",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Merton",
    "iso2": "MRT",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Mid and East Antrim",
    "iso2": "MEA",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Mid Ulster",
    "iso2": "MUL",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Middlesbrough",
    "iso2": "MDB",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Midlothian",
    "iso2": "MLN",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Milton Keynes",
    "iso2": "MIK",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Monmouthshire",
    "iso2": "MON",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Moray",
    "iso2": "MRY",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Neath Port Talbot",
    "iso2": "NTL",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Newcastle upon Tyne",
    "iso2": "NET",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Newham",
    "iso2": "NWM",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Newport",
    "iso2": "NWP",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Newry, Mourne and Down",
    "iso2": "NMD",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Norfolk",
    "iso2": "NFK",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "North Ayrshire",
    "iso2": "NAY",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "North East Lincolnshire",
    "iso2": "NEL",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "North Lanarkshire",
    "iso2": "NLK",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "North Lincolnshire",
    "iso2": "NLN",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "North Northamptonshire",
    "iso2": "NNH",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "North Somerset",
    "iso2": "NSM",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "North Tyneside",
    "iso2": "NTY",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "North Yorkshire",
    "iso2": "NYK",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Northern Ireland",
    "iso2": "NIR",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Northumberland",
    "iso2": "NBL",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Nottingham",
    "iso2": "NGM",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Nottinghamshire",
    "iso2": "NTT",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Oldham",
    "iso2": "OLD",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Orkney Islands",
    "iso2": "ORK",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Outer Hebrides",
    "iso2": "ELS",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Oxfordshire",
    "iso2": "OXF",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Pembrokeshire",
    "iso2": "PEM",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Perth and Kinross",
    "iso2": "PKN",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Peterborough",
    "iso2": "PTE",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Plymouth",
    "iso2": "PLY",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Portsmouth",
    "iso2": "POR",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Powys",
    "iso2": "POW",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Reading",
    "iso2": "RDG",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Redbridge",
    "iso2": "RDB",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Redcar and Cleveland",
    "iso2": "RCC",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Renfrewshire",
    "iso2": "RFW",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Rhondda Cynon Taf",
    "iso2": "RCT",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Richmond upon Thames",
    "iso2": "RIC",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Rochdale",
    "iso2": "RCH",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Rotherham",
    "iso2": "ROT",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Rutland",
    "iso2": "RUT",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Salford",
    "iso2": "SLF",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Sandwell",
    "iso2": "SAW",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Scotland",
    "iso2": "SCT",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Scottish Borders",
    "iso2": "SCB",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Sefton",
    "iso2": "SFT",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Sheffield",
    "iso2": "SHF",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Shetland Islands",
    "iso2": "ZET",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Shropshire",
    "iso2": "SHR",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Slough",
    "iso2": "SLG",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Solihull",
    "iso2": "SOL",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Somerset",
    "iso2": "SOM",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "South Ayrshire",
    "iso2": "SAY",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "South Gloucestershire",
    "iso2": "SGC",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "South Lanarkshire",
    "iso2": "SLK",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "South Tyneside",
    "iso2": "STY",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Southend-on-Sea",
    "iso2": "SOS",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Southwark",
    "iso2": "SWK",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "St Helens",
    "iso2": "SHN",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Staffordshire",
    "iso2": "STS",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Stirling",
    "iso2": "STG",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Stockport",
    "iso2": "SKP",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Stockton-on-Tees",
    "iso2": "STT",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Stoke-on-Trent",
    "iso2": "STE",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Suffolk",
    "iso2": "SFK",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Sunderland",
    "iso2": "SND",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Surrey",
    "iso2": "SRY",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Sutton",
    "iso2": "STN",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Swansea",
    "iso2": "SWA",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Swindon",
    "iso2": "SWD",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Tameside",
    "iso2": "TAM",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Telford and Wrekin",
    "iso2": "TFW",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Thurrock",
    "iso2": "THR",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Torbay",
    "iso2": "TOB",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Torfaen",
    "iso2": "TOF",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Tower Hamlets",
    "iso2": "TWH",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Trafford",
    "iso2": "TRF",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Vale of Glamorgan",
    "iso2": "VGL",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Wakefield",
    "iso2": "WKF",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Wales",
    "iso2": "WLS",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Walsall",
    "iso2": "WLL",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Waltham Forest",
    "iso2": "WFT",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Wandsworth",
    "iso2": "WND",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Warrington",
    "iso2": "WRT",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Warwickshire",
    "iso2": "WAR",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "West Berkshire",
    "iso2": "WBK",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "West Dunbartonshire",
    "iso2": "WDU",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "West Lothian",
    "iso2": "WLN",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "West Northamptonshire",
    "iso2": "WNH",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "West Sussex",
    "iso2": "WSX",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Westminster",
    "iso2": "WSM",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Wigan",
    "iso2": "WGN",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Wiltshire",
    "iso2": "WIL",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Windsor and Maidenhead",
    "iso2": "WNM",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Wirral",
    "iso2": "WRL",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Wokingham",
    "iso2": "WOK",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Wolverhampton",
    "iso2": "WLV",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Worcestershire",
    "iso2": "WOR",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Wrexham",
    "iso2": "WRX",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "York",
    "iso2": "YOR",
    "timezone": "Europe/London",
    "countryCode": "GB"
  },
  {
    "name": "Alabama",
    "iso2": "AL",
    "timezone": "America/Chicago",
    "countryCode": "US"
  },
  {
    "name": "Alaska",
    "iso2": "AK",
    "timezone": "America/Anchorage",
    "countryCode": "US"
  },
  {
    "name": "American Samoa",
    "iso2": "AS",
    "timezone": "America/New_York",
    "countryCode": "US"
  },
  {
    "name": "Arizona",
    "iso2": "AZ",
    "timezone": "America/Phoenix",
    "countryCode": "US"
  },
  {
    "name": "Arkansas",
    "iso2": "AR",
    "timezone": "America/Chicago",
    "countryCode": "US"
  },
  {
    "name": "Armed Forces Europe",
    "iso2": "AE",
    "timezone": "",
    "countryCode": "US"
  },
  {
    "name": "Armed Forces of the Americas",
    "iso2": "AA",
    "timezone": "",
    "countryCode": "US"
  },
  {
    "name": "Armed Forces Pacific",
    "iso2": "AP",
    "timezone": "",
    "countryCode": "US"
  },
  {
    "name": "California",
    "iso2": "CA",
    "timezone": "America/Los_Angeles",
    "countryCode": "US"
  },
  {
    "name": "Colorado",
    "iso2": "CO",
    "timezone": "America/Denver",
    "countryCode": "US"
  },
  {
    "name": "Connecticut",
    "iso2": "CT",
    "timezone": "America/New_York",
    "countryCode": "US"
  },
  {
    "name": "Delaware",
    "iso2": "DE",
    "timezone": "America/New_York",
    "countryCode": "US"
  },
  {
    "name": "District of Columbia",
    "iso2": "DC",
    "timezone": "America/New_York",
    "countryCode": "US"
  },
  {
    "name": "Florida",
    "iso2": "FL",
    "timezone": "America/New_York",
    "countryCode": "US"
  },
  {
    "name": "Georgia",
    "iso2": "GA",
    "timezone": "America/New_York",
    "countryCode": "US"
  },
  {
    "name": "Guam",
    "iso2": "GU",
    "timezone": "America/New_York",
    "countryCode": "US"
  },
  {
    "name": "Hawaii",
    "iso2": "HI",
    "timezone": "Pacific/Honolulu",
    "countryCode": "US"
  },
  {
    "name": "Idaho",
    "iso2": "ID",
    "timezone": "America/Denver",
    "countryCode": "US"
  },
  {
    "name": "Illinois",
    "iso2": "IL",
    "timezone": "America/Chicago",
    "countryCode": "US"
  },
  {
    "name": "Indiana",
    "iso2": "IN",
    "timezone": "America/Indiana/Indianapolis",
    "countryCode": "US"
  },
  {
    "name": "Iowa",
    "iso2": "IA",
    "timezone": "America/Chicago",
    "countryCode": "US"
  },
  {
    "name": "Kansas",
    "iso2": "KS",
    "timezone": "America/Chicago",
    "countryCode": "US"
  },
  {
    "name": "Kentucky",
    "iso2": "KY",
    "timezone": "America/Kentucky/Louisville",
    "countryCode": "US"
  },
  {
    "name": "Louisiana",
    "iso2": "LA",
    "timezone": "America/Chicago",
    "countryCode": "US"
  },
  {
    "name": "Maine",
    "iso2": "ME",
    "timezone": "America/New_York",
    "countryCode": "US"
  },
  {
    "name": "Maryland",
    "iso2": "MD",
    "timezone": "America/New_York",
    "countryCode": "US"
  },
  {
    "name": "Massachusetts",
    "iso2": "MA",
    "timezone": "America/New_York",
    "countryCode": "US"
  },
  {
    "name": "Michigan",
    "iso2": "MI",
    "timezone": "America/Detroit",
    "countryCode": "US"
  },
  {
    "name": "Minnesota",
    "iso2": "MN",
    "timezone": "America/Chicago",
    "countryCode": "US"
  },
  {
    "name": "Mississippi",
    "iso2": "MS",
    "timezone": "America/Chicago",
    "countryCode": "US"
  },
  {
    "name": "Missouri",
    "iso2": "MO",
    "timezone": "America/Chicago",
    "countryCode": "US"
  },
  {
    "name": "Montana",
    "iso2": "MT",
    "timezone": "America/Denver",
    "countryCode": "US"
  },
  {
    "name": "Nebraska",
    "iso2": "NE",
    "timezone": "America/Chicago",
    "countryCode": "US"
  },
  {
    "name": "Nevada",
    "iso2": "NV",
    "timezone": "America/Los_Angeles",
    "countryCode": "US"
  },
  {
    "name": "New Hampshire",
    "iso2": "NH",
    "timezone": "America/New_York",
    "countryCode": "US"
  },
  {
    "name": "New Jersey",
    "iso2": "NJ",
    "timezone": "America/New_York",
    "countryCode": "US"
  },
  {
    "name": "New Mexico",
    "iso2": "NM",
    "timezone": "America/Denver",
    "countryCode": "US"
  },
  {
    "name": "New York",
    "iso2": "NY",
    "timezone": "America/New_York",
    "countryCode": "US"
  },
  {
    "name": "North Carolina",
    "iso2": "NC",
    "timezone": "America/New_York",
    "countryCode": "US"
  },
  {
    "name": "North Dakota",
    "iso2": "ND",
    "timezone": "America/Chicago",
    "countryCode": "US"
  },
  {
    "name": "Northern Mariana Islands",
    "iso2": "MP",
    "timezone": "America/New_York",
    "countryCode": "US"
  },
  {
    "name": "Ohio",
    "iso2": "OH",
    "timezone": "America/New_York",
    "countryCode": "US"
  },
  {
    "name": "Oklahoma",
    "iso2": "OK",
    "timezone": "America/Chicago",
    "countryCode": "US"
  },
  {
    "name": "Oregon",
    "iso2": "OR",
    "timezone": "America/Los_Angeles",
    "countryCode": "US"
  },
  {
    "name": "Pennsylvania",
    "iso2": "PA",
    "timezone": "America/New_York",
    "countryCode": "US"
  },
  {
    "name": "Puerto Rico",
    "iso2": "PR",
    "timezone": "America/New_York",
    "countryCode": "US"
  },
  {
    "name": "Rhode Island",
    "iso2": "RI",
    "timezone": "America/New_York",
    "countryCode": "US"
  },
  {
    "name": "South Carolina",
    "iso2": "SC",
    "timezone": "America/New_York",
    "countryCode": "US"
  },
  {
    "name": "South Dakota",
    "iso2": "SD",
    "timezone": "America/Chicago",
    "countryCode": "US"
  },
  {
    "name": "Tennessee",
    "iso2": "TN",
    "timezone": "America/Chicago",
    "countryCode": "US"
  },
  {
    "name": "Texas",
    "iso2": "TX",
    "timezone": "America/Chicago",
    "countryCode": "US"
  },
  {
    "name": "United States Minor Outlying Islands",
    "iso2": "UM",
    "timezone": "America/New_York",
    "countryCode": "US"
  },
  {
    "name": "United States Virgin Islands",
    "iso2": "VI",
    "timezone": "America/New_York",
    "countryCode": "US"
  },
  {
    "name": "Utah",
    "iso2": "UT",
    "timezone": "America/Denver",
    "countryCode": "US"
  },
  {
    "name": "Vermont",
    "iso2": "VT",
    "timezone": "America/New_York",
    "countryCode": "US"
  },
  {
    "name": "Virginia",
    "iso2": "VA",
    "timezone": "America/New_York",
    "countryCode": "US"
  },
  {
    "name": "Washington",
    "iso2": "WA",
    "timezone": "America/Los_Angeles",
    "countryCode": "US"
  },
  {
    "name": "West Virginia",
    "iso2": "WV",
    "timezone": "America/New_York",
    "countryCode": "US"
  },
  {
    "name": "Wisconsin",
    "iso2": "WI",
    "timezone": "America/Chicago",
    "countryCode": "US"
  },
  {
    "name": "Wyoming",
    "iso2": "WY",
    "timezone": "America/Denver",
    "countryCode": "US"
  },
  {
    "name": "Baker Island",
    "iso2": "81",
    "timezone": "Pacific/Midway",
    "countryCode": "UM"
  },
  {
    "name": "Howland Island",
    "iso2": "84",
    "timezone": "Pacific/Midway",
    "countryCode": "UM"
  },
  {
    "name": "Jarvis Island",
    "iso2": "86",
    "timezone": "Pacific/Midway",
    "countryCode": "UM"
  },
  {
    "name": "Johnston Atoll",
    "iso2": "67",
    "timezone": "Pacific/Midway",
    "countryCode": "UM"
  },
  {
    "name": "Kingman Reef",
    "iso2": "89",
    "timezone": "Pacific/Midway",
    "countryCode": "UM"
  },
  {
    "name": "Midway Islands",
    "iso2": "71",
    "timezone": "Pacific/Midway",
    "countryCode": "UM"
  },
  {
    "name": "Navassa Island",
    "iso2": "76",
    "timezone": "Pacific/Midway",
    "countryCode": "UM"
  },
  {
    "name": "Palmyra Atoll",
    "iso2": "95",
    "timezone": "Pacific/Midway",
    "countryCode": "UM"
  },
  {
    "name": "Wake Island",
    "iso2": "79",
    "timezone": "Pacific/Midway",
    "countryCode": "UM"
  },
  {
    "name": "Artigas",
    "iso2": "AR",
    "timezone": "America/Montevideo",
    "countryCode": "UY"
  },
  {
    "name": "Canelones",
    "iso2": "CA",
    "timezone": "America/Montevideo",
    "countryCode": "UY"
  },
  {
    "name": "Cerro Largo",
    "iso2": "CL",
    "timezone": "America/Montevideo",
    "countryCode": "UY"
  },
  {
    "name": "Colonia",
    "iso2": "CO",
    "timezone": "America/Montevideo",
    "countryCode": "UY"
  },
  {
    "name": "Durazno",
    "iso2": "DU",
    "timezone": "America/Montevideo",
    "countryCode": "UY"
  },
  {
    "name": "Flores",
    "iso2": "FS",
    "timezone": "America/Montevideo",
    "countryCode": "UY"
  },
  {
    "name": "Florida",
    "iso2": "FD",
    "timezone": "America/Montevideo",
    "countryCode": "UY"
  },
  {
    "name": "Lavalleja",
    "iso2": "LA",
    "timezone": "America/Montevideo",
    "countryCode": "UY"
  },
  {
    "name": "Maldonado",
    "iso2": "MA",
    "timezone": "America/Montevideo",
    "countryCode": "UY"
  },
  {
    "name": "Montevideo",
    "iso2": "MO",
    "timezone": "America/Montevideo",
    "countryCode": "UY"
  },
  {
    "name": "Paysandú",
    "iso2": "PA",
    "timezone": "America/Montevideo",
    "countryCode": "UY"
  },
  {
    "name": "Río Negro",
    "iso2": "RN",
    "timezone": "America/Montevideo",
    "countryCode": "UY"
  },
  {
    "name": "Rivera",
    "iso2": "RV",
    "timezone": "America/Montevideo",
    "countryCode": "UY"
  },
  {
    "name": "Rocha",
    "iso2": "RO",
    "timezone": "America/Montevideo",
    "countryCode": "UY"
  },
  {
    "name": "Salto",
    "iso2": "SA",
    "timezone": "America/Montevideo",
    "countryCode": "UY"
  },
  {
    "name": "San José",
    "iso2": "SJ",
    "timezone": "America/Montevideo",
    "countryCode": "UY"
  },
  {
    "name": "Soriano",
    "iso2": "SO",
    "timezone": "America/Montevideo",
    "countryCode": "UY"
  },
  {
    "name": "Tacuarembó",
    "iso2": "TA",
    "timezone": "America/Montevideo",
    "countryCode": "UY"
  },
  {
    "name": "Treinta y Tres",
    "iso2": "TT",
    "timezone": "America/Montevideo",
    "countryCode": "UY"
  },
  {
    "name": "Andijan",
    "iso2": "AN",
    "timezone": "Asia/Samarkand",
    "countryCode": "UZ"
  },
  {
    "name": "Bukhara",
    "iso2": "BU",
    "timezone": "Asia/Samarkand",
    "countryCode": "UZ"
  },
  {
    "name": "Fergana",
    "iso2": "FA",
    "timezone": "Asia/Samarkand",
    "countryCode": "UZ"
  },
  {
    "name": "Jizzakh",
    "iso2": "JI",
    "timezone": "Asia/Samarkand",
    "countryCode": "UZ"
  },
  {
    "name": "Karakalpakstan",
    "iso2": "QR",
    "timezone": "Asia/Samarkand",
    "countryCode": "UZ"
  },
  {
    "name": "Namangan",
    "iso2": "NG",
    "timezone": "Asia/Samarkand",
    "countryCode": "UZ"
  },
  {
    "name": "Navoiy",
    "iso2": "NW",
    "timezone": "Asia/Samarkand",
    "countryCode": "UZ"
  },
  {
    "name": "Qashqadaryo",
    "iso2": "QA",
    "timezone": "Asia/Samarkand",
    "countryCode": "UZ"
  },
  {
    "name": "Samarqand",
    "iso2": "SA",
    "timezone": "Asia/Samarkand",
    "countryCode": "UZ"
  },
  {
    "name": "Sirdaryo",
    "iso2": "SI",
    "timezone": "Asia/Samarkand",
    "countryCode": "UZ"
  },
  {
    "name": "Surxondaryo",
    "iso2": "SU",
    "timezone": "Asia/Samarkand",
    "countryCode": "UZ"
  },
  {
    "name": "Tashkent",
    "iso2": "TK",
    "timezone": "Asia/Samarkand",
    "countryCode": "UZ"
  },
  {
    "name": "Tashkent",
    "iso2": "TO",
    "timezone": "Asia/Samarkand",
    "countryCode": "UZ"
  },
  {
    "name": "Xorazm",
    "iso2": "XO",
    "timezone": "Asia/Samarkand",
    "countryCode": "UZ"
  },
  {
    "name": "Malampa",
    "iso2": "MAP",
    "timezone": "Pacific/Efate",
    "countryCode": "VU"
  },
  {
    "name": "Penama",
    "iso2": "PAM",
    "timezone": "Pacific/Efate",
    "countryCode": "VU"
  },
  {
    "name": "Sanma",
    "iso2": "SAM",
    "timezone": "Pacific/Efate",
    "countryCode": "VU"
  },
  {
    "name": "Shefa",
    "iso2": "SEE",
    "timezone": "Pacific/Efate",
    "countryCode": "VU"
  },
  {
    "name": "Tafea",
    "iso2": "TAE",
    "timezone": "Pacific/Efate",
    "countryCode": "VU"
  },
  {
    "name": "Torba",
    "iso2": "TOB",
    "timezone": "Pacific/Efate",
    "countryCode": "VU"
  },
  {
    "name": "Amazonas",
    "iso2": "Z",
    "timezone": "America/Caracas",
    "countryCode": "VE"
  },
  {
    "name": "Anzoátegui",
    "iso2": "B",
    "timezone": "America/Caracas",
    "countryCode": "VE"
  },
  {
    "name": "Apure",
    "iso2": "C",
    "timezone": "America/Caracas",
    "countryCode": "VE"
  },
  {
    "name": "Aragua",
    "iso2": "D",
    "timezone": "America/Caracas",
    "countryCode": "VE"
  },
  {
    "name": "Barinas",
    "iso2": "E",
    "timezone": "America/Caracas",
    "countryCode": "VE"
  },
  {
    "name": "Bolívar",
    "iso2": "F",
    "timezone": "America/Caracas",
    "countryCode": "VE"
  },
  {
    "name": "Carabobo",
    "iso2": "G",
    "timezone": "America/Caracas",
    "countryCode": "VE"
  },
  {
    "name": "Cojedes",
    "iso2": "H",
    "timezone": "America/Caracas",
    "countryCode": "VE"
  },
  {
    "name": "Delta Amacuro",
    "iso2": "Y",
    "timezone": "America/Caracas",
    "countryCode": "VE"
  },
  {
    "name": "Distrito Capital",
    "iso2": "A",
    "timezone": "America/Caracas",
    "countryCode": "VE"
  },
  {
    "name": "Falcón",
    "iso2": "I",
    "timezone": "America/Caracas",
    "countryCode": "VE"
  },
  {
    "name": "Guárico",
    "iso2": "J",
    "timezone": "America/Caracas",
    "countryCode": "VE"
  },
  {
    "name": "La Guaira",
    "iso2": "X",
    "timezone": "America/Caracas",
    "countryCode": "VE"
  },
  {
    "name": "Lara",
    "iso2": "K",
    "timezone": "America/Caracas",
    "countryCode": "VE"
  },
  {
    "name": "Mérida",
    "iso2": "L",
    "timezone": "America/Caracas",
    "countryCode": "VE"
  },
  {
    "name": "Miranda",
    "iso2": "M",
    "timezone": "America/Caracas",
    "countryCode": "VE"
  },
  {
    "name": "Monagas",
    "iso2": "N",
    "timezone": "America/Caracas",
    "countryCode": "VE"
  },
  {
    "name": "Nueva Esparta",
    "iso2": "O",
    "timezone": "America/Caracas",
    "countryCode": "VE"
  },
  {
    "name": "Portuguesa",
    "iso2": "P",
    "timezone": "America/Caracas",
    "countryCode": "VE"
  },
  {
    "name": "Sucre",
    "iso2": "R",
    "timezone": "America/Caracas",
    "countryCode": "VE"
  },
  {
    "name": "Táchira",
    "iso2": "S",
    "timezone": "America/Caracas",
    "countryCode": "VE"
  },
  {
    "name": "Trujillo",
    "iso2": "T",
    "timezone": "America/Caracas",
    "countryCode": "VE"
  },
  {
    "name": "Venezuela",
    "iso2": "W",
    "timezone": "America/Caracas",
    "countryCode": "VE"
  },
  {
    "name": "Yaracuy",
    "iso2": "U",
    "timezone": "America/Caracas",
    "countryCode": "VE"
  },
  {
    "name": "Zulia",
    "iso2": "V",
    "timezone": "America/Caracas",
    "countryCode": "VE"
  },
  {
    "name": "An Giang",
    "iso2": "44",
    "timezone": "Asia/Ho_Chi_Minh",
    "countryCode": "VN"
  },
  {
    "name": "Bắc Ninh",
    "iso2": "56",
    "timezone": "Asia/Ho_Chi_Minh",
    "countryCode": "VN"
  },
  {
    "name": "Cà Mau",
    "iso2": "59",
    "timezone": "Asia/Ho_Chi_Minh",
    "countryCode": "VN"
  },
  {
    "name": "Cần Thơ",
    "iso2": "CT",
    "timezone": "Asia/Ho_Chi_Minh",
    "countryCode": "VN"
  },
  {
    "name": "Cao Bằng",
    "iso2": "04",
    "timezone": "Asia/Ho_Chi_Minh",
    "countryCode": "VN"
  },
  {
    "name": "Đà Nẵng",
    "iso2": "DN",
    "timezone": "Asia/Ho_Chi_Minh",
    "countryCode": "VN"
  },
  {
    "name": "Đắk Lắk",
    "iso2": "33",
    "timezone": "Asia/Ho_Chi_Minh",
    "countryCode": "VN"
  },
  {
    "name": "Điện Biên",
    "iso2": "71",
    "timezone": "Asia/Ho_Chi_Minh",
    "countryCode": "VN"
  },
  {
    "name": "Đồng Nai",
    "iso2": "39",
    "timezone": "Asia/Ho_Chi_Minh",
    "countryCode": "VN"
  },
  {
    "name": "Đồng Tháp",
    "iso2": "45",
    "timezone": "Asia/Ho_Chi_Minh",
    "countryCode": "VN"
  },
  {
    "name": "Gia Lai",
    "iso2": "30",
    "timezone": "Asia/Ho_Chi_Minh",
    "countryCode": "VN"
  },
  {
    "name": "Hà Nội",
    "iso2": "HN",
    "timezone": "Asia/Ho_Chi_Minh",
    "countryCode": "VN"
  },
  {
    "name": "Hà Tĩnh",
    "iso2": "23",
    "timezone": "Asia/Ho_Chi_Minh",
    "countryCode": "VN"
  },
  {
    "name": "Hải Phòng",
    "iso2": "HP",
    "timezone": "Asia/Ho_Chi_Minh",
    "countryCode": "VN"
  },
  {
    "name": "Hồ Chí Minh",
    "iso2": "SG",
    "timezone": "Asia/Ho_Chi_Minh",
    "countryCode": "VN"
  },
  {
    "name": "Hưng Yên",
    "iso2": "66",
    "timezone": "Asia/Ho_Chi_Minh",
    "countryCode": "VN"
  },
  {
    "name": "Khánh Hòa",
    "iso2": "34",
    "timezone": "Asia/Ho_Chi_Minh",
    "countryCode": "VN"
  },
  {
    "name": "Lai Châu",
    "iso2": "01",
    "timezone": "Asia/Ho_Chi_Minh",
    "countryCode": "VN"
  },
  {
    "name": "Lâm Đồng",
    "iso2": "35",
    "timezone": "Asia/Ho_Chi_Minh",
    "countryCode": "VN"
  },
  {
    "name": "Lạng Sơn",
    "iso2": "09",
    "timezone": "Asia/Ho_Chi_Minh",
    "countryCode": "VN"
  },
  {
    "name": "Lào Cai",
    "iso2": "02",
    "timezone": "Asia/Ho_Chi_Minh",
    "countryCode": "VN"
  },
  {
    "name": "Nghệ An",
    "iso2": "22",
    "timezone": "Asia/Ho_Chi_Minh",
    "countryCode": "VN"
  },
  {
    "name": "Ninh Bình",
    "iso2": "18",
    "timezone": "Asia/Ho_Chi_Minh",
    "countryCode": "VN"
  },
  {
    "name": "Phú Thọ",
    "iso2": "68",
    "timezone": "Asia/Ho_Chi_Minh",
    "countryCode": "VN"
  },
  {
    "name": "Quảng Ngãi",
    "iso2": "29",
    "timezone": "Asia/Ho_Chi_Minh",
    "countryCode": "VN"
  },
  {
    "name": "Quảng Ninh",
    "iso2": "13",
    "timezone": "Asia/Ho_Chi_Minh",
    "countryCode": "VN"
  },
  {
    "name": "Quảng Trị",
    "iso2": "25",
    "timezone": "Asia/Ho_Chi_Minh",
    "countryCode": "VN"
  },
  {
    "name": "Sơn La",
    "iso2": "05",
    "timezone": "Asia/Ho_Chi_Minh",
    "countryCode": "VN"
  },
  {
    "name": "Tây Ninh",
    "iso2": "37",
    "timezone": "Asia/Ho_Chi_Minh",
    "countryCode": "VN"
  },
  {
    "name": "Thái Nguyên",
    "iso2": "69",
    "timezone": "Asia/Ho_Chi_Minh",
    "countryCode": "VN"
  },
  {
    "name": "Thanh Hóa",
    "iso2": "21",
    "timezone": "Asia/Ho_Chi_Minh",
    "countryCode": "VN"
  },
  {
    "name": "Thừa Thiên-Huế",
    "iso2": "26",
    "timezone": "Asia/Ho_Chi_Minh",
    "countryCode": "VN"
  },
  {
    "name": "Tuyên Quang",
    "iso2": "07",
    "timezone": "Asia/Ho_Chi_Minh",
    "countryCode": "VN"
  },
  {
    "name": "Vĩnh Long",
    "iso2": "49",
    "timezone": "Asia/Ho_Chi_Minh",
    "countryCode": "VN"
  },
  {
    "name": "Saint Croix",
    "iso2": "SC",
    "timezone": "America/St_Thomas",
    "countryCode": "VI"
  },
  {
    "name": "Saint John",
    "iso2": "SJ",
    "timezone": "America/St_Thomas",
    "countryCode": "VI"
  },
  {
    "name": "Saint Thomas",
    "iso2": "ST",
    "timezone": "America/St_Thomas",
    "countryCode": "VI"
  },
  {
    "name": "Alo",
    "iso2": "AL",
    "timezone": "Pacific/Wallis",
    "countryCode": "WF"
  },
  {
    "name": "Sigave",
    "iso2": "SG",
    "timezone": "Pacific/Wallis",
    "countryCode": "WF"
  },
  {
    "name": "Uvea",
    "iso2": "UV",
    "timezone": "Pacific/Wallis",
    "countryCode": "WF"
  },
  {
    "name": "Abyan",
    "iso2": "AB",
    "timezone": "Asia/Aden",
    "countryCode": "YE"
  },
  {
    "name": "Ad Dali'",
    "iso2": "DA",
    "timezone": "Asia/Aden",
    "countryCode": "YE"
  },
  {
    "name": "Adan",
    "iso2": "AD",
    "timezone": "Asia/Aden",
    "countryCode": "YE"
  },
  {
    "name": "Al Bayda'",
    "iso2": "BA",
    "timezone": "Asia/Aden",
    "countryCode": "YE"
  },
  {
    "name": "Al Hudaydah",
    "iso2": "HU",
    "timezone": "Asia/Aden",
    "countryCode": "YE"
  },
  {
    "name": "Al Jawf",
    "iso2": "JA",
    "timezone": "Asia/Aden",
    "countryCode": "YE"
  },
  {
    "name": "Al Mahrah",
    "iso2": "MR",
    "timezone": "Asia/Aden",
    "countryCode": "YE"
  },
  {
    "name": "Al Mahwit",
    "iso2": "MW",
    "timezone": "Asia/Aden",
    "countryCode": "YE"
  },
  {
    "name": "Amanat Al Asimah",
    "iso2": "SA",
    "timezone": "Asia/Aden",
    "countryCode": "YE"
  },
  {
    "name": "Amran",
    "iso2": "AM",
    "timezone": "Asia/Aden",
    "countryCode": "YE"
  },
  {
    "name": "Dhamar",
    "iso2": "DH",
    "timezone": "Asia/Aden",
    "countryCode": "YE"
  },
  {
    "name": "Hadhramaut",
    "iso2": "HD",
    "timezone": "Asia/Aden",
    "countryCode": "YE"
  },
  {
    "name": "Hajjah",
    "iso2": "HJ",
    "timezone": "Asia/Aden",
    "countryCode": "YE"
  },
  {
    "name": "Ibb",
    "iso2": "IB",
    "timezone": "Asia/Aden",
    "countryCode": "YE"
  },
  {
    "name": "Lahij",
    "iso2": "LA",
    "timezone": "Asia/Aden",
    "countryCode": "YE"
  },
  {
    "name": "Ma'rib",
    "iso2": "MA",
    "timezone": "Asia/Aden",
    "countryCode": "YE"
  },
  {
    "name": "Raymah",
    "iso2": "RA",
    "timezone": "Asia/Aden",
    "countryCode": "YE"
  },
  {
    "name": "Saada",
    "iso2": "SD",
    "timezone": "Asia/Aden",
    "countryCode": "YE"
  },
  {
    "name": "Sana'a",
    "iso2": "SN",
    "timezone": "Asia/Aden",
    "countryCode": "YE"
  },
  {
    "name": "Shabwah",
    "iso2": "SH",
    "timezone": "Asia/Aden",
    "countryCode": "YE"
  },
  {
    "name": "Socotra",
    "iso2": "SU",
    "timezone": "Asia/Aden",
    "countryCode": "YE"
  },
  {
    "name": "Ta'izz",
    "iso2": "TA",
    "timezone": "Asia/Aden",
    "countryCode": "YE"
  },
  {
    "name": "Central",
    "iso2": "02",
    "timezone": "Africa/Lusaka",
    "countryCode": "ZM"
  },
  {
    "name": "Copperbelt",
    "iso2": "08",
    "timezone": "Africa/Lusaka",
    "countryCode": "ZM"
  },
  {
    "name": "Eastern",
    "iso2": "03",
    "timezone": "Africa/Lusaka",
    "countryCode": "ZM"
  },
  {
    "name": "Luapula",
    "iso2": "04",
    "timezone": "Africa/Lusaka",
    "countryCode": "ZM"
  },
  {
    "name": "Lusaka",
    "iso2": "09",
    "timezone": "Africa/Lusaka",
    "countryCode": "ZM"
  },
  {
    "name": "Muchinga",
    "iso2": "10",
    "timezone": "Africa/Lusaka",
    "countryCode": "ZM"
  },
  {
    "name": "Northern",
    "iso2": "05",
    "timezone": "Africa/Lusaka",
    "countryCode": "ZM"
  },
  {
    "name": "Northwestern",
    "iso2": "06",
    "timezone": "Africa/Lusaka",
    "countryCode": "ZM"
  },
  {
    "name": "Southern",
    "iso2": "07",
    "timezone": "Africa/Lusaka",
    "countryCode": "ZM"
  },
  {
    "name": "Western",
    "iso2": "01",
    "timezone": "Africa/Lusaka",
    "countryCode": "ZM"
  },
  {
    "name": "Bulawayo",
    "iso2": "BU",
    "timezone": "Africa/Harare",
    "countryCode": "ZW"
  },
  {
    "name": "Harare",
    "iso2": "HA",
    "timezone": "Africa/Harare",
    "countryCode": "ZW"
  },
  {
    "name": "Manicaland",
    "iso2": "MA",
    "timezone": "Africa/Harare",
    "countryCode": "ZW"
  },
  {
    "name": "Mashonaland Central",
    "iso2": "MC",
    "timezone": "Africa/Harare",
    "countryCode": "ZW"
  },
  {
    "name": "Mashonaland East",
    "iso2": "ME",
    "timezone": "Africa/Harare",
    "countryCode": "ZW"
  },
  {
    "name": "Mashonaland West",
    "iso2": "MW",
    "timezone": "Africa/Harare",
    "countryCode": "ZW"
  },
  {
    "name": "Masvingo",
    "iso2": "MV",
    "timezone": "Africa/Harare",
    "countryCode": "ZW"
  },
  {
    "name": "Matabeleland North",
    "iso2": "MN",
    "timezone": "Africa/Harare",
    "countryCode": "ZW"
  },
  {
    "name": "Matabeleland South",
    "iso2": "MS",
    "timezone": "Africa/Harare",
    "countryCode": "ZW"
  },
  {
    "name": "Midlands",
    "iso2": "MI",
    "timezone": "Africa/Harare",
    "countryCode": "ZW"
  }
];

export default DIVISIONS;
